webpackJsonp([1],{

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_feathers_client_dist_feathers__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_feathers_client_dist_feathers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_feathers_client_dist_feathers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_socket_io_client__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return bookingService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return boatService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reservationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settingService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sessionService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return userService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reasonService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return voucherService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return additonalServiceService; });
/* unused harmony export dailyReportService */
/* unused harmony export auth */






var socket = __WEBPACK_IMPORTED_MODULE_3_socket_io_client___default()('https://booking.meine-insel.at');

var app = __WEBPACK_IMPORTED_MODULE_1_feathers_client_dist_feathers___default()().configure(__WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client___default()(socket, {
  timeout: 15000
})).configure(__WEBPACK_IMPORTED_MODULE_1_feathers_client_dist_feathers___default.a.hooks()).configure(__WEBPACK_IMPORTED_MODULE_1_feathers_client_dist_feathers___default.a.authentication({ storage: window.localStorage }));

/* harmony default export */ __webpack_exports__["a"] = (app);

var bookingService = app.service('bookings');
var boatService = app.service('boats');
var reservationService = app.service('reservations');
var settingService = app.service('settings');
var sessionService = app.service('sessions');
var userService = app.service('users');
var reasonService = app.service('reasons');
var voucherService = app.service('vouchers');
var additonalServiceService = app.service('additionalServices');
var dailyReportService = app.service('dailyReports');

var auth = app.authentication;

app.io.on('reconnect', function (arg) {
  console.log('reconnected');
  app.authenticate({}).then(function () {
    console.log('reauthenticated');
  }).catch(function (error) {
    console.error('auth failed', error);
  });
});

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {!function(e,t,a,n){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.calendar=function(t){var o,r=e(this),i=r.selector||"",l=(new Date).getTime(),s=[],d=arguments[0],u="string"==typeof d,p=[].slice.call(arguments,1);return r.each(function(){var r,c,f=e.isPlainObject(t)?e.extend(!0,{},e.fn.calendar.settings,t):e.extend({},e.fn.calendar.settings),h=f.className,g=f.namespace,m=f.selector,v=f.formatter,y=f.parser,D=f.metadata,b=f.error,C="."+g,M="module-"+g,w=e(this),x=w.find(m.input),k=w.find(m.popup),T=w.find(m.activator),F=this,H=w.data(M),O=!1,I=!1;c={initialize:function(){c.debug("Initializing calendar for",F),r=c.get.isTouch(),c.setup.popup(),c.setup.inline(),c.setup.input(),c.setup.date(),c.create.calendar(),c.bind.events(),c.instantiate()},instantiate:function(){c.verbose("Storing instance of calendar"),H=c,w.data(M,H)},destroy:function(){c.verbose("Destroying previous calendar for",F),w.removeData(M),c.unbind.events()},setup:{popup:function(){if(!f.inline&&(T.length||(T=w.children().first(),T.length))){if(e.fn.popup===n)return void c.error(b.popup);k.length||(k=e("<div/>").addClass(h.popup).prependTo(T.parent())),k.addClass(h.calendar);var t=f.onVisible,a=f.onHidden;x.length||(k.attr("tabindex","0"),t=function(){return c.focus(),f.onVisible.apply(k,arguments)},a=function(){return c.blur(),f.onHidden.apply(k,arguments)});var o=function(){return c.set.focusDate(c.get.date()),c.set.mode(f.startMode),f.onShow.apply(k,arguments)},r=f.on||(x.length?"focus":"click"),i=e.extend({},f.popupOptions,{popup:k,on:r,hoverable:"hover"===r,onShow:o,onVisible:t,onHide:f.onHide,onHidden:a});c.popup(i)}},inline:function(){T.length&&!f.inline||(k=e("<div/>").addClass(h.calendar).appendTo(w),x.length||k.attr("tabindex","0"))},input:function(){f.touchReadonly&&x.length&&r&&x.prop("readonly",!0)},date:function(){if(x.length){var e=x.val(),t=y.date(e,f);c.set.date(t,f.formatInput,!1)}}},create:{calendar:function(){var t,a,n,o,r,i,l,s=c.get.mode(),d=new Date,u=c.get.date(),p=c.get.focusDate(),g=p||u||f.initialDate||d;g=c.helper.dateInRange(g),p||(p=g,c.set.focusDate(p,!1,!1));var m="year"===s,y="month"===s,b="day"===s,C="hour"===s,M="minute"===s,w="time"===f.type,x=Math.max(f.multiMonth,1),T=b?c.get.monthOffset():0,F=g.getMinutes(),H=g.getHours(),O=g.getDate(),I=g.getMonth()+T,N=g.getFullYear(),Y=b?7:C?4:3,E=7===Y?"seven":4===Y?"four":"three",R=b||C?6:4,A=b?x:1,j=k;for(j.empty(),A>1&&(l=e("<div/>").addClass(h.grid).appendTo(j)),o=0;o<A;o++){if(A>1){var S=e("<div/>").addClass(h.column).appendTo(l);j=S}var V=I+o,P=(new Date(N,V,1).getDay()-f.firstDayOfWeek%7+7)%7;if(!f.constantHeight&&b){var q=new Date(N,V+1,0).getDate()+P;R=Math.ceil(q/7)}var K=m?10:y?1:0,J=b?1:0,W=C||M?1:0,z=C||M?O:1,L=new Date(N-K,V-J,z-W,H),B=new Date(N+K,V+J,z+W,H),U=m?new Date(10*Math.ceil(N/10)-9,0,0):y?new Date(N,0,0):b?new Date(N,V,0):new Date(N,V,O,(-1)),Q=m?new Date(10*Math.ceil(N/10)+1,0,1):y?new Date(N+1,0,1):b?new Date(N,V+1,1):new Date(N,V,O+1),Z=e("<table/>").addClass(h.table).addClass(E+" column").addClass(s).appendTo(j);if(!w){var G=e("<thead/>").appendTo(Z);r=e("<tr/>").appendTo(G),i=e("<th/>").attr("colspan",""+Y).appendTo(r);var X=m||y?new Date(N,0,1):b?new Date(N,V,1):new Date(N,V,O,H,F),$=e("<span/>").addClass(h.link).appendTo(i);$.text(v.header(X,s,f));var _=y?f.disableYear?"day":"year":b?f.disableMonth?"year":"month":"day";if($.data(D.mode,_),0===o){var ee=e("<span/>").addClass(h.prev).appendTo(i);ee.data(D.focusDate,L),ee.toggleClass(h.disabledCell,!c.helper.isDateInRange(U,s)),e("<i/>").addClass(h.prevIcon).appendTo(ee)}if(o===A-1){var te=e("<span/>").addClass(h.next).appendTo(i);te.data(D.focusDate,B),te.toggleClass(h.disabledCell,!c.helper.isDateInRange(Q,s)),e("<i/>").addClass(h.nextIcon).appendTo(te)}if(b)for(r=e("<tr/>").appendTo(G),t=0;t<Y;t++)i=e("<th/>").appendTo(r),i.text(v.dayColumnHeader((t+f.firstDayOfWeek)%7,f))}var ae=e("<tbody/>").appendTo(Z);for(t=m?10*Math.ceil(N/10)-9:b?1-P:0,a=0;a<R;a++)for(r=e("<tr/>").appendTo(ae),n=0;n<Y;n++,t++){var ne=m?new Date(t,V,1,H,F):y?new Date(N,t,1,H,F):b?new Date(N,V,t,H,F):C?new Date(N,V,O,t):new Date(N,V,O,H,5*t),oe=m?t:y?f.text.monthsShort[t]:b?ne.getDate():v.time(ne,f,!0);i=e("<td/>").addClass(h.cell).appendTo(r),i.text(oe),i.data(D.date,ne);var re=b&&ne.getMonth()!==(V+12)%12,ie=re||!c.helper.isDateInRange(ne,s)||f.isDisabled(ne,s),le=c.helper.dateEqual(ne,u,s);i.toggleClass(h.adjacentCell,re),i.toggleClass(h.disabledCell,ie),i.toggleClass(h.activeCell,le&&!re),C||M||i.toggleClass(h.todayCell,!re&&c.helper.dateEqual(ne,d,s)),c.helper.dateEqual(ne,p,s)&&c.set.focusDate(ne,!1,!1)}if(f.today){var se=e("<tr/>").appendTo(ae),de=e("<td/>").attr("colspan",""+Y).addClass(h.today).appendTo(se);de.text(v.today(f)),de.data(D.date,d)}c.update.focus(!1,Z)}}},update:{focus:function(t,a){a=a||k;var n=c.get.mode(),o=c.get.date(),i=c.get.focusDate(),l=c.get.startDate(),s=c.get.endDate(),d=(t?i:null)||o||(r?null:i);a.find("td").each(function(){var t=e(this),a=t.data(D.date);if(a){var o=t.hasClass(h.disabledCell),u=t.hasClass(h.activeCell),p=t.hasClass(h.adjacentCell),f=c.helper.dateEqual(a,i,n),g=!!d&&(!!l&&c.helper.isDateInRange(a,n,l,d)||!!s&&c.helper.isDateInRange(a,n,d,s));t.toggleClass(h.focusCell,f&&(!r||O)&&!p),t.toggleClass(h.rangeCell,g&&!u&&!o)}})}},refresh:function(){c.create.calendar()},bind:{events:function(){k.on("mousedown"+C,c.event.mousedown),k.on("touchstart"+C,c.event.mousedown),k.on("mouseup"+C,c.event.mouseup),k.on("touchend"+C,c.event.mouseup),k.on("mouseover"+C,c.event.mouseover),x.length?(x.on("input"+C,c.event.inputChange),x.on("focus"+C,c.event.inputFocus),x.on("blur"+C,c.event.inputBlur),x.on("click"+C,c.event.inputClick),x.on("keydown"+C,c.event.keydown)):k.on("keydown"+C,c.event.keydown)}},unbind:{events:function(){k.off(C),x.length&&x.off(C)}},event:{mouseover:function(t){var a=e(t.target),n=a.data(D.date),o=1===t.buttons;n&&c.set.focusDate(n,!1,!0,o)},mousedown:function(t){x.length&&t.preventDefault(),O=t.type.indexOf("touch")>=0;var a=e(t.target),n=a.data(D.date);n&&c.set.focusDate(n,!1,!0,!0)},mouseup:function(t){c.focus(),t.preventDefault(),t.stopPropagation(),O=!1;var a=e(t.target),n=a.parent();(n.data(D.date)||n.data(D.focusDate)||n.data(D.mode))&&(a=n);var o=a.data(D.date),r=a.data(D.focusDate),i=a.data(D.mode);if(o){var l=a.hasClass(h.today);c.selectDate(o,l)}else r?c.set.focusDate(r):i&&c.set.mode(i)},keydown:function(e){if(27!==e.keyCode&&9!==e.keyCode||c.popup("hide"),c.popup("is visible"))if(37===e.keyCode||38===e.keyCode||39===e.keyCode||40===e.keyCode){var t=c.get.mode(),a="day"===t?7:"hour"===t?4:3,n=37===e.keyCode?-1:38===e.keyCode?-a:39==e.keyCode?1:a;n*="minute"===t?5:1;var o=c.get.focusDate()||c.get.date()||new Date,r=o.getFullYear()+("year"===t?n:0),i=o.getMonth()+("month"===t?n:0),l=o.getDate()+("day"===t?n:0),s=o.getHours()+("hour"===t?n:0),d=o.getMinutes()+("minute"===t?n:0),u=new Date(r,i,l,s,d);"time"===f.type&&(u=c.helper.mergeDateTime(o,u)),c.helper.isDateInRange(u,t)&&c.set.focusDate(u)}else if(13===e.keyCode){var t=c.get.mode(),p=c.get.focusDate();p&&!f.isDisabled(p,t)&&c.selectDate(p),e.preventDefault(),e.stopPropagation()}38!==e.keyCode&&40!==e.keyCode||(e.preventDefault(),c.popup("show"))},inputChange:function(){var e=x.val(),t=y.date(e,f);c.set.date(t,!1)},inputFocus:function(){k.addClass(h.active)},inputBlur:function(){if(k.removeClass(h.active),f.formatInput){var e=c.get.date(),t=v.datetime(e,f);x.val(t)}},inputClick:function(){c.popup("show")}},get:{date:function(){return w.data(D.date)||null},focusDate:function(){return w.data(D.focusDate)||null},startDate:function(){var e=c.get.calendarModule(f.startCalendar);return(e?e.get.date():w.data(D.startDate))||null},endDate:function(){var e=c.get.calendarModule(f.endCalendar);return(e?e.get.date():w.data(D.endDate))||null},monthOffset:function(){return w.data(D.monthOffset)||0},mode:function(){var t=w.data(D.mode)||f.startMode,a=c.get.validModes();return e.inArray(t,a)>=0?t:"time"===f.type?"hour":"month"===f.type?"month":"year"===f.type?"year":"day"},validModes:function(){var e=[];return"time"!==f.type&&(f.disableYear&&"year"!==f.type||e.push("year"),(!f.disableMonth&&"year"!==f.type||"month"===f.type)&&e.push("month"),f.type.indexOf("date")>=0&&e.push("day")),f.type.indexOf("time")>=0&&(e.push("hour"),f.disableMinute||e.push("minute")),e},isTouch:function(){try{return a.createEvent("TouchEvent"),!0}catch(e){return!1}},calendarModule:function(t){return t?(t instanceof e||(t=w.parent().children(t).first()),t.data(M)):null}},set:{date:function(e,t,a){t=t!==!1,a=a!==!1,e=c.helper.sanitiseDate(e),e=c.helper.dateInRange(e);var o=v.datetime(e,f);if(a&&f.onChange.call(F,e,o)===!1)return!1;c.set.focusDate(e);var r=c.get.mode();if(f.isDisabled(e,r))return!1;var i=c.get.endDate();i&&e&&e>i&&c.set.endDate(n),c.set.dataKeyValue(D.date,e),t&&x.length&&x.val(o)},startDate:function(e,t){e=c.helper.sanitiseDate(e);var a=c.get.calendarModule(f.startCalendar);a&&a.set.date(e),c.set.dataKeyValue(D.startDate,e,t)},endDate:function(e,t){e=c.helper.sanitiseDate(e);var a=c.get.calendarModule(f.endCalendar);a&&a.set.date(e),c.set.dataKeyValue(D.endDate,e,t)},focusDate:function(e,t,a,n){e=c.helper.sanitiseDate(e),e=c.helper.dateInRange(e);var o="day"===c.get.mode(),r=c.get.focusDate();if(o&&e&&r){var i=e.getFullYear()-r.getFullYear(),l=12*i+e.getMonth()-r.getMonth();if(l){var s=c.get.monthOffset()-l;c.set.monthOffset(s,!1)}}var d=c.set.dataKeyValue(D.focusDate,e,t);a=a!==!1&&d&&t===!1||I!=n,I=n,a&&c.update.focus(n)},monthOffset:function(e,t){var a=Math.max(f.multiMonth,1);e=Math.max(1-a,Math.min(0,e)),c.set.dataKeyValue(D.monthOffset,e,t)},mode:function(e,t){c.set.dataKeyValue(D.mode,e,t)},dataKeyValue:function(e,t,a){var n=w.data(e),o=n===t||n<=t&&n>=t;return t?w.data(e,t):w.removeData(e),a=a!==!1&&!o,a&&c.create.calendar(),!o}},selectDate:function(e,t){var a=c.get.mode(),n=t||"minute"===a||f.disableMinute&&"hour"===a||"date"===f.type&&"day"===a||"month"===f.type&&"month"===a||"year"===f.type&&"year"===a;if(n){var o=c.set.date(e)===!1;if(!o&&f.closable){c.popup("hide");var r=c.get.calendarModule(f.endCalendar);r&&(r.popup("show"),r.focus())}}else{var i="year"===a?f.disableMonth?"day":"month":"month"===a?"day":"day"===a?"hour":"minute";c.set.mode(i),"hour"===a||"day"===a&&c.get.date()?c.set.date(e):c.set.focusDate(e)}},changeDate:function(e){c.set.date(e)},clear:function(){c.set.date(n)},popup:function(){return T.popup.apply(T,arguments)},focus:function(){x.length?x.focus():k.focus()},blur:function(){x.length?x.blur():k.blur()},helper:{sanitiseDate:function(e){return e?(e instanceof Date||(e=y.date(""+e,f)),isNaN(e.getTime())?n:e):n},dateDiff:function(e,t,a){a=a||"day";var n="time"===f.type,o="year"===a,r=o||"month"===a,i="minute"===a,l=i||"hour"===a;return e=new Date(n?2e3:e.getFullYear(),n?0:o?0:e.getMonth(),n?1:r?1:e.getDate(),l?e.getHours():0,i?5*Math.floor(e.getMinutes()/5):0),t=new Date(n?2e3:t.getFullYear(),n?0:o?0:t.getMonth(),n?1:r?1:t.getDate(),l?t.getHours():0,i?5*Math.floor(t.getMinutes()/5):0),t.getTime()-e.getTime()},dateEqual:function(e,t,a){return!!e&&!!t&&0===c.helper.dateDiff(e,t,a)},isDateInRange:function(e,t,a,n){if(!a&&!n){var o=c.get.startDate();a=o&&f.minDate?new Date(Math.max(o,f.minDate)):o||f.minDate,n=f.maxDate}return a=a&&new Date(a.getFullYear(),a.getMonth(),a.getDate(),a.getHours(),5*Math.ceil(a.getMinutes()/5)),!(!e||a&&c.helper.dateDiff(e,a,t)>0||n&&c.helper.dateDiff(n,e,t)>0)},dateInRange:function(e,t,a){if(!t&&!a){var n=c.get.startDate();t=n&&f.minDate?new Date(Math.max(n,f.minDate)):n||f.minDate,a=f.maxDate}t=t&&new Date(t.getFullYear(),t.getMonth(),t.getDate(),t.getHours(),5*Math.ceil(t.getMinutes()/5));var o="time"===f.type;return e?t&&c.helper.dateDiff(e,t,"minute")>0?o?c.helper.mergeDateTime(e,t):t:a&&c.helper.dateDiff(a,e,"minute")>0?o?c.helper.mergeDateTime(e,a):a:e:e},mergeDateTime:function(e,t){return e&&t?new Date(e.getFullYear(),e.getMonth(),e.getDate(),t.getHours(),t.getMinutes()):t}},setting:function(t,a){if(c.debug("Changing setting",t,a),e.isPlainObject(t))e.extend(!0,f,t);else{if(a===n)return f[t];e.isPlainObject(f[t])?e.extend(!0,f[t],a):f[t]=a}},internal:function(t,a){return c.debug("Changing internal",t,a),a===n?c[t]:void(e.isPlainObject(t)?e.extend(!0,c,t):c[t]=a)},debug:function(){!f.silent&&f.debug&&(f.performance?c.performance.log(arguments):(c.debug=Function.prototype.bind.call(console.info,console,f.name+":"),c.debug.apply(console,arguments)))},verbose:function(){!f.silent&&f.verbose&&f.debug&&(f.performance?c.performance.log(arguments):(c.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),c.verbose.apply(console,arguments)))},error:function(){f.silent||(c.error=Function.prototype.bind.call(console.error,console,f.name+":"),c.error.apply(console,arguments))},performance:{log:function(e){var t,a,n;f.performance&&(t=(new Date).getTime(),n=l||t,a=t-n,l=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:F,"Execution Time":a})),clearTimeout(c.performance.timer),c.performance.timer=setTimeout(c.performance.display,500)},display:function(){var t=f.name+":",a=0;l=!1,clearTimeout(c.performance.timer),e.each(s,function(e,t){a+=t["Execution Time"]}),t+=" "+a+"ms",i&&(t+=" '"+i+"'"),(console.group!==n||console.table!==n)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,a,r){var i,l,s,d=H;return a=a||p,r=F||r,"string"==typeof t&&d!==n&&(t=t.split(/[\. ]/),i=t.length-1,e.each(t,function(a,o){var r=a!=i?o+t[a+1].charAt(0).toUpperCase()+t[a+1].slice(1):t;if(e.isPlainObject(d[r])&&a!=i)d=d[r];else{if(d[r]!==n)return l=d[r],!1;if(!e.isPlainObject(d[o])||a==i)return d[o]!==n?(l=d[o],!1):(c.error(b.method,t),!1);d=d[o]}})),e.isFunction(l)?s=l.apply(r,a):l!==n&&(s=l),e.isArray(o)?o.push(s):o!==n?o=[o,s]:s!==n&&(o=s),l}},u?(H===n&&c.initialize(),c.invoke(d)):(H!==n&&H.invoke("destroy"),c.initialize())}),o!==n?o:this},e.fn.calendar.settings={name:"Calendar",namespace:"calendar",silent:!1,debug:!1,verbose:!1,performance:!1,type:"datetime",firstDayOfWeek:0,constantHeight:!0,today:!1,closable:!0,monthFirst:!0,touchReadonly:!0,inline:!1,on:null,initialDate:null,startMode:!1,minDate:null,maxDate:null,ampm:!0,disableYear:!1,disableMonth:!1,disableMinute:!1,formatInput:!0,startCalendar:null,endCalendar:null,multiMonth:1,popupOptions:{position:"bottom left",lastResort:"bottom left",prefer:"opposite",hideOnScroll:!1},text:{days:["S","M","T","W","T","F","S"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",now:"Now",am:"AM",pm:"PM"},formatter:{header:function(e,t,a){return"year"===t?a.formatter.yearHeader(e,a):"month"===t?a.formatter.monthHeader(e,a):"day"===t?a.formatter.dayHeader(e,a):"hour"===t?a.formatter.hourHeader(e,a):a.formatter.minuteHeader(e,a)},yearHeader:function(e,t){var a=10*Math.ceil(e.getFullYear()/10);return a-9+" - "+(a+2)},monthHeader:function(e,t){return e.getFullYear()},dayHeader:function(e,t){var a=t.text.months[e.getMonth()],n=e.getFullYear();return a+" "+n},hourHeader:function(e,t){return t.formatter.date(e,t)},minuteHeader:function(e,t){return t.formatter.date(e,t)},dayColumnHeader:function(e,t){return t.text.days[e]},datetime:function(e,t){if(!e)return"";var a="time"===t.type?"":t.formatter.date(e,t),n=t.type.indexOf("time")<0?"":t.formatter.time(e,t,!1),o="datetime"===t.type?" ":"";return a+o+n},date:function(e,t){if(!e)return"";var a=e.getDate(),n=t.text.months[e.getMonth()],o=e.getFullYear();return"year"===t.type?o:"month"===t.type?n+" "+o:(t.monthFirst?n+" "+a:a+" "+n)+", "+o},time:function(e,t,a){if(!e)return"";var n=e.getHours(),o=e.getMinutes(),r="";return t.ampm&&(r=" "+(n<12?t.text.am:t.text.pm),n=0===n?12:n>12?n-12:n),n+":"+(o<10?"0":"")+o+r},today:function(e){return"date"===e.type?e.text.today:e.text.now}},parser:{date:function(t,a){if(!t)return null;if(t=(""+t).trim().toLowerCase(),0===t.length)return null;var o,r,i,l=-1,s=-1,d=-1,u=-1,p=-1,c=n,f="time"===a.type,h=a.type.indexOf("time")<0,g=t.split(a.regExp.dateWords),m=t.split(a.regExp.dateNumbers);if(!h)for(c=e.inArray(a.text.am.toLowerCase(),g)>=0||!(e.inArray(a.text.pm.toLowerCase(),g)>=0)&&n,o=0;o<m.length;o++){var v=m[o];if(v.indexOf(":")>=0){if(s<0||l<0){var y=v.split(":");for(i=0;i<Math.min(2,y.length);i++)r=parseInt(y[i]),isNaN(r)&&(r=0),0===i?s=r%24:l=r%60}m.splice(o,1)}}if(!f){for(o=0;o<g.length;o++){var D=g[o];if(!(D.length<=0)){for(D=D.substring(0,Math.min(D.length,3)),r=0;r<a.text.months.length;r++){var b=a.text.months[r];if(b=b.substring(0,Math.min(D.length,Math.min(b.length,3))).toLowerCase(),b===D){u=r+1;break}}if(u>=0)break}}for(o=0;o<m.length;o++)if(r=parseInt(m[o]),!isNaN(r)&&r>59){p=r,m.splice(o,1);break}if(u<0)for(o=0;o<m.length;o++)if(i=o>1||a.monthFirst?o:1===o?0:1,r=parseInt(m[i]),!isNaN(r)&&1<=r&&r<=12){u=r,m.splice(i,1);break}for(o=0;o<m.length;o++)if(r=parseInt(m[o]),!isNaN(r)&&1<=r&&r<=31){d=r,m.splice(o,1);break}if(p<0)for(o=m.length-1;o>=0;o--)if(r=parseInt(m[o]),!isNaN(r)){r<99&&(r+=2e3),p=r,m.splice(o,1);break}}if(!h){if(s<0)for(o=0;o<m.length;o++)if(r=parseInt(m[o]),!isNaN(r)&&0<=r&&r<=23){s=r,m.splice(o,1);break}if(l<0)for(o=0;o<m.length;o++)if(r=parseInt(m[o]),!isNaN(r)&&0<=r&&r<=59){l=r,m.splice(o,1);break}}if(l<0&&s<0&&d<0&&u<0&&p<0)return null;l<0&&(l=0),s<0&&(s=0),d<0&&(d=1),u<0&&(u=1),p<0&&(p=(new Date).getFullYear()),c!==n&&(c?12===s&&(s=0):s<12&&(s+=12));var C=new Date(p,u-1,d,s,l);return C.getMonth()===u-1&&C.getFullYear()===p||(C=new Date(p,u,0,s,l)),isNaN(C.getTime())?null:C}},onChange:function(e,t){return!0},onShow:function(){},onVisible:function(){},onHide:function(){},onHidden:function(){},isDisabled:function(e,t){return!1},selector:{popup:".ui.popup",input:"input",activator:"input"},regExp:{dateWords:/[^A-Za-z\u00C0-\u024F]+/g,dateNumbers:/[^\d:]+/g},error:{popup:"UI Popup, a required component is not included in this page",method:"The method you called is not defined."},className:{calendar:"calendar",active:"active",popup:"ui popup",grid:"ui equal width grid",column:"column",table:"ui celled center aligned unstackable table",prev:"prev link",next:"next link",prevIcon:"chevron left icon",nextIcon:"chevron right icon",link:"link",cell:"link",disabledCell:"disabled",adjacentCell:"adjacent",activeCell:"active",rangeCell:"range",focusCell:"focus",todayCell:"today",today:"today link"},metadata:{date:"date",focusDate:"focusDate",startDate:"startDate",endDate:"endDate",mode:"mode",monthOffset:"monthOffset"}}}(jQuery,window,document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(747),
  /* scopeId */
  "data-v-9405639e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(733),
  /* scopeId */
  "data-v-24ecb18b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Home__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_ConfirmReservation__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_ConfirmReservation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_ConfirmReservation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Login__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Admin__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Booking__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Booking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_Booking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_Settings__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_Reservations__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_Reservations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_Reservations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_Boats__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_Boats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_Boats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_Users__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_Reasons__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_Reasons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_admin_Reasons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_Services__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_Vouchers__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_Vouchers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_admin_Vouchers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_index__ = __webpack_require__(98);
var _this = this;


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_views_Home___default.a
  }, {
    name: 'confirmReservation',
    path: '/reservation/:id/confirm',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_ConfirmReservation___default.a
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Admin___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_6__components_admin_Booking___default.a
    }, {
      path: 'booking',
      component: __WEBPACK_IMPORTED_MODULE_6__components_admin_Booking___default.a
    }, {
      path: 'boats',
      component: __WEBPACK_IMPORTED_MODULE_9__components_admin_Boats___default.a
    }, {
      path: 'users',
      component: __WEBPACK_IMPORTED_MODULE_10__components_admin_Users___default.a
    }, {
      path: 'reasons',
      component: __WEBPACK_IMPORTED_MODULE_11__components_admin_Reasons___default.a
    }, {
      path: 'vouchers',
      component: __WEBPACK_IMPORTED_MODULE_13__components_admin_Vouchers___default.a
    }, {
      path: 'services',
      component: __WEBPACK_IMPORTED_MODULE_12__components_admin_Services___default.a
    }, {
      path: 'settings',
      component: __WEBPACK_IMPORTED_MODULE_7__components_admin_Settings___default.a
    }, {
      path: 'reservations',
      component: __WEBPACK_IMPORTED_MODULE_8__components_admin_Reservations___default.a
    }]
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Login___default.a
  }, {
    path: '/logout',
    beforeEnter: function (to, from, next) {
      __WEBPACK_IMPORTED_MODULE_14__services_index__["a" /* default */].logout().then(function () {
        __WEBPACK_IMPORTED_MODULE_15__store_index__["a" /* default */].dispatch('logoutUser');
        next('/login');
      });
    }.bind(this)
  }]
});

router.beforeEach(function (to, from, next) {

  if (__WEBPACK_IMPORTED_MODULE_15__store_index__["a" /* default */].state.user.authenticated || to.path === '/login' || to.path === '/' || to.name === 'confirmReservation') {
    next();
    return;
  }

  __WEBPACK_IMPORTED_MODULE_14__services_index__["a" /* default */].authenticate({}).then(function () {
    __WEBPACK_IMPORTED_MODULE_15__store_index__["a" /* default */].dispatch('authenticateUser', __WEBPACK_IMPORTED_MODULE_14__services_index__["a" /* default */].get('user')).then(function () {
      next();
    });
  }).catch(function (error) {
    console.error(error);
    next('/login');
  }.bind(_this));
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "Boat & Time": "Boot + Uhrzeit",
  "Choose your boat and desired date and time": "Welches Boot<br>Eines oder mehrere<br>Mietdauer",
  "Details & Extras": "Anzahl der Personen & Spezial Angebote",
  "Enter additional wishes": "Anzahl der Personen<br>Spezial Angebote<br>Gutschein",
  "Contact Details": "Ihre Kontaktdaten",
  "Enter contact details": "",
  "Review & Confirm": "Buchungsbestätigung",
  "Confirm your booking": "",
  "Accept & Continue": "Weiter",
  "Select slots to continue": "Wählen Sie Boot und Uhrzeit",
  "Go To Confirmation": "Zum Buchungsbestätigung",
  "Confirm Booking": "Kostenpflichtig buchen",
  "Please click here to finalize your booking.": "Bitte hier klicken, um Ihre Buchung verbindlich abzuschließen.",
  "Payment is made on-site": "Die Bezahlung erfolgt vor Ort",
  "in cash": "in bar",
  "— no card payments.": "— keine Kartenzahlung möglich.",
  "Back": "Zurück",
  "Selected date": "Gewähltes Datum",
  "Price for selected": "Preis",
  "Cancel Booking": "Buchung stornieren",
  "NOW": "JETZT",
  "ADDITIONAL DETAILS": "WEITERE DETAILS",
  "How many guests will be on the boat(s)?": "Personenanzahl",
  "What\'s the reason for booking our boats?": "Der Anlass für Ihre Fahrt (optional)",
  "Do you require additional services?": "Spezial Angebote",
  "Do you have any additional wishes?": "Haben Sie besondere Wünsche?",
  "Do you have any additional questions?": "Haben Sie noch Fragen?",
  "Do you have a voucher code?": "Gutschein Nummer",
  "Congratulations! You are eligible for discount": "Gutschein gültig",
  "YOUR CONTACT DETAILS": "IHRE KONTAKTDATEN",
  "Mr or Mrs": "Herr oder Frau",
  "Mr": "Herr",
  "Mrs": "Frau",
  "Select": "Auswählen",
  "Dr": "Dr",
  "Prof": "Prof",
  "Mag": "Mag",
  "Title": "Titel",
  "First Name": "Vorname",
  "Last Name": "Name",
  "Company": "Firma",
  "Email": "E-mail",
  "Telephone": "Telefon",
  "Address": "Strasse und Hausnummer",
  "City": "Stadt",
  "Post Code": "PLZ (Postleitzahl)",
  "I agree to receive newsletter emails": "Ich bin damit einverstanden, Newsletter-E-Mails zu erhalten",
  "I agree that my photos can be used for Meine Insel promotion": "Ich bin damit einverstanden, dass meine Fotos für Meine Insel Promotion verwendet werden können",
  "Please verify your booking and confirm.": "Bitte bestätigen Sie Ihre Buchung.",
  "Additional Services": "Extra Services",
  "Additional Wishes": "Extra Wünsche",
  "Questions": "Fragen",
  "People": "Anzahl der Gäste",
  "I accept the": "Ich akzeptiere die",
  "Terms of Service": "AGB"
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "Boat & Time": "Boat + Time",
  "Choose your boat and desired date and time": "Select the boat<br>One or more<br>Duration",
  "Details & Extras": "Number of persons & special offers",
  "Enter additional wishes": "Number of persons<br>Special offers<br>Voucher",
  "Contact Details": "Your Contact Details",
  "Enter contact details": "",
  "Review & Confirm": "Review & Confirm",
  "Confirm your booking": "Confirm your booking",
  "Accept & Continue": "Accept & Continue",
  "Select slots to continue": "Select boat and time",
  "Go To Confirmation": "Go To Confirmation",
  "Confirm Booking": "Confirm booking now",
  "Please click here to finalize your booking.": "Please click here to finalize your booking.",
  "Payment is made on-site": "Payment is made on-site",
  "in cash": "in cash",
  "— no card payments.": "— no card payments.",
  "Back": "Back",
  "Selected date": "Selected date",
  "Price for selected": "Price for selected",
  "Cancel Booking": "Cancel Booking",
  "NOW": "NOW",
  "ADDITIONAL DETAILS": "ADDITIONAL DETAILS",
  "How many guests will be on the boat(s)?": "Number of Persons",
  "What\'s the reason for booking our boats?": "The reason for renting (optional)",
  "Do you require additional services?": "Special offers",
  "Do you have any additional wishes?": "Do you have special wishes?",
  "Do you have any additional questions?": "Do you have additional questions?",
  "Do you have a voucher code?": "Voucher code",
  "Congratulations! You are eligible for discount": "Congratulations! You are eligible for discount",
  "YOUR CONTACT DETAILS": "YOUR CONTACT DETAILS",
  "Mr or Mrs": "Mr os Mrs",
  "Mr": "Mr",
  "Mrs": "Mrs",
  "Select": "Select",
  "Dr": "Dr",
  "Prof": "Prof",
  "Mag": "Mag",
  "Title": "Title",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "Company": "Company",
  "Email": "Email",
  "Telephone": "Telephone",
  "Address": "Address",
  "City": "City",
  "Post Code": "Post Code",
  "I agree to receive newsletter emails": "I agree to receive newsletter emails",
  "I agree that my photos can be used for Meine Insel promotion": "I agree that my photos can be used for Meine Insel promotion",
  "I accept the <a href=\"#\">Terms of Service</a>": "I accept the <a href=\"#\">Terms of Service</a>",
  "Please verify your booking and confirm.": "Please verify your booking and confirm.",
  "Additional Services": "Additional Services",
  "Additional Wishes": "Additional Wishes",
  "Questions": "Questions",
  "People": "People",
  "I accept the": "I accept the",
  "Terms of Service": "Terms of Service"
});

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(740),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) { /*
 * # Semantic UI - 2.2.10
 * https://github.com/Semantic-Org/Semantic-UI
 * http://www.semantic-ui.com/
 *
 * Copyright 2014 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */
!function(e,t,n,i){e.site=e.fn.site=function(o){var a,r,s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1),f=e.isPlainObject(o)?e.extend(!0,{},e.site.settings,o):e.extend({},e.site.settings),m=f.namespace,g=f.error,p="module-"+m,h=e(n),v=h,b=this,y=v.data(p);return a={initialize:function(){a.instantiate()},instantiate:function(){a.verbose("Storing instance of site",a),y=a,v.data(p,a)},normalize:function(){a.fix.console(),a.fix.requestAnimationFrame()},fix:{console:function(){a.debug("Normalizing window.console"),console!==i&&console.log!==i||(a.verbose("Console not available, normalizing events"),a.disable.console()),"undefined"!=typeof console.group&&"undefined"!=typeof console.groupEnd&&"undefined"!=typeof console.groupCollapsed||(a.verbose("Console group not available, normalizing events"),t.console.group=function(){},t.console.groupEnd=function(){},t.console.groupCollapsed=function(){}),"undefined"==typeof console.markTimeline&&(a.verbose("Mark timeline not available, normalizing events"),t.console.markTimeline=function(){})},consoleClear:function(){a.debug("Disabling programmatic console clearing"),t.console.clear=function(){}},requestAnimationFrame:function(){a.debug("Normalizing requestAnimationFrame"),t.requestAnimationFrame===i&&(a.debug("RequestAnimationFrame not available, normalizing event"),t.requestAnimationFrame=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)})}},moduleExists:function(t){return e.fn[t]!==i&&e.fn[t].settings!==i},enabled:{modules:function(t){var n=[];return t=t||f.modules,e.each(t,function(e,t){a.moduleExists(t)&&n.push(t)}),n}},disabled:{modules:function(t){var n=[];return t=t||f.modules,e.each(t,function(e,t){a.moduleExists(t)||n.push(t)}),n}},change:{setting:function(t,n,o,r){o="string"==typeof o?"all"===o?f.modules:[o]:o||f.modules,r=r!==i?r:!0,e.each(o,function(i,o){var s,l=a.moduleExists(o)?e.fn[o].settings.namespace||!1:!0;a.moduleExists(o)&&(a.verbose("Changing default setting",t,n,o),e.fn[o].settings[t]=n,r&&l&&(s=e(":data(module-"+l+")"),s.length>0&&(a.verbose("Modifying existing settings",s),s[o]("setting",t,n))))})},settings:function(t,n,o){n="string"==typeof n?[n]:n||f.modules,o=o!==i?o:!0,e.each(n,function(n,i){var r;a.moduleExists(i)&&(a.verbose("Changing default setting",t,i),e.extend(!0,e.fn[i].settings,t),o&&m&&(r=e(":data(module-"+m+")"),r.length>0&&(a.verbose("Modifying existing settings",r),r[i]("setting",t))))})}},enable:{console:function(){a.console(!0)},debug:function(e,t){e=e||f.modules,a.debug("Enabling debug for modules",e),a.change.setting("debug",!0,e,t)},verbose:function(e,t){e=e||f.modules,a.debug("Enabling verbose debug for modules",e),a.change.setting("verbose",!0,e,t)}},disable:{console:function(){a.console(!1)},debug:function(e,t){e=e||f.modules,a.debug("Disabling debug for modules",e),a.change.setting("debug",!1,e,t)},verbose:function(e,t){e=e||f.modules,a.debug("Disabling verbose debug for modules",e),a.change.setting("verbose",!1,e,t)}},console:function(e){if(e){if(y.cache.console===i)return void a.error(g.console);a.debug("Restoring console function"),t.console=y.cache.console}else a.debug("Disabling console function"),y.cache.console=t.console,t.console={clear:function(){},error:function(){},group:function(){},groupCollapsed:function(){},groupEnd:function(){},info:function(){},log:function(){},markTimeline:function(){},warn:function(){}}},destroy:function(){a.verbose("Destroying previous site for",v),v.removeData(p)},cache:{},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,a,t);else{if(n===i)return a[t];a[t]=n}},debug:function(){f.debug&&(f.performance?a.performance.log(arguments):(a.debug=Function.prototype.bind.call(console.info,console,f.name+":"),a.debug.apply(console,arguments)))},verbose:function(){f.verbose&&f.debug&&(f.performance?a.performance.log(arguments):(a.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),a.verbose.apply(console,arguments)))},error:function(){a.error=Function.prototype.bind.call(console.error,console,f.name+":"),a.error.apply(console,arguments)},performance:{log:function(e){var t,n,i;f.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Element:b,Name:e[0],Arguments:[].slice.call(e,1)||"","Execution Time":n})),clearTimeout(a.performance.timer),a.performance.timer=setTimeout(a.performance.display,500)},display:function(){var t=f.name+":",n=0;s=!1,clearTimeout(a.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,o){var s,l,c,u=y;return n=n||d,o=b||o,"string"==typeof t&&u!==i&&(t=t.split(/[\. ]/),s=t.length-1,e.each(t,function(n,o){var r=n!=s?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(u[r])&&n!=s)u=u[r];else{if(u[r]!==i)return l=u[r],!1;if(!e.isPlainObject(u[o])||n==s)return u[o]!==i?(l=u[o],!1):(a.error(g.method,t),!1);u=u[o]}})),e.isFunction(l)?c=l.apply(o,n):l!==i&&(c=l),e.isArray(r)?r.push(c):r!==i?r=[r,c]:c!==i&&(r=c),l}},u?(y===i&&a.initialize(),a.invoke(c)):(y!==i&&a.destroy(),a.initialize()),r!==i?r:this},e.site.settings={name:"Site",namespace:"site",error:{console:"Console cannot be restored, most likely it was overwritten outside of module",method:"The method you called is not defined."},debug:!1,verbose:!1,performance:!0,modules:["accordion","api","checkbox","dimmer","dropdown","embed","form","modal","nag","popup","rating","shape","sidebar","state","sticky","tab","transition","visit","visibility"],siteNamespace:"site",namespaceStub:{cache:{},config:{},sections:{},section:{},utilities:{}}},e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(n){return!!e.data(n,t)}}):function(t,n,i){return!!e.data(t,i[3])}})}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.form=function(t){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u=arguments[1],d="string"==typeof c,f=[].slice.call(arguments,1);return a.each(function(){var m,g,p,h,v,b,y,x,C,w,k,S,T,A,R,P,E,F,O,D=e(this),q=this,j=[],z=!1;O={initialize:function(){O.get.settings(),d?(F===i&&O.instantiate(),O.invoke(c)):(F!==i&&F.invoke("destroy"),O.verbose("Initializing form validation",D,x),O.bindEvents(),O.set.defaults(),O.instantiate())},instantiate:function(){O.verbose("Storing instance of module",O),F=O,D.data(P,O)},destroy:function(){O.verbose("Destroying previous module",F),O.removeEvents(),D.removeData(P)},refresh:function(){O.verbose("Refreshing selector cache"),m=D.find(k.field),g=D.find(k.group),p=D.find(k.message),h=D.find(k.prompt),v=D.find(k.submit),b=D.find(k.clear),y=D.find(k.reset)},submit:function(){O.verbose("Submitting form",D),D.submit()},attachEvents:function(t,n){n=n||"submit",e(t).on("click"+E,function(e){O[n](),e.preventDefault()})},bindEvents:function(){O.verbose("Attaching form events"),D.on("submit"+E,O.validate.form).on("blur"+E,k.field,O.event.field.blur).on("click"+E,k.submit,O.submit).on("click"+E,k.reset,O.reset).on("click"+E,k.clear,O.clear),x.keyboardShortcuts&&D.on("keydown"+E,k.field,O.event.field.keydown),m.each(function(){var t=e(this),n=t.prop("type"),i=O.get.changeEvent(n,t);e(this).on(i+E,O.event.field.change)})},clear:function(){m.each(function(){var t=e(this),n=t.parent(),i=t.closest(g),o=i.find(k.prompt),a=t.data(w.defaultValue)||"",r=n.is(k.uiCheckbox),s=n.is(k.uiDropdown),l=i.hasClass(S.error);l&&(O.verbose("Resetting error on field",i),i.removeClass(S.error),o.remove()),s?(O.verbose("Resetting dropdown value",n,a),n.dropdown("clear")):r?t.prop("checked",!1):(O.verbose("Resetting field value",t,a),t.val(""))})},reset:function(){m.each(function(){var t=e(this),n=t.parent(),o=t.closest(g),a=o.find(k.prompt),r=t.data(w.defaultValue),s=n.is(k.uiCheckbox),l=n.is(k.uiDropdown),c=o.hasClass(S.error);r!==i&&(c&&(O.verbose("Resetting error on field",o),o.removeClass(S.error),a.remove()),l?(O.verbose("Resetting dropdown value",n,r),n.dropdown("restore defaults")):s?(O.verbose("Resetting checkbox value",n,r),t.prop("checked",r)):(O.verbose("Resetting field value",t,r),t.val(r)))})},determine:{isValid:function(){var t=!0;return e.each(C,function(e,n){O.validate.field(n,e,!0)||(t=!1)}),t}},is:{bracketedRule:function(e){return e.type&&e.type.match(x.regExp.bracket)},empty:function(e){return e&&0!==e.length?e.is('input[type="checkbox"]')?!e.is(":checked"):O.is.blank(e):!0},blank:function(t){return""===e.trim(t.val())},valid:function(t){var n=!0;return t?(O.verbose("Checking if field is valid",t),O.validate.field(C[t],t,!1)):(O.verbose("Checking if form is valid"),e.each(C,function(e,t){O.is.valid(e)||(n=!1)}),n)}},removeEvents:function(){D.off(E),m.off(E),v.off(E),m.off(E)},event:{field:{keydown:function(t){var n=e(this),i=t.which,o=n.is(k.input),a=n.is(k.checkbox),r=n.closest(k.uiDropdown).length>0,s={enter:13,escape:27};i==s.escape&&(O.verbose("Escape key pressed blurring field"),n.blur()),t.ctrlKey||i!=s.enter||!o||r||a||(z||(n.one("keyup"+E,O.event.field.keyup),O.submit(),O.debug("Enter pressed on input submitting form")),z=!0)},keyup:function(){z=!1},blur:function(t){var n=e(this),i=n.closest(g),o=O.get.validation(n);i.hasClass(S.error)?(O.debug("Revalidating field",n,o),o&&O.validate.field(o)):"blur"!=x.on&&"change"!=x.on||o&&O.validate.field(o)},change:function(t){var n=e(this),i=n.closest(g),o=O.get.validation(n);o&&("change"==x.on||i.hasClass(S.error)&&x.revalidate)&&(clearTimeout(O.timer),O.timer=setTimeout(function(){O.debug("Revalidating field",n,O.get.validation(n)),O.validate.field(o)},x.delay))}}},get:{ancillaryValue:function(e){return e.type&&(e.value||O.is.bracketedRule(e))?e.value!==i?e.value:e.type.match(x.regExp.bracket)[1]+"":!1},ruleName:function(e){return O.is.bracketedRule(e)?e.type.replace(e.type.match(x.regExp.bracket)[0],""):e.type},changeEvent:function(e,t){return"checkbox"==e||"radio"==e||"hidden"==e||t.is("select")?"change":O.get.inputEvent()},inputEvent:function(){return n.createElement("input").oninput!==i?"input":n.createElement("input").onpropertychange!==i?"propertychange":"keyup"},prompt:function(e,t){var n,i,o,a=O.get.ruleName(e),r=O.get.ancillaryValue(e),s=e.prompt||x.prompt[a]||x.text.unspecifiedRule,l=-1!==s.search("{value}"),c=-1!==s.search("{name}");return(c||l)&&(i=O.get.field(t.identifier)),l&&(s=s.replace("{value}",i.val())),c&&(n=i.closest(k.group).find("label").eq(0),o=1==n.length?n.text():i.prop("placeholder")||x.text.unspecifiedField,s=s.replace("{name}",o)),s=s.replace("{identifier}",t.identifier),s=s.replace("{ruleValue}",r),e.prompt||O.verbose("Using default validation prompt for type",s,a),s},settings:function(){if(e.isPlainObject(t)){var n,o=Object.keys(t),a=o.length>0?t[o[0]].identifier!==i&&t[o[0]].rules!==i:!1;a?(x=e.extend(!0,{},e.fn.form.settings,u),C=e.extend({},e.fn.form.settings.defaults,t),O.error(x.error.oldSyntax,q),O.verbose("Extending settings from legacy parameters",C,x)):(t.fields&&(n=Object.keys(t.fields),("string"==typeof t.fields[n[0]]||e.isArray(t.fields[n[0]]))&&e.each(t.fields,function(n,i){"string"==typeof i&&(i=[i]),t.fields[n]={rules:[]},e.each(i,function(e,i){t.fields[n].rules.push({type:i})})})),x=e.extend(!0,{},e.fn.form.settings,t),C=e.extend({},e.fn.form.settings.defaults,x.fields),O.verbose("Extending settings",C,x))}else x=e.fn.form.settings,C=e.fn.form.settings.defaults,O.verbose("Using default form validation",C,x);R=x.namespace,w=x.metadata,k=x.selector,S=x.className,T=x.regExp,A=x.error,P="module-"+R,E="."+R,F=D.data(P),O.refresh()},field:function(t){return O.verbose("Finding field with identifier",t),t=O.escape.string(t),m.filter("#"+t).length>0?m.filter("#"+t):m.filter('[name="'+t+'"]').length>0?m.filter('[name="'+t+'"]'):m.filter('[name="'+t+'[]"]').length>0?m.filter('[name="'+t+'[]"]'):m.filter("[data-"+w.validate+'="'+t+'"]').length>0?m.filter("[data-"+w.validate+'="'+t+'"]'):e("<input/>")},fields:function(t){var n=e();return e.each(t,function(e,t){n=n.add(O.get.field(t))}),n},validation:function(t){var n,i;return C?(e.each(C,function(e,o){i=o.identifier||e,O.get.field(i)[0]==t[0]&&(o.identifier=i,n=o)}),n||!1):!1},value:function(e){var t,n=[];return n.push(e),t=O.get.values.call(q,n),t[e]},values:function(t){var n=e.isArray(t)?O.get.fields(t):m,i={};return n.each(function(t,n){var o=e(n),a=(o.prop("type"),o.prop("name")),r=o.val(),s=o.is(k.checkbox),l=o.is(k.radio),c=-1!==a.indexOf("[]"),u=s?o.is(":checked"):!1;a&&(c?(a=a.replace("[]",""),i[a]||(i[a]=[]),s?u?i[a].push(r||!0):i[a].push(!1):i[a].push(r)):l?u&&(i[a]=r):s?u?i[a]=r||!0:i[a]=!1:i[a]=r)}),i}},has:{field:function(e){return O.verbose("Checking for existence of a field with identifier",e),e=O.escape.string(e),"string"!=typeof e&&O.error(A.identifier,e),m.filter("#"+e).length>0?!0:m.filter('[name="'+e+'"]').length>0?!0:m.filter("[data-"+w.validate+'="'+e+'"]').length>0}},escape:{string:function(e){return e=String(e),e.replace(T.escape,"\\$&")}},add:{prompt:function(t,n){var o=O.get.field(t),a=o.closest(g),r=a.children(k.prompt),s=0!==r.length;n="string"==typeof n?[n]:n,O.verbose("Adding field error state",t),a.addClass(S.error),x.inline&&(s||(r=x.templates.prompt(n),r.appendTo(a)),r.html(n[0]),s?O.verbose("Inline errors are disabled, no inline error added",t):x.transition&&e.fn.transition!==i&&D.transition("is supported")?(O.verbose("Displaying error with css transition",x.transition),r.transition(x.transition+" in",x.duration)):(O.verbose("Displaying error with fallback javascript animation"),r.fadeIn(x.duration)))},errors:function(e){O.debug("Adding form error messages",e),O.set.error(),p.html(x.templates.error(e))}},remove:{prompt:function(t){var n=O.get.field(t),o=n.closest(g),a=o.children(k.prompt);o.removeClass(S.error),x.inline&&a.is(":visible")&&(O.verbose("Removing prompt for field",t),x.transition&&e.fn.transition!==i&&D.transition("is supported")?a.transition(x.transition+" out",x.duration,function(){a.remove()}):a.fadeOut(x.duration,function(){a.remove()}))}},set:{success:function(){D.removeClass(S.error).addClass(S.success)},defaults:function(){m.each(function(){var t=e(this),n=t.filter(k.checkbox).length>0,i=n?t.is(":checked"):t.val();t.data(w.defaultValue,i)})},error:function(){D.removeClass(S.success).addClass(S.error)},value:function(e,t){var n={};return n[e]=t,O.set.values.call(q,n)},values:function(t){e.isEmptyObject(t)||e.each(t,function(t,n){var i,o=O.get.field(t),a=o.parent(),r=e.isArray(n),s=a.is(k.uiCheckbox),l=a.is(k.uiDropdown),c=o.is(k.radio)&&s,u=o.length>0;u&&(r&&s?(O.verbose("Selecting multiple",n,o),a.checkbox("uncheck"),e.each(n,function(e,t){i=o.filter('[value="'+t+'"]'),a=i.parent(),i.length>0&&a.checkbox("check")})):c?(O.verbose("Selecting radio value",n,o),o.filter('[value="'+n+'"]').parent(k.uiCheckbox).checkbox("check")):s?(O.verbose("Setting checkbox value",n,a),n===!0?a.checkbox("check"):a.checkbox("uncheck")):l?(O.verbose("Setting dropdown value",n,a),a.dropdown("set selected",n)):(O.verbose("Setting field value",n,o),o.val(n)))})}},validate:{form:function(e,t){var n=O.get.values();if(z)return!1;if(j=[],O.determine.isValid()){if(O.debug("Form has no validation errors, submitting"),O.set.success(),t!==!0)return x.onSuccess.call(q,e,n)}else if(O.debug("Form has errors"),O.set.error(),x.inline||O.add.errors(j),D.data("moduleApi")!==i&&e.stopImmediatePropagation(),t!==!0)return x.onFailure.call(q,j,n)},field:function(t,n,o){o=o!==i?o:!0,"string"==typeof t&&(O.verbose("Validating field",t),n=t,t=C[t]);var a=t.identifier||n,r=O.get.field(a),s=t.depends?O.get.field(t.depends):!1,l=!0,c=[];return t.identifier||(O.debug("Using field name as identifier",a),t.identifier=a),r.prop("disabled")?(O.debug("Field is disabled. Skipping",a),l=!0):t.optional&&O.is.blank(r)?(O.debug("Field is optional and blank. Skipping",a),l=!0):t.depends&&O.is.empty(s)?(O.debug("Field depends on another value that is not present or empty. Skipping",s),l=!0):t.rules!==i&&e.each(t.rules,function(e,n){O.has.field(a)&&!O.validate.rule(t,n)&&(O.debug("Field is invalid",a,n.type),c.push(O.get.prompt(n,t)),l=!1)}),l?(o&&(O.remove.prompt(a,c),x.onValid.call(r)),!0):(o&&(j=j.concat(c),O.add.prompt(a,c),x.onInvalid.call(r,c)),!1)},rule:function(t,n){var o=O.get.field(t.identifier),a=(n.type,o.val()),r=O.get.ancillaryValue(n),s=O.get.ruleName(n),l=x.rules[s];return e.isFunction(l)?(a=a===i||""===a||null===a?"":e.trim(a+""),l.call(o,a,r)):void O.error(A.noRule,s)}},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,x,t);else{if(n===i)return x[t];x[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,O,t);else{if(n===i)return O[t];O[t]=n}},debug:function(){!x.silent&&x.debug&&(x.performance?O.performance.log(arguments):(O.debug=Function.prototype.bind.call(console.info,console,x.name+":"),O.debug.apply(console,arguments)))},verbose:function(){!x.silent&&x.verbose&&x.debug&&(x.performance?O.performance.log(arguments):(O.verbose=Function.prototype.bind.call(console.info,console,x.name+":"),O.verbose.apply(console,arguments)))},error:function(){x.silent||(O.error=Function.prototype.bind.call(console.error,console,x.name+":"),O.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;x.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:q,"Execution Time":n})),clearTimeout(O.performance.timer),O.performance.timer=setTimeout(O.performance.display,500)},display:function(){var t=x.name+":",n=0;s=!1,clearTimeout(O.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=F;return n=n||f,a=q||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},O.initialize()}),o!==i?o:this},e.fn.form.settings={name:"Form",namespace:"form",debug:!1,verbose:!1,performance:!0,fields:!1,keyboardShortcuts:!0,on:"submit",inline:!1,delay:200,revalidate:!0,transition:"scale",duration:200,onValid:function(){},onInvalid:function(){},onSuccess:function(){return!0},onFailure:function(){return!1},metadata:{defaultValue:"default",validate:"validate"},regExp:{htmlID:/^[a-zA-Z][\w:.-]*$/g,bracket:/\[(.*)\]/i,decimal:/^\d+\.?\d*$/,email:/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,escape:/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,flags:/^\/(.*)\/(.*)?/,integer:/^\-?\d+$/,number:/^\-?\d*(\.\d+)?$/,url:/(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/i},text:{unspecifiedRule:"Please enter a valid value",unspecifiedField:"This field"},prompt:{empty:"{name} must have a value",checked:"{name} must be checked",email:"{name} must be a valid e-mail",url:"{name} must be a valid url",regExp:"{name} is not formatted correctly",integer:"{name} must be an integer",decimal:"{name} must be a decimal number",number:"{name} must be set to a number",is:'{name} must be "{ruleValue}"',isExactly:'{name} must be exactly "{ruleValue}"',not:'{name} cannot be set to "{ruleValue}"',notExactly:'{name} cannot be set to exactly "{ruleValue}"',contain:'{name} cannot contain "{ruleValue}"',containExactly:'{name} cannot contain exactly "{ruleValue}"',doesntContain:'{name} must contain  "{ruleValue}"',doesntContainExactly:'{name} must contain exactly "{ruleValue}"',minLength:"{name} must be at least {ruleValue} characters",length:"{name} must be at least {ruleValue} characters",exactLength:"{name} must be exactly {ruleValue} characters",maxLength:"{name} cannot be longer than {ruleValue} characters",match:"{name} must match {ruleValue} field",different:"{name} must have a different value than {ruleValue} field",creditCard:"{name} must be a valid credit card number",minCount:"{name} must have at least {ruleValue} choices",exactCount:"{name} must have exactly {ruleValue} choices",maxCount:"{name} must have {ruleValue} or less choices"},selector:{checkbox:'input[type="checkbox"], input[type="radio"]',clear:".clear",field:"input, textarea, select",group:".field",input:"input",message:".error.message",prompt:".prompt.label",radio:'input[type="radio"]',reset:'.reset:not([type="reset"])',submit:'.submit:not([type="submit"])',uiCheckbox:".ui.checkbox",uiDropdown:".ui.dropdown"},className:{error:"error",label:"ui prompt label",pressed:"down",success:"success"},error:{identifier:"You must specify a string identifier for each field",method:"The method you called is not defined.",noRule:"There is no rule matching the one you specified",oldSyntax:"Starting in 2.0 forms now only take a single settings object. Validation settings converted to new syntax automatically."},templates:{error:function(t){var n='<ul class="list">';return e.each(t,function(e,t){n+="<li>"+t+"</li>"}),n+="</ul>",e(n)},prompt:function(t){return e("<div/>").addClass("ui basic red pointing prompt label").html(t[0])}},rules:{empty:function(t){return!(t===i||""===t||e.isArray(t)&&0===t.length)},checked:function(){return e(this).filter(":checked").length>0},email:function(t){return e.fn.form.settings.regExp.email.test(t)},url:function(t){return e.fn.form.settings.regExp.url.test(t)},regExp:function(t,n){if(n instanceof RegExp)return t.match(n);var i,o=n.match(e.fn.form.settings.regExp.flags);return o&&(n=o.length>=2?o[1]:n,i=o.length>=3?o[2]:""),t.match(new RegExp(n,i))},integer:function(t,n){var o,a,r,s=e.fn.form.settings.regExp.integer;return n&&-1===["",".."].indexOf(n)&&(-1==n.indexOf("..")?s.test(n)&&(o=a=n-0):(r=n.split("..",2),s.test(r[0])&&(o=r[0]-0),s.test(r[1])&&(a=r[1]-0))),s.test(t)&&(o===i||t>=o)&&(a===i||a>=t)},decimal:function(t){return e.fn.form.settings.regExp.decimal.test(t)},number:function(t){return e.fn.form.settings.regExp.number.test(t)},is:function(e,t){return t="string"==typeof t?t.toLowerCase():t,e="string"==typeof e?e.toLowerCase():e,e==t},isExactly:function(e,t){return e==t},not:function(e,t){return e="string"==typeof e?e.toLowerCase():e,t="string"==typeof t?t.toLowerCase():t,e!=t},notExactly:function(e,t){return e!=t},contains:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1!==t.search(new RegExp(n,"i"))},containsExactly:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1!==t.search(new RegExp(n))},doesntContain:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1===t.search(new RegExp(n,"i"))},doesntContainExactly:function(t,n){return n=n.replace(e.fn.form.settings.regExp.escape,"\\$&"),-1===t.search(new RegExp(n))},minLength:function(e,t){return e!==i?e.length>=t:!1},length:function(e,t){return e!==i?e.length>=t:!1},exactLength:function(e,t){return e!==i?e.length==t:!1},maxLength:function(e,t){return e!==i?e.length<=t:!1},match:function(t,n){var o;e(this);return e('[data-validate="'+n+'"]').length>0?o=e('[data-validate="'+n+'"]').val():e("#"+n).length>0?o=e("#"+n).val():e('[name="'+n+'"]').length>0?o=e('[name="'+n+'"]').val():e('[name="'+n+'[]"]').length>0&&(o=e('[name="'+n+'[]"]')),o!==i?t.toString()==o.toString():!1},different:function(t,n){var o;e(this);return e('[data-validate="'+n+'"]').length>0?o=e('[data-validate="'+n+'"]').val():e("#"+n).length>0?o=e("#"+n).val():e('[name="'+n+'"]').length>0?o=e('[name="'+n+'"]').val():e('[name="'+n+'[]"]').length>0&&(o=e('[name="'+n+'[]"]')),o!==i?t.toString()!==o.toString():!1},creditCard:function(t,n){var i,o,a={visa:{pattern:/^4/,length:[16]},amex:{pattern:/^3[47]/,length:[15]},mastercard:{pattern:/^5[1-5]/,length:[16]},discover:{pattern:/^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,length:[16]},unionPay:{pattern:/^(62|88)/,length:[16,17,18,19]},jcb:{pattern:/^35(2[89]|[3-8][0-9])/,length:[16]},maestro:{pattern:/^(5018|5020|5038|6304|6759|676[1-3])/,length:[12,13,14,15,16,17,18,19]},dinersClub:{pattern:/^(30[0-5]|^36)/,length:[14]},laser:{pattern:/^(6304|670[69]|6771)/,length:[16,17,18,19]},visaElectron:{pattern:/^(4026|417500|4508|4844|491(3|7))/,length:[16]}},r={},s=!1,l="string"==typeof n?n.split(","):!1;if("string"==typeof t&&0!==t.length){if(t=t.replace(/[\-]/g,""),l&&(e.each(l,function(n,i){o=a[i],o&&(r={length:-1!==e.inArray(t.length,o.length),pattern:-1!==t.search(o.pattern)},r.length&&r.pattern&&(s=!0))}),!s))return!1;if(i={number:-1!==e.inArray(t.length,a.unionPay.length),pattern:-1!==t.search(a.unionPay.pattern)},i.number&&i.pattern)return!0;for(var c=t.length,u=0,d=[[0,1,2,3,4,5,6,7,8,9],[0,2,4,6,8,1,3,5,7,9]],f=0;c--;)f+=d[u][parseInt(t.charAt(c),10)],u^=1;return f%10===0&&f>0}},minCount:function(e,t){return 0==t?!0:1==t?""!==e:e.split(",").length>=t},exactCount:function(e,t){return 0==t?""===e:1==t?""!==e&&-1===e.search(","):e.split(",").length==t},maxCount:function(e,t){return 0==t?!1:1==t?-1===e.search(","):e.split(",").length<=t}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.accordion=function(n){var o,a=e(this),r=(new Date).getTime(),s=[],l=arguments[0],c="string"==typeof l,u=[].slice.call(arguments,1);t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return a.each(function(){var d,f,m=e.isPlainObject(n)?e.extend(!0,{},e.fn.accordion.settings,n):e.extend({},e.fn.accordion.settings),g=m.className,p=m.namespace,h=m.selector,v=m.error,b="."+p,y="module-"+p,x=a.selector||"",C=e(this),w=C.find(h.title),k=C.find(h.content),S=this,T=C.data(y);f={initialize:function(){f.debug("Initializing",C),f.bind.events(),m.observeChanges&&f.observeChanges(),f.instantiate()},instantiate:function(){T=f,C.data(y,f)},destroy:function(){f.debug("Destroying previous instance",C),C.off(b).removeData(y)},refresh:function(){w=C.find(h.title),k=C.find(h.content)},observeChanges:function(){"MutationObserver"in t&&(d=new MutationObserver(function(e){f.debug("DOM tree modified, updating selector cache"),f.refresh()}),d.observe(S,{childList:!0,subtree:!0}),f.debug("Setting up mutation observer",d))},bind:{events:function(){f.debug("Binding delegated events"),C.on(m.on+b,h.trigger,f.event.click)}},event:{click:function(){f.toggle.call(this)}},toggle:function(t){var n=t!==i?"number"==typeof t?w.eq(t):e(t).closest(h.title):e(this).closest(h.title),o=n.next(k),a=o.hasClass(g.animating),r=o.hasClass(g.active),s=r&&!a,l=!r&&a;f.debug("Toggling visibility of content",n),s||l?m.collapsible?f.close.call(n):f.debug("Cannot close accordion content collapsing is disabled"):f.open.call(n)},open:function(t){var n=t!==i?"number"==typeof t?w.eq(t):e(t).closest(h.title):e(this).closest(h.title),o=n.next(k),a=o.hasClass(g.animating),r=o.hasClass(g.active),s=r||a;return s?void f.debug("Accordion already open, skipping",o):(f.debug("Opening accordion content",n),m.onOpening.call(o),m.exclusive&&f.closeOthers.call(n),n.addClass(g.active),o.stop(!0,!0).addClass(g.animating),m.animateChildren&&(e.fn.transition!==i&&C.transition("is supported")?o.children().transition({animation:"fade in",queue:!1,useFailSafe:!0,debug:m.debug,verbose:m.verbose,duration:m.duration}):o.children().stop(!0,!0).animate({opacity:1},m.duration,f.resetOpacity)),void o.slideDown(m.duration,m.easing,function(){o.removeClass(g.animating).addClass(g.active),f.reset.display.call(this),m.onOpen.call(this),m.onChange.call(this)}))},close:function(t){var n=t!==i?"number"==typeof t?w.eq(t):e(t).closest(h.title):e(this).closest(h.title),o=n.next(k),a=o.hasClass(g.animating),r=o.hasClass(g.active),s=!r&&a,l=r&&a;!r&&!s||l||(f.debug("Closing accordion content",o),m.onClosing.call(o),n.removeClass(g.active),o.stop(!0,!0).addClass(g.animating),m.animateChildren&&(e.fn.transition!==i&&C.transition("is supported")?o.children().transition({animation:"fade out",queue:!1,useFailSafe:!0,debug:m.debug,verbose:m.verbose,duration:m.duration}):o.children().stop(!0,!0).animate({opacity:0},m.duration,f.resetOpacity)),o.slideUp(m.duration,m.easing,function(){o.removeClass(g.animating).removeClass(g.active),f.reset.display.call(this),m.onClose.call(this),m.onChange.call(this)}))},closeOthers:function(t){var n,o,a,r=t!==i?w.eq(t):e(this).closest(h.title),s=r.parents(h.content).prev(h.title),l=r.closest(h.accordion),c=h.title+"."+g.active+":visible",u=h.content+"."+g.active+":visible";m.closeNested?(n=l.find(c).not(s),a=n.next(k)):(n=l.find(c).not(s),o=l.find(u).find(c).not(s),n=n.not(o),a=n.next(k)),n.length>0&&(f.debug("Exclusive enabled, closing other content",n),n.removeClass(g.active),a.removeClass(g.animating).stop(!0,!0),m.animateChildren&&(e.fn.transition!==i&&C.transition("is supported")?a.children().transition({animation:"fade out",useFailSafe:!0,debug:m.debug,verbose:m.verbose,duration:m.duration}):a.children().stop(!0,!0).animate({opacity:0},m.duration,f.resetOpacity)),a.slideUp(m.duration,m.easing,function(){e(this).removeClass(g.active),f.reset.display.call(this)}))},reset:{display:function(){f.verbose("Removing inline display from element",this),e(this).css("display",""),""===e(this).attr("style")&&e(this).attr("style","").removeAttr("style")},opacity:function(){f.verbose("Removing inline opacity from element",this),e(this).css("opacity",""),""===e(this).attr("style")&&e(this).attr("style","").removeAttr("style")}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){return f.debug("Changing internal",t,n),n===i?f[t]:void(e.isPlainObject(t)?e.extend(!0,f,t):f[t]=n)},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;m.performance&&(t=(new Date).getTime(),i=r||t,n=t-i,r=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:S,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;r=!1,clearTimeout(f.performance.timer),e.each(s,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",x&&(t+=" '"+x+"'"),(console.group!==i||console.table!==i)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,n,a){var r,s,l,c=T;return n=n||u,a=S||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(f.error(v.method,t),!1);c=c[o]}
})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},c?(T===i&&f.initialize(),f.invoke(l)):(T!==i&&T.invoke("destroy"),f.initialize())}),o!==i?o:this},e.fn.accordion.settings={name:"Accordion",namespace:"accordion",silent:!1,debug:!1,verbose:!1,performance:!0,on:"click",observeChanges:!0,exclusive:!0,collapsible:!0,closeNested:!1,animateChildren:!0,duration:350,easing:"easeOutQuad",onOpening:function(){},onOpen:function(){},onClosing:function(){},onClose:function(){},onChange:function(){},error:{method:"The method you called is not defined"},className:{active:"active",animating:"animating"},selector:{accordion:".accordion",title:".title",trigger:".title",content:".content"}},e.extend(e.easing,{easeOutQuad:function(e,t,n,i,o){return-i*(t/=o)*(t-2)+n}})}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.checkbox=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1);return r.each(function(){var r,m,g=e.extend(!0,{},e.fn.checkbox.settings,o),p=g.className,h=g.namespace,v=g.selector,b=g.error,y="."+h,x="module-"+h,C=e(this),w=e(this).children(v.label),k=e(this).children(v.input),S=k[0],T=!1,A=!1,R=C.data(x),P=this;m={initialize:function(){m.verbose("Initializing checkbox",g),m.create.label(),m.bind.events(),m.set.tabbable(),m.hide.input(),m.observeChanges(),m.instantiate(),m.setup()},instantiate:function(){m.verbose("Storing instance of module",m),R=m,C.data(x,m)},destroy:function(){m.verbose("Destroying module"),m.unbind.events(),m.show.input(),C.removeData(x)},fix:{reference:function(){C.is(v.input)&&(m.debug("Behavior called on <input> adjusting invoked element"),C=C.closest(v.checkbox),m.refresh())}},setup:function(){m.set.initialLoad(),m.is.indeterminate()?(m.debug("Initial value is indeterminate"),m.indeterminate()):m.is.checked()?(m.debug("Initial value is checked"),m.check()):(m.debug("Initial value is unchecked"),m.uncheck()),m.remove.initialLoad()},refresh:function(){w=C.children(v.label),k=C.children(v.input),S=k[0]},hide:{input:function(){m.verbose("Modifying <input> z-index to be unselectable"),k.addClass(p.hidden)}},show:{input:function(){m.verbose("Modifying <input> z-index to be selectable"),k.removeClass(p.hidden)}},observeChanges:function(){"MutationObserver"in t&&(r=new MutationObserver(function(e){m.debug("DOM tree modified, updating selector cache"),m.refresh()}),r.observe(P,{childList:!0,subtree:!0}),m.debug("Setting up mutation observer",r))},attachEvents:function(t,n){var i=e(t);n=e.isFunction(m[n])?m[n]:m.toggle,i.length>0?(m.debug("Attaching checkbox events to element",t,n),i.on("click"+y,n)):m.error(b.notFound)},event:{click:function(t){var n=e(t.target);return n.is(v.input)?void m.verbose("Using default check action on initialized checkbox"):n.is(v.link)?void m.debug("Clicking link inside checkbox, skipping toggle"):(m.toggle(),k.focus(),void t.preventDefault())},keydown:function(e){var t=e.which,n={enter:13,space:32,escape:27};t==n.escape?(m.verbose("Escape key pressed blurring field"),k.blur(),A=!0):e.ctrlKey||t!=n.space&&t!=n.enter?A=!1:(m.verbose("Enter/space key pressed, toggling checkbox"),m.toggle(),A=!0)},keyup:function(e){A&&e.preventDefault()}},check:function(){m.should.allowCheck()&&(m.debug("Checking checkbox",k),m.set.checked(),m.should.ignoreCallbacks()||(g.onChecked.call(S),g.onChange.call(S)))},uncheck:function(){m.should.allowUncheck()&&(m.debug("Unchecking checkbox"),m.set.unchecked(),m.should.ignoreCallbacks()||(g.onUnchecked.call(S),g.onChange.call(S)))},indeterminate:function(){return m.should.allowIndeterminate()?void m.debug("Checkbox is already indeterminate"):(m.debug("Making checkbox indeterminate"),m.set.indeterminate(),void(m.should.ignoreCallbacks()||(g.onIndeterminate.call(S),g.onChange.call(S))))},determinate:function(){return m.should.allowDeterminate()?void m.debug("Checkbox is already determinate"):(m.debug("Making checkbox determinate"),m.set.determinate(),void(m.should.ignoreCallbacks()||(g.onDeterminate.call(S),g.onChange.call(S))))},enable:function(){return m.is.enabled()?void m.debug("Checkbox is already enabled"):(m.debug("Enabling checkbox"),m.set.enabled(),g.onEnable.call(S),void g.onEnabled.call(S))},disable:function(){return m.is.disabled()?void m.debug("Checkbox is already disabled"):(m.debug("Disabling checkbox"),m.set.disabled(),g.onDisable.call(S),void g.onDisabled.call(S))},get:{radios:function(){var t=m.get.name();return e('input[name="'+t+'"]').closest(v.checkbox)},otherRadios:function(){return m.get.radios().not(C)},name:function(){return k.attr("name")}},is:{initialLoad:function(){return T},radio:function(){return k.hasClass(p.radio)||"radio"==k.attr("type")},indeterminate:function(){return k.prop("indeterminate")!==i&&k.prop("indeterminate")},checked:function(){return k.prop("checked")!==i&&k.prop("checked")},disabled:function(){return k.prop("disabled")!==i&&k.prop("disabled")},enabled:function(){return!m.is.disabled()},determinate:function(){return!m.is.indeterminate()},unchecked:function(){return!m.is.checked()}},should:{allowCheck:function(){return m.is.determinate()&&m.is.checked()&&!m.should.forceCallbacks()?(m.debug("Should not allow check, checkbox is already checked"),!1):g.beforeChecked.apply(S)===!1?(m.debug("Should not allow check, beforeChecked cancelled"),!1):!0},allowUncheck:function(){return m.is.determinate()&&m.is.unchecked()&&!m.should.forceCallbacks()?(m.debug("Should not allow uncheck, checkbox is already unchecked"),!1):g.beforeUnchecked.apply(S)===!1?(m.debug("Should not allow uncheck, beforeUnchecked cancelled"),!1):!0},allowIndeterminate:function(){return m.is.indeterminate()&&!m.should.forceCallbacks()?(m.debug("Should not allow indeterminate, checkbox is already indeterminate"),!1):g.beforeIndeterminate.apply(S)===!1?(m.debug("Should not allow indeterminate, beforeIndeterminate cancelled"),!1):!0},allowDeterminate:function(){return m.is.determinate()&&!m.should.forceCallbacks()?(m.debug("Should not allow determinate, checkbox is already determinate"),!1):g.beforeDeterminate.apply(S)===!1?(m.debug("Should not allow determinate, beforeDeterminate cancelled"),!1):!0},forceCallbacks:function(){return m.is.initialLoad()&&g.fireOnInit},ignoreCallbacks:function(){return T&&!g.fireOnInit}},can:{change:function(){return!(C.hasClass(p.disabled)||C.hasClass(p.readOnly)||k.prop("disabled")||k.prop("readonly"))},uncheck:function(){return"boolean"==typeof g.uncheckable?g.uncheckable:!m.is.radio()}},set:{initialLoad:function(){T=!0},checked:function(){return m.verbose("Setting class to checked"),C.removeClass(p.indeterminate).addClass(p.checked),m.is.radio()&&m.uncheckOthers(),!m.is.indeterminate()&&m.is.checked()?void m.debug("Input is already checked, skipping input property change"):(m.verbose("Setting state to checked",S),k.prop("indeterminate",!1).prop("checked",!0),void m.trigger.change())},unchecked:function(){return m.verbose("Removing checked class"),C.removeClass(p.indeterminate).removeClass(p.checked),!m.is.indeterminate()&&m.is.unchecked()?void m.debug("Input is already unchecked"):(m.debug("Setting state to unchecked"),k.prop("indeterminate",!1).prop("checked",!1),void m.trigger.change())},indeterminate:function(){return m.verbose("Setting class to indeterminate"),C.addClass(p.indeterminate),m.is.indeterminate()?void m.debug("Input is already indeterminate, skipping input property change"):(m.debug("Setting state to indeterminate"),k.prop("indeterminate",!0),void m.trigger.change())},determinate:function(){return m.verbose("Removing indeterminate class"),C.removeClass(p.indeterminate),m.is.determinate()?void m.debug("Input is already determinate, skipping input property change"):(m.debug("Setting state to determinate"),void k.prop("indeterminate",!1))},disabled:function(){return m.verbose("Setting class to disabled"),C.addClass(p.disabled),m.is.disabled()?void m.debug("Input is already disabled, skipping input property change"):(m.debug("Setting state to disabled"),k.prop("disabled","disabled"),void m.trigger.change())},enabled:function(){return m.verbose("Removing disabled class"),C.removeClass(p.disabled),m.is.enabled()?void m.debug("Input is already enabled, skipping input property change"):(m.debug("Setting state to enabled"),k.prop("disabled",!1),void m.trigger.change())},tabbable:function(){m.verbose("Adding tabindex to checkbox"),k.attr("tabindex")===i&&k.attr("tabindex",0)}},remove:{initialLoad:function(){T=!1}},trigger:{change:function(){var e=n.createEvent("HTMLEvents"),t=k[0];t&&(m.verbose("Triggering native change event"),e.initEvent("change",!0,!1),t.dispatchEvent(e))}},create:{label:function(){k.prevAll(v.label).length>0?(k.prev(v.label).detach().insertAfter(k),m.debug("Moving existing label",w)):m.has.label()||(w=e("<label>").insertAfter(k),m.debug("Creating label",w))}},has:{label:function(){return w.length>0}},bind:{events:function(){m.verbose("Attaching checkbox events"),C.on("click"+y,m.event.click).on("keydown"+y,v.input,m.event.keydown).on("keyup"+y,v.input,m.event.keyup)}},unbind:{events:function(){m.debug("Removing events"),C.off(y)}},uncheckOthers:function(){var e=m.get.otherRadios();m.debug("Unchecking other radios",e),e.removeClass(p.checked)},toggle:function(){return m.can.change()?void(m.is.indeterminate()||m.is.unchecked()?(m.debug("Currently unchecked"),m.check()):m.is.checked()&&m.can.uncheck()&&(m.debug("Currently checked"),m.uncheck())):void(m.is.radio()||m.debug("Checkbox is read-only or disabled, ignoring toggle"))},setting:function(t,n){if(m.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];e.isPlainObject(g[t])?e.extend(!0,g[t],n):g[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];m[t]=n}},debug:function(){!g.silent&&g.debug&&(g.performance?m.performance.log(arguments):(m.debug=Function.prototype.bind.call(console.info,console,g.name+":"),m.debug.apply(console,arguments)))},verbose:function(){!g.silent&&g.verbose&&g.debug&&(g.performance?m.performance.log(arguments):(m.verbose=Function.prototype.bind.call(console.info,console,g.name+":"),m.verbose.apply(console,arguments)))},error:function(){g.silent||(m.error=Function.prototype.bind.call(console.error,console,g.name+":"),m.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;g.performance&&(t=(new Date).getTime(),i=l||t,n=t-i,l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:P,"Execution Time":n})),clearTimeout(m.performance.timer),m.performance.timer=setTimeout(m.performance.display,500)},display:function(){var t=g.name+":",n=0;l=!1,clearTimeout(m.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=R;return n=n||f,o=P||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(m.error(b.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(R===i&&m.initialize(),m.invoke(u)):(R!==i&&R.invoke("destroy"),m.initialize())}),a!==i?a:this},e.fn.checkbox.settings={name:"Checkbox",namespace:"checkbox",silent:!1,debug:!1,verbose:!0,performance:!0,uncheckable:"auto",fireOnInit:!1,onChange:function(){},beforeChecked:function(){},beforeUnchecked:function(){},beforeDeterminate:function(){},beforeIndeterminate:function(){},onChecked:function(){},onUnchecked:function(){},onDeterminate:function(){},onIndeterminate:function(){},onEnable:function(){},onDisable:function(){},onEnabled:function(){},onDisabled:function(){},className:{checked:"checked",indeterminate:"indeterminate",disabled:"disabled",hidden:"hidden",radio:"radio",readOnly:"read-only"},error:{method:"The method you called is not defined"},selector:{checkbox:".ui.checkbox",label:"label, .box",input:'input[type="checkbox"], input[type="radio"]',link:"a[href]"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.dimmer=function(t){var o,a=e(this),r=(new Date).getTime(),s=[],l=arguments[0],c="string"==typeof l,u=[].slice.call(arguments,1);return a.each(function(){var d,f,m,g=e.isPlainObject(t)?e.extend(!0,{},e.fn.dimmer.settings,t):e.extend({},e.fn.dimmer.settings),p=g.selector,h=g.namespace,v=g.className,b=g.error,y="."+h,x="module-"+h,C=a.selector||"",w="ontouchstart"in n.documentElement?"touchstart":"click",k=e(this),S=this,T=k.data(x);m={preinitialize:function(){m.is.dimmer()?(f=k.parent(),d=k):(f=k,d=m.has.dimmer()?g.dimmerName?f.find(p.dimmer).filter("."+g.dimmerName):f.find(p.dimmer):m.create(),m.set.variation())},initialize:function(){m.debug("Initializing dimmer",g),m.bind.events(),m.set.dimmable(),m.instantiate()},instantiate:function(){m.verbose("Storing instance of module",m),T=m,k.data(x,T)},destroy:function(){m.verbose("Destroying previous module",d),m.unbind.events(),m.remove.variation(),f.off(y)},bind:{events:function(){"hover"==g.on?f.on("mouseenter"+y,m.show).on("mouseleave"+y,m.hide):"click"==g.on&&f.on(w+y,m.toggle),m.is.page()&&(m.debug("Setting as a page dimmer",f),m.set.pageDimmer()),m.is.closable()&&(m.verbose("Adding dimmer close event",d),f.on(w+y,p.dimmer,m.event.click))}},unbind:{events:function(){k.removeData(x),f.off(y)}},event:{click:function(t){m.verbose("Determining if event occured on dimmer",t),(0===d.find(t.target).length||e(t.target).is(p.content))&&(m.hide(),t.stopImmediatePropagation())}},addContent:function(t){var n=e(t);m.debug("Add content to dimmer",n),n.parent()[0]!==d[0]&&n.detach().appendTo(d)},create:function(){var t=e(g.template.dimmer());return g.dimmerName&&(m.debug("Creating named dimmer",g.dimmerName),t.addClass(g.dimmerName)),t.appendTo(f),t},show:function(t){t=e.isFunction(t)?t:function(){},m.debug("Showing dimmer",d,g),m.is.dimmed()&&!m.is.animating()||!m.is.enabled()?m.debug("Dimmer is already shown or disabled"):(m.animate.show(t),g.onShow.call(S),g.onChange.call(S))},hide:function(t){t=e.isFunction(t)?t:function(){},m.is.dimmed()||m.is.animating()?(m.debug("Hiding dimmer",d),m.animate.hide(t),g.onHide.call(S),g.onChange.call(S)):m.debug("Dimmer is not visible")},toggle:function(){m.verbose("Toggling dimmer visibility",d),m.is.dimmed()?m.hide():m.show()},animate:{show:function(t){t=e.isFunction(t)?t:function(){},g.useCSS&&e.fn.transition!==i&&d.transition("is supported")?("auto"!==g.opacity&&m.set.opacity(),d.transition({animation:g.transition+" in",queue:!1,duration:m.get.duration(),useFailSafe:!0,onStart:function(){m.set.dimmed()},onComplete:function(){m.set.active(),t()}})):(m.verbose("Showing dimmer animation with javascript"),m.set.dimmed(),"auto"==g.opacity&&(g.opacity=.8),d.stop().css({opacity:0,width:"100%",height:"100%"}).fadeTo(m.get.duration(),g.opacity,function(){d.removeAttr("style"),m.set.active(),t()}))},hide:function(t){t=e.isFunction(t)?t:function(){},g.useCSS&&e.fn.transition!==i&&d.transition("is supported")?(m.verbose("Hiding dimmer with css"),d.transition({animation:g.transition+" out",queue:!1,duration:m.get.duration(),useFailSafe:!0,onStart:function(){m.remove.dimmed()},onComplete:function(){m.remove.active(),t()}})):(m.verbose("Hiding dimmer with javascript"),m.remove.dimmed(),d.stop().fadeOut(m.get.duration(),function(){m.remove.active(),d.removeAttr("style"),t()}))}},get:{dimmer:function(){return d},duration:function(){return"object"==typeof g.duration?m.is.active()?g.duration.hide:g.duration.show:g.duration}},has:{dimmer:function(){return g.dimmerName?k.find(p.dimmer).filter("."+g.dimmerName).length>0:k.find(p.dimmer).length>0}},is:{active:function(){return d.hasClass(v.active)},animating:function(){return d.is(":animated")||d.hasClass(v.animating)},closable:function(){return"auto"==g.closable?"hover"!=g.on:g.closable},dimmer:function(){return k.hasClass(v.dimmer)},dimmable:function(){return k.hasClass(v.dimmable)},dimmed:function(){return f.hasClass(v.dimmed)},disabled:function(){return f.hasClass(v.disabled)},enabled:function(){return!m.is.disabled()},page:function(){return f.is("body")},pageDimmer:function(){return d.hasClass(v.pageDimmer)}},can:{show:function(){return!d.hasClass(v.disabled)}},set:{opacity:function(e){var t=d.css("background-color"),n=t.split(","),i=n&&3==n.length,o=n&&4==n.length;e=0===g.opacity?0:g.opacity||e,i||o?(n[3]=e+")",t=n.join(",")):t="rgba(0, 0, 0, "+e+")",m.debug("Setting opacity to",e),d.css("background-color",t)},active:function(){d.addClass(v.active)},dimmable:function(){f.addClass(v.dimmable)},dimmed:function(){f.addClass(v.dimmed)},pageDimmer:function(){d.addClass(v.pageDimmer)},disabled:function(){d.addClass(v.disabled)},variation:function(e){e=e||g.variation,e&&d.addClass(e)}},remove:{active:function(){d.removeClass(v.active)},dimmed:function(){f.removeClass(v.dimmed)},disabled:function(){d.removeClass(v.disabled)},variation:function(e){e=e||g.variation,e&&d.removeClass(e)}},setting:function(t,n){if(m.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];e.isPlainObject(g[t])?e.extend(!0,g[t],n):g[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];m[t]=n}},debug:function(){!g.silent&&g.debug&&(g.performance?m.performance.log(arguments):(m.debug=Function.prototype.bind.call(console.info,console,g.name+":"),m.debug.apply(console,arguments)))},verbose:function(){!g.silent&&g.verbose&&g.debug&&(g.performance?m.performance.log(arguments):(m.verbose=Function.prototype.bind.call(console.info,console,g.name+":"),m.verbose.apply(console,arguments)))},error:function(){g.silent||(m.error=Function.prototype.bind.call(console.error,console,g.name+":"),m.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;g.performance&&(t=(new Date).getTime(),i=r||t,n=t-i,r=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:S,"Execution Time":n})),clearTimeout(m.performance.timer),m.performance.timer=setTimeout(m.performance.display,500)},display:function(){var t=g.name+":",n=0;r=!1,clearTimeout(m.performance.timer),e.each(s,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",C&&(t+=" '"+C+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,n,a){var r,s,l,c=T;return n=n||u,a=S||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(m.error(b.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},m.preinitialize(),c?(T===i&&m.initialize(),m.invoke(l)):(T!==i&&T.invoke("destroy"),m.initialize())}),o!==i?o:this},e.fn.dimmer.settings={name:"Dimmer",namespace:"dimmer",silent:!1,debug:!1,verbose:!1,performance:!0,dimmerName:!1,variation:!1,closable:"auto",useCSS:!0,transition:"fade",on:!1,opacity:"auto",duration:{show:500,hide:500},onChange:function(){},onShow:function(){},onHide:function(){},error:{method:"The method you called is not defined."},className:{active:"active",animating:"animating",dimmable:"dimmable",dimmed:"dimmed",dimmer:"dimmer",disabled:"disabled",hide:"hide",pageDimmer:"page",show:"show"},selector:{dimmer:"> .ui.dimmer",content:".ui.dimmer > .content, .ui.dimmer > .content > .center"},template:{dimmer:function(){return e("<div />").attr("class","ui dimmer")}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.dropdown=function(o){var a,r=e(this),s=e(n),l=r.selector||"",c="ontouchstart"in n.documentElement,u=(new Date).getTime(),d=[],f=arguments[0],m="string"==typeof f,g=[].slice.call(arguments,1);return r.each(function(p){var h,v,b,y,x,C,w,k,S=e.isPlainObject(o)?e.extend(!0,{},e.fn.dropdown.settings,o):e.extend({},e.fn.dropdown.settings),T=S.className,A=S.message,R=S.fields,P=S.keys,E=S.metadata,F=S.namespace,O=S.regExp,D=S.selector,q=S.error,j=S.templates,z="."+F,I="module-"+F,M=e(this),L=e(S.context),N=M.find(D.text),V=M.find(D.search),H=M.find(D.sizer),U=M.find(D.input),W=M.find(D.icon),B=M.prev().find(D.text).length>0?M.prev().find(D.text):M.prev(),Q=M.children(D.menu),X=Q.find(D.item),$=!1,Y=!1,Z=!1,K=this,J=M.data(I);k={initialize:function(){k.debug("Initializing dropdown",S),k.is.alreadySetup()?k.setup.reference():(k.setup.layout(),k.refreshData(),k.save.defaults(),k.restore.selected(),k.create.id(),k.bind.events(),k.observeChanges(),k.instantiate())},instantiate:function(){k.verbose("Storing instance of dropdown",k),J=k,M.data(I,k)},destroy:function(){k.verbose("Destroying previous dropdown",M),k.remove.tabbable(),M.off(z).removeData(I),Q.off(z),s.off(y),k.disconnect.menuObserver(),k.disconnect.selectObserver()},observeChanges:function(){"MutationObserver"in t&&(C=new MutationObserver(k.event.select.mutation),w=new MutationObserver(k.event.menu.mutation),k.debug("Setting up mutation observer",C,w),k.observe.select(),k.observe.menu())},disconnect:{menuObserver:function(){w&&w.disconnect()},selectObserver:function(){C&&C.disconnect()}},observe:{select:function(){k.has.input()&&C.observe(U[0],{childList:!0,subtree:!0})},menu:function(){k.has.menu()&&w.observe(Q[0],{childList:!0,subtree:!0})}},create:{id:function(){x=(Math.random().toString(16)+"000000000").substr(2,8),y="."+x,k.verbose("Creating unique id for element",x)},userChoice:function(t){var n,o,a;return(t=t||k.get.userValues())?(t=e.isArray(t)?t:[t],e.each(t,function(t,r){k.get.item(r)===!1&&(a=S.templates.addition(k.add.variables(A.addResult,r)),o=e("<div />").html(a).attr("data-"+E.value,r).attr("data-"+E.text,r).addClass(T.addition).addClass(T.item),S.hideAdditions&&o.addClass(T.hidden),n=n===i?o:n.add(o),k.verbose("Creating user choices for value",r,o))}),n):!1},userLabels:function(t){var n=k.get.userValues();n&&(k.debug("Adding user labels",n),e.each(n,function(e,t){k.verbose("Adding custom user value"),k.add.label(t,t)}))},menu:function(){Q=e("<div />").addClass(T.menu).appendTo(M)},sizer:function(){H=e("<span />").addClass(T.sizer).insertAfter(V)}},search:function(e){e=e!==i?e:k.get.query(),k.verbose("Searching for query",e),k.has.minCharacters(e)?k.filter(e):k.hide()},select:{firstUnfiltered:function(){k.verbose("Selecting first non-filtered element"),k.remove.selectedItem(),X.not(D.unselectable).not(D.addition+D.hidden).eq(0).addClass(T.selected)},nextAvailable:function(e){e=e.eq(0);var t=e.nextAll(D.item).not(D.unselectable).eq(0),n=e.prevAll(D.item).not(D.unselectable).eq(0),i=t.length>0;i?(k.verbose("Moving selection to",t),t.addClass(T.selected)):(k.verbose("Moving selection to",n),n.addClass(T.selected))}},setup:{api:function(){var e={debug:S.debug,urlData:{value:k.get.value(),query:k.get.query()},on:!1};k.verbose("First request, initializing API"),M.api(e)},layout:function(){M.is("select")&&(k.setup.select(),k.setup.returnedObject()),k.has.menu()||k.create.menu(),k.is.search()&&!k.has.search()&&(k.verbose("Adding search input"),V=e("<input />").addClass(T.search).prop("autocomplete","off").insertBefore(N)),k.is.multiple()&&k.is.searchSelection()&&!k.has.sizer()&&k.create.sizer(),S.allowTab&&k.set.tabbable()},select:function(){var t=k.get.selectValues();k.debug("Dropdown initialized on a select",t),M.is("select")&&(U=M),U.parent(D.dropdown).length>0?(k.debug("UI dropdown already exists. Creating dropdown menu only"),M=U.closest(D.dropdown),k.has.menu()||k.create.menu(),Q=M.children(D.menu),k.setup.menu(t)):(k.debug("Creating entire dropdown from select"),M=e("<div />").attr("class",U.attr("class")).addClass(T.selection).addClass(T.dropdown).html(j.dropdown(t)).insertBefore(U),U.hasClass(T.multiple)&&U.prop("multiple")===!1&&(k.error(q.missingMultiple),U.prop("multiple",!0)),U.is("[multiple]")&&k.set.multiple(),U.prop("disabled")&&(k.debug("Disabling dropdown"),M.addClass(T.disabled)),U.removeAttr("class").detach().prependTo(M)),k.refresh()},menu:function(e){Q.html(j.menu(e,R)),X=Q.find(D.item)},reference:function(){k.debug("Dropdown behavior was called on select, replacing with closest dropdown"),M=M.parent(D.dropdown),k.refresh(),k.setup.returnedObject(),m&&(J=k,k.invoke(f))},returnedObject:function(){var e=r.slice(0,p),t=r.slice(p+1);r=e.add(M).add(t)}},refresh:function(){k.refreshSelectors(),k.refreshData()},refreshItems:function(){X=Q.find(D.item)},refreshSelectors:function(){k.verbose("Refreshing selector cache"),N=M.find(D.text),V=M.find(D.search),U=M.find(D.input),W=M.find(D.icon),B=M.prev().find(D.text).length>0?M.prev().find(D.text):M.prev(),Q=M.children(D.menu),X=Q.find(D.item)},refreshData:function(){k.verbose("Refreshing cached metadata"),X.removeData(E.text).removeData(E.value)},clearData:function(){k.verbose("Clearing metadata"),X.removeData(E.text).removeData(E.value),M.removeData(E.defaultText).removeData(E.defaultValue).removeData(E.placeholderText)},toggle:function(){k.verbose("Toggling menu visibility"),k.is.active()?k.hide():k.show()},show:function(t){if(t=e.isFunction(t)?t:function(){},!k.can.show()&&k.is.remote()&&(k.debug("No API results retrieved, searching before show"),k.queryRemote(k.get.query(),k.show)),k.can.show()&&!k.is.active()){if(k.debug("Showing dropdown"),!k.has.message()||k.has.maxSelections()||k.has.allResultsFiltered()||k.remove.message(),k.is.allFiltered())return!0;S.onShow.call(K)!==!1&&k.animate.show(function(){k.can.click()&&k.bind.intent(),k.has.menuSearch()&&k.focusSearch(),k.set.visible(),t.call(K)})}},hide:function(t){t=e.isFunction(t)?t:function(){},k.is.active()&&(k.debug("Hiding dropdown"),S.onHide.call(K)!==!1&&k.animate.hide(function(){k.remove.visible(),t.call(K)}))},hideOthers:function(){k.verbose("Finding other dropdowns to hide"),r.not(M).has(D.menu+"."+T.visible).dropdown("hide")},hideMenu:function(){k.verbose("Hiding menu  instantaneously"),k.remove.active(),k.remove.visible(),Q.transition("hide")},hideSubMenus:function(){var e=Q.children(D.item).find(D.menu);k.verbose("Hiding sub menus",e),e.transition("hide")},bind:{events:function(){c&&k.bind.touchEvents(),k.bind.keyboardEvents(),k.bind.inputEvents(),k.bind.mouseEvents()},touchEvents:function(){k.debug("Touch device detected binding additional touch events"),k.is.searchSelection()||k.is.single()&&M.on("touchstart"+z,k.event.test.toggle),Q.on("touchstart"+z,D.item,k.event.item.mouseenter)},keyboardEvents:function(){k.verbose("Binding keyboard events"),M.on("keydown"+z,k.event.keydown),k.has.search()&&M.on(k.get.inputEvent()+z,D.search,k.event.input),k.is.multiple()&&s.on("keydown"+y,k.event.document.keydown)},inputEvents:function(){k.verbose("Binding input change events"),M.on("change"+z,D.input,k.event.change)},mouseEvents:function(){k.verbose("Binding mouse events"),k.is.multiple()&&M.on("click"+z,D.label,k.event.label.click).on("click"+z,D.remove,k.event.remove.click),k.is.searchSelection()?(M.on("mousedown"+z,k.event.mousedown).on("mouseup"+z,k.event.mouseup).on("mousedown"+z,D.menu,k.event.menu.mousedown).on("mouseup"+z,D.menu,k.event.menu.mouseup).on("click"+z,D.icon,k.event.icon.click).on("focus"+z,D.search,k.event.search.focus).on("click"+z,D.search,k.event.search.focus).on("blur"+z,D.search,k.event.search.blur).on("click"+z,D.text,k.event.text.focus),k.is.multiple()&&M.on("click"+z,k.event.click)):("click"==S.on?M.on("click"+z,D.icon,k.event.icon.click).on("click"+z,k.event.test.toggle):"hover"==S.on?M.on("mouseenter"+z,k.delay.show).on("mouseleave"+z,k.delay.hide):M.on(S.on+z,k.toggle),M.on("mousedown"+z,k.event.mousedown).on("mouseup"+z,k.event.mouseup).on("focus"+z,k.event.focus),k.has.menuSearch()?M.on("blur"+z,D.search,k.event.search.blur):M.on("blur"+z,k.event.blur)),Q.on("mouseenter"+z,D.item,k.event.item.mouseenter).on("mouseleave"+z,D.item,k.event.item.mouseleave).on("click"+z,D.item,k.event.item.click)},intent:function(){k.verbose("Binding hide intent event to document"),c&&s.on("touchstart"+y,k.event.test.touch).on("touchmove"+y,k.event.test.touch),s.on("click"+y,k.event.test.hide)}},unbind:{intent:function(){k.verbose("Removing hide intent event from document"),c&&s.off("touchstart"+y).off("touchmove"+y),s.off("click"+y)}},filter:function(e){var t=e!==i?e:k.get.query(),n=function(){k.is.multiple()&&k.filterActive(),k.select.firstUnfiltered(),k.has.allResultsFiltered()?S.onNoResults.call(K,t)?S.allowAdditions?S.hideAdditions&&(k.verbose("User addition with no menu, setting empty style"),k.set.empty(),k.hideMenu()):(k.verbose("All items filtered, showing message",t),k.add.message(A.noResults)):(k.verbose("All items filtered, hiding dropdown",t),k.hideMenu()):(k.remove.empty(),k.remove.message()),S.allowAdditions&&k.add.userSuggestion(e),k.is.searchSelection()&&k.can.show()&&k.is.focusedOnSearch()&&k.show()};S.useLabels&&k.has.maxSelections()||(S.apiSettings?k.can.useAPI()?k.queryRemote(t,function(){S.filterRemoteData&&k.filterItems(t),n()}):k.error(q.noAPI):(k.filterItems(t),n()))},queryRemote:function(t,n){var i={errorDuration:!1,cache:"local",throttle:S.throttle,urlData:{query:t},onError:function(){k.add.message(A.serverError),n()},onFailure:function(){k.add.message(A.serverError),n()},onSuccess:function(e){k.remove.message(),k.setup.menu({values:e[R.remoteValues]}),n()}};M.api("get request")||k.setup.api(),i=e.extend(!0,{},i,S.apiSettings),M.api("setting",i).api("query")},filterItems:function(t){var n=t!==i?t:k.get.query(),o=null,a=k.escape.string(n),r=new RegExp("^"+a,"igm");k.has.query()&&(o=[],k.verbose("Searching for matching values",n),X.each(function(){var t,i,a=e(this);if("both"==S.match||"text"==S.match){if(t=String(k.get.choiceText(a,!1)),-1!==t.search(r))return o.push(this),!0;if("exact"===S.fullTextSearch&&k.exactSearch(n,t))return o.push(this),!0;if(S.fullTextSearch===!0&&k.fuzzySearch(n,t))return o.push(this),!0}if("both"==S.match||"value"==S.match){if(i=String(k.get.choiceValue(a,t)),-1!==i.search(r))return o.push(this),!0;if("exact"===S.fullTextSearch&&k.exactSearch(n,i))return o.push(this),!0;if(S.fullTextSearch===!0&&k.fuzzySearch(n,i))return o.push(this),!0}})),k.debug("Showing only matched items",n),k.remove.filteredItem(),o&&X.not(o).addClass(T.filtered)},fuzzySearch:function(e,t){var n=t.length,i=e.length;if(e=e.toLowerCase(),t=t.toLowerCase(),i>n)return!1;if(i===n)return e===t;e:for(var o=0,a=0;i>o;o++){for(var r=e.charCodeAt(o);n>a;)if(t.charCodeAt(a++)===r)continue e;return!1}return!0},exactSearch:function(e,t){return e=e.toLowerCase(),t=t.toLowerCase(),t.indexOf(e)>-1},filterActive:function(){S.useLabels&&X.filter("."+T.active).addClass(T.filtered)},focusSearch:function(e){k.has.search()&&!k.is.focusedOnSearch()&&(e?(M.off("focus"+z,D.search),V.focus(),M.on("focus"+z,D.search,k.event.search.focus)):V.focus())},forceSelection:function(){var e=X.not(T.filtered).filter("."+T.selected).eq(0),t=X.not(T.filtered).filter("."+T.active).eq(0),n=e.length>0?e:t,i=n.length>0;return i&&!k.is.multiple()?(k.debug("Forcing partial selection to selected item",n),void k.event.item.click.call(n,{},!0)):void(S.allowAdditions?(k.set.selected(k.get.query()),k.remove.searchTerm()):k.remove.searchTerm())},event:{change:function(){Z||(k.debug("Input changed, updating selection"),
k.set.selected())},focus:function(){S.showOnFocus&&!$&&k.is.hidden()&&!v&&k.show()},blur:function(e){v=n.activeElement===this,$||v||(k.remove.activeLabel(),k.hide())},mousedown:function(){k.is.searchSelection()?b=!0:$=!0},mouseup:function(){k.is.searchSelection()?b=!1:$=!1},click:function(t){var n=e(t.target);n.is(M)&&(k.is.focusedOnSearch()?k.show():k.focusSearch())},search:{focus:function(){$=!0,k.is.multiple()&&k.remove.activeLabel(),S.showOnFocus&&k.search()},blur:function(e){v=n.activeElement===this,k.is.searchSelection()&&!b&&(Y||v||(S.forceSelection&&k.forceSelection(),k.hide())),b=!1}},icon:{click:function(e){k.toggle()}},text:{focus:function(e){$=!0,k.focusSearch()}},input:function(e){(k.is.multiple()||k.is.searchSelection())&&k.set.filtered(),clearTimeout(k.timer),k.timer=setTimeout(k.search,S.delay.search)},label:{click:function(t){var n=e(this),i=M.find(D.label),o=i.filter("."+T.active),a=n.nextAll("."+T.active),r=n.prevAll("."+T.active),s=a.length>0?n.nextUntil(a).add(o).add(n):n.prevUntil(r).add(o).add(n);t.shiftKey?(o.removeClass(T.active),s.addClass(T.active)):t.ctrlKey?n.toggleClass(T.active):(o.removeClass(T.active),n.addClass(T.active)),S.onLabelSelect.apply(this,i.filter("."+T.active))}},remove:{click:function(){var t=e(this).parent();t.hasClass(T.active)?k.remove.activeLabels():k.remove.activeLabels(t)}},test:{toggle:function(e){var t=k.is.multiple()?k.show:k.toggle;k.is.bubbledLabelClick(e)||k.is.bubbledIconClick(e)||k.determine.eventOnElement(e,t)&&e.preventDefault()},touch:function(e){k.determine.eventOnElement(e,function(){"touchstart"==e.type?k.timer=setTimeout(function(){k.hide()},S.delay.touch):"touchmove"==e.type&&clearTimeout(k.timer)}),e.stopPropagation()},hide:function(e){k.determine.eventInModule(e,k.hide)}},select:{mutation:function(e){k.debug("<select> modified, recreating menu"),k.setup.select()}},menu:{mutation:function(t){var n=t[0],i=e(n.addedNodes?n.addedNodes[0]:!1),o=e(n.removedNodes?n.removedNodes[0]:!1),a=i.add(o),r=a.is(D.addition)||a.closest(D.addition).length>0,s=a.is(D.message)||a.closest(D.message).length>0;r||s?(k.debug("Updating item selector cache"),k.refreshItems()):(k.debug("Menu modified, updating selector cache"),k.refresh())},mousedown:function(){Y=!0},mouseup:function(){Y=!1}},item:{mouseenter:function(t){var n=e(t.target),i=e(this),o=i.children(D.menu),a=i.siblings(D.item).children(D.menu),r=o.length>0,s=o.find(n).length>0;!s&&r&&(clearTimeout(k.itemTimer),k.itemTimer=setTimeout(function(){k.verbose("Showing sub-menu",o),e.each(a,function(){k.animate.hide(!1,e(this))}),k.animate.show(!1,o)},S.delay.show),t.preventDefault())},mouseleave:function(t){var n=e(this).children(D.menu);n.length>0&&(clearTimeout(k.itemTimer),k.itemTimer=setTimeout(function(){k.verbose("Hiding sub-menu",n),k.animate.hide(!1,n)},S.delay.hide))},click:function(t,i){var o=e(this),a=e(t?t.target:""),r=o.find(D.menu),s=k.get.choiceText(o),l=k.get.choiceValue(o,s),c=r.length>0,u=r.find(a).length>0;k.has.menuSearch()&&e(n.activeElement).blur(),u||c&&!S.allowCategorySelection||(k.is.searchSelection()&&(S.allowAdditions&&k.remove.userAddition(),k.remove.searchTerm(),k.is.focusedOnSearch()||1==i||k.focusSearch(!0)),S.useLabels||(k.remove.filteredItem(),k.set.scrollPosition(o)),k.determine.selectAction.call(this,s,l))}},document:{keydown:function(e){var t=e.which,n=k.is.inObject(t,P);if(n){var i=M.find(D.label),o=i.filter("."+T.active),a=(o.data(E.value),i.index(o)),r=i.length,s=o.length>0,l=o.length>1,c=0===a,u=a+1==r,d=k.is.searchSelection(),f=k.is.focusedOnSearch(),m=k.is.focused(),g=f&&0===k.get.caretPosition();if(d&&!s&&!f)return;t==P.leftArrow?!m&&!g||s?s&&(e.shiftKey?k.verbose("Adding previous label to selection"):(k.verbose("Selecting previous label"),i.removeClass(T.active)),c&&!l?o.addClass(T.active):o.prev(D.siblingLabel).addClass(T.active).end(),e.preventDefault()):(k.verbose("Selecting previous label"),i.last().addClass(T.active)):t==P.rightArrow?(m&&!s&&i.first().addClass(T.active),s&&(e.shiftKey?k.verbose("Adding next label to selection"):(k.verbose("Selecting next label"),i.removeClass(T.active)),u?d?f?i.removeClass(T.active):k.focusSearch():l?o.next(D.siblingLabel).addClass(T.active):o.addClass(T.active):o.next(D.siblingLabel).addClass(T.active),e.preventDefault())):t==P.deleteKey||t==P.backspace?s?(k.verbose("Removing active labels"),u&&d&&!f&&k.focusSearch(),o.last().next(D.siblingLabel).addClass(T.active),k.remove.activeLabels(o),e.preventDefault()):g&&!s&&t==P.backspace&&(k.verbose("Removing last label on input backspace"),o=i.last().addClass(T.active),k.remove.activeLabels(o)):o.removeClass(T.active)}}},keydown:function(e){var t=e.which,n=k.is.inObject(t,P);if(n){var i,o,a=X.not(D.unselectable).filter("."+T.selected).eq(0),r=Q.children("."+T.active).eq(0),s=a.length>0?a:r,l=s.length>0?s.siblings(":not(."+T.filtered+")").addBack():Q.children(":not(."+T.filtered+")"),c=s.children(D.menu),u=s.closest(D.menu),d=u.hasClass(T.visible)||u.hasClass(T.animating)||u.parent(D.menu).length>0,f=c.length>0,m=s.length>0,g=s.not(D.unselectable).length>0,p=t==P.delimiter&&S.allowAdditions&&k.is.multiple(),h=S.allowAdditions&&S.hideAdditions&&(t==P.enter||p)&&g;if(h&&(k.verbose("Selecting item from keyboard shortcut",s),k.event.item.click.call(s,e),k.is.searchSelection()&&k.remove.searchTerm()),k.is.visible()){if((t==P.enter||p)&&(t==P.enter&&m&&f&&!S.allowCategorySelection?(k.verbose("Pressed enter on unselectable category, opening sub menu"),t=P.rightArrow):g&&(k.verbose("Selecting item from keyboard shortcut",s),k.event.item.click.call(s,e),k.is.searchSelection()&&k.remove.searchTerm()),e.preventDefault()),m&&(t==P.leftArrow&&(o=u[0]!==Q[0],o&&(k.verbose("Left key pressed, closing sub-menu"),k.animate.hide(!1,u),s.removeClass(T.selected),u.closest(D.item).addClass(T.selected),e.preventDefault())),t==P.rightArrow&&f&&(k.verbose("Right key pressed, opening sub-menu"),k.animate.show(!1,c),s.removeClass(T.selected),c.find(D.item).eq(0).addClass(T.selected),e.preventDefault())),t==P.upArrow){if(i=m&&d?s.prevAll(D.item+":not("+D.unselectable+")").eq(0):X.eq(0),l.index(i)<0)return k.verbose("Up key pressed but reached top of current menu"),void e.preventDefault();k.verbose("Up key pressed, changing active item"),s.removeClass(T.selected),i.addClass(T.selected),k.set.scrollPosition(i),S.selectOnKeydown&&k.is.single()&&k.set.selectedItem(i),e.preventDefault()}if(t==P.downArrow){if(i=m&&d?i=s.nextAll(D.item+":not("+D.unselectable+")").eq(0):X.eq(0),0===i.length)return k.verbose("Down key pressed but reached bottom of current menu"),void e.preventDefault();k.verbose("Down key pressed, changing active item"),X.removeClass(T.selected),i.addClass(T.selected),k.set.scrollPosition(i),S.selectOnKeydown&&k.is.single()&&k.set.selectedItem(i),e.preventDefault()}t==P.pageUp&&(k.scrollPage("up"),e.preventDefault()),t==P.pageDown&&(k.scrollPage("down"),e.preventDefault()),t==P.escape&&(k.verbose("Escape key pressed, closing dropdown"),k.hide())}else p&&e.preventDefault(),t!=P.downArrow||k.is.visible()||(k.verbose("Down key pressed, showing dropdown"),k.select.firstUnfiltered(),k.show(),e.preventDefault())}else k.has.search()||k.set.selectedLetter(String.fromCharCode(t))}},trigger:{change:function(){var e=n.createEvent("HTMLEvents"),t=U[0];t&&(k.verbose("Triggering native change event"),e.initEvent("change",!0,!1),t.dispatchEvent(e))}},determine:{selectAction:function(t,n){k.verbose("Determining action",S.action),e.isFunction(k.action[S.action])?(k.verbose("Triggering preset action",S.action,t,n),k.action[S.action].call(K,t,n,this)):e.isFunction(S.action)?(k.verbose("Triggering user action",S.action,t,n),S.action.call(K,t,n,this)):k.error(q.action,S.action)},eventInModule:function(t,i){var o=e(t.target),a=o.closest(n.documentElement).length>0,r=o.closest(M).length>0;return i=e.isFunction(i)?i:function(){},a&&!r?(k.verbose("Triggering event",i),i(),!0):(k.verbose("Event occurred in dropdown, canceling callback"),!1)},eventOnElement:function(t,i){var o=e(t.target),a=o.closest(D.siblingLabel),r=n.body.contains(t.target),s=0===M.find(a).length,l=0===o.closest(Q).length;return i=e.isFunction(i)?i:function(){},r&&s&&l?(k.verbose("Triggering event",i),i(),!0):(k.verbose("Event occurred in dropdown menu, canceling callback"),!1)}},action:{nothing:function(){},activate:function(t,n,o){if(n=n!==i?n:t,k.can.activate(e(o))){if(k.set.selected(n,e(o)),k.is.multiple()&&!k.is.allFiltered())return;k.hideAndClear()}},select:function(t,n,o){if(n=n!==i?n:t,k.can.activate(e(o))){if(k.set.value(n,e(o)),k.is.multiple()&&!k.is.allFiltered())return;k.hideAndClear()}},combo:function(t,n,o){n=n!==i?n:t,k.set.selected(n,e(o)),k.hideAndClear()},hide:function(e,t,n){k.set.value(t,e),k.hideAndClear()}},get:{id:function(){return x},defaultText:function(){return M.data(E.defaultText)},defaultValue:function(){return M.data(E.defaultValue)},placeholderText:function(){return M.data(E.placeholderText)||""},text:function(){return N.text()},query:function(){return e.trim(V.val())},searchWidth:function(e){return e=e!==i?e:V.val(),H.text(e),Math.ceil(H.width()+1)},selectionCount:function(){var t,n=k.get.values();return t=k.is.multiple()?e.isArray(n)?n.length:0:""!==k.get.value()?1:0},transition:function(e){return"auto"==S.transition?k.is.upward(e)?"slide up":"slide down":S.transition},userValues:function(){var t=k.get.values();return t?(t=e.isArray(t)?t:[t],e.grep(t,function(e){return k.get.item(e)===!1})):!1},uniqueArray:function(t){return e.grep(t,function(n,i){return e.inArray(n,t)===i})},caretPosition:function(){var e,t,i=V.get(0);return"selectionStart"in i?i.selectionStart:n.selection?(i.focus(),e=n.selection.createRange(),t=e.text.length,e.moveStart("character",-i.value.length),e.text.length-t):void 0},value:function(){var t=U.length>0?U.val():M.data(E.value),n=e.isArray(t)&&1===t.length&&""===t[0];return t===i||n?"":t},values:function(){var e=k.get.value();return""===e?"":!k.has.selectInput()&&k.is.multiple()?"string"==typeof e?e.split(S.delimiter):"":e},remoteValues:function(){var t=k.get.values(),n=!1;return t&&("string"==typeof t&&(t=[t]),e.each(t,function(e,t){var i=k.read.remoteData(t);k.verbose("Restoring value from session data",i,t),i&&(n||(n={}),n[t]=i)})),n},choiceText:function(t,n){return n=n!==i?n:S.preserveHTML,t?(t.find(D.menu).length>0&&(k.verbose("Retrieving text of element with sub-menu"),t=t.clone(),t.find(D.menu).remove(),t.find(D.menuIcon).remove()),t.data(E.text)!==i?t.data(E.text):n?e.trim(t.html()):e.trim(t.text())):void 0},choiceValue:function(t,n){return n=n||k.get.choiceText(t),t?t.data(E.value)!==i?String(t.data(E.value)):"string"==typeof n?e.trim(n.toLowerCase()):String(n):!1},inputEvent:function(){var e=V[0];return e?e.oninput!==i?"input":e.onpropertychange!==i?"propertychange":"keyup":!1},selectValues:function(){var t={};return t.values=[],M.find("option").each(function(){var n=e(this),o=n.html(),a=n.attr("disabled"),r=n.attr("value")!==i?n.attr("value"):o;"auto"===S.placeholder&&""===r?t.placeholder=o:t.values.push({name:o,value:r,disabled:a})}),S.placeholder&&"auto"!==S.placeholder&&(k.debug("Setting placeholder value to",S.placeholder),t.placeholder=S.placeholder),S.sortSelect?(t.values.sort(function(e,t){return e.name>t.name?1:-1}),k.debug("Retrieved and sorted values from select",t)):k.debug("Retrieved values from select",t),t},activeItem:function(){return X.filter("."+T.active)},selectedItem:function(){var e=X.not(D.unselectable).filter("."+T.selected);return e.length>0?e:X.eq(0)},itemWithAdditions:function(e){var t=k.get.item(e),n=k.create.userChoice(e),i=n&&n.length>0;return i&&(t=t.length>0?t.add(n):n),t},item:function(t,n){var o,a,r=!1;return t=t!==i?t:k.get.values()!==i?k.get.values():k.get.text(),o=a?t.length>0:t!==i&&null!==t,a=k.is.multiple()&&e.isArray(t),n=""===t||0===t?!0:n||!1,o&&X.each(function(){var o=e(this),s=k.get.choiceText(o),l=k.get.choiceValue(o,s);if(null!==l&&l!==i)if(a)-1===e.inArray(String(l),t)&&-1===e.inArray(s,t)||(r=r?r.add(o):o);else if(n){if(k.verbose("Ambiguous dropdown value using strict type check",o,t),l===t||s===t)return r=o,!0}else if(String(l)==String(t)||s==t)return k.verbose("Found select item by value",l,t),r=o,!0}),r}},check:{maxSelections:function(e){return S.maxSelections?(e=e!==i?e:k.get.selectionCount(),e>=S.maxSelections?(k.debug("Maximum selection count reached"),S.useLabels&&(X.addClass(T.filtered),k.add.message(A.maxSelections)),!0):(k.verbose("No longer at maximum selection count"),k.remove.message(),k.remove.filteredItem(),k.is.searchSelection()&&k.filterItems(),!1)):!0}},restore:{defaults:function(){k.clear(),k.restore.defaultText(),k.restore.defaultValue()},defaultText:function(){var e=k.get.defaultText(),t=k.get.placeholderText;e===t?(k.debug("Restoring default placeholder text",e),k.set.placeholderText(e)):(k.debug("Restoring default text",e),k.set.text(e))},placeholderText:function(){k.set.placeholderText()},defaultValue:function(){var e=k.get.defaultValue();e!==i&&(k.debug("Restoring default value",e),""!==e?(k.set.value(e),k.set.selected()):(k.remove.activeItem(),k.remove.selectedItem()))},labels:function(){S.allowAdditions&&(S.useLabels||(k.error(q.labels),S.useLabels=!0),k.debug("Restoring selected values"),k.create.userLabels()),k.check.maxSelections()},selected:function(){k.restore.values(),k.is.multiple()?(k.debug("Restoring previously selected values and labels"),k.restore.labels()):k.debug("Restoring previously selected values")},values:function(){k.set.initialLoad(),S.apiSettings&&S.saveRemoteData&&k.get.remoteValues()?k.restore.remoteValues():k.set.selected(),k.remove.initialLoad()},remoteValues:function(){var t=k.get.remoteValues();k.debug("Recreating selected from session data",t),t&&(k.is.single()?e.each(t,function(e,t){k.set.text(t)}):e.each(t,function(e,t){k.add.label(e,t)}))}},read:{remoteData:function(e){var n;return t.Storage===i?void k.error(q.noStorage):(n=sessionStorage.getItem(e),n!==i?n:!1)}},save:{defaults:function(){k.save.defaultText(),k.save.placeholderText(),k.save.defaultValue()},defaultValue:function(){var e=k.get.value();k.verbose("Saving default value as",e),M.data(E.defaultValue,e)},defaultText:function(){var e=k.get.text();k.verbose("Saving default text as",e),M.data(E.defaultText,e)},placeholderText:function(){var e;S.placeholder!==!1&&N.hasClass(T.placeholder)&&(e=k.get.text(),k.verbose("Saving placeholder text as",e),M.data(E.placeholderText,e))},remoteData:function(e,n){return t.Storage===i?void k.error(q.noStorage):(k.verbose("Saving remote data to session storage",n,e),void sessionStorage.setItem(n,e))}},clear:function(){k.is.multiple()&&S.useLabels?k.remove.labels():(k.remove.activeItem(),k.remove.selectedItem()),k.set.placeholderText(),k.clearValue()},clearValue:function(){k.set.value("")},scrollPage:function(e,t){var n,i,o,a=t||k.get.selectedItem(),r=a.closest(D.menu),s=r.outerHeight(),l=r.scrollTop(),c=X.eq(0).outerHeight(),u=Math.floor(s/c),d=(r.prop("scrollHeight"),"up"==e?l-c*u:l+c*u),f=X.not(D.unselectable);o="up"==e?f.index(a)-u:f.index(a)+u,n="up"==e?o>=0:o<f.length,i=n?f.eq(o):"up"==e?f.first():f.last(),i.length>0&&(k.debug("Scrolling page",e,i),a.removeClass(T.selected),i.addClass(T.selected),S.selectOnKeydown&&k.is.single()&&k.set.selectedItem(i),r.scrollTop(d))},set:{filtered:function(){var e=k.is.multiple(),t=k.is.searchSelection(),n=e&&t,i=t?k.get.query():"",o="string"==typeof i&&i.length>0,a=k.get.searchWidth(),r=""!==i;e&&o&&(k.verbose("Adjusting input width",a,S.glyphWidth),V.css("width",a)),o||n&&r?(k.verbose("Hiding placeholder text"),N.addClass(T.filtered)):(!e||n&&!r)&&(k.verbose("Showing placeholder text"),N.removeClass(T.filtered))},empty:function(){M.addClass(T.empty)},loading:function(){M.addClass(T.loading)},placeholderText:function(e){e=e||k.get.placeholderText(),k.debug("Setting placeholder text",e),k.set.text(e),N.addClass(T.placeholder)},tabbable:function(){k.is.searchSelection()?(k.debug("Added tabindex to searchable dropdown"),V.val("").attr("tabindex",0),Q.attr("tabindex",-1)):(k.debug("Added tabindex to dropdown"),M.attr("tabindex")===i&&(M.attr("tabindex",0),Q.attr("tabindex",-1)))},initialLoad:function(){k.verbose("Setting initial load"),h=!0},activeItem:function(e){S.allowAdditions&&e.filter(D.addition).length>0?e.addClass(T.filtered):e.addClass(T.active)},partialSearch:function(e){var t=k.get.query().length;V.val(e.substr(0,t))},scrollPosition:function(e,t){var n,o,a,r,s,l,c,u,d,f=5;e=e||k.get.selectedItem(),n=e.closest(D.menu),o=e&&e.length>0,t=t!==i?t:!1,e&&n.length>0&&o&&(r=e.position().top,n.addClass(T.loading),l=n.scrollTop(),s=n.offset().top,r=e.offset().top,a=l-s+r,t||(c=n.height(),d=a+f>l+c,u=l>a-f),k.debug("Scrolling to active item",a),(t||u||d)&&n.scrollTop(a),n.removeClass(T.loading))},text:function(e){"select"!==S.action&&("combo"==S.action?(k.debug("Changing combo button text",e,B),S.preserveHTML?B.html(e):B.text(e)):(e!==k.get.placeholderText()&&N.removeClass(T.placeholder),k.debug("Changing text",e,N),N.removeClass(T.filtered),S.preserveHTML?N.html(e):N.text(e)))},selectedItem:function(e){var t=k.get.choiceValue(e),n=k.get.choiceText(e,!1),i=k.get.choiceText(e,!0);k.debug("Setting user selection to item",e),k.remove.activeItem(),k.set.partialSearch(n),k.set.activeItem(e),k.set.selected(t,e),k.set.text(i)},selectedLetter:function(t){var n,i=X.filter("."+T.selected),o=i.length>0&&k.has.firstLetter(i,t),a=!1;o&&(n=i.nextAll(X).eq(0),k.has.firstLetter(n,t)&&(a=n)),a||X.each(function(){return k.has.firstLetter(e(this),t)?(a=e(this),!1):void 0}),a&&(k.verbose("Scrolling to next value with letter",t),k.set.scrollPosition(a),i.removeClass(T.selected),a.addClass(T.selected),S.selectOnKeydown&&k.is.single()&&k.set.selectedItem(a))},direction:function(e){"auto"==S.direction?k.is.onScreen(e)?k.remove.upward(e):k.set.upward(e):"upward"==S.direction&&k.set.upward(e)},upward:function(e){var t=e||M;t.addClass(T.upward)},value:function(e,t,n){var o=k.escape.value(e),a=U.length>0,r=(!k.has.value(e),k.get.values()),s=e!==i?String(e):e;if(a){if(!S.allowReselection&&s==r&&(k.verbose("Skipping value update already same value",e,r),!k.is.initialLoad()))return;k.is.single()&&k.has.selectInput()&&k.can.extendSelect()&&(k.debug("Adding user option",e),k.add.optionValue(e)),k.debug("Updating input value",o,r),Z=!0,U.val(o),S.fireOnInit===!1&&k.is.initialLoad()?k.debug("Input native change event ignored on initial load"):k.trigger.change(),Z=!1}else k.verbose("Storing value in metadata",o,U),o!==r&&M.data(E.value,s);S.fireOnInit===!1&&k.is.initialLoad()?k.verbose("No callback on initial load",S.onChange):S.onChange.call(K,e,t,n)},active:function(){M.addClass(T.active)},multiple:function(){M.addClass(T.multiple)},visible:function(){M.addClass(T.visible)},exactly:function(e,t){k.debug("Setting selected to exact values"),k.clear(),k.set.selected(e,t)},selected:function(t,n){var i=k.is.multiple();n=S.allowAdditions?n||k.get.itemWithAdditions(t):n||k.get.item(t),n&&(k.debug("Setting selected menu item to",n),k.is.multiple()&&k.remove.searchWidth(),k.is.single()?(k.remove.activeItem(),k.remove.selectedItem()):S.useLabels&&k.remove.selectedItem(),n.each(function(){var t=e(this),o=k.get.choiceText(t),a=k.get.choiceValue(t,o),r=t.hasClass(T.filtered),s=t.hasClass(T.active),l=t.hasClass(T.addition),c=i&&1==n.length;i?!s||l?(S.apiSettings&&S.saveRemoteData&&k.save.remoteData(o,a),S.useLabels?(k.add.value(a,o,t),k.add.label(a,o,c),k.set.activeItem(t),k.filterActive(),k.select.nextAvailable(n)):(k.add.value(a,o,t),k.set.text(k.add.variables(A.count)),k.set.activeItem(t))):r||(k.debug("Selected active value, removing label"),k.remove.selected(a)):(S.apiSettings&&S.saveRemoteData&&k.save.remoteData(o,a),k.set.text(o),k.set.value(a,o,t),t.addClass(T.active).addClass(T.selected))}))}},add:{label:function(t,n,i){var o,a=k.is.searchSelection()?V:N,r=k.escape.value(t);return o=e("<a />").addClass(T.label).attr("data-"+E.value,r).html(j.label(r,n)),o=S.onLabelCreate.call(o,r,n),k.has.label(t)?void k.debug("Label already exists, skipping",r):(S.label.variation&&o.addClass(S.label.variation),void(i===!0?(k.debug("Animating in label",o),o.addClass(T.hidden).insertBefore(a).transition(S.label.transition,S.label.duration)):(k.debug("Adding selection label",o),o.insertBefore(a))))},message:function(t){var n=Q.children(D.message),i=S.templates.message(k.add.variables(t));n.length>0?n.html(i):n=e("<div/>").html(i).addClass(T.message).appendTo(Q)},optionValue:function(t){var n=k.escape.value(t),i=U.find('option[value="'+k.escape.string(n)+'"]'),o=i.length>0;o||(k.disconnect.selectObserver(),k.is.single()&&(k.verbose("Removing previous user addition"),U.find("option."+T.addition).remove()),e("<option/>").prop("value",n).addClass(T.addition).html(t).appendTo(U),k.verbose("Adding user addition as an <option>",t),k.observe.select())},userSuggestion:function(e){var t,n=Q.children(D.addition),i=k.get.item(e),o=i&&i.not(D.addition).length,a=n.length>0;if(!S.useLabels||!k.has.maxSelections()){if(""===e||o)return void n.remove();a?(n.data(E.value,e).data(E.text,e).attr("data-"+E.value,e).attr("data-"+E.text,e).removeClass(T.filtered),S.hideAdditions||(t=S.templates.addition(k.add.variables(A.addResult,e)),n.html(t)),k.verbose("Replacing user suggestion with new value",n)):(n=k.create.userChoice(e),n.prependTo(Q),k.verbose("Adding item choice to menu corresponding with user choice addition",n)),S.hideAdditions&&!k.is.allFiltered()||n.addClass(T.selected).siblings().removeClass(T.selected),k.refreshItems()}},variables:function(e,t){var n,i,o=-1!==e.search("{count}"),a=-1!==e.search("{maxCount}"),r=-1!==e.search("{term}");return k.verbose("Adding templated variables to message",e),o&&(n=k.get.selectionCount(),e=e.replace("{count}",n)),a&&(n=k.get.selectionCount(),e=e.replace("{maxCount}",S.maxSelections)),r&&(i=t||k.get.query(),e=e.replace("{term}",i)),e},value:function(t,n,i){var o,a=k.get.values();return""===t?void k.debug("Cannot select blank values from multiselect"):(e.isArray(a)?(o=a.concat([t]),o=k.get.uniqueArray(o)):o=[t],k.has.selectInput()?k.can.extendSelect()&&(k.debug("Adding value to select",t,o,U),k.add.optionValue(t)):(o=o.join(S.delimiter),k.debug("Setting hidden input to delimited value",o,U)),S.fireOnInit===!1&&k.is.initialLoad()?k.verbose("Skipping onadd callback on initial load",S.onAdd):S.onAdd.call(K,t,n,i),k.set.value(o,t,n,i),void k.check.maxSelections())}},remove:{active:function(){M.removeClass(T.active)},activeLabel:function(){M.find(D.label).removeClass(T.active)},empty:function(){M.removeClass(T.empty)},loading:function(){M.removeClass(T.loading)},initialLoad:function(){h=!1},upward:function(e){var t=e||M;t.removeClass(T.upward)},visible:function(){M.removeClass(T.visible)},activeItem:function(){X.removeClass(T.active)},filteredItem:function(){S.useLabels&&k.has.maxSelections()||(S.useLabels&&k.is.multiple()?X.not("."+T.active).removeClass(T.filtered):X.removeClass(T.filtered),k.remove.empty())},optionValue:function(e){var t=k.escape.value(e),n=U.find('option[value="'+k.escape.string(t)+'"]'),i=n.length>0;i&&n.hasClass(T.addition)&&(C&&(C.disconnect(),k.verbose("Temporarily disconnecting mutation observer")),n.remove(),k.verbose("Removing user addition as an <option>",t),C&&C.observe(U[0],{childList:!0,subtree:!0}))},message:function(){Q.children(D.message).remove()},searchWidth:function(){V.css("width","")},searchTerm:function(){k.verbose("Cleared search term"),V.val(""),k.set.filtered()},userAddition:function(){X.filter(D.addition).remove()},selected:function(t,n){return(n=S.allowAdditions?n||k.get.itemWithAdditions(t):n||k.get.item(t))?void n.each(function(){var t=e(this),n=k.get.choiceText(t),i=k.get.choiceValue(t,n);k.is.multiple()?S.useLabels?(k.remove.value(i,n,t),k.remove.label(i)):(k.remove.value(i,n,t),0===k.get.selectionCount()?k.set.placeholderText():k.set.text(k.add.variables(A.count))):k.remove.value(i,n,t),t.removeClass(T.filtered).removeClass(T.active),S.useLabels&&t.removeClass(T.selected)}):!1},selectedItem:function(){X.removeClass(T.selected)},value:function(e,t,n){var i,o=k.get.values();k.has.selectInput()?(k.verbose("Input is <select> removing selected option",e),i=k.remove.arrayValue(e,o),k.remove.optionValue(e)):(k.verbose("Removing from delimited values",e),i=k.remove.arrayValue(e,o),i=i.join(S.delimiter)),S.fireOnInit===!1&&k.is.initialLoad()?k.verbose("No callback on initial load",S.onRemove):S.onRemove.call(K,e,t,n),k.set.value(i,t,n),k.check.maxSelections()},arrayValue:function(t,n){return e.isArray(n)||(n=[n]),n=e.grep(n,function(e){return t!=e}),k.verbose("Removed value from delimited string",t,n),n},label:function(e,t){var n=M.find(D.label),i=n.filter("[data-"+E.value+'="'+k.escape.string(e)+'"]');k.verbose("Removing label",i),i.remove()},activeLabels:function(e){e=e||M.find(D.label).filter("."+T.active),k.verbose("Removing active label selections",e),k.remove.labels(e)},labels:function(t){t=t||M.find(D.label),k.verbose("Removing labels",t),t.each(function(){var t=e(this),n=t.data(E.value),o=n!==i?String(n):n,a=k.is.userValue(o);return S.onLabelRemove.call(t,n)===!1?void k.debug("Label remove callback cancelled removal"):(k.remove.message(),void(a?(k.remove.value(o),k.remove.label(o)):k.remove.selected(o)))})},tabbable:function(){k.is.searchSelection()?(k.debug("Searchable dropdown initialized"),V.removeAttr("tabindex"),Q.removeAttr("tabindex")):(k.debug("Simple selection dropdown initialized"),M.removeAttr("tabindex"),Q.removeAttr("tabindex"))}},has:{menuSearch:function(){return k.has.search()&&V.closest(Q).length>0},search:function(){return V.length>0},sizer:function(){return H.length>0},selectInput:function(){return U.is("select")},minCharacters:function(e){return S.minCharacters?(e=e!==i?String(e):String(k.get.query()),e.length>=S.minCharacters):!0},firstLetter:function(e,t){var n,i;return e&&0!==e.length&&"string"==typeof t?(n=k.get.choiceText(e,!1),t=t.toLowerCase(),i=String(n).charAt(0).toLowerCase(),t==i):!1},input:function(){return U.length>0},items:function(){return X.length>0},menu:function(){return Q.length>0},message:function(){return 0!==Q.children(D.message).length},label:function(e){var t=k.escape.value(e),n=M.find(D.label);return n.filter("[data-"+E.value+'="'+k.escape.string(t)+'"]').length>0},maxSelections:function(){return S.maxSelections&&k.get.selectionCount()>=S.maxSelections},allResultsFiltered:function(){var e=X.not(D.addition);return e.filter(D.unselectable).length===e.length},userSuggestion:function(){return Q.children(D.addition).length>0},query:function(){return""!==k.get.query()},value:function(t){var n=k.get.values(),i=e.isArray(n)?n&&-1!==e.inArray(t,n):n==t;return!!i}},is:{active:function(){return M.hasClass(T.active)},bubbledLabelClick:function(t){return e(t.target).is("select, input")&&M.closest("label").length>0},bubbledIconClick:function(t){return e(t.target).closest(W).length>0},alreadySetup:function(){return M.is("select")&&M.parent(D.dropdown).length>0&&0===M.prev().length},animating:function(e){return e?e.transition&&e.transition("is animating"):Q.transition&&Q.transition("is animating")},disabled:function(){return M.hasClass(T.disabled)},focused:function(){return n.activeElement===M[0]},focusedOnSearch:function(){return n.activeElement===V[0]},allFiltered:function(){return(k.is.multiple()||k.has.search())&&!(0==S.hideAdditions&&k.has.userSuggestion())&&!k.has.message()&&k.has.allResultsFiltered()},hidden:function(e){return!k.is.visible(e)},initialLoad:function(){return h},onScreen:function(e){var t,n=e||Q,i=!0,o={};return n.addClass(T.loading),t={context:{scrollTop:L.scrollTop(),height:L.outerHeight()},menu:{offset:n.offset(),height:n.outerHeight()}},k.is.verticallyScrollableContext()&&(t.menu.offset.top+=t.context.scrollTop),o={above:t.context.scrollTop<=t.menu.offset.top-t.menu.height,below:t.context.scrollTop+t.context.height>=t.menu.offset.top+t.menu.height},o.below?(k.verbose("Dropdown can fit in context downward",o),i=!0):o.below||o.above?(k.verbose("Dropdown cannot fit below, opening upward",o),i=!1):(k.verbose("Dropdown cannot fit in either direction, favoring downward",o),i=!0),n.removeClass(T.loading),i},inObject:function(t,n){var i=!1;return e.each(n,function(e,n){return n==t?(i=!0,!0):void 0}),i},multiple:function(){return M.hasClass(T.multiple)},remote:function(){return S.apiSettings&&k.can.useAPI()},single:function(){return!k.is.multiple()},selectMutation:function(t){var n=!1;return e.each(t,function(t,i){return i.target&&e(i.target).is("select")?(n=!0,!0):void 0}),n},search:function(){return M.hasClass(T.search)},searchSelection:function(){return k.has.search()&&1===V.parent(D.dropdown).length},selection:function(){return M.hasClass(T.selection)},userValue:function(t){return-1!==e.inArray(t,k.get.userValues())},upward:function(e){var t=e||M;return t.hasClass(T.upward)},visible:function(e){return e?e.hasClass(T.visible):Q.hasClass(T.visible)},verticallyScrollableContext:function(){var e=L.get(0)!==t?L.css("overflow-y"):!1;return"auto"==e||"scroll"==e}},can:{activate:function(e){return S.useLabels?!0:k.has.maxSelections()?!(!k.has.maxSelections()||!e.hasClass(T.active)):!0},click:function(){return c||"click"==S.on},extendSelect:function(){return S.allowAdditions||S.apiSettings},show:function(){return!k.is.disabled()&&(k.has.items()||k.has.message())},useAPI:function(){return e.fn.api!==i}},animate:{show:function(t,n){var o,a=n||Q,r=n?function(){}:function(){k.hideSubMenus(),k.hideOthers(),k.set.active()};t=e.isFunction(t)?t:function(){},k.verbose("Doing menu show animation",a),k.set.direction(n),o=k.get.transition(n),k.is.selection()&&k.set.scrollPosition(k.get.selectedItem(),!0),(k.is.hidden(a)||k.is.animating(a))&&("none"==o?(r(),a.transition("show"),t.call(K)):e.fn.transition!==i&&M.transition("is supported")?a.transition({animation:o+" in",debug:S.debug,verbose:S.verbose,duration:S.duration,queue:!0,onStart:r,onComplete:function(){t.call(K)}}):k.error(q.noTransition,o))},hide:function(t,n){var o=n||Q,a=(n?.9*S.duration:S.duration,n?function(){}:function(){k.can.click()&&k.unbind.intent(),k.remove.active()}),r=k.get.transition(n);t=e.isFunction(t)?t:function(){},(k.is.visible(o)||k.is.animating(o))&&(k.verbose("Doing menu hide animation",o),"none"==r?(a(),o.transition("hide"),t.call(K)):e.fn.transition!==i&&M.transition("is supported")?o.transition({animation:r+" out",duration:S.duration,debug:S.debug,verbose:S.verbose,queue:!0,onStart:a,onComplete:function(){"auto"==S.direction&&k.remove.upward(n),t.call(K)}}):k.error(q.transition))}},hideAndClear:function(){k.remove.searchTerm(),k.has.maxSelections()||(k.has.search()?k.hide(function(){k.remove.filteredItem()}):k.hide())},delay:{show:function(){k.verbose("Delaying show event to ensure user intent"),clearTimeout(k.timer),k.timer=setTimeout(k.show,S.delay.show)},hide:function(){k.verbose("Delaying hide event to ensure user intent"),clearTimeout(k.timer),k.timer=setTimeout(k.hide,S.delay.hide)}},escape:{value:function(t){var n=e.isArray(t),i="string"==typeof t,o=!i&&!n,a=i&&-1!==t.search(O.quote),r=[];return o||!a?t:(k.debug("Encoding quote values for use in select",t),n?(e.each(t,function(e,t){r.push(t.replace(O.quote,"&quot;"))}),r):t.replace(O.quote,"&quot;"))},string:function(e){return e=String(e),e.replace(O.escape,"\\$&")}},setting:function(t,n){if(k.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,S,t);else{if(n===i)return S[t];e.isPlainObject(S[t])?e.extend(!0,S[t],n):S[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,k,t);else{if(n===i)return k[t];k[t]=n}},debug:function(){!S.silent&&S.debug&&(S.performance?k.performance.log(arguments):(k.debug=Function.prototype.bind.call(console.info,console,S.name+":"),k.debug.apply(console,arguments)))},verbose:function(){!S.silent&&S.verbose&&S.debug&&(S.performance?k.performance.log(arguments):(k.verbose=Function.prototype.bind.call(console.info,console,S.name+":"),k.verbose.apply(console,arguments)))},error:function(){S.silent||(k.error=Function.prototype.bind.call(console.error,console,S.name+":"),
k.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;S.performance&&(t=(new Date).getTime(),i=u||t,n=t-i,u=t,d.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:K,"Execution Time":n})),clearTimeout(k.performance.timer),k.performance.timer=setTimeout(k.performance.display,500)},display:function(){var t=S.name+":",n=0;u=!1,clearTimeout(k.performance.timer),e.each(d,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",l&&(t+=" '"+l+"'"),(console.group!==i||console.table!==i)&&d.length>0&&(console.groupCollapsed(t),console.table?console.table(d):e.each(d,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),d=[]}},invoke:function(t,n,o){var r,s,l,c=J;return n=n||g,o=K||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(k.error(q.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},m?(J===i&&k.initialize(),k.invoke(f)):(J!==i&&J.invoke("destroy"),k.initialize())}),a!==i?a:r},e.fn.dropdown.settings={silent:!1,debug:!1,verbose:!1,performance:!0,on:"click",action:"activate",apiSettings:!1,selectOnKeydown:!0,minCharacters:0,filterRemoteData:!1,saveRemoteData:!0,throttle:200,context:t,direction:"auto",keepOnScreen:!0,match:"both",fullTextSearch:!1,placeholder:"auto",preserveHTML:!0,sortSelect:!1,forceSelection:!0,allowAdditions:!1,hideAdditions:!0,maxSelections:!1,useLabels:!0,delimiter:",",showOnFocus:!0,allowReselection:!1,allowTab:!0,allowCategorySelection:!1,fireOnInit:!1,transition:"auto",duration:200,glyphWidth:1.037,label:{transition:"scale",duration:200,variation:!1},delay:{hide:300,show:200,search:20,touch:50},onChange:function(e,t,n){},onAdd:function(e,t,n){},onRemove:function(e,t,n){},onLabelSelect:function(e){},onLabelCreate:function(t,n){return e(this)},onLabelRemove:function(e){return!0},onNoResults:function(e){return!0},onShow:function(){},onHide:function(){},name:"Dropdown",namespace:"dropdown",message:{addResult:"Add <b>{term}</b>",count:"{count} selected",maxSelections:"Max {maxCount} selections",noResults:"No results found.",serverError:"There was an error contacting the server"},error:{action:"You called a dropdown action that was not defined",alreadySetup:"Once a select has been initialized behaviors must be called on the created ui dropdown",labels:"Allowing user additions currently requires the use of labels.",missingMultiple:"<select> requires multiple property to be set to correctly preserve multiple values",method:"The method you called is not defined.",noAPI:"The API module is required to load resources remotely",noStorage:"Saving remote data requires session storage",noTransition:"This module requires ui transitions <https://github.com/Semantic-Org/UI-Transition>"},regExp:{escape:/[-[\]{}()*+?.,\\^$|#\s]/g,quote:/"/g},metadata:{defaultText:"defaultText",defaultValue:"defaultValue",placeholderText:"placeholder",text:"text",value:"value"},fields:{remoteValues:"results",values:"values",disabled:"disabled",name:"name",value:"value",text:"text"},keys:{backspace:8,delimiter:188,deleteKey:46,enter:13,escape:27,pageUp:33,pageDown:34,leftArrow:37,upArrow:38,rightArrow:39,downArrow:40},selector:{addition:".addition",dropdown:".ui.dropdown",hidden:".hidden",icon:"> .dropdown.icon",input:'> input[type="hidden"], > select',item:".item",label:"> .label",remove:"> .label > .delete.icon",siblingLabel:".label",menu:".menu",message:".message",menuIcon:".dropdown.icon",search:"input.search, .menu > .search > input, .menu input.search",sizer:"> input.sizer",text:"> .text:not(.icon)",unselectable:".disabled, .filtered"},className:{active:"active",addition:"addition",animating:"animating",disabled:"disabled",empty:"empty",dropdown:"ui dropdown",filtered:"filtered",hidden:"hidden transition",item:"item",label:"ui label",loading:"loading",menu:"menu",message:"message",multiple:"multiple",placeholder:"default",sizer:"sizer",search:"search",selected:"selected",selection:"selection",upward:"upward",visible:"visible"}},e.fn.dropdown.settings.templates={dropdown:function(t){var n=t.placeholder||!1,i=(t.values||{},"");return i+='<i class="dropdown icon"></i>',i+=t.placeholder?'<div class="default text">'+n+"</div>":'<div class="text"></div>',i+='<div class="menu">',e.each(t.values,function(e,t){i+=t.disabled?'<div class="disabled item" data-value="'+t.value+'">'+t.name+"</div>":'<div class="item" data-value="'+t.value+'">'+t.name+"</div>"}),i+="</div>"},menu:function(t,n){var i=t[n.values]||{},o="";return e.each(i,function(e,t){var i=t[n.text]?'data-text="'+t[n.text]+'"':"",a=t[n.disabled]?"disabled ":"";o+='<div class="'+a+'item" data-value="'+t[n.value]+'"'+i+">",o+=t[n.name],o+="</div>"}),o},label:function(e,t){return t+'<i class="delete icon"></i>'},message:function(e){return e},addition:function(e){return e}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.embed=function(n){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var f,m=e.isPlainObject(n)?e.extend(!0,{},e.fn.embed.settings,n):e.extend({},e.fn.embed.settings),g=m.selector,p=m.className,h=m.sources,v=m.error,b=m.metadata,y=m.namespace,x=m.templates,C="."+y,w="module-"+y,k=(e(t),e(this)),S=k.find(g.placeholder),T=k.find(g.icon),A=k.find(g.embed),R=this,P=k.data(w);f={initialize:function(){f.debug("Initializing embed"),f.determine.autoplay(),f.create(),f.bind.events(),f.instantiate()},instantiate:function(){f.verbose("Storing instance of module",f),P=f,k.data(w,f)},destroy:function(){f.verbose("Destroying previous instance of embed"),f.reset(),k.removeData(w).off(C)},refresh:function(){f.verbose("Refreshing selector cache"),S=k.find(g.placeholder),T=k.find(g.icon),A=k.find(g.embed)},bind:{events:function(){f.has.placeholder()&&(f.debug("Adding placeholder events"),k.on("click"+C,g.placeholder,f.createAndShow).on("click"+C,g.icon,f.createAndShow))}},create:function(){var e=f.get.placeholder();e?f.createPlaceholder():f.createAndShow()},createPlaceholder:function(e){var t=f.get.icon(),n=f.get.url();f.generate.embed(n);e=e||f.get.placeholder(),k.html(x.placeholder(e,t)),f.debug("Creating placeholder for embed",e,t)},createEmbed:function(t){f.refresh(),t=t||f.get.url(),A=e("<div/>").addClass(p.embed).html(f.generate.embed(t)).appendTo(k),m.onCreate.call(R,t),f.debug("Creating embed object",A)},changeEmbed:function(e){A.html(f.generate.embed(e))},createAndShow:function(){f.createEmbed(),f.show()},change:function(e,t,n){f.debug("Changing video to ",e,t,n),k.data(b.source,e).data(b.id,t),n?k.data(b.url,n):k.removeData(b.url),f.has.embed()?f.changeEmbed():f.create()},reset:function(){f.debug("Clearing embed and showing placeholder"),f.remove.active(),f.remove.embed(),f.showPlaceholder(),m.onReset.call(R)},show:function(){f.debug("Showing embed"),f.set.active(),m.onDisplay.call(R)},hide:function(){f.debug("Hiding embed"),f.showPlaceholder()},showPlaceholder:function(){f.debug("Showing placeholder image"),f.remove.active(),m.onPlaceholderDisplay.call(R)},get:{id:function(){return m.id||k.data(b.id)},placeholder:function(){return m.placeholder||k.data(b.placeholder)},icon:function(){return m.icon?m.icon:k.data(b.icon)!==i?k.data(b.icon):f.determine.icon()},source:function(e){return m.source?m.source:k.data(b.source)!==i?k.data(b.source):f.determine.source()},type:function(){var e=f.get.source();return h[e]!==i?h[e].type:!1},url:function(){return m.url?m.url:k.data(b.url)!==i?k.data(b.url):f.determine.url()}},determine:{autoplay:function(){f.should.autoplay()&&(m.autoplay=!0)},source:function(t){var n=!1;return t=t||f.get.url(),t&&e.each(h,function(e,i){return-1!==t.search(i.domain)?(n=e,!1):void 0}),n},icon:function(){var e=f.get.source();return h[e]!==i?h[e].icon:!1},url:function(){var e,t=m.id||k.data(b.id),n=m.source||k.data(b.source);return e=h[n]!==i?h[n].url.replace("{id}",t):!1,e&&k.data(b.url,e),e}},set:{active:function(){k.addClass(p.active)}},remove:{active:function(){k.removeClass(p.active)},embed:function(){A.empty()}},encode:{parameters:function(e){var t,n=[];for(t in e)n.push(encodeURIComponent(t)+"="+encodeURIComponent(e[t]));return n.join("&amp;")}},generate:{embed:function(e){f.debug("Generating embed html");var t,n,i=f.get.source();return e=f.get.url(e),e?(n=f.generate.parameters(i),t=x.iframe(e,n)):f.error(v.noURL,k),t},parameters:function(t,n){var o=h[t]&&h[t].parameters!==i?h[t].parameters(m):{};return n=n||m.parameters,n&&(o=e.extend({},o,n)),o=m.onEmbed(o),f.encode.parameters(o)}},has:{embed:function(){return A.length>0},placeholder:function(){return m.placeholder||k.data(b.placeholder)}},should:{autoplay:function(){return"auto"===m.autoplay?m.placeholder||k.data(b.placeholder)!==i:m.autoplay}},is:{video:function(){return"video"==f.get.type()}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;m.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:R,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;s=!1,clearTimeout(f.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=P;return n=n||d,a=R||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(f.error(v.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},u?(P===i&&f.initialize(),f.invoke(c)):(P!==i&&P.invoke("destroy"),f.initialize())}),o!==i?o:this},e.fn.embed.settings={name:"Embed",namespace:"embed",silent:!1,debug:!1,verbose:!1,performance:!0,icon:!1,source:!1,url:!1,id:!1,autoplay:"auto",color:"#444444",hd:!0,brandedUI:!1,parameters:!1,onDisplay:function(){},onPlaceholderDisplay:function(){},onReset:function(){},onCreate:function(e){},onEmbed:function(e){return e},metadata:{id:"id",icon:"icon",placeholder:"placeholder",source:"source",url:"url"},error:{noURL:"No URL specified",method:"The method you called is not defined"},className:{active:"active",embed:"embed"},selector:{embed:".embed",placeholder:".placeholder",icon:".icon"},sources:{youtube:{name:"youtube",type:"video",icon:"video play",domain:"youtube.com",url:"//www.youtube.com/embed/{id}",parameters:function(e){return{autohide:!e.brandedUI,autoplay:e.autoplay,color:e.color||i,hq:e.hd,jsapi:e.api,modestbranding:!e.brandedUI}}},vimeo:{name:"vimeo",type:"video",icon:"video play",domain:"vimeo.com",url:"//player.vimeo.com/video/{id}",parameters:function(e){return{api:e.api,autoplay:e.autoplay,byline:e.brandedUI,color:e.color||i,portrait:e.brandedUI,title:e.brandedUI}}}},templates:{iframe:function(e,t){var n=e;return t&&(n+="?"+t),'<iframe src="'+n+'" width="100%" height="100%" frameborder="0" scrolling="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'},placeholder:function(e,t){var n="";return t&&(n+='<i class="'+t+' icon"></i>'),e&&(n+='<img class="placeholder" src="'+e+'">'),n}},api:!1,onPause:function(){},onPlay:function(){},onStop:function(){}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.modal=function(o){var a,r=e(this),s=e(t),l=e(n),c=e("body"),u=r.selector||"",d=(new Date).getTime(),f=[],m=arguments[0],g="string"==typeof m,p=[].slice.call(arguments,1),h=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return r.each(function(){var r,v,b,y,x,C,w,k,S,T=e.isPlainObject(o)?e.extend(!0,{},e.fn.modal.settings,o):e.extend({},e.fn.modal.settings),A=T.selector,R=T.className,P=T.namespace,E=T.error,F="."+P,O="module-"+P,D=e(this),q=e(T.context),j=D.find(A.close),z=this,I=D.data(O),M=!1;S={initialize:function(){S.verbose("Initializing dimmer",q),S.create.id(),S.create.dimmer(),S.refreshModals(),S.bind.events(),T.observeChanges&&S.observeChanges(),S.instantiate()},instantiate:function(){S.verbose("Storing instance of modal"),I=S,D.data(O,I)},create:{dimmer:function(){var t={debug:T.debug,dimmerName:"modals",duration:{show:T.duration,hide:T.duration}},n=e.extend(!0,t,T.dimmerSettings);return T.inverted&&(n.variation=n.variation!==i?n.variation+" inverted":"inverted"),e.fn.dimmer===i?void S.error(E.dimmer):(S.debug("Creating dimmer with settings",n),y=q.dimmer(n),T.detachable?(S.verbose("Modal is detachable, moving content into dimmer"),y.dimmer("add content",D)):S.set.undetached(),T.blurring&&y.addClass(R.blurring),void(x=y.dimmer("get dimmer")))},id:function(){w=(Math.random().toString(16)+"000000000").substr(2,8),C="."+w,S.verbose("Creating unique id for element",w)}},destroy:function(){S.verbose("Destroying previous modal"),D.removeData(O).off(F),s.off(C),x.off(C),j.off(F),q.dimmer("destroy")},observeChanges:function(){"MutationObserver"in t&&(k=new MutationObserver(function(e){S.debug("DOM tree modified, refreshing"),S.refresh()}),k.observe(z,{childList:!0,subtree:!0}),S.debug("Setting up mutation observer",k))},refresh:function(){S.remove.scrolling(),S.cacheSizes(),S.set.screenHeight(),S.set.type(),S.set.position()},refreshModals:function(){v=D.siblings(A.modal),r=v.add(D)},attachEvents:function(t,n){var i=e(t);n=e.isFunction(S[n])?S[n]:S.toggle,i.length>0?(S.debug("Attaching modal events to element",t,n),i.off(F).on("click"+F,n)):S.error(E.notFound,t)},bind:{events:function(){S.verbose("Attaching events"),D.on("click"+F,A.close,S.event.close).on("click"+F,A.approve,S.event.approve).on("click"+F,A.deny,S.event.deny),s.on("resize"+C,S.event.resize)}},get:{id:function(){return(Math.random().toString(16)+"000000000").substr(2,8)}},event:{approve:function(){return M||T.onApprove.call(z,e(this))===!1?void S.verbose("Approve callback returned false cancelling hide"):(M=!0,void S.hide(function(){M=!1}))},deny:function(){return M||T.onDeny.call(z,e(this))===!1?void S.verbose("Deny callback returned false cancelling hide"):(M=!0,void S.hide(function(){M=!1}))},close:function(){S.hide()},click:function(t){var i=e(t.target),o=i.closest(A.modal).length>0,a=e.contains(n.documentElement,t.target);!o&&a&&(S.debug("Dimmer clicked, hiding all modals"),S.is.active()&&(S.remove.clickaway(),T.allowMultiple?S.hide():S.hideAll()))},debounce:function(e,t){clearTimeout(S.timer),S.timer=setTimeout(e,t)},keyboard:function(e){var t=e.which,n=27;t==n&&(T.closable?(S.debug("Escape key pressed hiding modal"),S.hide()):S.debug("Escape key pressed, but closable is set to false"),e.preventDefault())},resize:function(){y.dimmer("is active")&&h(S.refresh)}},toggle:function(){S.is.active()||S.is.animating()?S.hide():S.show()},show:function(t){t=e.isFunction(t)?t:function(){},S.refreshModals(),S.showModal(t)},hide:function(t){t=e.isFunction(t)?t:function(){},S.refreshModals(),S.hideModal(t)},showModal:function(t){t=e.isFunction(t)?t:function(){},S.is.animating()||!S.is.active()?(S.showDimmer(),S.cacheSizes(),S.set.position(),S.set.screenHeight(),S.set.type(),S.set.clickaway(),!T.allowMultiple&&S.others.active()?S.hideOthers(S.showModal):(T.onShow.call(z),T.transition&&e.fn.transition!==i&&D.transition("is supported")?(S.debug("Showing modal with css animations"),D.transition({debug:T.debug,animation:T.transition+" in",queue:T.queue,duration:T.duration,useFailSafe:!0,onComplete:function(){T.onVisible.apply(z),T.keyboardShortcuts&&S.add.keyboardShortcuts(),S.save.focus(),S.set.active(),T.autofocus&&S.set.autofocus(),t()}})):S.error(E.noTransition))):S.debug("Modal is already visible")},hideModal:function(t,n){return t=e.isFunction(t)?t:function(){},S.debug("Hiding modal"),T.onHide.call(z,e(this))===!1?void S.verbose("Hide callback returned false cancelling hide"):void((S.is.animating()||S.is.active())&&(T.transition&&e.fn.transition!==i&&D.transition("is supported")?(S.remove.active(),D.transition({debug:T.debug,animation:T.transition+" out",queue:T.queue,duration:T.duration,useFailSafe:!0,onStart:function(){S.others.active()||n||S.hideDimmer(),T.keyboardShortcuts&&S.remove.keyboardShortcuts()},onComplete:function(){T.onHidden.call(z),S.restore.focus(),t()}})):S.error(E.noTransition)))},showDimmer:function(){y.dimmer("is animating")||!y.dimmer("is active")?(S.debug("Showing dimmer"),y.dimmer("show")):S.debug("Dimmer already visible")},hideDimmer:function(){return y.dimmer("is animating")||y.dimmer("is active")?void y.dimmer("hide",function(){S.remove.clickaway(),S.remove.screenHeight()}):void S.debug("Dimmer is not visible cannot hide")},hideAll:function(t){var n=r.filter("."+R.active+", ."+R.animating);t=e.isFunction(t)?t:function(){},n.length>0&&(S.debug("Hiding all visible modals"),S.hideDimmer(),n.modal("hide modal",t))},hideOthers:function(t){var n=v.filter("."+R.active+", ."+R.animating);t=e.isFunction(t)?t:function(){},n.length>0&&(S.debug("Hiding other modals",v),n.modal("hide modal",t,!0))},others:{active:function(){return v.filter("."+R.active).length>0},animating:function(){return v.filter("."+R.animating).length>0}},add:{keyboardShortcuts:function(){S.verbose("Adding keyboard shortcuts"),l.on("keyup"+F,S.event.keyboard)}},save:{focus:function(){b=e(n.activeElement).blur()}},restore:{focus:function(){b&&b.length>0&&b.focus()}},remove:{active:function(){D.removeClass(R.active)},clickaway:function(){T.closable&&x.off("click"+C)},bodyStyle:function(){""===c.attr("style")&&(S.verbose("Removing style attribute"),c.removeAttr("style"))},screenHeight:function(){S.debug("Removing page height"),c.css("height","")},keyboardShortcuts:function(){S.verbose("Removing keyboard shortcuts"),l.off("keyup"+F)},scrolling:function(){y.removeClass(R.scrolling),D.removeClass(R.scrolling)}},cacheSizes:function(){var o=D.outerHeight();S.cache!==i&&0===o||(S.cache={pageHeight:e(n).outerHeight(),height:o+T.offset,contextHeight:"body"==T.context?e(t).height():y.height()}),S.debug("Caching modal and container sizes",S.cache)},can:{fit:function(){return S.cache.height+2*T.padding<S.cache.contextHeight}},is:{active:function(){return D.hasClass(R.active)},animating:function(){return D.transition("is supported")?D.transition("is animating"):D.is(":visible")},scrolling:function(){return y.hasClass(R.scrolling)},modernBrowser:function(){return!(t.ActiveXObject||"ActiveXObject"in t)}},set:{autofocus:function(){var e=D.find("[tabindex], :input").filter(":visible"),t=e.filter("[autofocus]"),n=t.length>0?t.first():e.first();n.length>0&&n.focus()},clickaway:function(){T.closable&&x.on("click"+C,S.event.click)},screenHeight:function(){S.can.fit()?c.css("height",""):(S.debug("Modal is taller than page content, resizing page height"),c.css("height",S.cache.height+2*T.padding))},active:function(){D.addClass(R.active)},scrolling:function(){y.addClass(R.scrolling),D.addClass(R.scrolling)},type:function(){S.can.fit()?(S.verbose("Modal fits on screen"),S.others.active()||S.others.animating()||S.remove.scrolling()):(S.verbose("Modal cannot fit on screen setting to scrolling"),S.set.scrolling())},position:function(){S.verbose("Centering modal on page",S.cache),S.can.fit()?D.css({top:"",marginTop:-(S.cache.height/2)}):D.css({marginTop:"",top:l.scrollTop()})},undetached:function(){y.addClass(R.undetached)}},setting:function(t,n){if(S.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,T,t);else{if(n===i)return T[t];e.isPlainObject(T[t])?e.extend(!0,T[t],n):T[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,S,t);else{if(n===i)return S[t];S[t]=n}},debug:function(){!T.silent&&T.debug&&(T.performance?S.performance.log(arguments):(S.debug=Function.prototype.bind.call(console.info,console,T.name+":"),S.debug.apply(console,arguments)))},verbose:function(){!T.silent&&T.verbose&&T.debug&&(T.performance?S.performance.log(arguments):(S.verbose=Function.prototype.bind.call(console.info,console,T.name+":"),S.verbose.apply(console,arguments)))},error:function(){T.silent||(S.error=Function.prototype.bind.call(console.error,console,T.name+":"),S.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;T.performance&&(t=(new Date).getTime(),i=d||t,n=t-i,d=t,f.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:z,"Execution Time":n})),clearTimeout(S.performance.timer),S.performance.timer=setTimeout(S.performance.display,500)},display:function(){var t=T.name+":",n=0;d=!1,clearTimeout(S.performance.timer),e.each(f,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",u&&(t+=" '"+u+"'"),(console.group!==i||console.table!==i)&&f.length>0&&(console.groupCollapsed(t),console.table?console.table(f):e.each(f,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),f=[]}},invoke:function(t,n,o){var r,s,l,c=I;return n=n||p,o=z||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},g?(I===i&&S.initialize(),S.invoke(m)):(I!==i&&I.invoke("destroy"),S.initialize())}),a!==i?a:this},e.fn.modal.settings={name:"Modal",namespace:"modal",silent:!1,debug:!1,verbose:!1,performance:!0,observeChanges:!1,allowMultiple:!1,detachable:!0,closable:!0,autofocus:!0,inverted:!1,blurring:!1,dimmerSettings:{closable:!1,useCSS:!0},keyboardShortcuts:!0,context:"body",queue:!1,duration:500,offset:0,transition:"scale",padding:50,onShow:function(){},onVisible:function(){},onHide:function(){return!0},onHidden:function(){},onApprove:function(){return!0},onDeny:function(){return!0},selector:{close:"> .close",approve:".actions .positive, .actions .approve, .actions .ok",deny:".actions .negative, .actions .deny, .actions .cancel",modal:".ui.modal"},error:{dimmer:"UI Dimmer, a required component is not included in this page",method:"The method you called is not defined.",notFound:"The element you specified could not be found"},className:{active:"active",animating:"animating",blurring:"blurring",scrolling:"scrolling",undetached:"undetached"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.nag=function(n){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var a,f=e.isPlainObject(n)?e.extend(!0,{},e.fn.nag.settings,n):e.extend({},e.fn.nag.settings),m=(f.className,f.selector),g=f.error,p=f.namespace,h="."+p,v=p+"-module",b=e(this),y=(b.find(m.close),e(f.context?f.context:"body")),x=this,C=b.data(v);t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};a={initialize:function(){a.verbose("Initializing element"),b.on("click"+h,m.close,a.dismiss).data(v,a),f.detachable&&b.parent()[0]!==y[0]&&b.detach().prependTo(y),f.displayTime>0&&setTimeout(a.hide,f.displayTime),a.show()},destroy:function(){a.verbose("Destroying instance"),b.removeData(v).off(h)},show:function(){a.should.show()&&!b.is(":visible")&&(a.debug("Showing nag",f.animation.show),"fade"==f.animation.show?b.fadeIn(f.duration,f.easing):b.slideDown(f.duration,f.easing))},hide:function(){a.debug("Showing nag",f.animation.hide),"fade"==f.animation.show?b.fadeIn(f.duration,f.easing):b.slideUp(f.duration,f.easing)},onHide:function(){a.debug("Removing nag",f.animation.hide),b.remove(),f.onHide&&f.onHide()},dismiss:function(e){f.storageMethod&&a.storage.set(f.key,f.value),a.hide(),e.stopImmediatePropagation(),e.preventDefault()},should:{show:function(){return f.persist?(a.debug("Persistent nag is set, can show nag"),!0):a.storage.get(f.key)!=f.value.toString()?(a.debug("Stored value is not set, can show nag",a.storage.get(f.key)),!0):(a.debug("Stored value is set, cannot show nag",a.storage.get(f.key)),!1)}},get:{storageOptions:function(){var e={};return f.expires&&(e.expires=f.expires),f.domain&&(e.domain=f.domain),f.path&&(e.path=f.path),e}},clear:function(){a.storage.remove(f.key)},storage:{set:function(n,o){var r=a.get.storageOptions();if("localstorage"==f.storageMethod&&t.localStorage!==i)t.localStorage.setItem(n,o),a.debug("Value stored using local storage",n,o);else if("sessionstorage"==f.storageMethod&&t.sessionStorage!==i)t.sessionStorage.setItem(n,o),a.debug("Value stored using session storage",n,o);else{if(e.cookie===i)return void a.error(g.noCookieStorage);e.cookie(n,o,r),a.debug("Value stored using cookie",n,o,r)}},get:function(n,o){var r;return"localstorage"==f.storageMethod&&t.localStorage!==i?r=t.localStorage.getItem(n):"sessionstorage"==f.storageMethod&&t.sessionStorage!==i?r=t.sessionStorage.getItem(n):e.cookie!==i?r=e.cookie(n):a.error(g.noCookieStorage),"undefined"!=r&&"null"!=r&&r!==i&&null!==r||(r=i),r},remove:function(n){var o=a.get.storageOptions();"localstorage"==f.storageMethod&&t.localStorage!==i?t.localStorage.removeItem(n):"sessionstorage"==f.storageMethod&&t.sessionStorage!==i?t.sessionStorage.removeItem(n):e.cookie!==i?e.removeCookie(n,o):a.error(g.noStorage)}},setting:function(t,n){if(a.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];e.isPlainObject(f[t])?e.extend(!0,f[t],n):f[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,a,t);else{if(n===i)return a[t];a[t]=n}},debug:function(){!f.silent&&f.debug&&(f.performance?a.performance.log(arguments):(a.debug=Function.prototype.bind.call(console.info,console,f.name+":"),a.debug.apply(console,arguments)))},verbose:function(){!f.silent&&f.verbose&&f.debug&&(f.performance?a.performance.log(arguments):(a.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),a.verbose.apply(console,arguments)))},error:function(){f.silent||(a.error=Function.prototype.bind.call(console.error,console,f.name+":"),a.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;f.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:x,"Execution Time":n})),clearTimeout(a.performance.timer),a.performance.timer=setTimeout(a.performance.display,500)},display:function(){var t=f.name+":",n=0;s=!1,clearTimeout(a.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,r){var s,l,c,u=C;return n=n||d,r=x||r,"string"==typeof t&&u!==i&&(t=t.split(/[\. ]/),s=t.length-1,e.each(t,function(n,o){var r=n!=s?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(u[r])&&n!=s)u=u[r];else{if(u[r]!==i)return l=u[r],!1;if(!e.isPlainObject(u[o])||n==s)return u[o]!==i?(l=u[o],!1):(a.error(g.method,t),!1);u=u[o]}})),e.isFunction(l)?c=l.apply(r,n):l!==i&&(c=l),e.isArray(o)?o.push(c):o!==i?o=[o,c]:c!==i&&(o=c),l}},u?(C===i&&a.initialize(),a.invoke(c)):(C!==i&&C.invoke("destroy"),a.initialize())}),o!==i?o:this},e.fn.nag.settings={name:"Nag",silent:!1,debug:!1,verbose:!1,performance:!0,namespace:"Nag",persist:!1,displayTime:0,animation:{show:"slide",hide:"slide"},context:!1,detachable:!1,expires:30,domain:!1,path:"/",storageMethod:"cookie",key:"nag",value:"dismiss",error:{noCookieStorage:"$.cookie is not included. A storage solution is required.",noStorage:"Neither $.cookie or store is defined. A storage solution is required for storing state",method:"The method you called is not defined."},className:{bottom:"bottom",fixed:"fixed"},selector:{close:".close.icon"},speed:500,easing:"easeOutQuad",onHide:function(){}},e.extend(e.easing,{easeOutQuad:function(e,t,n,i,o){return-i*(t/=o)*(t-2)+n}})}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.popup=function(o){var a,r=e(this),s=e(n),l=e(t),c=e("body"),u=r.selector||"",d=!0,f=(new Date).getTime(),m=[],g=arguments[0],p="string"==typeof g,h=[].slice.call(arguments,1);return r.each(function(){var r,v,b,y,x,C,w=e.isPlainObject(o)?e.extend(!0,{},e.fn.popup.settings,o):e.extend({},e.fn.popup.settings),k=w.selector,S=w.className,T=w.error,A=w.metadata,R=w.namespace,P="."+w.namespace,E="module-"+R,F=e(this),O=e(w.context),D=e(w.scrollContext),q=e(w.boundary),j=w.target?e(w.target):F,z=0,I=!1,M=!1,L=this,N=F.data(E);C={initialize:function(){C.debug("Initializing",F),C.createID(),C.bind.events(),!C.exists()&&w.preserve&&C.create(),w.observeChanges&&C.observeChanges(),C.instantiate()},instantiate:function(){C.verbose("Storing instance",C),N=C,F.data(E,N)},observeChanges:function(){"MutationObserver"in t&&(b=new MutationObserver(C.event.documentChanged),b.observe(n,{childList:!0,subtree:!0}),C.debug("Setting up mutation observer",b))},refresh:function(){w.popup?r=e(w.popup).eq(0):w.inline&&(r=j.nextAll(k.popup).eq(0),w.popup=r),w.popup?(r.addClass(S.loading),v=C.get.offsetParent(),r.removeClass(S.loading),w.movePopup&&C.has.popup()&&C.get.offsetParent(r)[0]!==v[0]&&(C.debug("Moving popup to the same offset parent as activating element"),r.detach().appendTo(v))):v=w.inline?C.get.offsetParent(j):C.has.popup()?C.get.offsetParent(r):c,v.is("html")&&v[0]!==c[0]&&(C.debug("Setting page as offset parent"),v=c),C.get.variation()&&C.set.variation()},reposition:function(){C.refresh(),C.set.position()},destroy:function(){C.debug("Destroying previous module"),b&&b.disconnect(),r&&!w.preserve&&C.removePopup(),clearTimeout(C.hideTimer),clearTimeout(C.showTimer),C.unbind.close(),C.unbind.events(),F.removeData(E)},event:{start:function(t){var n=e.isPlainObject(w.delay)?w.delay.show:w.delay;clearTimeout(C.hideTimer),M||(C.showTimer=setTimeout(C.show,n))},end:function(){var t=e.isPlainObject(w.delay)?w.delay.hide:w.delay;clearTimeout(C.showTimer),C.hideTimer=setTimeout(C.hide,t)},touchstart:function(e){M=!0,C.show()},resize:function(){C.is.visible()&&C.set.position()},documentChanged:function(t){[].forEach.call(t,function(t){t.removedNodes&&[].forEach.call(t.removedNodes,function(t){(t==L||e(t).find(L).length>0)&&(C.debug("Element removed from DOM, tearing down events"),
C.destroy())})})},hideGracefully:function(t){var i=e(t.target),o=e.contains(n.documentElement,t.target),a=i.closest(k.popup).length>0;t&&!a&&o?(C.debug("Click occurred outside popup hiding popup"),C.hide()):C.debug("Click was inside popup, keeping popup open")}},create:function(){var t=C.get.html(),n=C.get.title(),i=C.get.content();t||i||n?(C.debug("Creating pop-up html"),t||(t=w.templates.popup({title:n,content:i})),r=e("<div/>").addClass(S.popup).data(A.activator,F).html(t),w.inline?(C.verbose("Inserting popup element inline",r),r.insertAfter(F)):(C.verbose("Appending popup element to body",r),r.appendTo(O)),C.refresh(),C.set.variation(),w.hoverable&&C.bind.popup(),w.onCreate.call(r,L)):0!==j.next(k.popup).length?(C.verbose("Pre-existing popup found"),w.inline=!0,w.popup=j.next(k.popup).data(A.activator,F),C.refresh(),w.hoverable&&C.bind.popup()):w.popup?(e(w.popup).data(A.activator,F),C.verbose("Used popup specified in settings"),C.refresh(),w.hoverable&&C.bind.popup()):C.debug("No content specified skipping display",L)},createID:function(){x=(Math.random().toString(16)+"000000000").substr(2,8),y="."+x,C.verbose("Creating unique id for element",x)},toggle:function(){C.debug("Toggling pop-up"),C.is.hidden()?(C.debug("Popup is hidden, showing pop-up"),C.unbind.close(),C.show()):(C.debug("Popup is visible, hiding pop-up"),C.hide())},show:function(e){if(e=e||function(){},C.debug("Showing pop-up",w.transition),C.is.hidden()&&(!C.is.active()||!C.is.dropdown())){if(C.exists()||C.create(),w.onShow.call(r,L)===!1)return void C.debug("onShow callback returned false, cancelling popup animation");w.preserve||w.popup||C.refresh(),r&&C.set.position()&&(C.save.conditions(),w.exclusive&&C.hideAll(),C.animate.show(e))}},hide:function(e){if(e=e||function(){},C.is.visible()||C.is.animating()){if(w.onHide.call(r,L)===!1)return void C.debug("onHide callback returned false, cancelling popup animation");C.remove.visible(),C.unbind.close(),C.restore.conditions(),C.animate.hide(e)}},hideAll:function(){e(k.popup).filter("."+S.visible).each(function(){e(this).data(A.activator).popup("hide")})},exists:function(){return r?w.inline||w.popup?C.has.popup():r.closest(O).length>=1:!1},removePopup:function(){C.has.popup()&&!w.popup&&(C.debug("Removing popup",r),r.remove(),r=i,w.onRemove.call(r,L))},save:{conditions:function(){C.cache={title:F.attr("title")},C.cache.title&&F.removeAttr("title"),C.verbose("Saving original attributes",C.cache.title)}},restore:{conditions:function(){return C.cache&&C.cache.title&&(F.attr("title",C.cache.title),C.verbose("Restoring original attributes",C.cache.title)),!0}},supports:{svg:function(){return typeof SVGGraphicsElement===i}},animate:{show:function(t){t=e.isFunction(t)?t:function(){},w.transition&&e.fn.transition!==i&&F.transition("is supported")?(C.set.visible(),r.transition({animation:w.transition+" in",queue:!1,debug:w.debug,verbose:w.verbose,duration:w.duration,onComplete:function(){C.bind.close(),t.call(r,L),w.onVisible.call(r,L)}})):C.error(T.noTransition)},hide:function(t){return t=e.isFunction(t)?t:function(){},C.debug("Hiding pop-up"),w.onHide.call(r,L)===!1?void C.debug("onHide callback returned false, cancelling popup animation"):void(w.transition&&e.fn.transition!==i&&F.transition("is supported")?r.transition({animation:w.transition+" out",queue:!1,duration:w.duration,debug:w.debug,verbose:w.verbose,onComplete:function(){C.reset(),t.call(r,L),w.onHidden.call(r,L)}}):C.error(T.noTransition))}},change:{content:function(e){r.html(e)}},get:{html:function(){return F.removeData(A.html),F.data(A.html)||w.html},title:function(){return F.removeData(A.title),F.data(A.title)||w.title},content:function(){return F.removeData(A.content),F.data(A.content)||F.attr("title")||w.content},variation:function(){return F.removeData(A.variation),F.data(A.variation)||w.variation},popup:function(){return r},popupOffset:function(){return r.offset()},calculations:function(){var e,n=j[0],i=q[0]==t,o=w.inline||w.popup&&w.movePopup?j.position():j.offset(),a=i?{top:0,left:0}:q.offset(),s={},c=i?{top:l.scrollTop(),left:l.scrollLeft()}:{top:0,left:0};return s={target:{element:j[0],width:j.outerWidth(),height:j.outerHeight(),top:o.top,left:o.left,margin:{}},popup:{width:r.outerWidth(),height:r.outerHeight()},parent:{width:v.outerWidth(),height:v.outerHeight()},screen:{top:a.top,left:a.left,scroll:{top:c.top,left:c.left},width:q.width(),height:q.height()}},w.setFluidWidth&&C.is.fluid()&&(s.container={width:r.parent().outerWidth()},s.popup.width=s.container.width),s.target.margin.top=w.inline?parseInt(t.getComputedStyle(n).getPropertyValue("margin-top"),10):0,s.target.margin.left=w.inline?C.is.rtl()?parseInt(t.getComputedStyle(n).getPropertyValue("margin-right"),10):parseInt(t.getComputedStyle(n).getPropertyValue("margin-left"),10):0,e=s.screen,s.boundary={top:e.top+e.scroll.top,bottom:e.top+e.scroll.top+e.height,left:e.left+e.scroll.left,right:e.left+e.scroll.left+e.width},s},id:function(){return x},startEvent:function(){return"hover"==w.on?"mouseenter":"focus"==w.on?"focus":!1},scrollEvent:function(){return"scroll"},endEvent:function(){return"hover"==w.on?"mouseleave":"focus"==w.on?"blur":!1},distanceFromBoundary:function(e,t){var n,i,o={};return t=t||C.get.calculations(),n=t.popup,i=t.boundary,e&&(o={top:e.top-i.top,left:e.left-i.left,right:i.right-(e.left+n.width),bottom:i.bottom-(e.top+n.height)},C.verbose("Distance from boundaries determined",e,o)),o},offsetParent:function(t){var n=t!==i?t[0]:F[0],o=n.parentNode,a=e(o);if(o)for(var r="none"===a.css("transform"),s="static"===a.css("position"),l=a.is("html");o&&!l&&s&&r;)o=o.parentNode,a=e(o),r="none"===a.css("transform"),s="static"===a.css("position"),l=a.is("html");return a&&a.length>0?a:e()},positions:function(){return{"top left":!1,"top center":!1,"top right":!1,"bottom left":!1,"bottom center":!1,"bottom right":!1,"left center":!1,"right center":!1}},nextPosition:function(e){var t=e.split(" "),n=t[0],i=t[1],o={top:"bottom",bottom:"top",left:"right",right:"left"},a={left:"center",center:"right",right:"left"},r={"top left":"top center","top center":"top right","top right":"right center","right center":"bottom right","bottom right":"bottom center","bottom center":"bottom left","bottom left":"left center","left center":"top left"},s="top"==n||"bottom"==n,l=!1,c=!1,u=!1;return I||(C.verbose("All available positions available"),I=C.get.positions()),C.debug("Recording last position tried",e),I[e]=!0,"opposite"===w.prefer&&(u=[o[n],i],u=u.join(" "),l=I[u]===!0,C.debug("Trying opposite strategy",u)),"adjacent"===w.prefer&&s&&(u=[n,a[i]],u=u.join(" "),c=I[u]===!0,C.debug("Trying adjacent strategy",u)),(c||l)&&(C.debug("Using backup position",u),u=r[e]),u}},set:{position:function(e,t){if(0===j.length||0===r.length)return void C.error(T.notFound);var n,o,a,s,l,c,u,d;if(t=t||C.get.calculations(),e=e||F.data(A.position)||w.position,n=F.data(A.offset)||w.offset,o=w.distanceAway,a=t.target,s=t.popup,l=t.parent,0===a.width&&0===a.height&&!C.is.svg(a.element))return C.debug("Popup target is hidden, no action taken"),!1;switch(w.inline&&(C.debug("Adding margin to calculation",a.margin),"left center"==e||"right center"==e?(n+=a.margin.top,o+=-a.margin.left):"top left"==e||"top center"==e||"top right"==e?(n+=a.margin.left,o-=a.margin.top):(n+=a.margin.left,o+=a.margin.top)),C.debug("Determining popup position from calculations",e,t),C.is.rtl()&&(e=e.replace(/left|right/g,function(e){return"left"==e?"right":"left"}),C.debug("RTL: Popup position updated",e)),z==w.maxSearchDepth&&"string"==typeof w.lastResort&&(e=w.lastResort),e){case"top left":c={top:"auto",bottom:l.height-a.top+o,left:a.left+n,right:"auto"};break;case"top center":c={bottom:l.height-a.top+o,left:a.left+a.width/2-s.width/2+n,top:"auto",right:"auto"};break;case"top right":c={bottom:l.height-a.top+o,right:l.width-a.left-a.width-n,top:"auto",left:"auto"};break;case"left center":c={top:a.top+a.height/2-s.height/2+n,right:l.width-a.left+o,left:"auto",bottom:"auto"};break;case"right center":c={top:a.top+a.height/2-s.height/2+n,left:a.left+a.width+o,bottom:"auto",right:"auto"};break;case"bottom left":c={top:a.top+a.height+o,left:a.left+n,bottom:"auto",right:"auto"};break;case"bottom center":c={top:a.top+a.height+o,left:a.left+a.width/2-s.width/2+n,bottom:"auto",right:"auto"};break;case"bottom right":c={top:a.top+a.height+o,right:l.width-a.left-a.width-n,left:"auto",bottom:"auto"}}if(c===i&&C.error(T.invalidPosition,e),C.debug("Calculated popup positioning values",c),r.css(c).removeClass(S.position).addClass(e).addClass(S.loading),u=C.get.popupOffset(),d=C.get.distanceFromBoundary(u,t),C.is.offstage(d,e)){if(C.debug("Position is outside viewport",e),z<w.maxSearchDepth)return z++,e=C.get.nextPosition(e),C.debug("Trying new position",e),r?C.set.position(e,t):!1;if(!w.lastResort)return C.debug("Popup could not find a position to display",r),C.error(T.cannotPlace,L),C.remove.attempts(),C.remove.loading(),C.reset(),w.onUnplaceable.call(r,L),!1;C.debug("No position found, showing with last position")}return C.debug("Position is on stage",e),C.remove.attempts(),C.remove.loading(),w.setFluidWidth&&C.is.fluid()&&C.set.fluidWidth(t),!0},fluidWidth:function(e){e=e||C.get.calculations(),C.debug("Automatically setting element width to parent width",e.parent.width),r.css("width",e.container.width)},variation:function(e){e=e||C.get.variation(),e&&C.has.popup()&&(C.verbose("Adding variation to popup",e),r.addClass(e))},visible:function(){F.addClass(S.visible)}},remove:{loading:function(){r.removeClass(S.loading)},variation:function(e){e=e||C.get.variation(),e&&(C.verbose("Removing variation",e),r.removeClass(e))},visible:function(){F.removeClass(S.visible)},attempts:function(){C.verbose("Resetting all searched positions"),z=0,I=!1}},bind:{events:function(){C.debug("Binding popup events to module"),"click"==w.on&&F.on("click"+P,C.toggle),"hover"==w.on&&d&&F.on("touchstart"+P,C.event.touchstart),C.get.startEvent()&&F.on(C.get.startEvent()+P,C.event.start).on(C.get.endEvent()+P,C.event.end),w.target&&C.debug("Target set to element",j),l.on("resize"+y,C.event.resize)},popup:function(){C.verbose("Allowing hover events on popup to prevent closing"),r&&C.has.popup()&&r.on("mouseenter"+P,C.event.start).on("mouseleave"+P,C.event.end)},close:function(){(w.hideOnScroll===!0||"auto"==w.hideOnScroll&&"click"!=w.on)&&D.one(C.get.scrollEvent()+y,C.event.hideGracefully),"hover"==w.on&&M&&(C.verbose("Binding popup close event to document"),s.on("touchstart"+y,function(e){C.verbose("Touched away from popup"),C.event.hideGracefully.call(L,e)})),"click"==w.on&&w.closable&&(C.verbose("Binding popup close event to document"),s.on("click"+y,function(e){C.verbose("Clicked away from popup"),C.event.hideGracefully.call(L,e)}))}},unbind:{events:function(){l.off(y),F.off(P)},close:function(){s.off(y),D.off(y)}},has:{popup:function(){return r&&r.length>0}},is:{offstage:function(t,n){var i=[];return e.each(t,function(e,t){t<-w.jitter&&(C.debug("Position exceeds allowable distance from edge",e,t,n),i.push(e))}),i.length>0},svg:function(e){return C.supports.svg()&&e instanceof SVGGraphicsElement},active:function(){return F.hasClass(S.active)},animating:function(){return r!==i&&r.hasClass(S.animating)},fluid:function(){return r!==i&&r.hasClass(S.fluid)},visible:function(){return r!==i&&r.hasClass(S.visible)},dropdown:function(){return F.hasClass(S.dropdown)},hidden:function(){return!C.is.visible()},rtl:function(){return"rtl"==F.css("direction")}},reset:function(){C.remove.visible(),w.preserve?e.fn.transition!==i&&r.transition("remove transition"):C.removePopup()},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,w,t);else{if(n===i)return w[t];w[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,C,t);else{if(n===i)return C[t];C[t]=n}},debug:function(){!w.silent&&w.debug&&(w.performance?C.performance.log(arguments):(C.debug=Function.prototype.bind.call(console.info,console,w.name+":"),C.debug.apply(console,arguments)))},verbose:function(){!w.silent&&w.verbose&&w.debug&&(w.performance?C.performance.log(arguments):(C.verbose=Function.prototype.bind.call(console.info,console,w.name+":"),C.verbose.apply(console,arguments)))},error:function(){w.silent||(C.error=Function.prototype.bind.call(console.error,console,w.name+":"),C.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;w.performance&&(t=(new Date).getTime(),i=f||t,n=t-i,f=t,m.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:L,"Execution Time":n})),clearTimeout(C.performance.timer),C.performance.timer=setTimeout(C.performance.display,500)},display:function(){var t=w.name+":",n=0;f=!1,clearTimeout(C.performance.timer),e.each(m,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",u&&(t+=" '"+u+"'"),(console.group!==i||console.table!==i)&&m.length>0&&(console.groupCollapsed(t),console.table?console.table(m):e.each(m,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),m=[]}},invoke:function(t,n,o){var r,s,l,c=N;return n=n||h,o=L||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},p?(N===i&&C.initialize(),C.invoke(g)):(N!==i&&N.invoke("destroy"),C.initialize())}),a!==i?a:this},e.fn.popup.settings={name:"Popup",silent:!1,debug:!1,verbose:!1,performance:!0,namespace:"popup",observeChanges:!0,onCreate:function(){},onRemove:function(){},onShow:function(){},onVisible:function(){},onHide:function(){},onUnplaceable:function(){},onHidden:function(){},on:"hover",boundary:t,addTouchEvents:!0,position:"top left",variation:"",movePopup:!0,target:!1,popup:!1,inline:!1,preserve:!1,hoverable:!1,content:!1,html:!1,title:!1,closable:!0,hideOnScroll:"auto",exclusive:!1,context:"body",scrollContext:t,prefer:"opposite",lastResort:!1,delay:{show:50,hide:70},setFluidWidth:!0,duration:200,transition:"scale",distanceAway:0,jitter:2,offset:0,maxSearchDepth:15,error:{invalidPosition:"The position you specified is not a valid position",cannotPlace:"Popup does not fit within the boundaries of the viewport",method:"The method you called is not defined.",noTransition:"This module requires ui transitions <https://github.com/Semantic-Org/UI-Transition>",notFound:"The target or popup you specified does not exist on the page"},metadata:{activator:"activator",content:"content",html:"html",offset:"offset",position:"position",title:"title",variation:"variation"},className:{active:"active",animating:"animating",dropdown:"dropdown",fluid:"fluid",loading:"loading",popup:"ui popup",position:"top left center bottom right",visible:"visible"},selector:{popup:".ui.popup"},templates:{escape:function(e){var t=/[&<>"'`]/g,n=/[&<>"'`]/,i={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},o=function(e){return i[e]};return n.test(e)?e.replace(t,o):e},popup:function(t){var n="",o=e.fn.popup.settings.templates.escape;return typeof t!==i&&(typeof t.title!==i&&t.title&&(t.title=o(t.title),n+='<div class="header">'+t.title+"</div>"),typeof t.content!==i&&t.content&&(t.content=o(t.content),n+='<div class="content">'+t.content+"</div>")),n}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();e.fn.progress=function(t){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var a,f,m=e.isPlainObject(t)?e.extend(!0,{},e.fn.progress.settings,t):e.extend({},e.fn.progress.settings),g=m.className,p=m.metadata,h=m.namespace,v=m.selector,b=m.error,y="."+h,x="module-"+h,C=e(this),w=e(this).find(v.bar),k=e(this).find(v.progress),S=e(this).find(v.label),T=this,A=C.data(x),R=!1;f={initialize:function(){f.debug("Initializing progress bar",m),f.set.duration(),f.set.transitionEvent(),f.read.metadata(),f.read.settings(),f.instantiate()},instantiate:function(){f.verbose("Storing instance of progress",f),A=f,C.data(x,f)},destroy:function(){f.verbose("Destroying previous progress for",C),clearInterval(A.interval),f.remove.state(),C.removeData(x),A=i},reset:function(){f.remove.nextValue(),f.update.progress(0)},complete:function(){(f.percent===i||f.percent<100)&&(f.remove.progressPoll(),f.set.percent(100))},read:{metadata:function(){var e={percent:C.data(p.percent),total:C.data(p.total),value:C.data(p.value)};e.percent&&(f.debug("Current percent value set from metadata",e.percent),f.set.percent(e.percent)),e.total&&(f.debug("Total value set from metadata",e.total),f.set.total(e.total)),e.value&&(f.debug("Current value set from metadata",e.value),f.set.value(e.value),f.set.progress(e.value))},settings:function(){m.total!==!1&&(f.debug("Current total set in settings",m.total),f.set.total(m.total)),m.value!==!1&&(f.debug("Current value set in settings",m.value),f.set.value(m.value),f.set.progress(f.value)),m.percent!==!1&&(f.debug("Current percent set in settings",m.percent),f.set.percent(m.percent))}},bind:{transitionEnd:function(e){var t=f.get.transitionEnd();w.one(t+y,function(t){clearTimeout(f.failSafeTimer),e.call(this,t)}),f.failSafeTimer=setTimeout(function(){w.triggerHandler(t)},m.duration+m.failSafeDelay),f.verbose("Adding fail safe timer",f.timer)}},increment:function(e){var t,n,i;f.has.total()?(n=f.get.value(),e=e||1,i=n+e):(n=f.get.percent(),e=e||f.get.randomValue(),i=n+e,t=100,f.debug("Incrementing percentage by",n,i)),i=f.get.normalizedValue(i),f.set.progress(i)},decrement:function(e){var t,n,i=f.get.total();i?(t=f.get.value(),e=e||1,n=t-e,f.debug("Decrementing value by",e,t)):(t=f.get.percent(),e=e||f.get.randomValue(),n=t-e,f.debug("Decrementing percentage by",e,t)),n=f.get.normalizedValue(n),f.set.progress(n)},has:{progressPoll:function(){return f.progressPoll},total:function(){return f.get.total()!==!1}},get:{text:function(e){var t=f.value||0,n=f.total||0,i=R?f.get.displayPercent():f.percent||0,o=f.total>0?n-t:100-i;return e=e||"",e=e.replace("{value}",t).replace("{total}",n).replace("{left}",o).replace("{percent}",i),f.verbose("Adding variables to progress bar text",e),e},normalizedValue:function(e){if(0>e)return f.debug("Value cannot decrement below 0"),0;if(f.has.total()){if(e>f.total)return f.debug("Value cannot increment above total",f.total),f.total}else if(e>100)return f.debug("Value cannot increment above 100 percent"),100;return e},updateInterval:function(){return"auto"==m.updateInterval?m.duration:m.updateInterval},randomValue:function(){return f.debug("Generating random increment percentage"),Math.floor(Math.random()*m.random.max+m.random.min)},numericValue:function(e){return"string"==typeof e?""!==e.replace(/[^\d.]/g,"")?+e.replace(/[^\d.]/g,""):!1:e},transitionEnd:function(){var e,t=n.createElement("element"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in o)if(t.style[e]!==i)return o[e]},displayPercent:function(){var e=w.width(),t=C.width(),n=parseInt(w.css("min-width"),10),i=e>n?e/t*100:f.percent;return m.precision>0?Math.round(i*(10*m.precision))/(10*m.precision):Math.round(i)},percent:function(){return f.percent||0},value:function(){return f.nextValue||f.value||0},total:function(){return f.total||!1}},create:{progressPoll:function(){f.progressPoll=setTimeout(function(){f.update.toNextValue(),f.remove.progressPoll()},f.get.updateInterval())}},is:{complete:function(){return f.is.success()||f.is.warning()||f.is.error()},success:function(){return C.hasClass(g.success)},warning:function(){return C.hasClass(g.warning)},error:function(){return C.hasClass(g.error)},active:function(){return C.hasClass(g.active)},visible:function(){return C.is(":visible")}},remove:{progressPoll:function(){f.verbose("Removing progress poll timer"),f.progressPoll&&(clearTimeout(f.progressPoll),delete f.progressPoll)},nextValue:function(){f.verbose("Removing progress value stored for next update"),delete f.nextValue},state:function(){f.verbose("Removing stored state"),delete f.total,delete f.percent,delete f.value},active:function(){f.verbose("Removing active state"),C.removeClass(g.active)},success:function(){f.verbose("Removing success state"),C.removeClass(g.success)},warning:function(){f.verbose("Removing warning state"),C.removeClass(g.warning)},error:function(){f.verbose("Removing error state"),C.removeClass(g.error)}},set:{barWidth:function(e){e>100?f.error(b.tooHigh,e):0>e?f.error(b.tooLow,e):(w.css("width",e+"%"),C.attr("data-percent",parseInt(e,10)))},duration:function(e){e=e||m.duration,e="number"==typeof e?e+"ms":e,f.verbose("Setting progress bar transition duration",e),w.css({"transition-duration":e})},percent:function(e){e="string"==typeof e?+e.replace("%",""):e,e=m.precision>0?Math.round(e*(10*m.precision))/(10*m.precision):Math.round(e),f.percent=e,f.has.total()||(f.value=m.precision>0?Math.round(e/100*f.total*(10*m.precision))/(10*m.precision):Math.round(e/100*f.total*10)/10,m.limitValues&&(f.value=f.value>100?100:f.value<0?0:f.value)),f.set.barWidth(e),f.set.labelInterval(),f.set.labels(),m.onChange.call(T,e,f.value,f.total)},labelInterval:function(){var t=function(){f.verbose("Bar finished animating, removing continuous label updates"),clearInterval(f.interval),R=!1,f.set.labels()};clearInterval(f.interval),f.bind.transitionEnd(t),R=!0,f.interval=setInterval(function(){var t=e.contains(n.documentElement,T);t||(clearInterval(f.interval),R=!1),f.set.labels()},m.framerate)},labels:function(){f.verbose("Setting both bar progress and outer label text"),f.set.barLabel(),f.set.state()},label:function(e){e=e||"",e&&(e=f.get.text(e),f.verbose("Setting label to text",e),S.text(e))},state:function(e){e=e!==i?e:f.percent,100===e?m.autoSuccess&&!(f.is.warning()||f.is.error()||f.is.success())?(f.set.success(),f.debug("Automatically triggering success at 100%")):(f.verbose("Reached 100% removing active state"),f.remove.active(),f.remove.progressPoll()):e>0?(f.verbose("Adjusting active progress bar label",e),f.set.active()):(f.remove.active(),f.set.label(m.text.active))},barLabel:function(e){e!==i?k.text(f.get.text(e)):"ratio"==m.label&&f.total?(f.verbose("Adding ratio to bar label"),k.text(f.get.text(m.text.ratio))):"percent"==m.label&&(f.verbose("Adding percentage to bar label"),k.text(f.get.text(m.text.percent)))},active:function(e){e=e||m.text.active,f.debug("Setting active state"),m.showActivity&&!f.is.active()&&C.addClass(g.active),f.remove.warning(),f.remove.error(),f.remove.success(),e=m.onLabelUpdate("active",e,f.value,f.total),e&&f.set.label(e),f.bind.transitionEnd(function(){m.onActive.call(T,f.value,f.total)})},success:function(e){e=e||m.text.success||m.text.active,f.debug("Setting success state"),C.addClass(g.success),f.remove.active(),f.remove.warning(),f.remove.error(),f.complete(),m.text.success?(e=m.onLabelUpdate("success",e,f.value,f.total),f.set.label(e)):(e=m.onLabelUpdate("active",e,f.value,f.total),f.set.label(e)),f.bind.transitionEnd(function(){m.onSuccess.call(T,f.total)})},warning:function(e){e=e||m.text.warning,f.debug("Setting warning state"),C.addClass(g.warning),f.remove.active(),f.remove.success(),f.remove.error(),f.complete(),e=m.onLabelUpdate("warning",e,f.value,f.total),e&&f.set.label(e),f.bind.transitionEnd(function(){m.onWarning.call(T,f.value,f.total)})},error:function(e){e=e||m.text.error,f.debug("Setting error state"),C.addClass(g.error),f.remove.active(),f.remove.success(),f.remove.warning(),f.complete(),e=m.onLabelUpdate("error",e,f.value,f.total),e&&f.set.label(e),f.bind.transitionEnd(function(){m.onError.call(T,f.value,f.total)})},transitionEvent:function(){a=f.get.transitionEnd()},total:function(e){f.total=e},value:function(e){f.value=e},progress:function(e){f.has.progressPoll()?(f.debug("Updated within interval, setting next update to use new value",e),f.set.nextValue(e)):(f.debug("First update in progress update interval, immediately updating",e),f.update.progress(e),f.create.progressPoll())},nextValue:function(e){f.nextValue=e}},update:{toNextValue:function(){var e=f.nextValue;e&&(f.debug("Update interval complete using last updated value",e),f.update.progress(e),f.remove.nextValue())},progress:function(e){var t;e=f.get.numericValue(e),e===!1&&f.error(b.nonNumeric,e),e=f.get.normalizedValue(e),f.has.total()?(f.set.value(e),t=e/f.total*100,f.debug("Calculating percent complete from total",t),f.set.percent(t)):(t=e,f.debug("Setting value to exact percentage value",t),f.set.percent(t))}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;m.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:T,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;s=!1,clearTimeout(f.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=A;return n=n||d,a=T||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(f.error(b.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},u?(A===i&&f.initialize(),f.invoke(c)):(A!==i&&A.invoke("destroy"),f.initialize())}),o!==i?o:this},e.fn.progress.settings={name:"Progress",namespace:"progress",silent:!1,debug:!1,verbose:!1,performance:!0,random:{min:2,max:5},duration:300,updateInterval:"auto",autoSuccess:!0,showActivity:!0,limitValues:!0,label:"percent",precision:0,framerate:1e3/30,percent:!1,total:!1,value:!1,failSafeDelay:100,onLabelUpdate:function(e,t,n,i){return t},onChange:function(e,t,n){},onSuccess:function(e){},onActive:function(e,t){},onError:function(e,t){},onWarning:function(e,t){},error:{method:"The method you called is not defined.",nonNumeric:"Progress value is non numeric",tooHigh:"Value specified is above 100%",tooLow:"Value specified is below 0%"},regExp:{variable:/\{\$*[A-z0-9]+\}/g},metadata:{percent:"percent",total:"total",value:"value"},selector:{bar:"> .bar",label:"> .label",progress:".bar > .progress"},text:{active:!1,error:!1,success:!1,warning:!1,percent:"{percent}%",ratio:"{value} of {total}"},className:{active:"active",error:"error",success:"success",warning:"warning"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.rating=function(t){var n,o=e(this),a=o.selector||"",r=(new Date).getTime(),s=[],l=arguments[0],c="string"==typeof l,u=[].slice.call(arguments,1);return o.each(function(){var d,f,m=e.isPlainObject(t)?e.extend(!0,{},e.fn.rating.settings,t):e.extend({},e.fn.rating.settings),g=m.namespace,p=m.className,h=m.metadata,v=m.selector,b=(m.error,"."+g),y="module-"+g,x=this,C=e(this).data(y),w=e(this),k=w.find(v.icon);f={initialize:function(){f.verbose("Initializing rating module",m),0===k.length&&f.setup.layout(),m.interactive?f.enable():f.disable(),f.set.initialLoad(),f.set.rating(f.get.initialRating()),f.remove.initialLoad(),f.instantiate()},instantiate:function(){f.verbose("Instantiating module",m),C=f,w.data(y,f)},destroy:function(){f.verbose("Destroying previous instance",C),f.remove.events(),w.removeData(y)},refresh:function(){k=w.find(v.icon)},setup:{layout:function(){var t=f.get.maxRating(),n=e.fn.rating.settings.templates.icon(t);f.debug("Generating icon html dynamically"),w.html(n),f.refresh()}},event:{mouseenter:function(){var t=e(this);t.nextAll().removeClass(p.selected),w.addClass(p.selected),t.addClass(p.selected).prevAll().addClass(p.selected)},mouseleave:function(){w.removeClass(p.selected),k.removeClass(p.selected)},click:function(){var t=e(this),n=f.get.rating(),i=k.index(t)+1,o="auto"==m.clearable?1===k.length:m.clearable;o&&n==i?f.clearRating():f.set.rating(i)}},clearRating:function(){f.debug("Clearing current rating"),f.set.rating(0)},bind:{events:function(){f.verbose("Binding events"),w.on("mouseenter"+b,v.icon,f.event.mouseenter).on("mouseleave"+b,v.icon,f.event.mouseleave).on("click"+b,v.icon,f.event.click)}},remove:{events:function(){f.verbose("Removing events"),w.off(b)},initialLoad:function(){d=!1}},enable:function(){f.debug("Setting rating to interactive mode"),f.bind.events(),w.removeClass(p.disabled)},disable:function(){f.debug("Setting rating to read-only mode"),f.remove.events(),w.addClass(p.disabled)},is:{initialLoad:function(){return d}},get:{initialRating:function(){return w.data(h.rating)!==i?(w.removeData(h.rating),w.data(h.rating)):m.initialRating},maxRating:function(){return w.data(h.maxRating)!==i?(w.removeData(h.maxRating),w.data(h.maxRating)):m.maxRating},rating:function(){var e=k.filter("."+p.active).length;return f.verbose("Current rating retrieved",e),e}},set:{rating:function(e){var t=e-1>=0?e-1:0,n=k.eq(t);w.removeClass(p.selected),k.removeClass(p.selected).removeClass(p.active),e>0&&(f.verbose("Setting current rating to",e),n.prevAll().addBack().addClass(p.active)),f.is.initialLoad()||m.onRate.call(x,e)},initialLoad:function(){d=!0}},setting:function(t,n){if(f.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,f,t);else{if(n===i)return f[t];f[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?f.performance.log(arguments):(f.debug=Function.prototype.bind.call(console.info,console,m.name+":"),f.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?f.performance.log(arguments):(f.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),f.verbose.apply(console,arguments)))},error:function(){m.silent||(f.error=Function.prototype.bind.call(console.error,console,m.name+":"),f.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;m.performance&&(t=(new Date).getTime(),i=r||t,n=t-i,r=t,s.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:x,"Execution Time":n})),clearTimeout(f.performance.timer),f.performance.timer=setTimeout(f.performance.display,500)},display:function(){var t=m.name+":",n=0;r=!1,clearTimeout(f.performance.timer),e.each(s,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",a&&(t+=" '"+a+"'"),o.length>1&&(t+=" ("+o.length+")"),(console.group!==i||console.table!==i)&&s.length>0&&(console.groupCollapsed(t),console.table?console.table(s):e.each(s,function(e,t){
console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),s=[]}},invoke:function(t,o,a){var r,s,l,c=C;return o=o||u,a=x||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(a,o):s!==i&&(l=s),e.isArray(n)?n.push(l):n!==i?n=[n,l]:l!==i&&(n=l),s}},c?(C===i&&f.initialize(),f.invoke(l)):(C!==i&&C.invoke("destroy"),f.initialize())}),n!==i?n:this},e.fn.rating.settings={name:"Rating",namespace:"rating",slent:!1,debug:!1,verbose:!1,performance:!0,initialRating:0,interactive:!0,maxRating:4,clearable:"auto",fireOnInit:!1,onRate:function(e){},error:{method:"The method you called is not defined",noMaximum:"No maximum rating specified. Cannot generate HTML automatically"},metadata:{rating:"rating",maxRating:"maxRating"},className:{active:"active",disabled:"disabled",selected:"selected",loading:"loading"},selector:{icon:".icon"},templates:{icon:function(e){for(var t=1,n="";e>=t;)n+='<i class="icon"></i>',t++;return n}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.search=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1);return e(this).each(function(){var m,g=e.isPlainObject(o)?e.extend(!0,{},e.fn.search.settings,o):e.extend({},e.fn.search.settings),p=g.className,h=g.metadata,v=g.regExp,b=g.fields,y=g.selector,x=g.error,C=g.namespace,w="."+C,k=C+"-module",S=e(this),T=S.find(y.prompt),A=S.find(y.searchButton),R=S.find(y.results),P=S.find(y.result),E=S.find(y.category),F=this,O=S.data(k),D=!1,q=!1;m={initialize:function(){m.verbose("Initializing module"),m.determine.searchFields(),m.bind.events(),m.set.type(),m.create.results(),m.instantiate()},instantiate:function(){m.verbose("Storing instance of module",m),O=m,S.data(k,m)},destroy:function(){m.verbose("Destroying instance"),S.off(w).removeData(k)},refresh:function(){m.debug("Refreshing selector cache"),T=S.find(y.prompt),A=S.find(y.searchButton),E=S.find(y.category),R=S.find(y.results),P=S.find(y.result)},refreshResults:function(){R=S.find(y.results),P=S.find(y.result)},bind:{events:function(){m.verbose("Binding events to search"),g.automatic&&(S.on(m.get.inputEvent()+w,y.prompt,m.event.input),T.attr("autocomplete","off")),S.on("focus"+w,y.prompt,m.event.focus).on("blur"+w,y.prompt,m.event.blur).on("keydown"+w,y.prompt,m.handleKeyboard).on("click"+w,y.searchButton,m.query).on("mousedown"+w,y.results,m.event.result.mousedown).on("mouseup"+w,y.results,m.event.result.mouseup).on("click"+w,y.result,m.event.result.click)}},determine:{searchFields:function(){o&&o.searchFields!==i&&(g.searchFields=o.searchFields)}},event:{input:function(){clearTimeout(m.timer),m.timer=setTimeout(m.query,g.searchDelay)},focus:function(){m.set.focus(),g.searchOnFocus&&m.has.minimumCharacters()&&m.query(function(){m.can.show()&&m.showResults()})},blur:function(e){var t=n.activeElement===this,i=function(){m.cancel.query(),m.remove.focus(),m.timer=setTimeout(m.hideResults,g.hideDelay)};t||(q=!1,m.resultsClicked?(m.debug("Determining if user action caused search to close"),S.one("click.close"+w,y.results,function(e){return m.is.inMessage(e)||D?void T.focus():(D=!1,void(m.is.animating()||m.is.hidden()||i()))})):(m.debug("Input blurred without user action, closing results"),i()))},result:{mousedown:function(){m.resultsClicked=!0},mouseup:function(){m.resultsClicked=!1},click:function(n){m.debug("Search result selected");var i=e(this),o=i.find(y.title).eq(0),a=i.is("a[href]")?i:i.find("a[href]").eq(0),r=a.attr("href")||!1,s=a.attr("target")||!1,l=(o.html(),o.length>0?o.text():!1),c=m.get.results(),u=i.data(h.result)||m.get.result(l,c);return e.isFunction(g.onSelect)&&g.onSelect.call(F,u,c)===!1?(m.debug("Custom onSelect callback cancelled default select action"),void(D=!0)):(m.hideResults(),l&&m.set.value(l),void(r&&(m.verbose("Opening search link found in result",a),"_blank"==s||n.ctrlKey?t.open(r):t.location.href=r)))}}},handleKeyboard:function(e){var t,n=S.find(y.result),i=S.find(y.category),o=n.filter("."+p.active),a=n.index(o),r=n.length,s=o.length>0,l=e.which,c={backspace:8,enter:13,escape:27,upArrow:38,downArrow:40};if(l==c.escape&&(m.verbose("Escape key pressed, blurring search field"),m.hideResults(),q=!0),m.is.visible())if(l==c.enter){if(m.verbose("Enter key pressed, selecting active result"),n.filter("."+p.active).length>0)return m.event.result.click.call(n.filter("."+p.active),e),e.preventDefault(),!1}else l==c.upArrow&&s?(m.verbose("Up key pressed, changing active result"),t=0>a-1?a:a-1,i.removeClass(p.active),n.removeClass(p.active).eq(t).addClass(p.active).closest(i).addClass(p.active),e.preventDefault()):l==c.downArrow&&(m.verbose("Down key pressed, changing active result"),t=a+1>=r?a:a+1,i.removeClass(p.active),n.removeClass(p.active).eq(t).addClass(p.active).closest(i).addClass(p.active),e.preventDefault());else l==c.enter&&(m.verbose("Enter key pressed, executing query"),m.query(),m.set.buttonPressed(),T.one("keyup",m.remove.buttonFocus))},setup:{api:function(t,n){var i={debug:g.debug,on:!1,cache:!0,action:"search",urlData:{query:t},onSuccess:function(e){m.parse.response.call(F,e,t),n()},onFailure:function(){m.displayMessage(x.serverError),n()},onAbort:function(e){},onError:m.error};e.extend(!0,i,g.apiSettings),m.verbose("Setting up API request",i),S.api(i)}},can:{useAPI:function(){return e.fn.api!==i},show:function(){return m.is.focused()&&!m.is.visible()&&!m.is.empty()},transition:function(){return g.transition&&e.fn.transition!==i&&S.transition("is supported")}},is:{animating:function(){return R.hasClass(p.animating)},hidden:function(){return R.hasClass(p.hidden)},inMessage:function(t){if(t.target){var i=e(t.target),o=e.contains(n.documentElement,t.target);return o&&i.closest(y.message).length>0}},empty:function(){return""===R.html()},visible:function(){return R.filter(":visible").length>0},focused:function(){return T.filter(":focus").length>0}},get:{inputEvent:function(){var e=T[0],t=e!==i&&e.oninput!==i?"input":e!==i&&e.onpropertychange!==i?"propertychange":"keyup";return t},value:function(){return T.val()},results:function(){var e=S.data(h.results);return e},result:function(t,n){var o=["title","id"],a=!1;return t=t!==i?t:m.get.value(),n=n!==i?n:m.get.results(),"category"===g.type?(m.debug("Finding result that matches",t),e.each(n,function(n,i){return e.isArray(i.results)&&(a=m.search.object(t,i.results,o)[0])?!1:void 0})):(m.debug("Finding result in results object",t),a=m.search.object(t,n,o)[0]),a||!1}},select:{firstResult:function(){m.verbose("Selecting first result"),P.first().addClass(p.active)}},set:{focus:function(){S.addClass(p.focus)},loading:function(){S.addClass(p.loading)},value:function(e){m.verbose("Setting search input value",e),T.val(e)},type:function(e){e=e||g.type,"category"==g.type&&S.addClass(g.type)},buttonPressed:function(){A.addClass(p.pressed)}},remove:{loading:function(){S.removeClass(p.loading)},focus:function(){S.removeClass(p.focus)},buttonPressed:function(){A.removeClass(p.pressed)}},query:function(t){t=e.isFunction(t)?t:function(){};var n=m.get.value(),i=m.read.cache(n);t=t||function(){},m.has.minimumCharacters()?(i?(m.debug("Reading result from cache",n),m.save.results(i.results),m.addResults(i.html),m.inject.id(i.results),t()):(m.debug("Querying for",n),e.isPlainObject(g.source)||e.isArray(g.source)?(m.search.local(n),t()):m.can.useAPI()?m.search.remote(n,t):(m.error(x.source),t())),g.onSearchQuery.call(F,n)):m.hideResults()},search:{local:function(e){var t,n=m.search.object(e,g.content);m.set.loading(),m.save.results(n),m.debug("Returned local search results",n),t=m.generateResults({results:n}),m.remove.loading(),m.addResults(t),m.inject.id(n),m.write.cache(e,{html:t,results:n})},remote:function(t,n){n=e.isFunction(n)?n:function(){},S.api("is loading")&&S.api("abort"),m.setup.api(t,n),S.api("query")},object:function(t,n,o){var a=[],r=[],s=t.toString().replace(v.escape,"\\$&"),l=new RegExp(v.beginsWith+s,"i"),c=function(t,n){var i=-1==e.inArray(n,a),o=-1==e.inArray(n,r);i&&o&&t.push(n)};return n=n||g.source,o=o!==i?o:g.searchFields,e.isArray(o)||(o=[o]),n===i||n===!1?(m.error(x.source),[]):(e.each(o,function(i,o){e.each(n,function(e,n){var i="string"==typeof n[o];i&&(-1!==n[o].search(l)?c(a,n):g.searchFullText&&m.fuzzySearch(t,n[o])&&c(r,n))})}),e.merge(a,r))}},fuzzySearch:function(e,t){var n=t.length,i=e.length;if("string"!=typeof e)return!1;if(e=e.toLowerCase(),t=t.toLowerCase(),i>n)return!1;if(i===n)return e===t;e:for(var o=0,a=0;i>o;o++){for(var r=e.charCodeAt(o);n>a;)if(t.charCodeAt(a++)===r)continue e;return!1}return!0},parse:{response:function(e,t){var n=m.generateResults(e);m.verbose("Parsing server response",e),e!==i&&t!==i&&e[b.results]!==i&&(m.addResults(n),m.inject.id(e[b.results]),m.write.cache(t,{html:n,results:e[b.results]}),m.save.results(e[b.results]))}},cancel:{query:function(){m.can.useAPI()&&S.api("abort")}},has:{minimumCharacters:function(){var e=m.get.value(),t=e.length;return t>=g.minCharacters},results:function(){if(0===R.length)return!1;var e=R.html();return""!=e}},clear:{cache:function(e){var t=S.data(h.cache);e?e&&t&&t[e]&&(m.debug("Removing value from cache",e),delete t[e],S.data(h.cache,t)):(m.debug("Clearing cache",e),S.removeData(h.cache))}},read:{cache:function(e){var t=S.data(h.cache);return g.cache?(m.verbose("Checking cache for generated html for query",e),"object"==typeof t&&t[e]!==i?t[e]:!1):!1}},create:{id:function(e,t){var n,o,a=e+1;return t!==i?(n=String.fromCharCode(97+t),o=n+a,m.verbose("Creating category result id",o)):(o=a,m.verbose("Creating result id",o)),o},results:function(){0===R.length&&(R=e("<div />").addClass(p.results).appendTo(S))}},inject:{result:function(e,t,n){m.verbose("Injecting result into results");var o=n!==i?R.children().eq(n).children(y.result).eq(t):R.children(y.result).eq(t);m.verbose("Injecting results metadata",o),o.data(h.result,e)},id:function(t){m.debug("Injecting unique ids into results");var n=0,o=0;return"category"===g.type?e.each(t,function(t,a){o=0,e.each(a.results,function(e,t){var r=a.results[e];r.id===i&&(r.id=m.create.id(o,n)),m.inject.result(r,o,n),o++}),n++}):e.each(t,function(e,n){var a=t[e];a.id===i&&(a.id=m.create.id(o)),m.inject.result(a,o),o++}),t}},save:{results:function(e){m.verbose("Saving current search results to metadata",e),S.data(h.results,e)}},write:{cache:function(e,t){var n=S.data(h.cache)!==i?S.data(h.cache):{};g.cache&&(m.verbose("Writing generated html to cache",e,t),n[e]=t,S.data(h.cache,n))}},addResults:function(t){return e.isFunction(g.onResultsAdd)&&g.onResultsAdd.call(R,t)===!1?(m.debug("onResultsAdd callback cancelled default action"),!1):void(t?(R.html(t),m.refreshResults(),g.selectFirstResult&&m.select.firstResult(),m.showResults()):m.hideResults(function(){R.empty()}))},showResults:function(t){t=e.isFunction(t)?t:function(){},q||!m.is.visible()&&m.has.results()&&(m.can.transition()?(m.debug("Showing results with css animations"),R.transition({animation:g.transition+" in",debug:g.debug,verbose:g.verbose,duration:g.duration,onComplete:function(){t()},queue:!0})):(m.debug("Showing results with javascript"),R.stop().fadeIn(g.duration,g.easing)),g.onResultsOpen.call(R))},hideResults:function(t){t=e.isFunction(t)?t:function(){},m.is.visible()&&(m.can.transition()?(m.debug("Hiding results with css animations"),R.transition({animation:g.transition+" out",debug:g.debug,verbose:g.verbose,duration:g.duration,onComplete:function(){t()},queue:!0})):(m.debug("Hiding results with javascript"),R.stop().fadeOut(g.duration,g.easing)),g.onResultsClose.call(R))},generateResults:function(t){m.debug("Generating html from response",t);var n=g.templates[g.type],i=e.isPlainObject(t[b.results])&&!e.isEmptyObject(t[b.results]),o=e.isArray(t[b.results])&&t[b.results].length>0,a="";return i||o?(g.maxResults>0&&(i?"standard"==g.type&&m.error(x.maxResults):t[b.results]=t[b.results].slice(0,g.maxResults)),e.isFunction(n)?a=n(t,b):m.error(x.noTemplate,!1)):g.showNoResults&&(a=m.displayMessage(x.noResults,"empty")),g.onResults.call(F,t),a},displayMessage:function(e,t){return t=t||"standard",m.debug("Displaying message",e,t),m.addResults(g.templates.message(e,t)),g.templates.message(e,t)},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];g[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];m[t]=n}},debug:function(){!g.silent&&g.debug&&(g.performance?m.performance.log(arguments):(m.debug=Function.prototype.bind.call(console.info,console,g.name+":"),m.debug.apply(console,arguments)))},verbose:function(){!g.silent&&g.verbose&&g.debug&&(g.performance?m.performance.log(arguments):(m.verbose=Function.prototype.bind.call(console.info,console,g.name+":"),m.verbose.apply(console,arguments)))},error:function(){g.silent||(m.error=Function.prototype.bind.call(console.error,console,g.name+":"),m.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;g.performance&&(t=(new Date).getTime(),i=l||t,n=t-i,l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:F,"Execution Time":n})),clearTimeout(m.performance.timer),m.performance.timer=setTimeout(m.performance.display,500)},display:function(){var t=g.name+":",n=0;l=!1,clearTimeout(m.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),r.length>1&&(t+=" ("+r.length+")"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=O;return n=n||f,o=F||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(O===i&&m.initialize(),m.invoke(u)):(O!==i&&O.invoke("destroy"),m.initialize())}),a!==i?a:this},e.fn.search.settings={name:"Search",namespace:"search",silent:!1,debug:!1,verbose:!1,performance:!0,type:"standard",minCharacters:1,selectFirstResult:!1,apiSettings:!1,source:!1,searchOnFocus:!0,searchFields:["title","description"],displayField:"",searchFullText:!0,automatic:!0,hideDelay:0,searchDelay:200,maxResults:7,cache:!0,showNoResults:!0,transition:"scale",duration:200,easing:"easeOutExpo",onSelect:!1,onResultsAdd:!1,onSearchQuery:function(e){},onResults:function(e){},onResultsOpen:function(){},onResultsClose:function(){},className:{animating:"animating",active:"active",empty:"empty",focus:"focus",hidden:"hidden",loading:"loading",results:"results",pressed:"down"},error:{source:"Cannot search. No source used, and Semantic API module was not included",noResults:"Your search returned no results",logging:"Error in debug logging, exiting.",noEndpoint:"No search endpoint was specified",noTemplate:"A valid template name was not specified.",serverError:"There was an issue querying the server.",maxResults:"Results must be an array to use maxResults setting",method:"The method you called is not defined."},metadata:{cache:"cache",results:"results",result:"result"},regExp:{escape:/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,beginsWith:"(?:s|^)"},fields:{categories:"results",categoryName:"name",categoryResults:"results",description:"description",image:"image",price:"price",results:"results",title:"title",url:"url",action:"action",actionText:"text",actionURL:"url"},selector:{prompt:".prompt",searchButton:".search.button",results:".results",message:".results > .message",category:".category",result:".result",title:".title, .name"},templates:{escape:function(e){var t=/[&<>"'`]/g,n=/[&<>"'`]/,i={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},o=function(e){return i[e]};return n.test(e)?e.replace(t,o):e},message:function(e,t){var n="";return e!==i&&t!==i&&(n+='<div class="message '+t+'">',n+="empty"==t?'<div class="header">No Results</div class="header"><div class="description">'+e+'</div class="description">':' <div class="description">'+e+"</div>",n+="</div>"),n},category:function(t,n){var o="";e.fn.search.settings.templates.escape;return t[n.categoryResults]!==i?(e.each(t[n.categoryResults],function(t,a){a[n.results]!==i&&a.results.length>0&&(o+='<div class="category">',a[n.categoryName]!==i&&(o+='<div class="name">'+a[n.categoryName]+"</div>"),e.each(a.results,function(e,t){o+=t[n.url]?'<a class="result" href="'+t[n.url]+'">':'<a class="result">',t[n.image]!==i&&(o+='<div class="image"> <img src="'+t[n.image]+'"></div>'),o+='<div class="content">',t[n.price]!==i&&(o+='<div class="price">'+t[n.price]+"</div>"),t[n.title]!==i&&(o+='<div class="title">'+t[n.title]+"</div>"),t[n.description]!==i&&(o+='<div class="description">'+t[n.description]+"</div>"),o+="</div>",o+="</a>"}),o+="</div>")}),t[n.action]&&(o+='<a href="'+t[n.action][n.actionURL]+'" class="action">'+t[n.action][n.actionText]+"</a>"),o):!1},standard:function(t,n){var o="";return t[n.results]!==i?(e.each(t[n.results],function(e,t){o+=t[n.url]?'<a class="result" href="'+t[n.url]+'">':'<a class="result">',t[n.image]!==i&&(o+='<div class="image"> <img src="'+t[n.image]+'"></div>'),o+='<div class="content">',t[n.price]!==i&&(o+='<div class="price">'+t[n.price]+"</div>"),t[n.title]!==i&&(o+='<div class="title">'+t[n.title]+"</div>"),t[n.description]!==i&&(o+='<div class="description">'+t[n.description]+"</div>"),o+="</div>",o+="</a>"}),t[n.action]&&(o+='<a href="'+t[n.action][n.actionURL]+'" class="action">'+t[n.action][n.actionText]+"</a>"),o):!1}}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.shape=function(o){var a,r=e(this),s=(e("body"),(new Date).getTime()),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1),f=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return r.each(function(){var t,m,g,p=r.selector||"",h=e.isPlainObject(o)?e.extend(!0,{},e.fn.shape.settings,o):e.extend({},e.fn.shape.settings),v=h.namespace,b=h.selector,y=h.error,x=h.className,C="."+v,w="module-"+v,k=e(this),S=k.find(b.sides),T=k.find(b.side),A=!1,R=this,P=k.data(w);g={initialize:function(){g.verbose("Initializing module for",R),g.set.defaultSide(),g.instantiate()},instantiate:function(){g.verbose("Storing instance of module",g),P=g,k.data(w,P)},destroy:function(){g.verbose("Destroying previous module for",R),k.removeData(w).off(C)},refresh:function(){g.verbose("Refreshing selector cache for",R),k=e(R),S=e(this).find(b.shape),T=e(this).find(b.side)},repaint:function(){g.verbose("Forcing repaint event");var e=S[0]||n.createElement("div");e.offsetWidth},animate:function(e,n){g.verbose("Animating box with properties",e),n=n||function(e){g.verbose("Executing animation callback"),e!==i&&e.stopPropagation(),g.reset(),g.set.active()},h.beforeChange.call(m[0]),g.get.transitionEvent()?(g.verbose("Starting CSS animation"),k.addClass(x.animating),S.css(e).one(g.get.transitionEvent(),n),g.set.duration(h.duration),f(function(){k.addClass(x.animating),t.addClass(x.hidden)})):n()},queue:function(e){g.debug("Queueing animation of",e),S.one(g.get.transitionEvent(),function(){g.debug("Executing queued animation"),setTimeout(function(){k.shape(e)},0)})},reset:function(){g.verbose("Animating states reset"),k.removeClass(x.animating).attr("style","").removeAttr("style"),S.attr("style","").removeAttr("style"),T.attr("style","").removeAttr("style").removeClass(x.hidden),m.removeClass(x.animating).attr("style","").removeAttr("style")},is:{complete:function(){return T.filter("."+x.active)[0]==m[0]},animating:function(){return k.hasClass(x.animating)}},set:{defaultSide:function(){t=k.find("."+h.className.active),m=t.next(b.side).length>0?t.next(b.side):k.find(b.side).first(),A=!1,g.verbose("Active side set to",t),g.verbose("Next side set to",m)},duration:function(e){e=e||h.duration,e="number"==typeof e?e+"ms":e,g.verbose("Setting animation duration",e),(h.duration||0===h.duration)&&S.add(T).css({"-webkit-transition-duration":e,"-moz-transition-duration":e,"-ms-transition-duration":e,"-o-transition-duration":e,"transition-duration":e})},currentStageSize:function(){var e=k.find("."+h.className.active),t=e.outerWidth(!0),n=e.outerHeight(!0);k.css({width:t,height:n})},stageSize:function(){var e=k.clone().addClass(x.loading),t=e.find("."+h.className.active),n=A?e.find(b.side).eq(A):t.next(b.side).length>0?t.next(b.side):e.find(b.side).first(),i="next"==h.width?n.outerWidth(!0):"initial"==h.width?k.width():h.width,o="next"==h.height?n.outerHeight(!0):"initial"==h.height?k.height():h.height;t.removeClass(x.active),n.addClass(x.active),e.insertAfter(k),e.remove(),"auto"!=h.width&&(k.css("width",i+h.jitter),g.verbose("Specifying width during animation",i)),"auto"!=h.height&&(k.css("height",o+h.jitter),g.verbose("Specifying height during animation",o))},nextSide:function(e){A=e,m=T.filter(e),A=T.index(m),0===m.length&&(g.set.defaultSide(),g.error(y.side)),g.verbose("Next side manually set to",m)},active:function(){g.verbose("Setting new side to active",m),T.removeClass(x.active),m.addClass(x.active),h.onChange.call(m[0]),g.set.defaultSide()}},flip:{up:function(){if(g.is.complete()&&!g.is.animating()&&!h.allowRepeats)return void g.debug("Side already visible",m);if(g.is.animating())g.queue("flip up");else{g.debug("Flipping up",m);var e=g.get.transform.up();g.set.stageSize(),g.stage.above(),g.animate(e)}},down:function(){if(g.is.complete()&&!g.is.animating()&&!h.allowRepeats)return void g.debug("Side already visible",m);if(g.is.animating())g.queue("flip down");else{g.debug("Flipping down",m);var e=g.get.transform.down();g.set.stageSize(),g.stage.below(),g.animate(e)}},left:function(){if(g.is.complete()&&!g.is.animating()&&!h.allowRepeats)return void g.debug("Side already visible",m);if(g.is.animating())g.queue("flip left");else{g.debug("Flipping left",m);var e=g.get.transform.left();g.set.stageSize(),g.stage.left(),g.animate(e)}},right:function(){if(g.is.complete()&&!g.is.animating()&&!h.allowRepeats)return void g.debug("Side already visible",m);if(g.is.animating())g.queue("flip right");else{g.debug("Flipping right",m);var e=g.get.transform.right();g.set.stageSize(),g.stage.right(),g.animate(e)}},over:function(){return!g.is.complete()||g.is.animating()||h.allowRepeats?void(g.is.animating()?g.queue("flip over"):(g.debug("Flipping over",m),g.set.stageSize(),g.stage.behind(),g.animate(g.get.transform.over()))):void g.debug("Side already visible",m)},back:function(){return!g.is.complete()||g.is.animating()||h.allowRepeats?void(g.is.animating()?g.queue("flip back"):(g.debug("Flipping back",m),g.set.stageSize(),g.stage.behind(),g.animate(g.get.transform.back()))):void g.debug("Side already visible",m)}},get:{transform:{up:function(){var e={y:-((t.outerHeight(!0)-m.outerHeight(!0))/2),z:-(t.outerHeight(!0)/2)};return{transform:"translateY("+e.y+"px) translateZ("+e.z+"px) rotateX(-90deg)"}},down:function(){var e={y:-((t.outerHeight(!0)-m.outerHeight(!0))/2),z:-(t.outerHeight(!0)/2)};return{transform:"translateY("+e.y+"px) translateZ("+e.z+"px) rotateX(90deg)"}},left:function(){var e={x:-((t.outerWidth(!0)-m.outerWidth(!0))/2),z:-(t.outerWidth(!0)/2)};return{transform:"translateX("+e.x+"px) translateZ("+e.z+"px) rotateY(90deg)"}},right:function(){var e={x:-((t.outerWidth(!0)-m.outerWidth(!0))/2),z:-(t.outerWidth(!0)/2)};return{transform:"translateX("+e.x+"px) translateZ("+e.z+"px) rotateY(-90deg)"}},over:function(){var e={x:-((t.outerWidth(!0)-m.outerWidth(!0))/2)};return{transform:"translateX("+e.x+"px) rotateY(180deg)"}},back:function(){var e={x:-((t.outerWidth(!0)-m.outerWidth(!0))/2)};return{transform:"translateX("+e.x+"px) rotateY(-180deg)"}}},transitionEvent:function(){var e,t=n.createElement("element"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in o)if(t.style[e]!==i)return o[e]},nextSide:function(){return t.next(b.side).length>0?t.next(b.side):k.find(b.side).first()}},stage:{above:function(){var e={origin:(t.outerHeight(!0)-m.outerHeight(!0))/2,depth:{active:m.outerHeight(!0)/2,next:t.outerHeight(!0)/2}};g.verbose("Setting the initial animation position as above",m,e),S.css({transform:"translateZ(-"+e.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+e.depth.active+"px)"}),m.addClass(x.animating).css({top:e.origin+"px",transform:"rotateX(90deg) translateZ("+e.depth.next+"px)"})},below:function(){var e={origin:(t.outerHeight(!0)-m.outerHeight(!0))/2,depth:{active:m.outerHeight(!0)/2,next:t.outerHeight(!0)/2}};g.verbose("Setting the initial animation position as below",m,e),S.css({transform:"translateZ(-"+e.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+e.depth.active+"px)"}),m.addClass(x.animating).css({top:e.origin+"px",transform:"rotateX(-90deg) translateZ("+e.depth.next+"px)"})},left:function(){var e={active:t.outerWidth(!0),next:m.outerWidth(!0)},n={origin:(e.active-e.next)/2,depth:{active:e.next/2,next:e.active/2}};g.verbose("Setting the initial animation position as left",m,n),S.css({transform:"translateZ(-"+n.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+n.depth.active+"px)"}),m.addClass(x.animating).css({left:n.origin+"px",transform:"rotateY(-90deg) translateZ("+n.depth.next+"px)"})},right:function(){var e={active:t.outerWidth(!0),next:m.outerWidth(!0)},n={origin:(e.active-e.next)/2,depth:{active:e.next/2,next:e.active/2}};g.verbose("Setting the initial animation position as left",m,n),S.css({transform:"translateZ(-"+n.depth.active+"px)"}),t.css({transform:"rotateY(0deg) translateZ("+n.depth.active+"px)"}),m.addClass(x.animating).css({left:n.origin+"px",transform:"rotateY(90deg) translateZ("+n.depth.next+"px)"})},behind:function(){var e={active:t.outerWidth(!0),next:m.outerWidth(!0)},n={origin:(e.active-e.next)/2,depth:{active:e.next/2,next:e.active/2}};g.verbose("Setting the initial animation position as behind",m,n),t.css({transform:"rotateY(0deg)"}),m.addClass(x.animating).css({left:n.origin+"px",transform:"rotateY(-180deg)"})}},setting:function(t,n){if(g.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,h,t);else{if(n===i)return h[t];e.isPlainObject(h[t])?e.extend(!0,h[t],n):h[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,g,t);else{if(n===i)return g[t];g[t]=n}},debug:function(){!h.silent&&h.debug&&(h.performance?g.performance.log(arguments):(g.debug=Function.prototype.bind.call(console.info,console,h.name+":"),g.debug.apply(console,arguments)))},verbose:function(){!h.silent&&h.verbose&&h.debug&&(h.performance?g.performance.log(arguments):(g.verbose=Function.prototype.bind.call(console.info,console,h.name+":"),g.verbose.apply(console,arguments)))},error:function(){h.silent||(g.error=Function.prototype.bind.call(console.error,console,h.name+":"),g.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;h.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:R,"Execution Time":n})),clearTimeout(g.performance.timer),g.performance.timer=setTimeout(g.performance.display,500)},display:function(){var t=h.name+":",n=0;s=!1,clearTimeout(g.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",p&&(t+=" '"+p+"'"),r.length>1&&(t+=" ("+r.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,o){var r,s,l,c=P;return n=n||d,o=R||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},u?(P===i&&g.initialize(),g.invoke(c)):(P!==i&&P.invoke("destroy"),g.initialize())}),a!==i?a:this},e.fn.shape.settings={name:"Shape",silent:!1,debug:!1,verbose:!1,jitter:0,performance:!0,namespace:"shape",width:"initial",height:"initial",beforeChange:function(){},onChange:function(){},allowRepeats:!1,duration:!1,error:{side:"You tried to switch to a side that does not exist.",method:"The method you called is not defined"},className:{animating:"animating",hidden:"hidden",loading:"loading",active:"active"},selector:{sides:".sides",side:".side"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.sidebar=function(o){var a,r=e(this),s=e(t),l=e(n),c=e("html"),u=e("head"),d=r.selector||"",f=(new Date).getTime(),m=[],g=arguments[0],p="string"==typeof g,h=[].slice.call(arguments,1),v=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return r.each(function(){var r,b,y,x,C,w,k=e.isPlainObject(o)?e.extend(!0,{},e.fn.sidebar.settings,o):e.extend({},e.fn.sidebar.settings),S=k.selector,T=k.className,A=k.namespace,R=k.regExp,P=k.error,E="."+A,F="module-"+A,O=e(this),D=e(k.context),q=O.children(S.sidebar),j=D.children(S.fixed),z=D.children(S.pusher),I=this,M=O.data(F);w={initialize:function(){w.debug("Initializing sidebar",o),w.create.id(),C=w.get.transitionEvent(),w.is.ios()&&w.set.ios(),k.delaySetup?v(w.setup.layout):w.setup.layout(),v(function(){w.setup.cache()}),w.instantiate()},instantiate:function(){w.verbose("Storing instance of module",w),M=w,O.data(F,w)},create:{id:function(){y=(Math.random().toString(16)+"000000000").substr(2,8),b="."+y,w.verbose("Creating unique id for element",y)}},destroy:function(){w.verbose("Destroying previous module for",O),O.off(E).removeData(F),w.is.ios()&&w.remove.ios(),D.off(b),s.off(b),l.off(b)},event:{clickaway:function(e){var t=z.find(e.target).length>0||z.is(e.target),n=D.is(e.target);t&&(w.verbose("User clicked on dimmed page"),w.hide()),n&&(w.verbose("User clicked on dimmable context (scaled out page)"),w.hide())},touch:function(e){},containScroll:function(e){I.scrollTop<=0&&(I.scrollTop=1),I.scrollTop+I.offsetHeight>=I.scrollHeight&&(I.scrollTop=I.scrollHeight-I.offsetHeight-1)},scroll:function(t){0===e(t.target).closest(S.sidebar).length&&t.preventDefault()}},bind:{clickaway:function(){w.verbose("Adding clickaway events to context",D),k.closable&&D.on("click"+b,w.event.clickaway).on("touchend"+b,w.event.clickaway)},scrollLock:function(){k.scrollLock&&(w.debug("Disabling page scroll"),s.on("DOMMouseScroll"+b,w.event.scroll)),w.verbose("Adding events to contain sidebar scroll"),l.on("touchmove"+b,w.event.touch),O.on("scroll"+E,w.event.containScroll)}},unbind:{clickaway:function(){w.verbose("Removing clickaway events from context",D),D.off(b)},scrollLock:function(){w.verbose("Removing scroll lock from page"),l.off(b),s.off(b),O.off("scroll"+E)}},add:{inlineCSS:function(){var t,n=w.cache.width||O.outerWidth(),i=w.cache.height||O.outerHeight(),o=w.is.rtl(),a=w.get.direction(),s={left:n,right:-n,top:i,bottom:-i};o&&(w.verbose("RTL detected, flipping widths"),s.left=-n,s.right=n),t="<style>","left"===a||"right"===a?(w.debug("Adding CSS rules for animation distance",n),
t+=" .ui.visible."+a+".sidebar ~ .fixed, .ui.visible."+a+".sidebar ~ .pusher {   -webkit-transform: translate3d("+s[a]+"px, 0, 0);           transform: translate3d("+s[a]+"px, 0, 0); }"):"top"!==a&&"bottom"!=a||(t+=" .ui.visible."+a+".sidebar ~ .fixed, .ui.visible."+a+".sidebar ~ .pusher {   -webkit-transform: translate3d(0, "+s[a]+"px, 0);           transform: translate3d(0, "+s[a]+"px, 0); }"),w.is.ie()&&("left"===a||"right"===a?(w.debug("Adding CSS rules for animation distance",n),t+=" body.pushable > .ui.visible."+a+".sidebar ~ .pusher:after {   -webkit-transform: translate3d("+s[a]+"px, 0, 0);           transform: translate3d("+s[a]+"px, 0, 0); }"):"top"!==a&&"bottom"!=a||(t+=" body.pushable > .ui.visible."+a+".sidebar ~ .pusher:after {   -webkit-transform: translate3d(0, "+s[a]+"px, 0);           transform: translate3d(0, "+s[a]+"px, 0); }"),t+=" body.pushable > .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher:after, body.pushable > .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher:after {   -webkit-transform: translate3d(0px, 0, 0);           transform: translate3d(0px, 0, 0); }"),t+="</style>",r=e(t).appendTo(u),w.debug("Adding sizing css to head",r)}},refresh:function(){w.verbose("Refreshing selector cache"),D=e(k.context),q=D.children(S.sidebar),z=D.children(S.pusher),j=D.children(S.fixed),w.clear.cache()},refreshSidebars:function(){w.verbose("Refreshing other sidebars"),q=D.children(S.sidebar)},repaint:function(){w.verbose("Forcing repaint event"),I.style.display="none";I.offsetHeight;I.scrollTop=I.scrollTop,I.style.display=""},setup:{cache:function(){w.cache={width:O.outerWidth(),height:O.outerHeight(),rtl:"rtl"==O.css("direction")}},layout:function(){0===D.children(S.pusher).length&&(w.debug("Adding wrapper element for sidebar"),w.error(P.pusher),z=e('<div class="pusher" />'),D.children().not(S.omitted).not(q).wrapAll(z),w.refresh()),0!==O.nextAll(S.pusher).length&&O.nextAll(S.pusher)[0]===z[0]||(w.debug("Moved sidebar to correct parent element"),w.error(P.movedSidebar,I),O.detach().prependTo(D),w.refresh()),w.clear.cache(),w.set.pushable(),w.set.direction()}},attachEvents:function(t,n){var i=e(t);n=e.isFunction(w[n])?w[n]:w.toggle,i.length>0?(w.debug("Attaching sidebar events to element",t,n),i.on("click"+E,n)):w.error(P.notFound,t)},show:function(t){if(t=e.isFunction(t)?t:function(){},w.is.hidden()){if(w.refreshSidebars(),k.overlay&&(w.error(P.overlay),k.transition="overlay"),w.refresh(),w.othersActive())if(w.debug("Other sidebars currently visible"),k.exclusive){if("overlay"!=k.transition)return void w.hideOthers(w.show);w.hideOthers()}else k.transition="overlay";w.pushPage(function(){t.call(I),k.onShow.call(I)}),k.onChange.call(I),k.onVisible.call(I)}else w.debug("Sidebar is already visible")},hide:function(t){t=e.isFunction(t)?t:function(){},(w.is.visible()||w.is.animating())&&(w.debug("Hiding sidebar",t),w.refreshSidebars(),w.pullPage(function(){t.call(I),k.onHidden.call(I)}),k.onChange.call(I),k.onHide.call(I))},othersAnimating:function(){return q.not(O).filter("."+T.animating).length>0},othersVisible:function(){return q.not(O).filter("."+T.visible).length>0},othersActive:function(){return w.othersVisible()||w.othersAnimating()},hideOthers:function(e){var t=q.not(O).filter("."+T.visible),n=t.length,i=0;e=e||function(){},t.sidebar("hide",function(){i++,i==n&&e()})},toggle:function(){w.verbose("Determining toggled direction"),w.is.hidden()?w.show():w.hide()},pushPage:function(t){var n,i,o,a=w.get.transition(),r="overlay"===a||w.othersActive()?O:z;t=e.isFunction(t)?t:function(){},"scale down"==k.transition&&w.scrollToTop(),w.set.transition(a),w.repaint(),n=function(){w.bind.clickaway(),w.add.inlineCSS(),w.set.animating(),w.set.visible()},i=function(){w.set.dimmed()},o=function(e){e.target==r[0]&&(r.off(C+b,o),w.remove.animating(),w.bind.scrollLock(),t.call(I))},r.off(C+b),r.on(C+b,o),v(n),k.dimPage&&!w.othersVisible()&&v(i)},pullPage:function(t){var n,i,o=w.get.transition(),a="overlay"==o||w.othersActive()?O:z;t=e.isFunction(t)?t:function(){},w.verbose("Removing context push state",w.get.direction()),w.unbind.clickaway(),w.unbind.scrollLock(),n=function(){w.set.transition(o),w.set.animating(),w.remove.visible(),k.dimPage&&!w.othersVisible()&&z.removeClass(T.dimmed)},i=function(e){e.target==a[0]&&(a.off(C+b,i),w.remove.animating(),w.remove.transition(),w.remove.inlineCSS(),("scale down"==o||k.returnScroll&&w.is.mobile())&&w.scrollBack(),t.call(I))},a.off(C+b),a.on(C+b,i),v(n)},scrollToTop:function(){w.verbose("Scrolling to top of page to avoid animation issues"),x=e(t).scrollTop(),O.scrollTop(0),t.scrollTo(0,0)},scrollBack:function(){w.verbose("Scrolling back to original page position"),t.scrollTo(0,x)},clear:{cache:function(){w.verbose("Clearing cached dimensions"),w.cache={}}},set:{ios:function(){c.addClass(T.ios)},pushed:function(){D.addClass(T.pushed)},pushable:function(){D.addClass(T.pushable)},dimmed:function(){z.addClass(T.dimmed)},active:function(){O.addClass(T.active)},animating:function(){O.addClass(T.animating)},transition:function(e){e=e||w.get.transition(),O.addClass(e)},direction:function(e){e=e||w.get.direction(),O.addClass(T[e])},visible:function(){O.addClass(T.visible)},overlay:function(){O.addClass(T.overlay)}},remove:{inlineCSS:function(){w.debug("Removing inline css styles",r),r&&r.length>0&&r.remove()},ios:function(){c.removeClass(T.ios)},pushed:function(){D.removeClass(T.pushed)},pushable:function(){D.removeClass(T.pushable)},active:function(){O.removeClass(T.active)},animating:function(){O.removeClass(T.animating)},transition:function(e){e=e||w.get.transition(),O.removeClass(e)},direction:function(e){e=e||w.get.direction(),O.removeClass(T[e])},visible:function(){O.removeClass(T.visible)},overlay:function(){O.removeClass(T.overlay)}},get:{direction:function(){return O.hasClass(T.top)?T.top:O.hasClass(T.right)?T.right:O.hasClass(T.bottom)?T.bottom:T.left},transition:function(){var e,t=w.get.direction();return e=w.is.mobile()?"auto"==k.mobileTransition?k.defaultTransition.mobile[t]:k.mobileTransition:"auto"==k.transition?k.defaultTransition.computer[t]:k.transition,w.verbose("Determined transition",e),e},transitionEvent:function(){var e,t=n.createElement("element"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in o)if(t.style[e]!==i)return o[e]}},is:{ie:function(){var e=!t.ActiveXObject&&"ActiveXObject"in t,n="ActiveXObject"in t;return e||n},ios:function(){var e=navigator.userAgent,t=e.match(R.ios),n=e.match(R.mobileChrome);return t&&!n?(w.verbose("Browser was found to be iOS",e),!0):!1},mobile:function(){var e=navigator.userAgent,t=e.match(R.mobile);return t?(w.verbose("Browser was found to be mobile",e),!0):(w.verbose("Browser is not mobile, using regular transition",e),!1)},hidden:function(){return!w.is.visible()},visible:function(){return O.hasClass(T.visible)},open:function(){return w.is.visible()},closed:function(){return w.is.hidden()},vertical:function(){return O.hasClass(T.top)},animating:function(){return D.hasClass(T.animating)},rtl:function(){return w.cache.rtl===i&&(w.cache.rtl="rtl"==O.css("direction")),w.cache.rtl}},setting:function(t,n){if(w.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,k,t);else{if(n===i)return k[t];e.isPlainObject(k[t])?e.extend(!0,k[t],n):k[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,w,t);else{if(n===i)return w[t];w[t]=n}},debug:function(){!k.silent&&k.debug&&(k.performance?w.performance.log(arguments):(w.debug=Function.prototype.bind.call(console.info,console,k.name+":"),w.debug.apply(console,arguments)))},verbose:function(){!k.silent&&k.verbose&&k.debug&&(k.performance?w.performance.log(arguments):(w.verbose=Function.prototype.bind.call(console.info,console,k.name+":"),w.verbose.apply(console,arguments)))},error:function(){k.silent||(w.error=Function.prototype.bind.call(console.error,console,k.name+":"),w.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;k.performance&&(t=(new Date).getTime(),i=f||t,n=t-i,f=t,m.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:I,"Execution Time":n})),clearTimeout(w.performance.timer),w.performance.timer=setTimeout(w.performance.display,500)},display:function(){var t=k.name+":",n=0;f=!1,clearTimeout(w.performance.timer),e.each(m,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",d&&(t+=" '"+d+"'"),(console.group!==i||console.table!==i)&&m.length>0&&(console.groupCollapsed(t),console.table?console.table(m):e.each(m,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),m=[]}},invoke:function(t,n,o){var r,s,l,c=M;return n=n||h,o=I||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(w.error(P.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},p?(M===i&&w.initialize(),w.invoke(g)):(M!==i&&w.invoke("destroy"),w.initialize())}),a!==i?a:this},e.fn.sidebar.settings={name:"Sidebar",namespace:"sidebar",silent:!1,debug:!1,verbose:!1,performance:!0,transition:"auto",mobileTransition:"auto",defaultTransition:{computer:{left:"uncover",right:"uncover",top:"overlay",bottom:"overlay"},mobile:{left:"uncover",right:"uncover",top:"overlay",bottom:"overlay"}},context:"body",exclusive:!1,closable:!0,dimPage:!0,scrollLock:!1,returnScroll:!1,delaySetup:!1,duration:500,onChange:function(){},onShow:function(){},onHide:function(){},onHidden:function(){},onVisible:function(){},className:{active:"active",animating:"animating",dimmed:"dimmed",ios:"ios",pushable:"pushable",pushed:"pushed",right:"right",top:"top",left:"left",bottom:"bottom",visible:"visible"},selector:{fixed:".fixed",omitted:"script, link, style, .ui.modal, .ui.dimmer, .ui.nag, .ui.fixed",pusher:".pusher",sidebar:".ui.sidebar"},regExp:{ios:/(iPad|iPhone|iPod)/g,mobileChrome:/(CriOS)/g,mobile:/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/g},error:{method:"The method you called is not defined.",pusher:"Had to add pusher element. For optimal performance make sure body content is inside a pusher element",movedSidebar:"Had to move sidebar. For optimal performance make sure sidebar and pusher are direct children of your body tag",overlay:"The overlay setting is no longer supported, use animation: overlay",notFound:"There were no elements that matched the specified selector"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.sticky=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1);return r.each(function(){var r,m,g,p,h,v=e.isPlainObject(o)?e.extend(!0,{},e.fn.sticky.settings,o):e.extend({},e.fn.sticky.settings),b=v.className,y=v.namespace,x=v.error,C="."+y,w="module-"+y,k=e(this),S=e(t),T=e(v.scrollContext),A=(k.selector||"",k.data(w)),R=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)},P=this;h={initialize:function(){h.determineContainer(),h.determineContext(),h.verbose("Initializing sticky",v,r),h.save.positions(),h.checkErrors(),h.bind.events(),v.observeChanges&&h.observeChanges(),h.instantiate()},instantiate:function(){h.verbose("Storing instance of module",h),A=h,k.data(w,h)},destroy:function(){h.verbose("Destroying previous instance"),h.reset(),g&&g.disconnect(),p&&p.disconnect(),S.off("load"+C,h.event.load).off("resize"+C,h.event.resize),T.off("scrollchange"+C,h.event.scrollchange),k.removeData(w)},observeChanges:function(){"MutationObserver"in t&&(g=new MutationObserver(h.event.documentChanged),p=new MutationObserver(h.event.changed),g.observe(n,{childList:!0,subtree:!0}),p.observe(P,{childList:!0,subtree:!0}),p.observe(m[0],{childList:!0,subtree:!0}),h.debug("Setting up mutation observer",p))},determineContainer:function(){r=v.container?e(v.container):k.offsetParent()},determineContext:function(){return m=v.context?e(v.context):r,0===m.length?void h.error(x.invalidContext,v.context,k):void 0},checkErrors:function(){return h.is.hidden()&&h.error(x.visible,k),h.cache.element.height>h.cache.context.height?(h.reset(),void h.error(x.elementSize,k)):void 0},bind:{events:function(){S.on("load"+C,h.event.load).on("resize"+C,h.event.resize),T.off("scroll"+C).on("scroll"+C,h.event.scroll).on("scrollchange"+C,h.event.scrollchange)}},event:{changed:function(e){clearTimeout(h.timer),h.timer=setTimeout(function(){h.verbose("DOM tree modified, updating sticky menu",e),h.refresh()},100)},documentChanged:function(t){[].forEach.call(t,function(t){t.removedNodes&&[].forEach.call(t.removedNodes,function(t){(t==P||e(t).find(P).length>0)&&(h.debug("Element removed from DOM, tearing down events"),h.destroy())})})},load:function(){h.verbose("Page contents finished loading"),R(h.refresh)},resize:function(){h.verbose("Window resized"),R(h.refresh)},scroll:function(){R(function(){T.triggerHandler("scrollchange"+C,T.scrollTop())})},scrollchange:function(e,t){h.stick(t),v.onScroll.call(P)}},refresh:function(e){h.reset(),v.context||h.determineContext(),e&&h.determineContainer(),h.save.positions(),h.stick(),v.onReposition.call(P)},supports:{sticky:function(){var t=e("<div/>");t[0];return t.addClass(b.supported),t.css("position").match("sticky")}},save:{lastScroll:function(e){h.lastScroll=e},elementScroll:function(e){h.elementScroll=e},positions:function(){var e={height:T.height()},t={margin:{top:parseInt(k.css("margin-top"),10),bottom:parseInt(k.css("margin-bottom"),10)},offset:k.offset(),width:k.outerWidth(),height:k.outerHeight()},n={offset:m.offset(),height:m.outerHeight()};({height:r.outerHeight()});h.is.standardScroll()||(h.debug("Non-standard scroll. Removing scroll offset from element offset"),e.top=T.scrollTop(),e.left=T.scrollLeft(),t.offset.top+=e.top,n.offset.top+=e.top,t.offset.left+=e.left,n.offset.left+=e.left),h.cache={fits:t.height<e.height,scrollContext:{height:e.height},element:{margin:t.margin,top:t.offset.top-t.margin.top,left:t.offset.left,width:t.width,height:t.height,bottom:t.offset.top+t.height},context:{top:n.offset.top,height:n.height,bottom:n.offset.top+n.height}},h.set.containerSize(),h.set.size(),h.stick(),h.debug("Caching element positions",h.cache)}},get:{direction:function(e){var t="down";return e=e||T.scrollTop(),h.lastScroll!==i&&(h.lastScroll<e?t="down":h.lastScroll>e&&(t="up")),t},scrollChange:function(e){return e=e||T.scrollTop(),h.lastScroll?e-h.lastScroll:0},currentElementScroll:function(){return h.elementScroll?h.elementScroll:h.is.top()?Math.abs(parseInt(k.css("top"),10))||0:Math.abs(parseInt(k.css("bottom"),10))||0},elementScroll:function(e){e=e||T.scrollTop();var t=h.cache.element,n=h.cache.scrollContext,i=h.get.scrollChange(e),o=t.height-n.height+v.offset,a=h.get.currentElementScroll(),r=a+i;return a=h.cache.fits||0>r?0:r>o?o:r}},remove:{lastScroll:function(){delete h.lastScroll},elementScroll:function(e){delete h.elementScroll},offset:function(){k.css("margin-top","")}},set:{offset:function(){h.verbose("Setting offset on element",v.offset),k.css("margin-top",v.offset)},containerSize:function(){var e=r.get(0).tagName;"HTML"===e||"body"==e?h.determineContainer():Math.abs(r.outerHeight()-h.cache.context.height)>v.jitter&&(h.debug("Context has padding, specifying exact height for container",h.cache.context.height),r.css({height:h.cache.context.height}))},minimumSize:function(){var e=h.cache.element;r.css("min-height",e.height)},scroll:function(e){h.debug("Setting scroll on element",e),h.elementScroll!=e&&(h.is.top()&&k.css("bottom","").css("top",-e),h.is.bottom()&&k.css("top","").css("bottom",e))},size:function(){0!==h.cache.element.height&&0!==h.cache.element.width&&(P.style.setProperty("width",h.cache.element.width+"px","important"),P.style.setProperty("height",h.cache.element.height+"px","important"))}},is:{standardScroll:function(){return T[0]==t},top:function(){return k.hasClass(b.top)},bottom:function(){return k.hasClass(b.bottom)},initialPosition:function(){return!h.is.fixed()&&!h.is.bound()},hidden:function(){return!k.is(":visible")},bound:function(){return k.hasClass(b.bound)},fixed:function(){return k.hasClass(b.fixed)}},stick:function(e){var t=e||T.scrollTop(),n=h.cache,i=n.fits,o=n.element,a=n.scrollContext,r=n.context,s=h.is.bottom()&&v.pushing?v.bottomOffset:v.offset,e={top:t+s,bottom:t+s+a.height},l=(h.get.direction(e.top),i?0:h.get.elementScroll(e.top)),c=!i,u=0!==o.height;u&&(h.is.initialPosition()?e.top>=r.bottom?(h.debug("Initial element position is bottom of container"),h.bindBottom()):e.top>o.top&&(o.height+e.top-l>=r.bottom?(h.debug("Initial element position is bottom of container"),h.bindBottom()):(h.debug("Initial element position is fixed"),h.fixTop())):h.is.fixed()?h.is.top()?e.top<=o.top?(h.debug("Fixed element reached top of container"),h.setInitialPosition()):o.height+e.top-l>=r.bottom?(h.debug("Fixed element reached bottom of container"),h.bindBottom()):c&&(h.set.scroll(l),h.save.lastScroll(e.top),h.save.elementScroll(l)):h.is.bottom()&&(e.bottom-o.height<=o.top?(h.debug("Bottom fixed rail has reached top of container"),h.setInitialPosition()):e.bottom>=r.bottom?(h.debug("Bottom fixed rail has reached bottom of container"),h.bindBottom()):c&&(h.set.scroll(l),h.save.lastScroll(e.top),h.save.elementScroll(l))):h.is.bottom()&&(e.top<=o.top?(h.debug("Jumped from bottom fixed to top fixed, most likely used home/end button"),h.setInitialPosition()):v.pushing?h.is.bound()&&e.bottom<=r.bottom&&(h.debug("Fixing bottom attached element to bottom of browser."),h.fixBottom()):h.is.bound()&&e.top<=r.bottom-o.height&&(h.debug("Fixing bottom attached element to top of browser."),h.fixTop())))},bindTop:function(){h.debug("Binding element to top of parent container"),h.remove.offset(),k.css({left:"",top:"",marginBottom:""}).removeClass(b.fixed).removeClass(b.bottom).addClass(b.bound).addClass(b.top),v.onTop.call(P),v.onUnstick.call(P)},bindBottom:function(){h.debug("Binding element to bottom of parent container"),h.remove.offset(),k.css({left:"",top:""}).removeClass(b.fixed).removeClass(b.top).addClass(b.bound).addClass(b.bottom),v.onBottom.call(P),v.onUnstick.call(P)},setInitialPosition:function(){h.debug("Returning to initial position"),h.unfix(),h.unbind()},fixTop:function(){h.debug("Fixing element to top of page"),h.set.minimumSize(),h.set.offset(),k.css({left:h.cache.element.left,bottom:"",marginBottom:""}).removeClass(b.bound).removeClass(b.bottom).addClass(b.fixed).addClass(b.top),v.onStick.call(P)},fixBottom:function(){h.debug("Sticking element to bottom of page"),h.set.minimumSize(),h.set.offset(),k.css({left:h.cache.element.left,bottom:"",marginBottom:""}).removeClass(b.bound).removeClass(b.top).addClass(b.fixed).addClass(b.bottom),v.onStick.call(P)},unbind:function(){h.is.bound()&&(h.debug("Removing container bound position on element"),h.remove.offset(),k.removeClass(b.bound).removeClass(b.top).removeClass(b.bottom))},unfix:function(){h.is.fixed()&&(h.debug("Removing fixed position on element"),h.remove.offset(),k.removeClass(b.fixed).removeClass(b.top).removeClass(b.bottom),v.onUnstick.call(P))},reset:function(){h.debug("Resetting elements position"),h.unbind(),h.unfix(),h.resetCSS(),h.remove.offset(),h.remove.lastScroll()},resetCSS:function(){k.css({width:"",height:""}),r.css({height:""})},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];v[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,h,t);else{if(n===i)return h[t];h[t]=n}},debug:function(){!v.silent&&v.debug&&(v.performance?h.performance.log(arguments):(h.debug=Function.prototype.bind.call(console.info,console,v.name+":"),h.debug.apply(console,arguments)))},verbose:function(){!v.silent&&v.verbose&&v.debug&&(v.performance?h.performance.log(arguments):(h.verbose=Function.prototype.bind.call(console.info,console,v.name+":"),h.verbose.apply(console,arguments)))},error:function(){v.silent||(h.error=Function.prototype.bind.call(console.error,console,v.name+":"),h.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;v.performance&&(t=(new Date).getTime(),i=l||t,n=t-i,l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:P,"Execution Time":n})),clearTimeout(h.performance.timer),h.performance.timer=setTimeout(h.performance.display,0)},display:function(){var t=v.name+":",n=0;l=!1,clearTimeout(h.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=A;return n=n||f,o=P||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(A===i&&h.initialize(),h.invoke(u)):(A!==i&&A.invoke("destroy"),h.initialize())}),a!==i?a:this},e.fn.sticky.settings={name:"Sticky",namespace:"sticky",silent:!1,debug:!1,verbose:!0,performance:!0,pushing:!1,context:!1,container:!1,scrollContext:t,offset:0,bottomOffset:0,jitter:5,observeChanges:!1,onReposition:function(){},onScroll:function(){},onStick:function(){},onUnstick:function(){},onTop:function(){},onBottom:function(){},error:{container:"Sticky element must be inside a relative container",visible:"Element is hidden, you must call refresh after element becomes visible. Use silent setting to surpress this warning in production.",method:"The method you called is not defined.",invalidContext:"Context specified does not exist",elementSize:"Sticky element is larger than its container, cannot create sticky."},className:{bound:"bound",fixed:"fixed",supported:"native",top:"top",bottom:"bottom"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.tab=function(o){var a,r=e(e.isFunction(this)?t:this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1),m=!1;return r.each(function(){var g,p,h,v,b,y,x=e.isPlainObject(o)?e.extend(!0,{},e.fn.tab.settings,o):e.extend({},e.fn.tab.settings),C=x.className,w=x.metadata,k=x.selector,S=x.error,T="."+x.namespace,A="module-"+x.namespace,R=e(this),P={},E=!0,F=0,O=this,D=R.data(A);b={initialize:function(){b.debug("Initializing tab menu item",R),b.fix.callbacks(),b.determineTabs(),b.debug("Determining tabs",x.context,p),x.auto&&b.set.auto(),b.bind.events(),x.history&&!m&&(b.initializeHistory(),m=!0),b.instantiate()},instantiate:function(){b.verbose("Storing instance of module",b),D=b,R.data(A,b)},destroy:function(){b.debug("Destroying tabs",R),R.removeData(A).off(T)},bind:{events:function(){e.isWindow(O)||(b.debug("Attaching tab activation events to element",R),R.on("click"+T,b.event.click))}},determineTabs:function(){var t;"parent"===x.context?(R.closest(k.ui).length>0?(t=R.closest(k.ui),b.verbose("Using closest UI element as parent",t)):t=R,g=t.parent(),b.verbose("Determined parent element for creating context",g)):x.context?(g=e(x.context),b.verbose("Using selector for tab context",x.context,g)):g=e("body"),x.childrenOnly?(p=g.children(k.tabs),b.debug("Searching tab context children for tabs",g,p)):(p=g.find(k.tabs),b.debug("Searching tab context for tabs",g,p))},fix:{callbacks:function(){e.isPlainObject(o)&&(o.onTabLoad||o.onTabInit)&&(o.onTabLoad&&(o.onLoad=o.onTabLoad,delete o.onTabLoad,b.error(S.legacyLoad,o.onLoad)),o.onTabInit&&(o.onFirstLoad=o.onTabInit,delete o.onTabInit,b.error(S.legacyInit,o.onFirstLoad)),x=e.extend(!0,{},e.fn.tab.settings,o))}},initializeHistory:function(){if(b.debug("Initializing page state"),e.address===i)return b.error(S.state),!1;if("state"==x.historyType){if(b.debug("Using HTML5 to manage state"),x.path===!1)return b.error(S.path),!1;e.address.history(!0).state(x.path)}e.address.bind("change",b.event.history.change)},event:{click:function(t){var n=e(this).data(w.tab);n!==i?(x.history?(b.verbose("Updating page state",t),e.address.value(n)):(b.verbose("Changing tab",t),b.changeTab(n)),t.preventDefault()):b.debug("No tab specified")},history:{change:function(t){var n=t.pathNames.join("/")||b.get.initialPath(),o=x.templates.determineTitle(n)||!1;b.performance.display(),b.debug("History change event",n,t),y=t,n!==i&&b.changeTab(n),o&&e.address.title(o)}}},refresh:function(){h&&(b.debug("Refreshing tab",h),b.changeTab(h))},cache:{read:function(e){return e!==i?P[e]:!1},add:function(e,t){e=e||h,b.debug("Adding cached content for",e),P[e]=t},remove:function(e){e=e||h,b.debug("Removing cached content for",e),delete P[e]}},set:{auto:function(){var t="string"==typeof x.path?x.path.replace(/\/$/,"")+"/{$tab}":"/{$tab}";b.verbose("Setting up automatic tab retrieval from server",t),e.isPlainObject(x.apiSettings)?x.apiSettings.url=t:x.apiSettings={url:t}},loading:function(e){var t=b.get.tabElement(e),n=t.hasClass(C.loading);n||(b.verbose("Setting loading state for",t),t.addClass(C.loading).siblings(p).removeClass(C.active+" "+C.loading),t.length>0&&x.onRequest.call(t[0],e))},state:function(t){e.address.value(t)}},changeTab:function(n){var i=t.history&&t.history.pushState,o=i&&x.ignoreFirstLoad&&E,a=x.auto||e.isPlainObject(x.apiSettings),r=a&&!o?b.utilities.pathToArray(n):b.get.defaultPathArray(n);n=b.utilities.arrayToPath(r),e.each(r,function(t,i){var s,l,c,u,d=r.slice(0,t+1),f=b.utilities.arrayToPath(d),m=b.is.tab(f),p=t+1==r.length,k=b.get.tabElement(f);if(b.verbose("Looking for tab",i),m){if(b.verbose("Tab was found",i),h=f,v=b.utilities.filterArray(r,d),p?u=!0:(l=r.slice(0,t+2),c=b.utilities.arrayToPath(l),u=!b.is.tab(c),u&&b.verbose("Tab parameters found",l)),u&&a)return o?(b.debug("Ignoring remote content on first tab load",f),E=!1,b.cache.add(n,k.html()),b.activate.all(f),x.onFirstLoad.call(k[0],f,v,y),x.onLoad.call(k[0],f,v,y)):(b.activate.navigation(f),b.fetch.content(f,n)),!1;b.debug("Opened local tab",f),b.activate.all(f),b.cache.read(f)||(b.cache.add(f,!0),b.debug("First time tab loaded calling tab init"),x.onFirstLoad.call(k[0],f,v,y)),x.onLoad.call(k[0],f,v,y)}else{if(-1!=n.search("/")||""===n)return b.error(S.missingTab,R,g,f),!1;if(s=e("#"+n+', a[name="'+n+'"]'),f=s.closest("[data-tab]").data(w.tab),k=b.get.tabElement(f),s&&s.length>0&&f)return b.debug("Anchor link used, opening parent tab",k,s),k.hasClass(C.active)||setTimeout(function(){b.scrollTo(s)},0),b.activate.all(f),b.cache.read(f)||(b.cache.add(f,!0),b.debug("First time tab loaded calling tab init"),x.onFirstLoad.call(k[0],f,v,y)),x.onLoad.call(k[0],f,v,y),!1}})},scrollTo:function(t){var i=t&&t.length>0?t.offset().top:!1;i!==!1&&(b.debug("Forcing scroll to an in-page link in a hidden tab",i,t),e(n).scrollTop(i))},update:{content:function(t,n,o){var a=b.get.tabElement(t),r=a[0];o=o!==i?o:x.evaluateScripts,"string"==typeof x.cacheType&&"dom"==x.cacheType.toLowerCase()&&"string"!=typeof n?a.empty().append(e(n).clone(!0)):o?(b.debug("Updating HTML and evaluating inline scripts",t,n),a.html(n)):(b.debug("Updating HTML",t,n),r.innerHTML=n)}},fetch:{content:function(t,n){var o,a,r=b.get.tabElement(t),s={dataType:"html",encodeParameters:!1,on:"now",cache:x.alwaysRefresh,headers:{"X-Remote":!0},onSuccess:function(e){"response"==x.cacheType&&b.cache.add(n,e),b.update.content(t,e),t==h?(b.debug("Content loaded",t),b.activate.tab(t)):b.debug("Content loaded in background",t),x.onFirstLoad.call(r[0],t,v,y),x.onLoad.call(r[0],t,v,y),x.loadOnce?b.cache.add(n,!0):"string"==typeof x.cacheType&&"dom"==x.cacheType.toLowerCase()&&r.children().length>0?setTimeout(function(){var e=r.children().clone(!0);e=e.not("script"),b.cache.add(n,e)},0):b.cache.add(n,r.html())},urlData:{tab:n}},l=r.api("get request")||!1,c=l&&"pending"===l.state();n=n||t,a=b.cache.read(n),x.cache&&a?(b.activate.tab(t),b.debug("Adding cached content",n),x.loadOnce||("once"==x.evaluateScripts?b.update.content(t,a,!1):b.update.content(t,a)),x.onLoad.call(r[0],t,v,y)):c?(b.set.loading(t),b.debug("Content is already loading",n)):e.api!==i?(o=e.extend(!0,{},x.apiSettings,s),b.debug("Retrieving remote content",n,o),b.set.loading(t),r.api(o)):b.error(S.api)}},activate:{all:function(e){b.activate.tab(e),b.activate.navigation(e)},tab:function(e){var t=b.get.tabElement(e),n="siblings"==x.deactivate?t.siblings(p):p.not(t),i=t.hasClass(C.active);b.verbose("Showing tab content for",t),i||(t.addClass(C.active),n.removeClass(C.active+" "+C.loading),t.length>0&&x.onVisible.call(t[0],e))},navigation:function(e){var t=b.get.navElement(e),n="siblings"==x.deactivate?t.siblings(r):r.not(t),i=t.hasClass(C.active);b.verbose("Activating tab navigation for",t,e),i||(t.addClass(C.active),n.removeClass(C.active+" "+C.loading))}},deactivate:{all:function(){b.deactivate.navigation(),b.deactivate.tabs()},navigation:function(){r.removeClass(C.active)},tabs:function(){p.removeClass(C.active+" "+C.loading)}},is:{tab:function(e){return e!==i?b.get.tabElement(e).length>0:!1}},get:{initialPath:function(){return r.eq(0).data(w.tab)||p.eq(0).data(w.tab)},path:function(){return e.address.value()},defaultPathArray:function(e){return b.utilities.pathToArray(b.get.defaultPath(e))},defaultPath:function(e){var t=r.filter("[data-"+w.tab+'^="'+e+'/"]').eq(0),n=t.data(w.tab)||!1;if(n){if(b.debug("Found default tab",n),F<x.maxDepth)return F++,b.get.defaultPath(n);b.error(S.recursion)}else b.debug("No default tabs found for",e,p);return F=0,e},navElement:function(e){return e=e||h,r.filter("[data-"+w.tab+'="'+e+'"]')},tabElement:function(e){var t,n,i,o;return e=e||h,i=b.utilities.pathToArray(e),o=b.utilities.last(i),t=p.filter("[data-"+w.tab+'="'+e+'"]'),n=p.filter("[data-"+w.tab+'="'+o+'"]'),t.length>0?t:n},tab:function(){return h}},utilities:{filterArray:function(t,n){return e.grep(t,function(t){return-1==e.inArray(t,n)})},last:function(t){return e.isArray(t)?t[t.length-1]:!1},pathToArray:function(e){return e===i&&(e=h),"string"==typeof e?e.split("/"):[e]},arrayToPath:function(t){return e.isArray(t)?t.join("/"):!1}},setting:function(t,n){if(b.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,x,t);else{if(n===i)return x[t];e.isPlainObject(x[t])?e.extend(!0,x[t],n):x[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,b,t);else{if(n===i)return b[t];b[t]=n}},debug:function(){!x.silent&&x.debug&&(x.performance?b.performance.log(arguments):(b.debug=Function.prototype.bind.call(console.info,console,x.name+":"),b.debug.apply(console,arguments)))},verbose:function(){!x.silent&&x.verbose&&x.debug&&(x.performance?b.performance.log(arguments):(b.verbose=Function.prototype.bind.call(console.info,console,x.name+":"),b.verbose.apply(console,arguments)))},error:function(){x.silent||(b.error=Function.prototype.bind.call(console.error,console,x.name+":"),b.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;x.performance&&(t=(new Date).getTime(),i=l||t,n=t-i,l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:O,"Execution Time":n})),clearTimeout(b.performance.timer),b.performance.timer=setTimeout(b.performance.display,500)},display:function(){var t=x.name+":",n=0;l=!1,clearTimeout(b.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),
console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=D;return n=n||f,o=O||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(b.error(S.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(D===i&&b.initialize(),b.invoke(u)):(D!==i&&D.invoke("destroy"),b.initialize())}),a!==i?a:this},e.tab=function(){e(t).tab.apply(this,arguments)},e.fn.tab.settings={name:"Tab",namespace:"tab",silent:!1,debug:!1,verbose:!1,performance:!0,auto:!1,history:!1,historyType:"hash",path:!1,context:!1,childrenOnly:!1,maxDepth:25,deactivate:"siblings",alwaysRefresh:!1,cache:!0,loadOnce:!1,cacheType:"response",ignoreFirstLoad:!1,apiSettings:!1,evaluateScripts:"once",onFirstLoad:function(e,t,n){},onLoad:function(e,t,n){},onVisible:function(e,t,n){},onRequest:function(e,t,n){},templates:{determineTitle:function(e){}},error:{api:"You attempted to load content without API module",method:"The method you called is not defined",missingTab:"Activated tab cannot be found. Tabs are case-sensitive.",noContent:"The tab you specified is missing a content url.",path:"History enabled, but no path was specified",recursion:"Max recursive depth reached",legacyInit:"onTabInit has been renamed to onFirstLoad in 2.0, please adjust your code.",legacyLoad:"onTabLoad has been renamed to onLoad in 2.0. Please adjust your code",state:"History requires Asual's Address library <https://github.com/asual/jquery-address>"},metadata:{tab:"tab",loaded:"loaded",promise:"promise"},className:{loading:"loading",active:"active"},selector:{tabs:".ui.tab",ui:".ui"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.transition=function(){var o,a=e(this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments,u=c[0],d=[].slice.call(arguments,1),f="string"==typeof u;t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)};return a.each(function(t){var m,g,p,h,v,b,y,x,C,w=e(this),k=this;C={initialize:function(){m=C.get.settings.apply(k,c),h=m.className,p=m.error,v=m.metadata,x="."+m.namespace,y="module-"+m.namespace,g=w.data(y)||C,b=C.get.animationEndEvent(),f&&(f=C.invoke(u)),f===!1&&(C.verbose("Converted arguments into settings object",m),m.interval?C.delay(m.animate):C.animate(),C.instantiate())},instantiate:function(){C.verbose("Storing instance of module",C),g=C,w.data(y,g)},destroy:function(){C.verbose("Destroying previous module for",k),w.removeData(y)},refresh:function(){C.verbose("Refreshing display type on next animation"),delete C.displayType},forceRepaint:function(){C.verbose("Forcing element repaint");var e=w.parent(),t=w.next();0===t.length?w.detach().appendTo(e):w.detach().insertBefore(t)},repaint:function(){C.verbose("Repainting element");k.offsetWidth},delay:function(e){var n,o,r=C.get.animationDirection();r||(r=C.can.transition()?C.get.direction():"static"),e=e!==i?e:m.interval,n="auto"==m.reverse&&r==h.outward,o=n||1==m.reverse?(a.length-t)*m.interval:t*m.interval,C.debug("Delaying animation by",o),setTimeout(C.animate,o)},animate:function(e){if(m=e||m,!C.is.supported())return C.error(p.support),!1;if(C.debug("Preparing animation",m.animation),C.is.animating()){if(m.queue)return!m.allowRepeats&&C.has.direction()&&C.is.occurring()&&C.queuing!==!0?C.debug("Animation is currently occurring, preventing queueing same animation",m.animation):C.queue(m.animation),!1;if(!m.allowRepeats&&C.is.occurring())return C.debug("Animation is already occurring, will not execute repeated animation",m.animation),!1;C.debug("New animation started, completing previous early",m.animation),g.complete()}C.can.animate()?C.set.animating(m.animation):C.error(p.noAnimation,m.animation,k)},reset:function(){C.debug("Resetting animation to beginning conditions"),C.remove.animationCallbacks(),C.restore.conditions(),C.remove.animating()},queue:function(e){C.debug("Queueing animation of",e),C.queuing=!0,w.one(b+".queue"+x,function(){C.queuing=!1,C.repaint(),C.animate.apply(this,m)})},complete:function(e){C.debug("Animation complete",m.animation),C.remove.completeCallback(),C.remove.failSafe(),C.is.looping()||(C.is.outward()?(C.verbose("Animation is outward, hiding element"),C.restore.conditions(),C.hide()):C.is.inward()?(C.verbose("Animation is outward, showing element"),C.restore.conditions(),C.show()):(C.verbose("Static animation completed"),C.restore.conditions(),m.onComplete.call(k)))},force:{visible:function(){var e=w.attr("style"),t=C.get.userStyle(),n=C.get.displayType(),o=t+"display: "+n+" !important;",a=w.css("display"),r=e===i||""===e;a!==n?(C.verbose("Overriding default display to show element",n),w.attr("style",o)):r&&w.removeAttr("style")},hidden:function(){var e=w.attr("style"),t=w.css("display"),n=e===i||""===e;"none"===t||C.is.hidden()?n&&w.removeAttr("style"):(C.verbose("Overriding default display to hide element"),w.css("display","none"))}},has:{direction:function(t){var n=!1;return t=t||m.animation,"string"==typeof t&&(t=t.split(" "),e.each(t,function(e,t){t!==h.inward&&t!==h.outward||(n=!0)})),n},inlineDisplay:function(){var t=w.attr("style")||"";return e.isArray(t.match(/display.*?;/,""))}},set:{animating:function(e){var t;C.remove.completeCallback(),e=e||m.animation,t=C.get.animationClass(e),C.save.animation(t),C.force.visible(),C.remove.hidden(),C.remove.direction(),C.start.animation(t)},duration:function(e,t){t=t||m.duration,t="number"==typeof t?t+"ms":t,(t||0===t)&&(C.verbose("Setting animation duration",t),w.css({"animation-duration":t}))},direction:function(e){e=e||C.get.direction(),e==h.inward?C.set.inward():C.set.outward()},looping:function(){C.debug("Transition set to loop"),w.addClass(h.looping)},hidden:function(){w.addClass(h.transition).addClass(h.hidden)},inward:function(){C.debug("Setting direction to inward"),w.removeClass(h.outward).addClass(h.inward)},outward:function(){C.debug("Setting direction to outward"),w.removeClass(h.inward).addClass(h.outward)},visible:function(){w.addClass(h.transition).addClass(h.visible)}},start:{animation:function(e){e=e||C.get.animationClass(),C.debug("Starting tween",e),w.addClass(e).one(b+".complete"+x,C.complete),m.useFailSafe&&C.add.failSafe(),C.set.duration(m.duration),m.onStart.call(k)}},save:{animation:function(e){C.cache||(C.cache={}),C.cache.animation=e},displayType:function(e){"none"!==e&&w.data(v.displayType,e)},transitionExists:function(t,n){e.fn.transition.exists[t]=n,C.verbose("Saving existence of transition",t,n)}},restore:{conditions:function(){var e=C.get.currentAnimation();e&&(w.removeClass(e),C.verbose("Removing animation class",C.cache)),C.remove.duration()}},add:{failSafe:function(){var e=C.get.duration();C.timer=setTimeout(function(){w.triggerHandler(b)},e+m.failSafeDelay),C.verbose("Adding fail safe timer",C.timer)}},remove:{animating:function(){w.removeClass(h.animating)},animationCallbacks:function(){C.remove.queueCallback(),C.remove.completeCallback()},queueCallback:function(){w.off(".queue"+x)},completeCallback:function(){w.off(".complete"+x)},display:function(){w.css("display","")},direction:function(){w.removeClass(h.inward).removeClass(h.outward)},duration:function(){w.css("animation-duration","")},failSafe:function(){C.verbose("Removing fail safe timer",C.timer),C.timer&&clearTimeout(C.timer)},hidden:function(){w.removeClass(h.hidden)},visible:function(){w.removeClass(h.visible)},looping:function(){C.debug("Transitions are no longer looping"),C.is.looping()&&(C.reset(),w.removeClass(h.looping))},transition:function(){w.removeClass(h.visible).removeClass(h.hidden)}},get:{settings:function(t,n,i){return"object"==typeof t?e.extend(!0,{},e.fn.transition.settings,t):"function"==typeof i?e.extend({},e.fn.transition.settings,{animation:t,onComplete:i,duration:n}):"string"==typeof n||"number"==typeof n?e.extend({},e.fn.transition.settings,{animation:t,duration:n}):"object"==typeof n?e.extend({},e.fn.transition.settings,n,{animation:t}):"function"==typeof n?e.extend({},e.fn.transition.settings,{animation:t,onComplete:n}):e.extend({},e.fn.transition.settings,{animation:t})},animationClass:function(e){var t=e||m.animation,n=C.can.transition()&&!C.has.direction()?C.get.direction()+" ":"";return h.animating+" "+h.transition+" "+n+t},currentAnimation:function(){return C.cache&&C.cache.animation!==i?C.cache.animation:!1},currentDirection:function(){return C.is.inward()?h.inward:h.outward},direction:function(){return C.is.hidden()||!C.is.visible()?h.inward:h.outward},animationDirection:function(t){var n;return t=t||m.animation,"string"==typeof t&&(t=t.split(" "),e.each(t,function(e,t){t===h.inward?n=h.inward:t===h.outward&&(n=h.outward)})),n?n:!1},duration:function(e){return e=e||m.duration,e===!1&&(e=w.css("animation-duration")||0),"string"==typeof e?e.indexOf("ms")>-1?parseFloat(e):1e3*parseFloat(e):e},displayType:function(e){return e=e!==i?e:!0,m.displayType?m.displayType:(e&&w.data(v.displayType)===i&&C.can.transition(!0),w.data(v.displayType))},userStyle:function(e){return e=e||w.attr("style")||"",e.replace(/display.*?;/,"")},transitionExists:function(t){return e.fn.transition.exists[t]},animationStartEvent:function(){var e,t=n.createElement("div"),o={animation:"animationstart",OAnimation:"oAnimationStart",MozAnimation:"mozAnimationStart",WebkitAnimation:"webkitAnimationStart"};for(e in o)if(t.style[e]!==i)return o[e];return!1},animationEndEvent:function(){var e,t=n.createElement("div"),o={animation:"animationend",OAnimation:"oAnimationEnd",MozAnimation:"mozAnimationEnd",WebkitAnimation:"webkitAnimationEnd"};for(e in o)if(t.style[e]!==i)return o[e];return!1}},can:{transition:function(t){var n,o,a,r,s,l,c=m.animation,u=C.get.transitionExists(c),d=C.get.displayType(!1);if(u===i||t){if(C.verbose("Determining whether animation exists"),n=w.attr("class"),o=w.prop("tagName"),a=e("<"+o+" />").addClass(n).insertAfter(w),r=a.addClass(c).removeClass(h.inward).removeClass(h.outward).addClass(h.animating).addClass(h.transition).css("animationName"),s=a.addClass(h.inward).css("animationName"),d||(d=a.attr("class",n).removeAttr("style").removeClass(h.hidden).removeClass(h.visible).show().css("display"),C.verbose("Determining final display state",d),C.save.displayType(d)),a.remove(),r!=s)C.debug("Direction exists for animation",c),l=!0;else{if("none"==r||!r)return void C.debug("No animation defined in css",c);C.debug("Static animation found",c,d),l=!1}C.save.transitionExists(c,l)}return u!==i?u:l},animate:function(){return C.can.transition()!==i}},is:{animating:function(){return w.hasClass(h.animating)},inward:function(){return w.hasClass(h.inward)},outward:function(){return w.hasClass(h.outward)},looping:function(){return w.hasClass(h.looping)},occurring:function(e){return e=e||m.animation,e="."+e.replace(" ","."),w.filter(e).length>0},visible:function(){return w.is(":visible")},hidden:function(){return"hidden"===w.css("visibility")},supported:function(){return b!==!1}},hide:function(){C.verbose("Hiding element"),C.is.animating()&&C.reset(),k.blur(),C.remove.display(),C.remove.visible(),C.set.hidden(),C.force.hidden(),m.onHide.call(k),m.onComplete.call(k)},show:function(e){C.verbose("Showing element",e),C.remove.hidden(),C.set.visible(),C.force.visible(),m.onShow.call(k),m.onComplete.call(k)},toggle:function(){C.is.visible()?C.hide():C.show()},stop:function(){C.debug("Stopping current animation"),w.triggerHandler(b)},stopAll:function(){C.debug("Stopping all animation"),C.remove.queueCallback(),w.triggerHandler(b)},clear:{queue:function(){C.debug("Clearing animation queue"),C.remove.queueCallback()}},enable:function(){C.verbose("Starting animation"),w.removeClass(h.disabled)},disable:function(){C.debug("Stopping animation"),w.addClass(h.disabled)},setting:function(t,n){if(C.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,m,t);else{if(n===i)return m[t];e.isPlainObject(m[t])?e.extend(!0,m[t],n):m[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,C,t);else{if(n===i)return C[t];C[t]=n}},debug:function(){!m.silent&&m.debug&&(m.performance?C.performance.log(arguments):(C.debug=Function.prototype.bind.call(console.info,console,m.name+":"),C.debug.apply(console,arguments)))},verbose:function(){!m.silent&&m.verbose&&m.debug&&(m.performance?C.performance.log(arguments):(C.verbose=Function.prototype.bind.call(console.info,console,m.name+":"),C.verbose.apply(console,arguments)))},error:function(){m.silent||(C.error=Function.prototype.bind.call(console.error,console,m.name+":"),C.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;m.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:k,"Execution Time":n})),clearTimeout(C.performance.timer),C.performance.timer=setTimeout(C.performance.display,500)},display:function(){var t=m.name+":",n=0;s=!1,clearTimeout(C.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),a.length>1&&(t+=" ("+a.length+")"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=g;return n=n||d,a=k||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):!1;c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s!==i?s:!1}},C.initialize()}),o!==i?o:this},e.fn.transition.exists={},e.fn.transition.settings={name:"Transition",silent:!1,debug:!1,verbose:!1,performance:!0,namespace:"transition",interval:0,reverse:"auto",onStart:function(){},onComplete:function(){},onShow:function(){},onHide:function(){},useFailSafe:!0,failSafeDelay:100,allowRepeats:!1,displayType:!1,animation:"fade",duration:!1,queue:!0,metadata:{displayType:"display"},className:{animating:"animating",disabled:"disabled",hidden:"hidden",inward:"in",loading:"loading",looping:"looping",outward:"out",transition:"transition",visible:"visible"},error:{noAnimation:"Element is no longer attached to DOM. Unable to animate.  Use silent setting to surpress this warning in production.",repeated:"That animation is already occurring, cancelling repeated animation",method:"The method you called is not defined",support:"This browser does not support CSS animations"}}}(jQuery,window,document),function(e,t,n,i){"use strict";var t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();e.api=e.fn.api=function(n){var o,a=e(e.isFunction(this)?t:this),r=a.selector||"",s=(new Date).getTime(),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var a,f,m,g,p,h,v=e.isPlainObject(n)?e.extend(!0,{},e.fn.api.settings,n):e.extend({},e.fn.api.settings),b=v.namespace,y=v.metadata,x=v.selector,C=v.error,w=v.className,k="."+b,S="module-"+b,T=e(this),A=T.closest(x.form),R=v.stateContext?e(v.stateContext):T,P=this,E=R[0],F=T.data(S);h={initialize:function(){u||h.bind.events(),h.instantiate()},instantiate:function(){h.verbose("Storing instance of module",h),F=h,T.data(S,F)},destroy:function(){h.verbose("Destroying previous module for",P),T.removeData(S).off(k)},bind:{events:function(){var e=h.get.event();e?(h.verbose("Attaching API events to element",e),T.on(e+k,h.event.trigger)):"now"==v.on&&(h.debug("Querying API endpoint immediately"),h.query())}},decode:{json:function(e){if(e!==i&&"string"==typeof e)try{e=JSON.parse(e)}catch(t){}return e}},read:{cachedResponse:function(e){var n;return t.Storage===i?void h.error(C.noStorage):(n=sessionStorage.getItem(e),h.debug("Using cached response",e,n),n=h.decode.json(n))}},write:{cachedResponse:function(n,o){return o&&""===o?void h.debug("Response empty, not caching",o):t.Storage===i?void h.error(C.noStorage):(e.isPlainObject(o)&&(o=JSON.stringify(o)),sessionStorage.setItem(n,o),void h.verbose("Storing cached response for url",n,o))}},query:function(){if(h.is.disabled())return void h.debug("Element is disabled API request aborted");if(h.is.loading()){if(!v.interruptRequests)return void h.debug("Cancelling request, previous request is still pending");h.debug("Interrupting previous request"),h.abort()}return v.defaultData&&e.extend(!0,v.urlData,h.get.defaultData()),v.serializeForm&&(v.data=h.add.formData(v.data)),f=h.get.settings(),f===!1?(h.cancelled=!0,void h.error(C.beforeSend)):(h.cancelled=!1,m=h.get.templatedURL(),m||h.is.mocked()?(m=h.add.urlData(m),m||h.is.mocked()?(f.url=v.base+m,a=e.extend(!0,{},v,{type:v.method||v.type,data:g,url:v.base+m,beforeSend:v.beforeXHR,success:function(){},failure:function(){},complete:function(){}}),h.debug("Querying URL",a.url),h.verbose("Using AJAX settings",a),"local"===v.cache&&h.read.cachedResponse(m)?(h.debug("Response returned from local cache"),h.request=h.create.request(),void h.request.resolveWith(E,[h.read.cachedResponse(m)])):void(v.throttle?v.throttleFirstRequest||h.timer?(h.debug("Throttling request",v.throttle),clearTimeout(h.timer),h.timer=setTimeout(function(){h.timer&&delete h.timer,h.debug("Sending throttled request",g,a.method),h.send.request()},v.throttle)):(h.debug("Sending request",g,a.method),h.send.request(),h.timer=setTimeout(function(){},v.throttle)):(h.debug("Sending request",g,a.method),h.send.request()))):void 0):void h.error(C.missingURL))},should:{removeError:function(){return v.hideError===!0||"auto"===v.hideError&&!h.is.form()}},is:{disabled:function(){return T.filter(x.disabled).length>0},expectingJSON:function(){return"json"===v.dataType||"jsonp"===v.dataType},form:function(){return T.is("form")||R.is("form")},mocked:function(){return v.mockResponse||v.mockResponseAsync||v.response||v.responseAsync},input:function(){return T.is("input")},loading:function(){return h.request?"pending"==h.request.state():!1},abortedRequest:function(e){return e&&e.readyState!==i&&0===e.readyState?(h.verbose("XHR request determined to be aborted"),!0):(h.verbose("XHR request was not aborted"),!1)},validResponse:function(t){return h.is.expectingJSON()&&e.isFunction(v.successTest)?(h.debug("Checking JSON returned success",v.successTest,t),v.successTest(t)?(h.debug("Response passed success test",t),!0):(h.debug("Response failed success test",t),!1)):(h.verbose("Response is not JSON, skipping validation",v.successTest,t),!0)}},was:{cancelled:function(){return h.cancelled||!1},succesful:function(){return h.request&&"resolved"==h.request.state()},failure:function(){return h.request&&"rejected"==h.request.state()},complete:function(){return h.request&&("resolved"==h.request.state()||"rejected"==h.request.state())}},add:{urlData:function(t,n){var o,a;return t&&(o=t.match(v.regExp.required),a=t.match(v.regExp.optional),n=n||v.urlData,o&&(h.debug("Looking for required URL variables",o),e.each(o,function(o,a){var r=-1!==a.indexOf("$")?a.substr(2,a.length-3):a.substr(1,a.length-2),s=e.isPlainObject(n)&&n[r]!==i?n[r]:T.data(r)!==i?T.data(r):R.data(r)!==i?R.data(r):n[r];return s===i?(h.error(C.requiredParameter,r,t),t=!1,!1):(h.verbose("Found required variable",r,s),s=v.encodeParameters?h.get.urlEncodedValue(s):s,t=t.replace(a,s),void 0)})),a&&(h.debug("Looking for optional URL variables",o),e.each(a,function(o,a){var r=-1!==a.indexOf("$")?a.substr(3,a.length-4):a.substr(2,a.length-3),s=e.isPlainObject(n)&&n[r]!==i?n[r]:T.data(r)!==i?T.data(r):R.data(r)!==i?R.data(r):n[r];s!==i?(h.verbose("Optional variable Found",r,s),t=t.replace(a,s)):(h.verbose("Optional variable not found",r),t=-1!==t.indexOf("/"+a)?t.replace("/"+a,""):t.replace(a,""))}))),t},formData:function(t){var n,o=e.fn.serializeObject!==i,a=o?A.serializeObject():A.serialize();return t=t||v.data,n=e.isPlainObject(t),n?o?(h.debug("Extending existing data with form data",t,a),t=e.extend(!0,{},t,a)):(h.error(C.missingSerialize),h.debug("Cant extend data. Replacing data with form data",t,a),t=a):(h.debug("Adding form data",a),t=a),t}},send:{request:function(){h.set.loading(),h.request=h.create.request(),h.is.mocked()?h.mockedXHR=h.create.mockedXHR():h.xhr=h.create.xhr(),v.onRequest.call(E,h.request,h.xhr)}},event:{trigger:function(e){h.query(),"submit"!=e.type&&"click"!=e.type||e.preventDefault()},xhr:{always:function(){},done:function(t,n,i){var o=this,a=(new Date).getTime()-p,r=v.loadingDuration-a,s=e.isFunction(v.onResponse)?h.is.expectingJSON()?v.onResponse.call(o,e.extend(!0,{},t)):v.onResponse.call(o,t):!1;r=r>0?r:0,s&&(h.debug("Modified API response in onResponse callback",v.onResponse,s,t),t=s),r>0&&h.debug("Response completed early delaying state change by",r),setTimeout(function(){h.is.validResponse(t)?h.request.resolveWith(o,[t,i]):h.request.rejectWith(o,[i,"invalid"])},r)},fail:function(e,t,n){var i=this,o=(new Date).getTime()-p,a=v.loadingDuration-o;a=a>0?a:0,a>0&&h.debug("Response completed early delaying state change by",a),setTimeout(function(){h.is.abortedRequest(e)?h.request.rejectWith(i,[e,"aborted",n]):h.request.rejectWith(i,[e,"error",t,n])},a)}},request:{done:function(e,t){h.debug("Successful API Response",e),"local"===v.cache&&m&&(h.write.cachedResponse(m,e),h.debug("Saving server response locally",h.cache)),v.onSuccess.call(E,e,T,t)},complete:function(e,t){var n,i;h.was.succesful()?(i=e,n=t):(n=e,i=h.get.responseFromXHR(n)),h.remove.loading(),v.onComplete.call(E,i,T,n)},fail:function(e,t,n){var o=h.get.responseFromXHR(e),r=h.get.errorFromRequest(o,t,n);return"aborted"==t?(h.debug("XHR Aborted (Most likely caused by page navigation or CORS Policy)",t,n),v.onAbort.call(E,t,T,e),!0):("invalid"==t?h.debug("JSON did not pass success test. A server-side error has most likely occurred",o):"error"==t&&e!==i&&(h.debug("XHR produced a server error",t,n),200!=e.status&&n!==i&&""!==n&&h.error(C.statusMessage+n,a.url),v.onError.call(E,r,T,e)),v.errorDuration&&"aborted"!==t&&(h.debug("Adding error state"),h.set.error(),h.should.removeError()&&setTimeout(h.remove.error,v.errorDuration)),h.debug("API Request failed",r,e),void v.onFailure.call(E,o,T,e))}}},create:{request:function(){return e.Deferred().always(h.event.request.complete).done(h.event.request.done).fail(h.event.request.fail)},mockedXHR:function(){var t,n,i,o=!1,a=!1,r=!1,s=v.mockResponse||v.response,l=v.mockResponseAsync||v.responseAsync;return i=e.Deferred().always(h.event.xhr.complete).done(h.event.xhr.done).fail(h.event.xhr.fail),s?(e.isFunction(s)?(h.debug("Using specified synchronous callback",s),n=s.call(E,f)):(h.debug("Using settings specified response",s),n=s),i.resolveWith(E,[n,o,{responseText:n}])):e.isFunction(l)&&(t=function(e){h.debug("Async callback returned response",e),e?i.resolveWith(E,[e,o,{responseText:e}]):i.rejectWith(E,[{responseText:e},a,r])},h.debug("Using specified async response callback",l),l.call(E,f,t)),i},xhr:function(){var t;return t=e.ajax(a).always(h.event.xhr.always).done(h.event.xhr.done).fail(h.event.xhr.fail),h.verbose("Created server request",t,a),t}},set:{error:function(){h.verbose("Adding error state to element",R),R.addClass(w.error)},loading:function(){h.verbose("Adding loading state to element",R),R.addClass(w.loading),p=(new Date).getTime()}},remove:{error:function(){h.verbose("Removing error state from element",R),R.removeClass(w.error)},loading:function(){h.verbose("Removing loading state from element",R),R.removeClass(w.loading)}},get:{responseFromXHR:function(t){return e.isPlainObject(t)?h.is.expectingJSON()?h.decode.json(t.responseText):t.responseText:!1},errorFromRequest:function(t,n,o){return e.isPlainObject(t)&&t.error!==i?t.error:v.error[n]!==i?v.error[n]:o},request:function(){return h.request||!1},xhr:function(){return h.xhr||!1},settings:function(){var t;return t=v.beforeSend.call(E,v),t&&(t.success!==i&&(h.debug("Legacy success callback detected",t),h.error(C.legacyParameters,t.success),t.onSuccess=t.success),t.failure!==i&&(h.debug("Legacy failure callback detected",t),h.error(C.legacyParameters,t.failure),t.onFailure=t.failure),t.complete!==i&&(h.debug("Legacy complete callback detected",t),h.error(C.legacyParameters,t.complete),t.onComplete=t.complete)),t===i&&h.error(C.noReturnedValue),t===!1?t:t!==i?e.extend(!0,{},t):e.extend(!0,{},v)},urlEncodedValue:function(e){var n=t.decodeURIComponent(e),i=t.encodeURIComponent(e),o=n!==e;return o?(h.debug("URL value is already encoded, avoiding double encoding",e),e):(h.verbose("Encoding value using encodeURIComponent",e,i),i)},defaultData:function(){var t={};return e.isWindow(P)||(h.is.input()?t.value=T.val():h.is.form()||(t.text=T.text())),t},event:function(){return e.isWindow(P)||"now"==v.on?(h.debug("API called without element, no events attached"),!1):"auto"==v.on?T.is("input")?P.oninput!==i?"input":P.onpropertychange!==i?"propertychange":"keyup":T.is("form")?"submit":"click":v.on},templatedURL:function(e){if(e=e||T.data(y.action)||v.action||!1,m=T.data(y.url)||v.url||!1)return h.debug("Using specified url",m),m;if(e){if(h.debug("Looking up url for action",e,v.api),v.api[e]===i&&!h.is.mocked())return void h.error(C.missingAction,v.action,v.api);m=v.api[e]}else h.is.form()&&(m=T.attr("action")||R.attr("action")||!1,h.debug("No url or action specified, defaulting to form action",m));return m}},abort:function(){var e=h.get.xhr();e&&"resolved"!==e.state()&&(h.debug("Cancelling API request"),e.abort())},reset:function(){h.remove.error(),h.remove.loading()},setting:function(t,n){if(h.debug("Changing setting",t,n),e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];e.isPlainObject(v[t])?e.extend(!0,v[t],n):v[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,h,t);else{if(n===i)return h[t];h[t]=n}},debug:function(){!v.silent&&v.debug&&(v.performance?h.performance.log(arguments):(h.debug=Function.prototype.bind.call(console.info,console,v.name+":"),h.debug.apply(console,arguments)))},verbose:function(){!v.silent&&v.verbose&&v.debug&&(v.performance?h.performance.log(arguments):(h.verbose=Function.prototype.bind.call(console.info,console,v.name+":"),h.verbose.apply(console,arguments)))},error:function(){v.silent||(h.error=Function.prototype.bind.call(console.error,console,v.name+":"),h.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;v.performance&&(t=(new Date).getTime(),i=s||t,n=t-i,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"","Execution Time":n})),clearTimeout(h.performance.timer),h.performance.timer=setTimeout(h.performance.display,500)},display:function(){var t=v.name+":",n=0;s=!1,clearTimeout(h.performance.timer),e.each(l,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,n,a){var r,s,l,c=F;return n=n||d,a=P||a,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(h.error(C.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(a,n):s!==i&&(l=s),e.isArray(o)?o.push(l):o!==i?o=[o,l]:l!==i&&(o=l),s}},u?(F===i&&h.initialize(),h.invoke(c)):(F!==i&&F.invoke("destroy"),h.initialize())}),o!==i?o:this},e.api.settings={name:"API",namespace:"api",debug:!1,verbose:!1,performance:!0,api:{},cache:!0,interruptRequests:!0,on:"auto",stateContext:!1,loadingDuration:0,hideError:"auto",errorDuration:2e3,encodeParameters:!0,action:!1,url:!1,base:"",urlData:{},defaultData:!0,serializeForm:!1,throttle:0,throttleFirstRequest:!0,method:"get",data:{},dataType:"json",mockResponse:!1,mockResponseAsync:!1,response:!1,responseAsync:!1,beforeSend:function(e){return e},beforeXHR:function(e){},onRequest:function(e,t){},onResponse:!1,onSuccess:function(e,t){},onComplete:function(e,t){},onFailure:function(e,t){},onError:function(e,t){},onAbort:function(e,t){},successTest:!1,error:{beforeSend:"The before send function has aborted the request",error:"There was an error with your request",exitConditions:"API Request Aborted. Exit conditions met",JSONParse:"JSON could not be parsed during error handling",legacyParameters:"You are using legacy API success callback names",method:"The method you called is not defined",missingAction:"API action used but no url was defined",missingSerialize:"jquery-serialize-object is required to add form data to an existing data object",missingURL:"No URL specified for api event",noReturnedValue:"The beforeSend callback must return a settings object, beforeSend ignored.",noStorage:"Caching responses locally requires session storage",parseError:"There was an error parsing your request",requiredParameter:"Missing a required URL parameter: ",statusMessage:"Server gave an error: ",timeout:"Your request timed out"},regExp:{required:/\{\$*[A-z0-9]+\}/g,optional:/\{\/\$*[A-z0-9]+\}/g},className:{loading:"loading",error:"error"},selector:{disabled:".disabled",form:"form"},metadata:{action:"action",url:"url"}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.state=function(t){var o,a=e(this),r=a.selector||"",s=("ontouchstart"in n.documentElement,(new Date).getTime()),l=[],c=arguments[0],u="string"==typeof c,d=[].slice.call(arguments,1);return a.each(function(){var n,f=e.isPlainObject(t)?e.extend(!0,{},e.fn.state.settings,t):e.extend({},e.fn.state.settings),m=f.error,g=f.metadata,p=f.className,h=f.namespace,v=f.states,b=f.text,y="."+h,x=h+"-module",C=e(this),w=this,k=C.data(x);n={initialize:function(){n.verbose("Initializing module"),f.automatic&&n.add.defaults(),f.context&&""!==r?e(f.context).on(r,"mouseenter"+y,n.change.text).on(r,"mouseleave"+y,n.reset.text).on(r,"click"+y,n.toggle.state):C.on("mouseenter"+y,n.change.text).on("mouseleave"+y,n.reset.text).on("click"+y,n.toggle.state),n.instantiate()},instantiate:function(){n.verbose("Storing instance of module",n),k=n,C.data(x,n)},destroy:function(){n.verbose("Destroying previous module",k),C.off(y).removeData(x)},refresh:function(){n.verbose("Refreshing selector cache"),C=e(w)},add:{defaults:function(){var o=t&&e.isPlainObject(t.states)?t.states:{};e.each(f.defaults,function(t,a){n.is[t]!==i&&n.is[t]()&&(n.verbose("Adding default states",t,w),e.extend(f.states,a,o))})}},is:{active:function(){return C.hasClass(p.active)},loading:function(){return C.hasClass(p.loading)},inactive:function(){return!C.hasClass(p.active)},state:function(e){return p[e]===i?!1:C.hasClass(p[e])},enabled:function(){return!C.is(f.filter.active)},disabled:function(){return C.is(f.filter.active)},textEnabled:function(){return!C.is(f.filter.text)},button:function(){return C.is(".button:not(a, .submit)")},input:function(){return C.is("input")},progress:function(){return C.is(".ui.progress")}},allow:function(e){n.debug("Now allowing state",e),v[e]=!0},disallow:function(e){n.debug("No longer allowing",e),v[e]=!1},allows:function(e){return v[e]||!1},enable:function(){C.removeClass(p.disabled)},disable:function(){C.addClass(p.disabled)},setState:function(e){n.allows(e)&&C.addClass(p[e])},removeState:function(e){n.allows(e)&&C.removeClass(p[e])},toggle:{state:function(){var t,o;if(n.allows("active")&&n.is.enabled()){
if(n.refresh(),e.fn.api!==i)if(t=C.api("get request"),o=C.api("was cancelled"))n.debug("API Request cancelled by beforesend"),f.activateTest=function(){return!1},f.deactivateTest=function(){return!1};else if(t)return void n.listenTo(t);n.change.state()}}},listenTo:function(t){n.debug("API request detected, waiting for state signal",t),t&&(b.loading&&n.update.text(b.loading),e.when(t).then(function(){"resolved"==t.state()?(n.debug("API request succeeded"),f.activateTest=function(){return!0},f.deactivateTest=function(){return!0}):(n.debug("API request failed"),f.activateTest=function(){return!1},f.deactivateTest=function(){return!1}),n.change.state()}))},change:{state:function(){n.debug("Determining state change direction"),n.is.inactive()?n.activate():n.deactivate(),f.sync&&n.sync(),f.onChange.call(w)},text:function(){n.is.textEnabled()&&(n.is.disabled()?(n.verbose("Changing text to disabled text",b.hover),n.update.text(b.disabled)):n.is.active()?b.hover?(n.verbose("Changing text to hover text",b.hover),n.update.text(b.hover)):b.deactivate&&(n.verbose("Changing text to deactivating text",b.deactivate),n.update.text(b.deactivate)):b.hover?(n.verbose("Changing text to hover text",b.hover),n.update.text(b.hover)):b.activate&&(n.verbose("Changing text to activating text",b.activate),n.update.text(b.activate)))}},activate:function(){f.activateTest.call(w)&&(n.debug("Setting state to active"),C.addClass(p.active),n.update.text(b.active),f.onActivate.call(w))},deactivate:function(){f.deactivateTest.call(w)&&(n.debug("Setting state to inactive"),C.removeClass(p.active),n.update.text(b.inactive),f.onDeactivate.call(w))},sync:function(){n.verbose("Syncing other buttons to current state"),n.is.active()?a.not(C).state("activate"):a.not(C).state("deactivate")},get:{text:function(){return f.selector.text?C.find(f.selector.text).text():C.html()},textFor:function(e){return b[e]||!1}},flash:{text:function(e,t,i){var o=n.get.text();n.debug("Flashing text message",e,t),e=e||f.text.flash,t=t||f.flashDuration,i=i||function(){},n.update.text(e),setTimeout(function(){n.update.text(o),i.call(w)},t)}},reset:{text:function(){var e=b.active||C.data(g.storedText),t=b.inactive||C.data(g.storedText);n.is.textEnabled()&&(n.is.active()&&e?(n.verbose("Resetting active text",e),n.update.text(e)):t&&(n.verbose("Resetting inactive text",e),n.update.text(t)))}},update:{text:function(e){var t=n.get.text();e&&e!==t?(n.debug("Updating text",e),f.selector.text?C.data(g.storedText,e).find(f.selector.text).text(e):C.data(g.storedText,e).html(e)):n.debug("Text is already set, ignoring update",e)}},setting:function(t,o){if(n.debug("Changing setting",t,o),e.isPlainObject(t))e.extend(!0,f,t);else{if(o===i)return f[t];e.isPlainObject(f[t])?e.extend(!0,f[t],o):f[t]=o}},internal:function(t,o){if(e.isPlainObject(t))e.extend(!0,n,t);else{if(o===i)return n[t];n[t]=o}},debug:function(){!f.silent&&f.debug&&(f.performance?n.performance.log(arguments):(n.debug=Function.prototype.bind.call(console.info,console,f.name+":"),n.debug.apply(console,arguments)))},verbose:function(){!f.silent&&f.verbose&&f.debug&&(f.performance?n.performance.log(arguments):(n.verbose=Function.prototype.bind.call(console.info,console,f.name+":"),n.verbose.apply(console,arguments)))},error:function(){f.silent||(n.error=Function.prototype.bind.call(console.error,console,f.name+":"),n.error.apply(console,arguments))},performance:{log:function(e){var t,i,o;f.performance&&(t=(new Date).getTime(),o=s||t,i=t-o,s=t,l.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:w,"Execution Time":i})),clearTimeout(n.performance.timer),n.performance.timer=setTimeout(n.performance.display,500)},display:function(){var t=f.name+":",o=0;s=!1,clearTimeout(n.performance.timer),e.each(l,function(e,t){o+=t["Execution Time"]}),t+=" "+o+"ms",r&&(t+=" '"+r+"'"),(console.group!==i||console.table!==i)&&l.length>0&&(console.groupCollapsed(t),console.table?console.table(l):e.each(l,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),l=[]}},invoke:function(t,a,r){var s,l,c,u=k;return a=a||d,r=w||r,"string"==typeof t&&u!==i&&(t=t.split(/[\. ]/),s=t.length-1,e.each(t,function(o,a){var r=o!=s?a+t[o+1].charAt(0).toUpperCase()+t[o+1].slice(1):t;if(e.isPlainObject(u[r])&&o!=s)u=u[r];else{if(u[r]!==i)return l=u[r],!1;if(!e.isPlainObject(u[a])||o==s)return u[a]!==i?(l=u[a],!1):(n.error(m.method,t),!1);u=u[a]}})),e.isFunction(l)?c=l.apply(r,a):l!==i&&(c=l),e.isArray(o)?o.push(c):o!==i?o=[o,c]:c!==i&&(o=c),l}},u?(k===i&&n.initialize(),n.invoke(c)):(k!==i&&k.invoke("destroy"),n.initialize())}),o!==i?o:this},e.fn.state.settings={name:"State",debug:!1,verbose:!1,namespace:"state",performance:!0,onActivate:function(){},onDeactivate:function(){},onChange:function(){},activateTest:function(){return!0},deactivateTest:function(){return!0},automatic:!0,sync:!1,flashDuration:1e3,filter:{text:".loading, .disabled",active:".disabled"},context:!1,error:{beforeSend:"The before send function has cancelled state change",method:"The method you called is not defined."},metadata:{promise:"promise",storedText:"stored-text"},className:{active:"active",disabled:"disabled",error:"error",loading:"loading",success:"success",warning:"warning"},selector:{text:!1},defaults:{input:{disabled:!0,loading:!0,active:!0},button:{disabled:!0,loading:!0,active:!0},progress:{active:!0,success:!0,warning:!0,error:!0}},states:{active:!0,disabled:!0,error:!0,loading:!0,success:!0,warning:!0},text:{disabled:!1,flash:!1,hover:!1,active:!1,inactive:!1,activate:!1,deactivate:!1}}}(jQuery,window,document),function(e,t,n,i){"use strict";t="undefined"!=typeof t&&t.Math==Math?t:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),e.fn.visibility=function(o){var a,r=e(this),s=r.selector||"",l=(new Date).getTime(),c=[],u=arguments[0],d="string"==typeof u,f=[].slice.call(arguments,1),m=r.length,g=0;return r.each(function(){var r,p,h,v,b=e.isPlainObject(o)?e.extend(!0,{},e.fn.visibility.settings,o):e.extend({},e.fn.visibility.settings),y=b.className,x=b.namespace,C=b.error,w=b.metadata,k="."+x,S="module-"+x,T=e(t),A=e(this),R=e(b.context),P=(A.selector||"",A.data(S)),E=t.requestAnimationFrame||t.mozRequestAnimationFrame||t.webkitRequestAnimationFrame||t.msRequestAnimationFrame||function(e){setTimeout(e,0)},F=this,O=!1;v={initialize:function(){v.debug("Initializing",b),v.setup.cache(),v.should.trackChanges()&&("image"==b.type&&v.setup.image(),"fixed"==b.type&&v.setup.fixed(),b.observeChanges&&v.observeChanges(),v.bind.events()),v.save.position(),v.is.visible()||v.error(C.visible,A),b.initialCheck&&v.checkVisibility(),v.instantiate()},instantiate:function(){v.debug("Storing instance",v),A.data(S,v),P=v},destroy:function(){v.verbose("Destroying previous module"),h&&h.disconnect(),p&&p.disconnect(),T.off("load"+k,v.event.load).off("resize"+k,v.event.resize),R.off("scroll"+k,v.event.scroll).off("scrollchange"+k,v.event.scrollchange),"fixed"==b.type&&(v.resetFixed(),v.remove.placeholder()),A.off(k).removeData(S)},observeChanges:function(){"MutationObserver"in t&&(p=new MutationObserver(v.event.contextChanged),h=new MutationObserver(v.event.changed),p.observe(n,{childList:!0,subtree:!0}),h.observe(F,{childList:!0,subtree:!0}),v.debug("Setting up mutation observer",h))},bind:{events:function(){v.verbose("Binding visibility events to scroll and resize"),b.refreshOnLoad&&T.on("load"+k,v.event.load),T.on("resize"+k,v.event.resize),R.off("scroll"+k).on("scroll"+k,v.event.scroll).on("scrollchange"+k,v.event.scrollchange)}},event:{changed:function(e){v.verbose("DOM tree modified, updating visibility calculations"),v.timer=setTimeout(function(){v.verbose("DOM tree modified, updating sticky menu"),v.refresh()},100)},contextChanged:function(t){[].forEach.call(t,function(t){t.removedNodes&&[].forEach.call(t.removedNodes,function(t){(t==F||e(t).find(F).length>0)&&(v.debug("Element removed from DOM, tearing down events"),v.destroy())})})},resize:function(){v.debug("Window resized"),b.refreshOnResize&&E(v.refresh)},load:function(){v.debug("Page finished loading"),E(v.refresh)},scroll:function(){b.throttle?(clearTimeout(v.timer),v.timer=setTimeout(function(){R.triggerHandler("scrollchange"+k,[R.scrollTop()])},b.throttle)):E(function(){R.triggerHandler("scrollchange"+k,[R.scrollTop()])})},scrollchange:function(e,t){v.checkVisibility(t)}},precache:function(t,i){t instanceof Array||(t=[t]);for(var o=t.length,a=0,r=[],s=n.createElement("img"),l=function(){a++,a>=t.length&&e.isFunction(i)&&i()};o--;)s=n.createElement("img"),s.onload=l,s.onerror=l,s.src=t[o],r.push(s)},enableCallbacks:function(){v.debug("Allowing callbacks to occur"),O=!1},disableCallbacks:function(){v.debug("Disabling all callbacks temporarily"),O=!0},should:{trackChanges:function(){return d?(v.debug("One time query, no need to bind events"),!1):(v.debug("Callbacks being attached"),!0)}},setup:{cache:function(){v.cache={occurred:{},screen:{},element:{}}},image:function(){var e=A.data(w.src);e&&(v.verbose("Lazy loading image",e),b.once=!0,b.observeChanges=!1,b.onOnScreen=function(){v.debug("Image on screen",F),v.precache(e,function(){v.set.image(e,function(){g++,g==m&&b.onAllLoaded.call(this),b.onLoad.call(this)})})})},fixed:function(){v.debug("Setting up fixed"),b.once=!1,b.observeChanges=!1,b.initialCheck=!0,b.refreshOnLoad=!0,o.transition||(b.transition=!1),v.create.placeholder(),v.debug("Added placeholder",r),b.onTopPassed=function(){v.debug("Element passed, adding fixed position",A),v.show.placeholder(),v.set.fixed(),b.transition&&e.fn.transition!==i&&A.transition(b.transition,b.duration)},b.onTopPassedReverse=function(){v.debug("Element returned to position, removing fixed",A),v.hide.placeholder(),v.remove.fixed()}}},create:{placeholder:function(){v.verbose("Creating fixed position placeholder"),r=A.clone(!1).css("display","none").addClass(y.placeholder).insertAfter(A)}},show:{placeholder:function(){v.verbose("Showing placeholder"),r.css("display","block").css("visibility","hidden")}},hide:{placeholder:function(){v.verbose("Hiding placeholder"),r.css("display","none").css("visibility","")}},set:{fixed:function(){v.verbose("Setting element to fixed position"),A.addClass(y.fixed).css({position:"fixed",top:b.offset+"px",left:"auto",zIndex:b.zIndex}),b.onFixed.call(F)},image:function(t,n){if(A.attr("src",t),b.transition)if(e.fn.transition!==i){if(A.hasClass(y.visible))return void v.debug("Transition already occurred on this image, skipping animation");A.transition(b.transition,b.duration,n)}else A.fadeIn(b.duration,n);else A.show()}},is:{onScreen:function(){var e=v.get.elementCalculations();return e.onScreen},offScreen:function(){var e=v.get.elementCalculations();return e.offScreen},visible:function(){return v.cache&&v.cache.element?!(0===v.cache.element.width&&0===v.cache.element.offset.top):!1},verticallyScrollableContext:function(){var e=R.get(0)!==t?R.css("overflow-y"):!1;return"auto"==e||"scroll"==e},horizontallyScrollableContext:function(){var e=R.get(0)!==t?R.css("overflow-x"):!1;return"auto"==e||"scroll"==e}},refresh:function(){v.debug("Refreshing constants (width/height)"),"fixed"==b.type&&v.resetFixed(),v.reset(),v.save.position(),b.checkOnRefresh&&v.checkVisibility(),b.onRefresh.call(F)},resetFixed:function(){v.remove.fixed(),v.remove.occurred()},reset:function(){v.verbose("Resetting all cached values"),e.isPlainObject(v.cache)&&(v.cache.screen={},v.cache.element={})},checkVisibility:function(e){v.verbose("Checking visibility of element",v.cache.element),!O&&v.is.visible()&&(v.save.scroll(e),v.save.calculations(),v.passed(),v.passingReverse(),v.topVisibleReverse(),v.bottomVisibleReverse(),v.topPassedReverse(),v.bottomPassedReverse(),v.onScreen(),v.offScreen(),v.passing(),v.topVisible(),v.bottomVisible(),v.topPassed(),v.bottomPassed(),b.onUpdate&&b.onUpdate.call(F,v.get.elementCalculations()))},passed:function(t,n){var o=v.get.elementCalculations();if(t&&n)b.onPassed[t]=n;else{if(t!==i)return v.get.pixelsPassed(t)>o.pixelsPassed;o.passing&&e.each(b.onPassed,function(e,t){o.bottomVisible||o.pixelsPassed>v.get.pixelsPassed(e)?v.execute(t,e):b.once||v.remove.occurred(t)})}},onScreen:function(e){var t=v.get.elementCalculations(),n=e||b.onOnScreen,o="onScreen";return e&&(v.debug("Adding callback for onScreen",e),b.onOnScreen=e),t.onScreen?v.execute(n,o):b.once||v.remove.occurred(o),e!==i?t.onOnScreen:void 0},offScreen:function(e){var t=v.get.elementCalculations(),n=e||b.onOffScreen,o="offScreen";return e&&(v.debug("Adding callback for offScreen",e),b.onOffScreen=e),t.offScreen?v.execute(n,o):b.once||v.remove.occurred(o),e!==i?t.onOffScreen:void 0},passing:function(e){var t=v.get.elementCalculations(),n=e||b.onPassing,o="passing";return e&&(v.debug("Adding callback for passing",e),b.onPassing=e),t.passing?v.execute(n,o):b.once||v.remove.occurred(o),e!==i?t.passing:void 0},topVisible:function(e){var t=v.get.elementCalculations(),n=e||b.onTopVisible,o="topVisible";return e&&(v.debug("Adding callback for top visible",e),b.onTopVisible=e),t.topVisible?v.execute(n,o):b.once||v.remove.occurred(o),e===i?t.topVisible:void 0},bottomVisible:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomVisible,o="bottomVisible";return e&&(v.debug("Adding callback for bottom visible",e),b.onBottomVisible=e),t.bottomVisible?v.execute(n,o):b.once||v.remove.occurred(o),e===i?t.bottomVisible:void 0},topPassed:function(e){var t=v.get.elementCalculations(),n=e||b.onTopPassed,o="topPassed";return e&&(v.debug("Adding callback for top passed",e),b.onTopPassed=e),t.topPassed?v.execute(n,o):b.once||v.remove.occurred(o),e===i?t.topPassed:void 0},bottomPassed:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomPassed,o="bottomPassed";return e&&(v.debug("Adding callback for bottom passed",e),b.onBottomPassed=e),t.bottomPassed?v.execute(n,o):b.once||v.remove.occurred(o),e===i?t.bottomPassed:void 0},passingReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onPassingReverse,o="passingReverse";return e&&(v.debug("Adding callback for passing reverse",e),b.onPassingReverse=e),t.passing?b.once||v.remove.occurred(o):v.get.occurred("passing")&&v.execute(n,o),e!==i?!t.passing:void 0},topVisibleReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onTopVisibleReverse,o="topVisibleReverse";return e&&(v.debug("Adding callback for top visible reverse",e),b.onTopVisibleReverse=e),t.topVisible?b.once||v.remove.occurred(o):v.get.occurred("topVisible")&&v.execute(n,o),e===i?!t.topVisible:void 0},bottomVisibleReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomVisibleReverse,o="bottomVisibleReverse";return e&&(v.debug("Adding callback for bottom visible reverse",e),b.onBottomVisibleReverse=e),t.bottomVisible?b.once||v.remove.occurred(o):v.get.occurred("bottomVisible")&&v.execute(n,o),e===i?!t.bottomVisible:void 0},topPassedReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onTopPassedReverse,o="topPassedReverse";return e&&(v.debug("Adding callback for top passed reverse",e),b.onTopPassedReverse=e),t.topPassed?b.once||v.remove.occurred(o):v.get.occurred("topPassed")&&v.execute(n,o),e===i?!t.onTopPassed:void 0},bottomPassedReverse:function(e){var t=v.get.elementCalculations(),n=e||b.onBottomPassedReverse,o="bottomPassedReverse";return e&&(v.debug("Adding callback for bottom passed reverse",e),b.onBottomPassedReverse=e),t.bottomPassed?b.once||v.remove.occurred(o):v.get.occurred("bottomPassed")&&v.execute(n,o),e===i?!t.bottomPassed:void 0},execute:function(e,t){var n=v.get.elementCalculations(),i=v.get.screenCalculations();e=e||!1,e&&(b.continuous?(v.debug("Callback being called continuously",t,n),e.call(F,n,i)):v.get.occurred(t)||(v.debug("Conditions met",t,n),e.call(F,n,i))),v.save.occurred(t)},remove:{fixed:function(){v.debug("Removing fixed position"),A.removeClass(y.fixed).css({position:"",top:"",left:"",zIndex:""}),b.onUnfixed.call(F)},placeholder:function(){v.debug("Removing placeholder content"),r&&r.remove()},occurred:function(e){if(e){var t=v.cache.occurred;t[e]!==i&&t[e]===!0&&(v.debug("Callback can now be called again",e),v.cache.occurred[e]=!1)}else v.cache.occurred={}}},save:{calculations:function(){v.verbose("Saving all calculations necessary to determine positioning"),v.save.direction(),v.save.screenCalculations(),v.save.elementCalculations()},occurred:function(e){e&&(v.cache.occurred[e]!==i&&v.cache.occurred[e]===!0||(v.verbose("Saving callback occurred",e),v.cache.occurred[e]=!0))},scroll:function(e){e=e+b.offset||R.scrollTop()+b.offset,v.cache.scroll=e},direction:function(){var e,t=v.get.scroll(),n=v.get.lastScroll();return e=t>n&&n?"down":n>t&&n?"up":"static",v.cache.direction=e,v.cache.direction},elementPosition:function(){var e=v.cache.element,t=v.get.screenSize();return v.verbose("Saving element position"),e.fits=e.height<t.height,e.offset=A.offset(),e.width=A.outerWidth(),e.height=A.outerHeight(),v.is.verticallyScrollableContext()&&(e.offset.top+=R.scrollTop()-R.offset().top),v.is.horizontallyScrollableContext()&&(e.offset.left+=R.scrollLeft-R.offset().left),v.cache.element=e,e},elementCalculations:function(){var e=v.get.screenCalculations(),t=v.get.elementPosition();return b.includeMargin?(t.margin={},t.margin.top=parseInt(A.css("margin-top"),10),t.margin.bottom=parseInt(A.css("margin-bottom"),10),t.top=t.offset.top-t.margin.top,t.bottom=t.offset.top+t.height+t.margin.bottom):(t.top=t.offset.top,t.bottom=t.offset.top+t.height),t.topPassed=e.top>=t.top,t.bottomPassed=e.top>=t.bottom,t.topVisible=e.bottom>=t.top&&!t.bottomPassed,t.bottomVisible=e.bottom>=t.bottom&&!t.topPassed,t.pixelsPassed=0,t.percentagePassed=0,t.onScreen=t.topVisible&&!t.bottomPassed,t.passing=t.topPassed&&!t.bottomPassed,t.offScreen=!t.onScreen,t.passing&&(t.pixelsPassed=e.top-t.top,t.percentagePassed=(e.top-t.top)/t.height),v.cache.element=t,v.verbose("Updated element calculations",t),t},screenCalculations:function(){var e=v.get.scroll();return v.save.direction(),v.cache.screen.top=e,v.cache.screen.bottom=e+v.cache.screen.height,v.cache.screen},screenSize:function(){v.verbose("Saving window position"),v.cache.screen={height:R.height()}},position:function(){v.save.screenSize(),v.save.elementPosition()}},get:{pixelsPassed:function(e){var t=v.get.elementCalculations();return e.search("%")>-1?t.height*(parseInt(e,10)/100):parseInt(e,10)},occurred:function(e){return v.cache.occurred!==i?v.cache.occurred[e]||!1:!1},direction:function(){return v.cache.direction===i&&v.save.direction(),v.cache.direction},elementPosition:function(){return v.cache.element===i&&v.save.elementPosition(),v.cache.element},elementCalculations:function(){return v.cache.element===i&&v.save.elementCalculations(),v.cache.element},screenCalculations:function(){return v.cache.screen===i&&v.save.screenCalculations(),v.cache.screen},screenSize:function(){return v.cache.screen===i&&v.save.screenSize(),v.cache.screen},scroll:function(){return v.cache.scroll===i&&v.save.scroll(),v.cache.scroll},lastScroll:function(){return v.cache.screen===i?(v.debug("First scroll event, no last scroll could be found"),!1):v.cache.screen.top}},setting:function(t,n){if(e.isPlainObject(t))e.extend(!0,b,t);else{if(n===i)return b[t];b[t]=n}},internal:function(t,n){if(e.isPlainObject(t))e.extend(!0,v,t);else{if(n===i)return v[t];v[t]=n}},debug:function(){!b.silent&&b.debug&&(b.performance?v.performance.log(arguments):(v.debug=Function.prototype.bind.call(console.info,console,b.name+":"),v.debug.apply(console,arguments)))},verbose:function(){!b.silent&&b.verbose&&b.debug&&(b.performance?v.performance.log(arguments):(v.verbose=Function.prototype.bind.call(console.info,console,b.name+":"),v.verbose.apply(console,arguments)))},error:function(){b.silent||(v.error=Function.prototype.bind.call(console.error,console,b.name+":"),v.error.apply(console,arguments))},performance:{log:function(e){var t,n,i;b.performance&&(t=(new Date).getTime(),i=l||t,n=t-i,l=t,c.push({Name:e[0],Arguments:[].slice.call(e,1)||"",Element:F,"Execution Time":n})),clearTimeout(v.performance.timer),v.performance.timer=setTimeout(v.performance.display,500)},display:function(){var t=b.name+":",n=0;l=!1,clearTimeout(v.performance.timer),e.each(c,function(e,t){n+=t["Execution Time"]}),t+=" "+n+"ms",s&&(t+=" '"+s+"'"),(console.group!==i||console.table!==i)&&c.length>0&&(console.groupCollapsed(t),console.table?console.table(c):e.each(c,function(e,t){console.log(t.Name+": "+t["Execution Time"]+"ms")}),console.groupEnd()),c=[]}},invoke:function(t,n,o){var r,s,l,c=P;return n=n||f,o=F||o,"string"==typeof t&&c!==i&&(t=t.split(/[\. ]/),r=t.length-1,e.each(t,function(n,o){var a=n!=r?o+t[n+1].charAt(0).toUpperCase()+t[n+1].slice(1):t;if(e.isPlainObject(c[a])&&n!=r)c=c[a];else{if(c[a]!==i)return s=c[a],!1;if(!e.isPlainObject(c[o])||n==r)return c[o]!==i?(s=c[o],!1):(v.error(C.method,t),!1);c=c[o]}})),e.isFunction(s)?l=s.apply(o,n):s!==i&&(l=s),e.isArray(a)?a.push(l):a!==i?a=[a,l]:l!==i&&(a=l),s}},d?(P===i&&v.initialize(),P.save.scroll(),P.save.calculations(),v.invoke(u)):(P!==i&&P.invoke("destroy"),v.initialize())}),a!==i?a:this},e.fn.visibility.settings={name:"Visibility",namespace:"visibility",debug:!1,verbose:!1,performance:!0,observeChanges:!0,initialCheck:!0,refreshOnLoad:!0,refreshOnResize:!0,checkOnRefresh:!0,once:!0,continuous:!1,offset:0,includeMargin:!1,context:t,throttle:!1,type:!1,zIndex:"10",transition:"fade in",duration:1e3,onPassed:{},onOnScreen:!1,onOffScreen:!1,onPassing:!1,onTopVisible:!1,onBottomVisible:!1,onTopPassed:!1,onBottomPassed:!1,onPassingReverse:!1,onTopVisibleReverse:!1,onBottomVisibleReverse:!1,onTopPassedReverse:!1,onBottomPassedReverse:!1,onLoad:function(){},onAllLoaded:function(){},onFixed:function(){},onUnfixed:function(){},onUpdate:!1,onRefresh:function(){},metadata:{src:"src"},className:{fixed:"fixed",placeholder:"placeholder",visible:"visible"},error:{method:"The method you called is not defined.",visible:"Element is hidden, you must call refresh after element becomes visible"}}}(jQuery,window,document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_semantic_semantic_min_css__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_semantic_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dist_semantic_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_semantic_semantic_min_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_semantic_semantic_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dist_semantic_semantic_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr_build_toastr_min_css__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr_build_toastr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr_build_toastr_min_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {}
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, numeral, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services___ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookingChoice_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookingChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BookingChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking_CancelBooking_vue__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking_CancelBooking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__booking_CancelBooking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__booking_BookingConfirmation_vue__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__booking_BookingConfirmation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__booking_BookingConfirmation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bower_components_semantic_ui_calendar_dist_calendar_min__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bower_components_semantic_ui_calendar_dist_calendar_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bower_components_semantic_ui_calendar_dist_calendar_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bower_components_semantic_ui_calendar_dist_calendar_min_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bower_components_semantic_ui_calendar_dist_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__bower_components_semantic_ui_calendar_dist_calendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_vue2_animate_dist_vue2_animate_min_css__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_vue2_animate_dist_vue2_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__node_modules_vue2_animate_dist_vue2_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_print_js__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_print_js__);














/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'step': 1,
      'date': null,
      'allBookings': [],
      'selected': [],
      'contact': {
        'firstName': null,
        'lastName': null,
        'email': null,
        'address': null,
        'city': null,
        'zip': null,
        'tel': null,
        'termsAccepted': false,
        'newsletterAccepted': true,
        'photosAccepted': true
      },
      'parsedTel': null,
      'details': {
        'numPeople': null,
        'voucher': null,
        'wishes': null,
        'questions': null,
        '_reason': null,
        'reason': null,
        'services': []
      },
      'describeBoat': {
        'name': null,
        'description': null
      },
      'formValid': false,
      'detailsFormValid': false,
      'hours': ['10 - 11', '11 - 12', '12 - 13', '13 - 14', '14 - 15', '15 - 16', '16 - 17', '17 - 18', '18 - 19', '19 - 20', '20 - 21', '21 - 22', '22 - 23'],
      'boats': [],
      'clientId': null,
      'moment': moment,
      'numeral': numeral,
      'animation': {
        'enter': 'fadeInRight',
        'leave': 'fadeOutLeft',
        'oldStep': 1
      },
      'voucher': null,
      'createdReservation': {
        'code': null,
        'bookings': [],
        'contact': {},
        'people': 0,
        'cost': null,
        'questions': null,
        'reason': null,
        'services': [],
        'wishes': null
      },
      'settings': {},
      'reasons': [],
      'additionalServices': [],
      'rulerGeometry': {
        'span': 50,
        'leftOffset': 0
      },
      'submitting': false,
      'updatedBooking': null,
      'now': new Date(),
      'bookingDisabled': false
    };
  },

  watch: {
    step: function step(newStep, currentStep) {
      var _this = this;

      this.animation.oldStep = currentStep;

      $("html, body").animate({ scrollTop: 0 }, 400);

      if (this.step === 1) {
        setTimeout(function () {
          _this.initUiFirstStep();
        }, 100);
      } else if (this.step === 2) {
        setTimeout(function () {
          $('.ui.selection.dropdown').dropdown();

          var uniqueBoats = [];

          var _loop = function _loop(booking) {
            if (!uniqueBoats.find(function (one) {
              return one.boat === booking.boat._id;
            })) uniqueBoats.push({ 'boat': booking.boat._id, 'capacity': booking.boat.capacity.max });
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.selected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var booking = _step.value;

              _loop(booking);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var maxPeople = uniqueBoats.map(function (one) {
            return one.capacity;
          }).reduce(function (a, b) {
            return a + b;
          });

          $('.ui.details.form').form({
            fields: {
              numPeople: {
                identifier: 'numPeople',
                rules: [{
                  type: 'empty',
                  prompt: 'Please enter the number of people'
                }, {
                  type: 'integer[1..' + maxPeople.toString() + ']',
                  prompt: 'Number of people is too low or higher than the capacity of selected boats. <strong>Max: ' + maxPeople.toString() + ' people.</strong>'
                }]
              }
            },
            prompt: {
              empty: 'This field is required',
              checked: 'You have to accept the Terms of service'
            },
            inline: true,
            on: 'change',
            keyboardShortcuts: false,
            onSuccess: function () {
              this.detailsFormValid = true;
              this.step = 3;
            }.bind(_this),
            onFailure: function () {
              this.detailsFormValid = false;
            }.bind(_this)
          });
        }, 100);
      } else if (this.step === 3) {
        setTimeout(function () {
          $('.ui.selection.dropdown').dropdown();
          $('.ui.accordion').accordion({ exclusive: false });
          $('.ui.contact-details.form').form({
            fields: {
              firstName: 'empty',
              lastName: 'empty',
              tel: 'empty',
              email: ['empty', 'email'],
              terms: 'checked'
            },
            prompt: {
              empty: 'This field is required',
              checked: 'You have to accept the Terms of service'
            },
            inline: true,
            on: 'blur',
            keyboardShortcuts: false,

            onSuccess: function () {
              this.formValid = true;
              this.step = 4;
            }.bind(_this),
            onFailure: function () {
              this.formValid = false;
            }.bind(_this)
          });
        }, 100);
      }
    },
    'details.voucher': __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function () {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["f" /* voucherService */].find({ query: { code: this.details.voucher, $limit: 1 } }).then(function (vouchers) {
        if (vouchers.data[0]) _this2.voucher = vouchers.data[0];
      });
    }, 500),
    'details._reason': function details_reason() {
      var _this3 = this;

      if (this.details._reason) this.details.reason = this.reasons.find(function (reason) {
        return reason._id === _this3.details._reason;
      })['title'];
    },
    'date': __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function () {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["i" /* bookingService */].find({
        query: {
          date: this.date,
          $limit: 500
        }
      }).then(function (bookings) {

        _this4.allBookings = bookings.data;
      }).catch(function (error) {
        toastr.error('There was an error loading bookings, please try again!', 'Error');

        throw error;
      });
    }, 50)

  },
  computed: {
    selectedPrice: function selectedPrice() {
      var price = 0;

      var cost = this.selected.map(function (item) {
        return item.cost;
      });

      if (cost.length > 0) {
        price = cost.reduce(function (a, b) {
          return a + b;
        });
      }

      if (price === 0) return 0;

      if (this.voucher && this.voucher.deduct.absolute) price = price - this.voucher.deduct.absolute;
      if (this.voucher && this.voucher.deduct.percentage) price = (1 - this.voucher.deduct.percentage) * price;

      return numeral(price).format('0,0.00');
    },
    canContinue: function canContinue() {
      if (this.step === 1) {
        if (this.selected.length > 0) return true;
      } else if (this.step === 2) {
        return true;
      } else if (this.step === 3) {
        return true;
      }

      return false;
    },
    canBack: function canBack() {
      return this.step > 1;
    },
    ruler: function ruler() {
      if (this.date != moment().format('YYYY-MM-DD')) {
        return {
          'visible': false,
          'left': '0px'
        };
      }

      var firstTime = moment().hours(10).minutes(0).seconds(0);
      var diffSeconds = moment(this.now).diff(firstTime, 'seconds');
      var left = 0;

      if (diffSeconds > 0 && diffSeconds <= 13 * 60 * 60) {
        left = Math.round(this.rulerGeometry.leftOffset + diffSeconds / (13 * 60 * 60) * this.rulerGeometry.span);
      } else {
        return {
          'visible': false,
          'left': '0px'
        };
      }

      return {
        'visible': true,
        'left': left + 'px'
      };
    },
    boatsStartFull: function boatsStartFull() {
      return this.boats.filter(function (b) {
        return !b.startsAtHalfHour;
      });
    },
    boatsStartHalf: function boatsStartHalf() {
      return this.boats.filter(function (b) {
        return !!b.startsAtHalfHour;
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.fetchBoats();

    setInterval(function () {
      _this5.now = moment().format();
    }, 60 * 1000);

    this.setupClientId();
    this.setupTimeoutEvents();
    this.setUpEvents();

    this.loadSettings();

    if (this.$route.query.confirmed) {
      $('#emailConfirmModal').modal({
        onHide: function () {
          this.$router.push('/');
        }.bind(this)
      }).modal('show');
    }

    moment.locale('de');

    this.initUiFirstStep();

    setTimeout(function () {
      $('.ui.basic.calendar').calendar('focus');
    }, 300);

    this.getGeometry();
  },

  methods: {
    setupClientId: function setupClientId() {
      var _this6 = this;

      var bookingClient = this.$cookie.get('booking-client');

      if (bookingClient) this.clientId = bookingClient;

      __WEBPACK_IMPORTED_MODULE_2__services_index__["a" /* default */].io.on('connect', function (arg) {
        if (!bookingClient) {
          _this6.$cookie.set('booking-client', __WEBPACK_IMPORTED_MODULE_2__services_index__["a" /* default */].io.id);
          _this6.clientId = __WEBPACK_IMPORTED_MODULE_2__services_index__["a" /* default */].io.id;
        }
        _this6.pushClientToSocket();
      });
    },
    setupTimeoutEvents: function setupTimeoutEvents() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["j" /* sessionService */].on('notifyTimeoutClient', function (data) {
        if (data.clientId != _this7.clientId) return;

        if (_this7.selected.length > 0) $('#timeoutWarningModal').modal('show');
      });

      __WEBPACK_IMPORTED_MODULE_1__services___["j" /* sessionService */].on('timeoutClient', function (data) {
        if (data.clientId != _this7.clientId) return;

        $('#timeoutWarningModal').modal('hide');
        _this7.selected = [];
        _this7.step = 1;
      });

      $('#timeoutWarningModal').modal({
        onHide: function () {
          this.resetSession();
        }.bind(this)
      });
    },
    setUpEvents: function setUpEvents() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["i" /* bookingService */].on('created', function (booking) {
        _this8.updatedBooking = booking;
      });

      __WEBPACK_IMPORTED_MODULE_1__services___["i" /* bookingService */].on('patched', function (booking) {
        _this8.updatedBooking = booking;
      });
    },
    initUiFirstStep: function initUiFirstStep() {
      var _this9 = this;

      var formatter = {
        date: function date(_date, settings) {
          return moment(_date).format('dddd, LL');
        }
      };

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });

      $('.ui.basic.calendar').calendar({
        type: 'date',
        initialDate: new Date(),
        minDate: new Date('2026-01-01'),
        maxDate: new Date('2026-12-31'),
        firstDayOfWeek: 1,
        formatter: formatter,
        text: {
          days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
          monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
          today: 'Heute',
          now: 'Jetzt'
        },
        onChange: function onChange(date, text) {
          _this9.date = moment(date).format('YYYY-MM-DD');
        }
      }).calendar('set date', this.date ? this.date : moment().hour() >= 23 ? moment().add(1, 'days').toDate() : new Date());

      $('.ui.dropdown').dropdown();
    },
    loadSettings: function loadSettings() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["b" /* settingService */].find({
        $limit: 1,
        $sort: { _id: -1 }
      }).then(function (settings) {
        if (settings.total > 0) _this10.settings = settings.data[0];
      });

      __WEBPACK_IMPORTED_MODULE_1__services___["g" /* reasonService */].find({}).then(function (reasons) {
        _this10.reasons = reasons.data;
      });

      __WEBPACK_IMPORTED_MODULE_1__services___["e" /* additonalServiceService */].find({}).then(function (services) {
        _this10.additionalServices = services.data;
      });
    },
    toggleService: function toggleService(service) {
      if (!('selected' in service)) service.selected = true;else service.selected = !service.selected;

      this.additionalServices.splice(this.additionalServices.findIndex(function (addService) {
        return addService._id === service._id;
      }), 1, service);
    },
    showBoatDescription: function showBoatDescription(boat) {
      this.describeBoat = boat;
      setTimeout(function () {
        $('#boatDescriptionModal').modal('refresh');
      }, 100);
      $('#boatDescriptionModal').modal('show');
    },
    fetchBoats: function fetchBoats() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["d" /* boatService */].find({ query: { hidden: { $ne: true }, $sort: { 'order': 1 } } }).then(function (boats) {
        _this11.boats = boats.data;
      });
    },
    datePlus: function datePlus() {
      $('.ui.basic.calendar').calendar('set date', moment(this.date).add(1, 'd').format());
    },
    dateMinus: function dateMinus() {
      $('.ui.basic.calendar').calendar('set date', moment(this.date).subtract(1, 'd').format());
    },
    selected: function selected(booking) {
      this.selected.push(booking);
    },
    pushClientToSocket: function pushClientToSocket() {
      __WEBPACK_IMPORTED_MODULE_2__services_index__["a" /* default */].io['clientId'] = this.clientId;
    },
    confirmBooking: function confirmBooking() {
      var _this12 = this;

      if (this.submitting) return;

      this.submitting = true;

      var reservation = {
        'contact': this.contact,
        'parsedTel': this.contact.tel.replace(/[^1-9]/, ''),
        '_bookings': this.selected.map(function (booking) {
          return booking._id;
        }),
        'confirmed': true,
        'allBookings': this.selected,
        'wishes': this.details.wishes,
        'questions': this.details.questions,
        '_reason': this.details._reason,
        'reason': this.details.reason,
        'services': this.additionalServices.filter(function (service) {
          return service.selected;
        }),
        'people': this.details.numPeople,
        'discount': this.voucher ? { 'absolute': this.voucher.deduct.absolute, 'percentage': this.voucher.deduct.percentage, 'voucher': this.voucher.code } : null,
        'clientId': this.clientId
      };

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].create(reservation).then(function (createdReservations) {
        _this12.submitting = false;

        _this12.createdReservation.code = createdReservations[0].code;
        _this12.createdReservation.contact = createdReservations[0].contact;
        _this12.createdReservation.bookings = reservation.allBookings;
        _this12.createdReservation.people = createdReservations[0].people;
        _this12.createdReservation.wishes = createdReservations[0].wishes;
        _this12.createdReservation.questions = createdReservations[0].questions;
        _this12.createdReservation.services = createdReservations[0].services;
        _this12.createdReservation.reason = createdReservations[0].reason;
        _this12.createdReservation.discount = createdReservations[0].discount;
        _this12.createdReservation.cost = createdReservations[0].payment.toPay;

        setTimeout(function () {
          $('#emailConfirmModal').modal('show');
          setTimeout(function () {
            $('#emailConfirmModal').modal('refresh');
          }, 300);
        }, 100);

        _this12.selected = [];
        _this12.detailsFormValid = false;
        _this12.formValid = false;
        _this12.step = 1;
        _this12.contact['firstName'] = null;
        _this12.contact['lastName'] = null;
        _this12.contact['email'] = null;
        _this12.contact['company'] = null;
        _this12.contact['title'] = null;
        _this12.contact['terms'] = false;
        _this12.contact['address'] = null;
        _this12.contact['city'] = null;
        _this12.contact['zip'] = null;
        _this12.contact['tel'] = null;
        _this12.details = {
          'numPeople': null,
          'voucher': null,
          'wishes': null,
          'questions': null,
          'reason': null,
          'services': []
        };
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this12.additionalServices), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var service = _step2.value;

            service.selected = false;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }).catch(function (error) {
        _this12.submitting = false;

        toastr.error(error, 'Something went wrong!');

        throw error;
      });
    },
    goToConfirm: function goToConfirm() {
      $('.ui.contact-details.form').form('validate form');
    },
    goToContactDetails: function goToContactDetails() {
      $('.ui.details.form').form('validate form');
    },
    resetSession: function resetSession() {
      __WEBPACK_IMPORTED_MODULE_1__services___["j" /* sessionService */].patch(null, { lastAction: new Date() }, { query: { clientId: this.clientId } }).then(function (session) {});
    },
    triggerCancelModal: function triggerCancelModal() {
      $('#cancelModal').modal('show');
    },
    beforeAnimationEnter: function beforeAnimationEnter(el) {
      if (this.step > this.animation.oldStep) {
        $(el).addClass('fadeInRight');
      } else {
        $(el).addClass('fadeInLeft');
      }
    },
    beforeAnimationLeave: function beforeAnimationLeave(el) {
      if (this.step > this.animation.oldStep) {
        $(el).addClass('fadeOutLeft');
      } else {
        $(el).addClass('fadeOutRight');
      }
    },
    getGeometry: function getGeometry() {
      var _this13 = this;

      setTimeout(function () {
        var firstHourHeader = document.getElementById('firstHourHeader').getBoundingClientRect();
        var lastHourHeader = document.getElementById('lastHourHeader').getBoundingClientRect();
        var container = document.getElementById('segment').getBoundingClientRect();

        var offsetFirst = firstHourHeader.left - container.left;
        var offsetLast = lastHourHeader.right - container.left;

        _this13.rulerGeometry.span = offsetLast - offsetFirst;
        _this13.rulerGeometry.leftOffset = offsetFirst;
      }, 500);
    },
    printConfirmation: function printConfirmation() {
      __WEBPACK_IMPORTED_MODULE_10_print_js___default()({ printable: 'bookingConfirmation', type: 'html', font: 'Arial', documentTitle: 'buki_bestaetigung' });
    }
  },
  components: {
    BookingChoice: __WEBPACK_IMPORTED_MODULE_3__BookingChoice_vue___default.a, CancelBooking: __WEBPACK_IMPORTED_MODULE_4__booking_CancelBooking_vue___default.a, BookingConfirmation: __WEBPACK_IMPORTED_MODULE_5__booking_BookingConfirmation_vue___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(45), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(13);





var defaultBooking = {
  _id: null,
  _boat: null,
  hour: null,
  date: null,
  status: 'open',
  clientId: null
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hovered: false,
      screenWidth: null,
      booking: {
        _id: null,
        _boat: this.boat._id,
        hour: this.hour,
        date: this.date,
        status: 'open',
        clientId: this.clientId
      }
    };
  },

  watch: {
    allBookings: function allBookings() {
      var _this = this;

      this.booking = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.booking, {
        _id: null,
        date: this.date,
        status: 'open',
        clientId: null
      });

      var thisBooking = this.allBookings.find(function (booking) {
        return booking.hour === _this.hour && booking._boat === _this.boat._id && booking.date === _this.date;
      });

      if (thisBooking) this.booking = thisBooking;
    },
    date: function date(_date) {},
    updatedBooking: {
      deep: true,
      handler: function handler(newBooking) {
        if (newBooking) {
          if (newBooking._boat === this.boat._id && newBooking.hour === this.hour && newBooking.date === this.date) {
            this.booking = newBooking;
          }
        }
      }
    }
  },
  computed: {
    booked: function booked() {
      return this.booking.status == 'reserved';
    },
    disabled: function disabled() {
      if (this.booking.status === 'open') return false;

      if (['selected'].indexOf(this.booking.status) > -1 && this.booking.clientId === this.clientId) return false;

      return true;
    },
    expired: function expired() {
      return moment().isAfter(moment(this.date).hour(this.hour.split(" - ")[0]).minute(0).second(0).subtract(this.bookingAllowedBefore, 'seconds'));
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services__["i" /* bookingService */].find({ query: { _boat: this.boat._id, hour: this.hour, date: this.date, $limit: 1 } }).then(function (bookings) {
      if (bookings.data[0]) {
        _this2.booking = bookings.data[0];

        if (_this2.booking.status == 'selected' && _this2.booking.clientId == _this2.clientId && _this2.selected.filter(function (b) {
          return b._id == _this2.booking._id;
        }).length == 0) _this2.selected.push(_this2.booking);
      }
    });

    this.screenWidth = window.screen.width;
    var that = this;

    this.$nextTick(function () {
      window.addEventListener('resize', function (e) {
        that.screenWidth = window.screen.width;
      });
    });
  },

  methods: {
    select: function select() {
      var _this3 = this;

      if (this.disabled || this.expired) return;

      var bookingDocument = {
        '_boat': this.boat._id,
        'boat': {
          'name': this.boat.name
        },
        'hour': this.hour,
        'date': this.date,
        'cost': this.boat.price,
        'status': this.booking.status === 'selected' ? 'open' : 'selected',
        'clientId': this.clientId
      };

      __WEBPACK_IMPORTED_MODULE_1__services__["i" /* bookingService */].find({ query: {
          '_boat': this.boat._id,
          'date': this.date,
          'hour': this.hour,
          $limit: 1
        } }).then(function (bookings) {
        var bookingId = null;

        if (bookings.data.length > 0) {
          bookingId = bookings.data[0]._id;

          var oldBooking = bookings.data[0];

          if (oldBooking.clientId === _this3.clientId) {
            if (_this3.booking.status !== oldBooking.status) {
              _this3.booking.status = oldBooking.status;
              bookingDocument.status = _this3.booking.status === 'selected' ? 'open' : 'selected';
            }
          } else if (_this3.booking.status === 'open' && oldBooking.status === 'selected') {
            throw new Error('Booking already selected by someone else');
          }
        }

        if (bookingId) {
          __WEBPACK_IMPORTED_MODULE_1__services__["i" /* bookingService */].patch(bookingId, bookingDocument).then(function (booking) {
            if (booking.status == 'selected') _this3.selected.push(booking);else {
              _this3.selected.splice(_this3.selected.findIndex(function (selected) {
                return selected._id === booking._id;
              }), 1);
            }
          }).catch(function (reason) {
            toastr.error(reason);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1__services__["i" /* bookingService */].create(bookingDocument).then(function (booking) {
            if (booking.status == 'selected') _this3.selected.push(booking);else _this3.selected.splice(_this3.selected.findIndex(function (selected) {
              return selected._id === booking._id;
            }), 1);
          }).catch(function (reason) {
            toastr.error(reason);
          });
        }
      }).catch(function (error) {
        toastr.error(error);

        throw error;
      });
    }
  },
  props: ['boat', 'hour', 'date', 'bookingAllowedBefore', 'selected', 'clientId', 'updatedBooking', 'allBookings']
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(18)))

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_editor__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_editor__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'boats': [],
      'settings': {},
      'boat': {
        capacity: {}
      },
      'boatForDelete': null,
      'fetching': false,
      'moment': moment
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchBoats();

    __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].on('created', function () {
      _this.fetchBoats();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].on('patched', function () {
      _this.fetchBoats();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].on('removed', function () {
      _this.fetchBoats();
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });
  },

  computed: {},
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
  },

  methods: {
    fetchBoats: function fetchBoats() {
      var _this2 = this;

      this.fetching = true;

      __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].find({ query: { $sort: { order: 1 } } }).then(function (boats) {
        _this2.boats = boats.data;
        _this2.fetching = false;
        _this2.initDropdown();
      });
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      console.log('open reservation');
      this.editReservation = reservation;
      $('#reservationModal').modal({}).modal('show');
    },
    showBoatModal: function showBoatModal() {
      $('#boatModal').modal('show');
    },
    editBoat: function editBoat(boat) {
      this.boat = boat;
      this.showBoatModal();
    },
    addBoat: function addBoat(boat) {
      this.boat = {
        name: null,
        type: null,
        description: null,
        price: null,
        capacity: {
          min: null,
          max: null
        },
        startsAtHalfHour: false,
        order: 1,
        hidden: false,
        state: {
          battery: 100
        }
      };
      this.showBoatModal();
    },
    saveBoat: function saveBoat() {
      if (this.boat._id) {
        __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].patch(this.boat._id, this.boat).then(function (boat) {
          toastr.success('Boat saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].create(this.boat).then(function (boat) {
          toastr.success('Boat saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      }
    },
    triggerDeleteBoat: function triggerDeleteBoat(boat) {
      this.boatForDelete = boat;

      $('.ui.delete.modal').modal('show');
    },
    deleteBoat: function deleteBoat(boat) {
      __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].remove(boat._id).then(function (boat) {
        toastr.info('Removed boat <strong>' + boat.name + '</strong>', 'Boat removed!');
      });
    }
  },
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_1_vue2_editor__["VueEditor"]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(numeral, moment, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BookingChoice_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BookingChoice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BookingChoice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reservations_DetailsModal_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reservations_DetailsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reservations_DetailsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewReservationModal_vue__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewReservationModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewReservationModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bower_components_semantic_ui_calendar_dist_calendar_min__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bower_components_semantic_ui_calendar_dist_calendar_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__bower_components_semantic_ui_calendar_dist_calendar_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bower_components_semantic_ui_calendar_dist_calendar_min_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bower_components_semantic_ui_calendar_dist_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bower_components_semantic_ui_calendar_dist_calendar_min_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'date': null,
      'loading': false,
      'allBookings': [],
      'selected': [],
      'hours': ['10 - 11', '11 - 12', '12 - 13', '13 - 14', '14 - 15', '15 - 16', '16 - 17', '17 - 18', '18 - 19', '19 - 20', '20 - 21', '21 - 22', '22 - 23'],
      'boats': [],
      'move': {
        'status': false,
        'booking': null
      },
      'create': {
        'status': false,
        'selectedDone': false,
        'selected': []
      },
      'editReservation': null,
      'settings': {},
      'now': new Date(),

      'rulerGeometry': {
        'span': 50,
        'leftOffset': 0
      },
      'dailyReport': {
        'date': null,
        'income': 0
      },
      'searchInProgress': 0,
      'updatedBooking': null,
      'numeral': numeral
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchBoats();

    setInterval(function () {
      _this.now = moment().format();
    }, 60 * 1000);

    __WEBPACK_IMPORTED_MODULE_0__services___["b" /* settingService */].find({
      $limit: 1,
      $sort: { _id: -1 }
    }).then(function (settings) {
      console.log(settings);
      if (settings.total > 0) _this.settings = settings.data[0];
    });

    moment.locale('de');

    var formatter = {
      date: function date(_date, settings) {
        return moment(_date).format('dddd, LL');
      }
    };

    __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].on('patched', function (boat) {
      var updated = _this.boats.filter(function (filterBoat) {
        return filterBoat._id === boat._id;
      });

      if (updated.length > 0) _this.boats.splice(_this.boats.indexOf(updated[0]), 1, boat);
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });

    $('.ui.basic.calendar').calendar({
      type: 'date',
      initialDate: new Date(),
      formatter: formatter,
      text: {
        months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
        today: 'Heute',
        now: 'Jetzt'
      },
      onChange: function onChange(date, text) {
        _this.date = moment(date).format('YYYY-MM-DD');
      }
    }).calendar('set date', new Date());

    this.setUpEvents();

    this.getGeometry();
  },

  watch: {
    date: _.debounce(function () {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].find({
        query: {
          date: this.date,
          $limit: 500
        }
      }).then(function (bookings) {
        _this2.loading = false;

        _this2.allBookings = bookings.data;
      }).catch(function (error) {
        _this2.loading = false;
        toastr.error('There was an error loading bookings, please try again!', 'Error');
      });
    }, 200)
  },
  computed: {
    ruler: function ruler() {
      if (this.date != moment().format('YYYY-MM-DD')) {
        return {
          'visible': false,
          'left': '0px'
        };
      }

      console.log('calculating ruler...');

      var firstTime = moment().hours(10).minutes(0).seconds(0);
      var diffSeconds = moment(this.now).diff(firstTime, 'seconds');
      var left = 0;

      if (diffSeconds > 0 && diffSeconds <= 13 * 60 * 60) {
        left = Math.round(this.rulerGeometry.leftOffset + diffSeconds / (13 * 60 * 60) * this.rulerGeometry.span);
      } else {
        return {
          'visible': false,
          'left': '0px'
        };
      }

      return {
        'visible': true,
        'left': left + 'px'
      };
    },
    boatsStartFull: function boatsStartFull() {
      return this.boats.filter(function (b) {
        return !b.startsAtHalfHour;
      });
    },
    boatsStartHalf: function boatsStartHalf() {
      return this.boats.filter(function (b) {
        return !!b.startsAtHalfHour;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
    __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].removeListener('created');
    __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].removeListener('patched');
    __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].removeListener('removed');
    __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].removeListener('patched');
  },

  methods: {
    setUpEvents: function setUpEvents() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].on('created', function (booking) {
        _this3.updatedBooking = booking;

        if (booking.status !== 'open' && _this3.create.selected.filter(function (b) {
          return b._id === booking._id;
        }).length > 0) {
          toastr.error('Someone has just selected the same booking slot.', 'Clearing selection!');
          _this3.create.selected = [];
          $('#newReservationModal').modal('hide');
        }
      });

      __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].on('patched', function (booking) {
        _this3.updatedBooking = booking;

        if (booking.status !== 'open' && _this3.create.selected.filter(function (b) {
          return b._id === booking._id;
        }).length > 0) {
          toastr.error('Someone has just selected the same booking slot.', 'Clearing selection!');
          _this3.create.selected = [];
          $('#newReservationModal').modal('hide');
        }
      });

      __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].on('removed', function (booking) {});

      __WEBPACK_IMPORTED_MODULE_0__services___["c" /* reservationService */].on('patched', function (reservation) {
        if (_this3.editReservation && _this3.editReservation._id === reservation._id) _this3.editReservation = reservation;
      });
    },
    getGeometry: function getGeometry() {
      var _this4 = this;

      setTimeout(function () {
        var firstHourHeader = document.getElementById('firstHourHeader').getBoundingClientRect();
        var lastHourHeader = document.getElementById('lastHourHeader').getBoundingClientRect();
        var container = document.getElementById('segment').getBoundingClientRect();

        var offsetFirst = firstHourHeader.left - container.left;
        var offsetLast = lastHourHeader.right - container.left;

        _this4.rulerGeometry.span = offsetLast - offsetFirst;
        _this4.rulerGeometry.leftOffset = offsetFirst;
      }, 500);
    },
    fetchBoats: function fetchBoats() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__services___["d" /* boatService */].find({ query: { $sort: { 'order': 1 }, $limit: 200 } }).then(function (boats) {
        _this5.boats = boats.data;
        _this5.initDropdown();
      });
    },
    datePlus: function datePlus() {
      $('.ui.basic.calendar').calendar('set date', moment(this.date).add(1, 'd').format());
    },
    dateMinus: function dateMinus() {
      $('.ui.basic.calendar').calendar('set date', moment(this.date).subtract(1, 'd').format());
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    selected: function selected(booking) {
      this.selected.push(booking);
    },
    moveBooking: function moveBooking(booking) {
      console.log('receiving move booking', booking);
      this.move.status = true;
      this.move.booking = booking;
    },
    moveTo: function moveTo(booking) {
      var _this6 = this;

      if (booking._id) {

        console.log('patching old object');

        __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].patch(booking._id, {
          '_reservation': this.move.booking._reservation,
          'status': this.move.booking.status
        }).then(function (newBooking) {
          return __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].patch(_this6.move.booking._id, {
            '_reservation': null,
            'discardedReservation': _this6.move.booking.reservation,
            'status': 'open'
          });
        }).then(function (oldBooking) {
          toastr.success('Move completed!');
          _this6.move.status = false;
          _this6.move.booking = null;
        });
      } else {
        var bookingDocument = {
          '_boat': booking._boat,
          'hour': booking.hour,
          'date': booking.date,
          'cost': booking.boat.price,
          '_reservation': this.move.booking._reservation,
          'status': this.move.booking.status
        };

        console.log('creating new object', bookingDocument);

        __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].create(bookingDocument).then(function (newBooking) {
          console.log(newBooking);
          return __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].patch(_this6.move.booking._id, {
            '_reservation': null,
            'discardedReservation': _this6.move.booking.reservation,
            'status': 'open'
          });
        }).then(function (oldBooking) {
          toastr.success('Move completed!');
          _this6.move.status = false;
          _this6.move.booking = null;
        });
      }
    },
    selectForCreate: function selectForCreate(booking) {
      if (!booking._id) return;

      var index = this.create.selected.findIndex(function (selectedBooking) {
        return selectedBooking._id === booking._id;
      });

      if (index !== -1) this.create.selected.splice(index, 1);else this.create.selected.push(booking);
    },
    startCreateReservation: function startCreateReservation() {
      this.create.status = true;
    },
    showNewReservationModal: function showNewReservationModal() {
      $('#newReservationModal').modal('show');
      setTimeout(function () {
        $('#newReservationModal').modal('refresh');
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      console.log('open reservation');
      this.editReservation = reservation;
      $('#reservationModal').modal('show');
    }
  },
  components: {
    BookingChoice: __WEBPACK_IMPORTED_MODULE_1__BookingChoice_vue___default.a, DetailsModal: __WEBPACK_IMPORTED_MODULE_2__reservations_DetailsModal_vue___default.a, NewReservationModal: __WEBPACK_IMPORTED_MODULE_3__NewReservationModal_vue___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(45), __webpack_require__(1), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      hovered: false,
      booking: {
        _boat: this.boat._id,
        boat: this.boat,
        hour: this.hour,
        date: this.date,
        status: 'open',
        clientId: "admin"
      }
    };
  },

  computed: {
    moving: function moving() {
      return this.move.status && this.move.booking == this.booking;
    },
    createSelected: function createSelected() {
      var _this = this;

      return this.create.status && this.booking._id && this.create.selected.filter(function (booking) {
        return booking._id === _this.booking._id;
      }).length;
    }
  },
  watch: {
    allBookings: function allBookings() {
      var _this2 = this;

      this.booking = {
        _boat: this.boat._id,
        boat: this.boat,
        hour: this.hour,
        date: this.date,
        status: 'open',
        clientId: "admin"
      };

      var thisBooking = this.allBookings.find(function (booking) {
        return booking.hour === _this2.hour && booking._boat === _this2.boat._id && booking.date === _this2.date;
      });

      if (thisBooking) this.booking = thisBooking;
    },
    updatedBooking: {
      deep: true,
      handler: function handler(newBooking) {
        if (newBooking) {
          if (newBooking._boat === this.boat._id && newBooking.hour === this.hour && newBooking.date === this.date) {
            this.booking = newBooking;
            this.initDropdown();
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].find({
      query: {
        _boat: this.boat._id,
        hour: this.hour,
        date: this.date,
        $limit: 1
      }
    }).then(function (bookings) {
      if (bookings.data[0]) _this3.booking = bookings.data[0];
    });
  },

  methods: {
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    toggleDropdown: function toggleDropdown() {
      if (this.move.status == true) {
        this.moveToThis();
        return;
      } else if (this.create.status === true) {
        this.selectThisForNew();
        return;
      }

      $('#' + this.boat._id + '-' + this.hourIndex + ' .ui.dropdown').dropdown('toggle');
    },
    moveToThis: function moveToThis() {

      console.log('MOVE TO THIS', this.booking);

      if (this.booking.status === 'open' || !this.booking.status) {
        this.$emit('moveTo', this.booking);
        return;
      }

      if (this.booking.status === 'selected' && this.settings.adminOverridesSelected) {
        this.$emit('moveTo', this.booking);
        return;
      }

      toastr.error('Selected booking slot is not free, please choose another one', 'Not allowed!');
    },
    selectThisForNew: function selectThisForNew() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].find({ query: {
          '_boat': this.boat._id,
          'date': this.date,
          'hour': this.hour,
          $limit: 1
        } }).then(function (bookings) {
        var oldBooking = null;
        var bookingForSelect = _this4.booking;

        if (bookings.data.length > 0) {
          oldBooking = bookings.data[0];
        }

        if (oldBooking) {
          if (oldBooking.status === 'open' || oldBooking.status === 'selected' && _this4.settings.adminOverridesSelected) {
            bookingForSelect.cost = _this4.boat.price;
            _this4.$emit('selectForCreate', bookingForSelect);
            return;
          }

          if (oldBooking.status === 'selected' && _this4.settings.adminOverridesSelected) {
            bookingForSelect.cost = _this4.boat.price;
            _this4.$emit('selectForCreate', _this4.booking);
            return;
          }

          throw new Error('Booking already selected');
        } else {
          __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].create(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.booking, {
            status: 'open',
            cost: _this4.booking.boat.price
          })).then(function (booking) {
            _this4.$emit('selectForCreate', booking);
          });
        }
      }).catch(function (e) {
        toastr.error(e, 'Not allowed!');

        throw e;
      });
    },
    cancelBooking: function cancelBooking() {
      __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(this.booking._id, {
        status: 'open',
        _reservation: null,
        discardedReservation: this.booking.reservation,
        clientId: 'admin'
      }).then(function (booking) {
        toastr.info('Booking cancelled');
      });
    },
    cancelReservation: function cancelReservation() {
      if (!this.booking.reservation) return;

      __WEBPACK_IMPORTED_MODULE_2__services__["c" /* reservationService */].patch(this.booking.reservation._id, {
        status: 'cancelled',
        statusReason: 'adminAction'
      }).then(function (result) {
        toastr.info('Reservation cancelled');
      });
    },
    moveBooking: function moveBooking() {
      this.$emit('moveBooking', this.booking);
      $('.ui.dropdown').dropdown('hide');
    },
    extendBooking: function extendBooking() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].find({
        query: {
          _boat: this.boat._id,
          hour: this.hours[this.hourIndex + 1],
          date: this.date,
          $limit: 1
        }
      }).then(function (bookings) {
        if (bookings.data[0] && bookings.data[0].status !== 'open') {
          toastr.error('The next booking slot is not free!', 'Error extending');
          return;
        }

        console.log(bookings.data);
        if (!bookings.data[0]) {
          var newBooking = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.booking);
          delete newBooking._id;
          newBooking.hour = _this5.hours[_this5.hourIndex + 1];

          __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].create(newBooking).then(function (booking) {
            toastr.success('Booking was successfully extended!', 'Booking extended');
          });
        } else {
          var booking = bookings.data[0];

          __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(booking._id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.booking, { _id: null, hour: _this5.hours[_this5.hourIndex + 1] })).then(function (booking) {
            toastr.success('Booking was successfully extended!', 'Booking extended');
          });
        }
      });
    },
    blockSlot: function blockSlot() {
      if (this.booking.status === 'selected' && !this.settings.adminOverridesSelected) {
        toastr.error('Overriding currently selected booking slots is not allowed', 'Not Allowed');
        return;
      }

      if (this.booking._id) {
        __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(this.booking._id, { status: 'blocked' }).then(function (booking) {
          toastr.info('Booking slot blocked');
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].create(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.booking, { status: 'blocked' })).then(function (booking) {
          toastr.info('Booking slot blocked');
        });
      }
    },
    unblockSlot: function unblockSlot() {
      __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(this.booking._id, { status: 'open' }).then(function (booking) {
        toastr.info('Booking slot unblocked');
      });
    },
    makeSlotOpen: function makeSlotOpen() {
      __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(this.booking._id, { status: 'open' }).then(function (booking) {
        toastr.info('Booking slot reset');
      });
    },
    goOut: function goOut() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2__services__["c" /* reservationService */].patch(this.booking._reservation, { status: 'inProgress' }).then(function (reservation) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(reservation.bookings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var booking = _step.value;

            __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(booking._id, { status: 'boatOut' });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_2__services__["d" /* boatService */].patch(_this6.booking._boat, { 'state.currentlyOut': true });
        toastr.info('Boat went out');
      });
    },
    returned: function returned() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__services__["c" /* reservationService */].patch(this.booking._reservation, { status: 'returned' }).then(function (reservation) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(reservation.bookings), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var booking = _step2.value;

            __WEBPACK_IMPORTED_MODULE_2__services__["i" /* bookingService */].patch(booking._id, { status: 'returned' });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_2__services__["d" /* boatService */].patch(_this7.booking._boat, { 'state.currentlyOut': false });
        toastr.info('Boat has returned');
      });
    },
    viewDetails: function viewDetails() {
      this.$emit('triggerDetails', this.booking.reservation);
    },
    select: function select() {}
  },
  props: ['boat', 'hour', 'hours', 'date', 'selected', 'hourIndex', 'move', 'create', 'settings', 'updatedBooking', 'allBookings']
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    user: function user() {
      return this.$store.state.user;
    },
    canSeeUsers: function canSeeUsers() {
      return ['superAdmin'].indexOf(this.user.data.role) > -1;
    },
    canSeeBoats: function canSeeBoats() {
      return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1;
    },
    canSeeSettings: function canSeeSettings() {
      return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1;
    },
    canSeeReasons: function canSeeReasons() {
      return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1;
    },
    canSeeVouchers: function canSeeVouchers() {
      return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1;
    },
    canSeeServices: function canSeeServices() {
      return ['superAdmin', 'admin'].indexOf(this.user.data.role) > -1;
    }
  },
  watch: {
    $route: function $route(route) {
      $('.ui.sidebar').sidebar('hide');
    }
  },
  mounted: function mounted() {
    $('.ui.sidebar').sidebar({
      transition: 'overlay'
    });
  },

  props: ['visible']
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16)))

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, numeral, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services___ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      moment: moment,
      'contact': {
        'firstName': "",
        'lastName': "",
        'email': "",
        'address': "",
        'city': "",
        'zip': "",
        'tel': "",
        'termsAccepted': false,
        'comments': ""
      },
      'details': {
        'numPeople': null,
        'voucher': null,
        'wishes': null,
        'questions': null,
        '_reason': null,
        'reason': null,
        'services': []
      },
      'voucher': null,
      'reasons': [],
      'additionalServices': [],
      'numeral': numeral,
      'submitting': false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services___["g" /* reasonService */].find({}).then(function (reasons) {
      _this.reasons = reasons.data;
    });

    __WEBPACK_IMPORTED_MODULE_1__services___["e" /* additonalServiceService */].find({}).then(function (services) {
      _this.additionalServices = services.data;
    });

    $('#newReservationModal').modal();
  },

  computed: {
    totalCost: function totalCost() {
      var price = 0;

      var cost = this.selected.map(function (item) {
        return item.cost;
      });

      if (cost.length > 0) {
        price = cost.reduce(function (a, b) {
          return a + b;
        });
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.additionalServices), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var service = _step.value;

          if (service.selected) {
            if (service.priceType === 'perPerson') price = price + (this.details.numPeople || 0) * Number(service.price);else price = price + Number(service.price);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (price === 0) return 0;

      if (this.voucher && this.voucher.deduct.absolute) price = price - this.voucher.deduct.absolute;
      if (this.voucher && this.voucher.deduct.percentage) price = (1 - this.voucher.deduct.percentage) * price;

      return numeral(price).format('0,0.00');
    },
    user: function user() {
      if (!this.$store.state.user) return null;

      return this.$store.state.user.data._id;
    }
  },
  watch: {
    selected: function selected() {
      $('newReservationModal').modal('refresh');
    },
    'details.voucher': _.debounce(function () {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["f" /* voucherService */].find({ query: { code: this.details.voucher, $limit: 1 } }).then(function (vouchers) {
        if (vouchers.data[0]) _this2.voucher = vouchers.data[0];
      });
    }, 500),
    'details._reason': function details_reason() {
      var _this3 = this;

      if (this.details._reason) this.details.reason = this.reasons.find(function (reason) {
        return reason._id === _this3.details._reason;
      })['title'];
    }
  },
  methods: {
    reserve: function reserve() {
      var _this4 = this;

      if (this.submitting) return;

      this.submitting = true;

      var reservation = {
        'contact': this.contact,
        'parsedTel': this.contact.tel ? this.contact.tel.replace(/[^1-9]/, '') : "",
        '_bookings': this.selected.map(function (booking) {
          return booking._id;
        }),
        'confirmed': true,
        'allBookings': this.selected,
        'wishes': this.details.wishes,
        'questions': this.details.questions,
        '_reason': this.details._reason,
        'reason': this.details.reason,
        'services': this.additionalServices.filter(function (service) {
          return service.selected;
        }),
        'people': this.details.numPeople,
        'discount': this.voucher ? { 'absolute': this.voucher.deduct.absolute, 'percentage': this.voucher.deduct.percentage, 'voucher': this.voucher.code } : null,
        'user': this.user
      };

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].create(reservation).then(function (createdReservations) {
        _this4.$emit('reservationCreated');
        toastr.success('Reservation was successfully created for <strong>' + _this4.contact.firstName + ' ' + _this4.contact.lastName + '</strong>', 'Reservation Created!');
        _this4.contact['firstName'] = null;
        _this4.contact['lastName'] = null;
        _this4.contact['email'] = null;
        _this4.contact['company'] = null;
        _this4.contact['title'] = null;
        _this4.contact['terms'] = false;
        _this4.contact['address'] = null;
        _this4.contact['city'] = null;
        _this4.contact['zip'] = null;
        _this4.contact['tel'] = null;
        _this4.details = {
          'numPeople': null,
          'voucher': null,
          'wishes': null,
          'questions': null,
          'reason': null,
          'services': []
        };
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this4.additionalServices), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var service = _step2.value;

            service.selected = false;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this4.submitting = false;
      }).catch(function (error) {
        _this4.submitting = false;

        toastr.error(error, 'Error submitting reservation!');

        throw error;
      });
    },
    toggleService: function toggleService(service) {
      if (!('selected' in service)) service.selected = true;else service.selected = !service.selected;

      this.additionalServices.splice(this.additionalServices.findIndex(function (addService) {
        return addService._id === service._id;
      }), 1, service);
    }
  },
  props: ['selected']
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(45), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'reasons': [],
      'settings': {},
      'reason': {},
      'reasonForDelete': null,
      'fetching': false,
      'moment': moment
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchReasons();

    __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].on('created', function () {
      _this.fetchReasons();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].on('patched', function () {
      _this.fetchReasons();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].on('removed', function () {
      _this.fetchReasons();
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });
  },
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
  },

  methods: {
    fetchReasons: function fetchReasons() {
      var _this2 = this;

      this.fetching = true;

      __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].find().then(function (reasons) {
        _this2.reasons = reasons.data;
        _this2.fetching = false;
        _this2.initDropdown();
      });
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      console.log('open reservation');
      this.editReservation = reservation;
      $('#reservationModal').modal({}).modal('show');
    },
    showReasonModal: function showReasonModal() {
      $('#reasonModal').modal('show');
    },
    editReason: function editReason(reason) {
      this.reason = reason;
      this.showReasonModal();
    },
    addReason: function addReason() {
      this.reason = {
        title: null
      };
      this.showReasonModal();
    },
    saveReason: function saveReason() {
      if (this.reason._id) {
        __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].patch(this.reason._id, this.reason).then(function (reason) {
          toastr.success('Reason saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].create(this.reason).then(function (reason) {
          toastr.success('Reason saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      }
    },
    triggerDeleteReason: function triggerDeleteReason(reason) {
      this.reasonForDelete = reason;

      $('.ui.delete.modal').modal('show');
    },
    deleteReason: function deleteReason(reason) {
      __WEBPACK_IMPORTED_MODULE_0__services___["g" /* reasonService */].remove(reason._id).then(function (reason) {
        toastr.info('Removed reason <strong>' + reason.title + '</strong>', 'Reason removed!');
      });
    }
  },
  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, numeral, $) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services___ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reservations_ReservationRow__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reservations_ReservationRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reservations_ReservationRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reservations_DetailsModal__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reservations_DetailsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reservations_DetailsModal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'reservations': [],
      'date': null,
      'settings': {},
      'filters': {
        'code': null,
        'name': null,
        'date': moment().format('YYYY-MM-DD'),
        'dateTo': undefined
      },
      'receipt': {
        'code': null,
        'boat': null
      },
      'editReservation': null,
      'fetching': false,
      'dailyReport': {
        'date': null,
        'income': 0
      },
      'moment': moment,
      'numeral': numeral,
      boats: []
    };
  },

  watch: {
    filters: {
      deep: true,
      handler: function handler() {
        this.fetchReservations();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchReservations();
    this.fetchBoats();

    __WEBPACK_IMPORTED_MODULE_1__services___["b" /* settingService */].find({
      $limit: 1,
      $sort: { _id: -1 }
    }).then(function (settings) {
      console.log(settings);
      if (settings.total > 0) _this.settings = settings.data[0];
    });

    __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].on('created', function (reservation) {
      return _this.fetchReservations();
    });

    __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].on('patched', function (reservation) {
      var index = _this.reservations.findIndex(function (arrayReservation) {
        return arrayReservation._id == reservation._id;
      });

      if (index == -1) return;

      _this.reservations.splice(index, 1, reservation);

      if (_this.editReservation && reservation._id === _this.editReservation._id) {
        _this.editReservation = reservation;
      }
    });

    var formatter = {
      date: function date(_date, settings) {
        return moment(_date).format('dddd, LL');
      }
    };

    $('#calendar1').calendar({
      type: 'date',
      initialDate: new Date(),
      formatter: formatter,
      text: {
        months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
        today: 'Heute',
        now: 'Jetzt'
      },
      onChange: function onChange(date, text) {
        _this.filters.date = moment(date).format('YYYY-MM-DD');
      }
    }).calendar('set date', new Date());

    $('#calendar2').calendar({
      type: 'date',
      initialDate: new Date(),
      formatter: formatter,
      text: {
        months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
        today: 'Heute',
        now: 'Jetzt'
      },
      onChange: function onChange(date, text) {
        if (!date) {
          _this.filters.dateTo = undefined;
          return;
        }
        _this.filters.dateTo = moment(date).format('YYYY-MM-DD');
      }
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });
  },
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
    __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].removeListener('created');
    __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].removeListener('updated');
    __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].removeListener('patched');
    __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].removeListener('removed');
  },

  methods: {
    clearDateTo: function clearDateTo() {
      $('#calendar2').calendar('set date', undefined);
    },
    fetchReservations: function fetchReservations() {
      var _this2 = this;

      this.fetching = true;

      var queryPart = {};

      if (this.filters.code) {
        queryPart = { code: { $search: this.filters.code } };
      } else {
        if (this.filters.dateTo) {
          queryPart['firstBooking.date'] = {
            $gte: this.filters.date,
            $lte: this.filters.dateTo
          };
        } else {
          queryPart = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filters.date && { 'firstBooking.date': this.filters.date });
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].find({ query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryPart, {
          status: { $in: ['reserved', 'checkIn', 'inProgress', 'returned', 'paid', 'checkOut'] },
          $sort: { 'firstBooking.date': -1, 'firstBooking.hour': 1 }
        }) }).then(function (reservations) {
        _this2.fetching = false;
        _this2.reservations = reservations.data;
        _this2.initDropdown();
      });
    },
    datePlus: function datePlus() {
      $('#calendar1').calendar('set date', moment(this.filters.date).add(1, 'd').format());
      this.initDropdown();
    },
    dateMinus: function dateMinus() {
      $('#calendar1').calendar('set date', moment(this.filters.date).subtract(1, 'd').format());
      this.initDropdown();
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      console.log('open reservation');
      this.editReservation = reservation;
      $('#reservationModal').modal({
        debug: true
      }).modal('show');
    },
    printReceipt: function printReceipt(reservation) {
      this.receipt.code = reservation.code;
      this.receipt.boat = reservation.boat.name;
      setTimeout(function () {
        var w = window.open();
        w.document.write($('.pickup.receipt').html());
        w.print();
        w.close();
      });
    },
    fetchBoats: function fetchBoats() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services___["d" /* boatService */].find({ query: { $sort: { 'type': 1, 'name': 1 } } }).then(function (boats) {
        _this3.boats = boats.data;
      });
    }
  },
  components: {
    ReservationRow: __WEBPACK_IMPORTED_MODULE_2__reservations_ReservationRow___default.a, DetailsModal: __WEBPACK_IMPORTED_MODULE_3__reservations_DetailsModal___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(45), __webpack_require__(16)))

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, numeral, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'services': [],
      'settings': {},
      'service': {
        title: null,
        price: null,
        priceType: "fixed",
        description: null,
        happens: null,
        letter: null
      },
      'serviceForDelete': null,
      'fetching': false,
      'moment': moment,
      'numeral': numeral
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchServices();

    __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].on('created', function () {
      _this.fetchServices();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].on('patched', function () {
      _this.fetchServices();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].on('removed', function () {
      _this.fetchServices();
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });
  },
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
  },

  methods: {
    fetchServices: function fetchServices() {
      var _this2 = this;

      this.fetching = true;

      __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].find().then(function (services) {
        _this2.services = services.data;
        _this2.fetching = false;
        _this2.initDropdown();
      });
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      this.editReservation = reservation;
      $('#reservationModal').modal({}).modal('show');
    },
    showServiceModal: function showServiceModal() {
      $('#serviceModal').modal('show');
    },
    editService: function editService(service) {
      this.service = service;
      this.showServiceModal();
    },
    addService: function addService() {
      this.service = {
        title: null,
        price: null,
        description: null,
        happens: null,
        letter: null
      };
      this.showServiceModal();
    },
    saveService: function saveService() {

      if (this.service._id) {
        __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].patch(this.service._id, this.service).then(function (service) {
          toastr.success('Service saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].create(this.service).then(function (service) {
          toastr.success('Service saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      }
    },
    triggerDeleteService: function triggerDeleteService(service) {
      this.serviceForDelete = service;

      $('.ui.delete.modal').modal('show');
    },
    deleteService: function deleteService(service) {
      __WEBPACK_IMPORTED_MODULE_0__services___["e" /* additonalServiceService */].remove(service._id).then(function (service) {
        toastr.info('Removed service <strong>' + service.title + '</strong>', 'Service removed!');
      });
    }
  },
  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(45), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            'settings': {
                'adminOverridesSelected': false,
                'sessionTimeout': null,
                'sessionTimeoutClear': null,
                'bookingAllowedBefore': null,
                'reasonsForBooking': []
            },
            'newReason': null
        };
    },
    mounted: function mounted() {
        var _this = this;

        $('.ui.checkbox').checkbox();

        __WEBPACK_IMPORTED_MODULE_0__services___["b" /* settingService */].find({
            $limit: 1,
            $sort: {
                _id: -1
            },
            query: {
                'toMinutes': true
            }
        }).then(function (settings) {
            if (settings.total > 0) _this.settings = settings.data[0];
        });
    },

    methods: {
        triggerMenu: function triggerMenu() {
            $('.ui.sidebar').sidebar('toggle');
        },
        saveSettings: function saveSettings() {
            if (!this.settings._id) {
                __WEBPACK_IMPORTED_MODULE_0__services___["b" /* settingService */].create(this.settings).then(function (setting) {
                    toastr.success('Settings updated');
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0__services___["b" /* settingService */].patch(this.settings._id, this.settings).then(function (setting) {
                    toastr.success('Settings updated');
                });
            }
        },
        trackChange: function trackChange(value) {
            this.settings.adminOverridesSelected = $(value.target).prop('checked');
        },
        saveReason: function saveReason() {
            if (!this.settings.reasonsForBooking) this.settings.reasonsForBooking = [];
            this.settings.reasonsForBooking.push(this.newReason);
            this.newReason = null;
        }
    },
    components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'users': [],
      'settings': {},
      'user': {},
      'userForDelete': null,
      'fetching': false,
      'moment': moment
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchUsers();

    __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].on('created', function () {
      _this.fetchUsers();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].on('patched', function () {
      _this.fetchUsers();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].on('removed', function () {
      _this.fetchUsers();
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });
  },

  computed: {
    userRole: function userRole() {
      return this.$store.state.user.data.role;
    }
  },
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
  },

  methods: {
    fetchUsers: function fetchUsers() {
      var _this2 = this;

      this.fetching = true;

      __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].find().then(function (users) {
        _this2.users = users.data;
        _this2.fetching = false;
        _this2.initDropdown();
      });
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      console.log('open reservation');
      this.editReservation = reservation;
      $('#reservationModal').modal({}).modal('show');
    },
    showUserModal: function showUserModal() {
      $('#userModal').modal('show');
    },
    editUser: function editUser(user) {
      this.user = user;
      this.showUserModal();
    },
    addUser: function addUser() {
      this.user = {
        email: null,
        password: null,
        name: null,
        role: null
      };
      this.showUserModal();
    },
    saveUser: function saveUser() {
      if (this.user._id) {
        __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].patch(this.user._id, this.user).then(function (user) {
          toastr.success('User saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].create(this.user).then(function (user) {
          toastr.success('User saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      }
    },
    triggerDeleteUser: function triggerDeleteUser(user) {
      this.userForDelete = user;

      $('.ui.delete.modal').modal('show');
    },
    deleteUser: function deleteUser(user) {
      __WEBPACK_IMPORTED_MODULE_0__services___["h" /* userService */].remove(user._id).then(function (user) {
        toastr.info('Removed user <strong>' + user.name + '</strong>', 'User removed!');
      });
    }
  },
  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'vouchers': [],
      'settings': {},
      'voucher': {
        code: null,
        deduct: {
          percentage: null,
          absolute: null
        },
        min: {
          absolute: null,
          hours: null
        },
        status: 'active'
      },
      'voucherForDelete': null,
      'fetching': false,
      'moment': moment
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchVouchers();

    __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].on('created', function () {
      _this.fetchVouchers();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].on('patched', function () {
      _this.fetchVouchers();
    });
    __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].on('removed', function () {
      _this.fetchVouchers();
    });

    $('.huge.menu').visibility({
      type: 'fixed',
      offset: 0
    });
  },
  beforeDestroy: function beforeDestroy() {
    $('.ui.modals').remove();
  },

  methods: {
    fetchVouchers: function fetchVouchers() {
      var _this2 = this;

      this.fetching = true;

      __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].find().then(function (vouchers) {
        _this2.vouchers = vouchers.data;
        _this2.fetching = false;
        _this2.initDropdown();
      });
    },
    initDropdown: function initDropdown() {
      setTimeout(function () {
        $('.ui.dropdown').dropdown();
      }, 50);
    },
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    openReservationDetails: function openReservationDetails(reservation) {
      console.log('open reservation');
      this.editReservation = reservation;
      $('#reservationModal').modal({}).modal('show');
    },
    showVoucherModal: function showVoucherModal() {
      $('#voucherModal').modal('show');
    },
    editVoucher: function editVoucher(voucher) {
      this.voucher = voucher;
      this.voucher.deduct.percentage = this.voucher.deduct.percentage * 100;
      this.showVoucherModal();
    },
    addVoucher: function addVoucher() {
      this.voucher = {
        code: null,
        deduct: {
          percentage: null,
          absolute: null
        },
        min: {
          absolute: null,
          hours: null
        },
        status: 'active'
      };
      this.showVoucherModal();
    },
    saveVoucher: function saveVoucher() {
      this.voucher.deduct.percentage = this.voucher.deduct.percentage / 100;

      if (this.voucher._id) {
        __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].patch(this.voucher._id, this.voucher).then(function (voucher) {
          toastr.success('Voucher saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].create(this.voucher).then(function (voucher) {
          toastr.success('Voucher saved!');
        }).catch(function (error) {
          toastr.error(error.message);
        });
      }
    },
    triggerDeleteVoucher: function triggerDeleteVoucher(voucher) {
      this.voucherForDelete = voucher;

      $('.ui.delete.modal').modal('show');
    },
    deleteVoucher: function deleteVoucher(voucher) {
      __WEBPACK_IMPORTED_MODULE_0__services___["f" /* voucherService */].remove(voucher._id).then(function (voucher) {
        toastr.info('Removed voucher <strong>' + voucher.name + '</strong>', 'Voucher removed!');
      });
    }
  },
  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, numeral, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services___ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bookings: [],
      people: null,
      moment: moment,
      numeral: numeral
    };
  },
  mounted: function mounted() {
    $('#reservationModal').modal();
  },

  computed: {
    reservation: function reservation() {
      return this.reservationProp;
    },
    paymentTotal: function paymentTotal() {
      return numeral(this.reservation.payment.total).format('0,0.00');
    },
    boat: function boat() {
      var _this = this;

      return this.boats.find(function (b) {
        return b._id === _this.reservation.bookings[0]._boat;
      });
    }
  },
  watch: {
    reservation: function reservation() {
      this.people = this.reservation.people;
      setTimeout(function () {
        $('#reservationModal').modal('refresh');
        $('.ui.dropdown').dropdown();
      }, 100);
    }
  },
  methods: {
    checkIn: function checkIn() {
      this.closeDropdown();
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'status': 'checkIn' }).then(function (reservation) {
        toastr.success('Visitor checked in');
      });
    },
    checkOut: function checkOut() {
      this.closeDropdown();
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'status': 'checkOut' }).then(function (reservation) {
        toastr.success('Visitor has checked out');
      });
    },
    paid: function paid() {
      this.closeDropdown();
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'payment.status': 'paid' }).then(function (reservation) {
        toastr.success('Visitor has paid');
      });
    },
    unpaid: function unpaid() {
      this.closeDropdown();
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'payment.status': 'unpaid' }).then(function (reservation) {
        toastr.success('Visitor has paid');
      });
    },
    savePeople: function savePeople() {
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'people': this.people }).then(function (reservation) {
        toastr.success('Number of people saved');
      });
    },
    serviceStatus: function serviceStatus(serviceId, status) {
      $('.ui.dropdown').dropdown('hide');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.reservation.services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var service = _step.value;

          if (service._id === serviceId) service.status = status;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'services': this.reservation.services }).then(function (reservation) {
        toastr.success('Service status updated');
      });
    },
    toggleBillStatus: function toggleBillStatus(serviceId) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.reservation.services), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var service = _step2.value;

          if (service._id === serviceId) {
            if ('billed' in service) {
              service.billed = !service.billed;
            } else {
              service.billed = true;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'services': this.reservation.services }).then(function (reservation) {
        toastr.success('Service status updated');
      });
    },
    questionsStatus: function questionsStatus(status) {
      $('.ui.dropdown').dropdown('hide');

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'questionsStatus': status }).then(function (reservation) {
        toastr.success('Status of questions updated.');
      });
    },
    wishesStatus: function wishesStatus(status) {
      $('.ui.dropdown').dropdown('hide');

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'wishesStatus': status }).then(function (reservation) {
        toastr.success('Status of questions updated.');
      });
    },
    closeDropdown: function closeDropdown() {
      $('.ui.dropdown').dropdown('hide');
    }
  },
  props: ['reservationProp', 'boats']
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(45), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services___ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'moment': moment
    };
  },
  mounted: function mounted() {},

  computed: {
    boat: function boat() {
      var _this = this;

      return this.boats.find(function (b) {
        return b._id === _this.reservation.bookings[0]._boat;
      });
    },
    starts: function starts() {
      if (this.boat && this.boat.startsAtHalfHour) {
        return parseInt(this.reservation.bookings[0].hour.split(' - ')[0]) - 1 + ':30';
      }

      return this.reservation.bookings[0].hour.split(' - ')[0];
    },
    ends: function ends() {
      if (this.boat && this.boat.startsAtHalfHour) {
        return parseInt(this.reservation.bookings[this.reservation.bookings.length - 1].hour.split(' - ')[1]) - 1 + ':30';
      }

      return this.reservation.bookings[this.reservation.bookings.length - 1].hour.split(' - ')[1];
    }
  },
  methods: {
    triggerMenu: function triggerMenu() {
      $('.ui.sidebar').sidebar('toggle');
    },
    checkIn: function checkIn() {
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'status': 'checkIn' }).then(function (reservation) {
        toastr.success('Visitor checked in');
      });
    },
    paid: function paid() {
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'payment.status': 'paid' }).then(function (reservation) {
        toastr.success('Visitor has paid');
      });
    },
    checkOut: function checkOut() {
      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'status': 'checkOut' }).then(function (reservation) {
        toastr.success('Visitor has checked out');
      });
    },
    questionsStatus: function questionsStatus(status) {
      $('.ui.dropdown').dropdown('hide');

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'questionsStatus': status }).then(function (reservation) {
        toastr.success('Status of questions updated.');
      });
    },
    serviceStatus: function serviceStatus(serviceId, status) {
      $('.ui.dropdown').dropdown('hide');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.reservation.services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var service = _step.value;

          if (service._id === serviceId) service.status = status;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'services': this.reservation.services }).then(function (reservation) {
        toastr.success('Service status updated');
      });
    },
    wishesStatus: function wishesStatus(status) {
      $('.ui.dropdown').dropdown('hide');

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'wishesStatus': status }).then(function (reservation) {
        toastr.success('Status of questions updated.');
      });
    },
    toggleBillStatus: function toggleBillStatus(serviceId) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.reservation.services), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var service = _step2.value;

          if (service._id === serviceId) {
            if ('billed' in service) {
              service.billed = !service.billed;
            } else {
              service.billed = true;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_1__services___["c" /* reservationService */].patch(this.reservation._id, { 'services': this.reservation.services }).then(function (reservation) {
        toastr.success('Service status updated');
      });
    },
    triggerDetails: function triggerDetails() {
      this.$emit('triggerDetails', this.reservation);
    }
  },
  props: ['reservation', 'boats'],
  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(16), __webpack_require__(18)))

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, numeral) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['createdReservation'],
  computed: {
    totalCost: function totalCost() {
      if (!this.createdReservation || !this.createdReservation.bookings) return this.createdReservation.cost;

      return Number(this.createdReservation.bookings.map(function (b) {
        return Number(b.cost);
      }).reduce(function (a, b) {
        return a + b;
      }));
    }
  },
  data: function data() {
    return {
      'moment': moment,
      'numeral': numeral
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(45)))

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(numeral, moment, $) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: null,
      searched: false,
      reservations: [],
      bookings: [],
      cancelled: false,
      numeral: numeral,
      moment: moment
    };
  },
  mounted: function mounted() {
    moment.locale('de');
  },

  watch: {
    reservations: function reservations() {
      if (this.reservations) {
        setTimeout(function () {
          $('.cancel-booking.button').popup({
            inline: true,
            position: 'top center',
            on: 'click'
          });
          $('#cancelModal').modal('refresh');
        }, 50);
      }
    }
  },
  computed: {
    toPay: function toPay() {
      if (this.reservations.length === 0) return null;

      return numeral(this.reservations.map(function (reservation) {
        return reservation.payment.total;
      }).reduce(function (a, b) {
        return a + b;
      })).format('0,0.00');
    }
  },
  methods: {
    searchReservation: function searchReservation() {
      var _this = this;

      this.searched = false;
      this.reservations = null;

      __WEBPACK_IMPORTED_MODULE_0__services___["c" /* reservationService */].find({ query: {
          $or: [{ code: this.search.toUpperCase() }, { 'contact.email': this.search }, { parsedTel: this.search.replace(/[^1-9]/, '') }],
          status: { $in: ['reserved'] }
        } }).then(function (reservations) {
        _this.searched = true;

        if (reservations.total > 0) {
          _this.reservations = reservations.data;

          var allBookings = [].concat.apply([], _this.reservations.map(function (reservation) {
            return reservation.bookings.map(function (booking) {
              return booking._id;
            });
          }));

          __WEBPACK_IMPORTED_MODULE_0__services___["i" /* bookingService */].find({ query: { _id: { $in: allBookings }, $sort: { _boat: 1, date: 1, hour: 1 } } }).then(function (bookings) {
            _this.bookings = bookings.data;
          });
        }
      });
    },
    cancelReservation: function cancelReservation() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services___["c" /* reservationService */].patch(null, { status: 'cancelled', statusReason: 'userAction' }, { query: { _id: { $in: this.reservations.map(function (reservation) {
              return reservation._id;
            }) } } }).then(function (reservation) {
        _this2.cancelled = true;
        _this2.searched = false;
        _this2.reservation = null;
        _this2.search = null;
        setTimeout(function () {
          _this2.cancelled = false;
          $('#cancelModal').modal('hide');
        }, 10 * 1000);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(45), __webpack_require__(1), __webpack_require__(16)))

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__admin_Booking__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__admin_Booking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__admin_Booking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__admin_Navigation__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__admin_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__admin_Navigation__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Booking: __WEBPACK_IMPORTED_MODULE_0__admin_Booking___default.a, Navigation: __WEBPACK_IMPORTED_MODULE_1__admin_Navigation___default.a
    }
});

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var reservationToken = to.params.id;

    if (!reservationToken) next('/');

    __WEBPACK_IMPORTED_MODULE_1__services__["c" /* reservationService */].patch(null, { confirmed: true }, { query: { t: reservationToken, confirmed: false } }).then(function (reservations) {
      if (reservations.length === 0) next('/');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(reservations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var reservation = _step.value;

          __WEBPACK_IMPORTED_MODULE_1__services__["i" /* bookingService */].patch(null, { _reservation: reservation._id }, { query: { _reservation: reservation._id } });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      next({ path: '/', query: { confirmed: true, code: reservations[0].code } });
    }).catch(function (error) {
      next('/');
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Booking_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Booking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Booking_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Booking: __WEBPACK_IMPORTED_MODULE_0__Booking_vue___default.a
  }
});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(98);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loginData: {
        email: '',
        password: ''
      },
      error: ''
    };
  },

  methods: {
    doLogin: function doLogin() {
      this.error = null;

      __WEBPACK_IMPORTED_MODULE_0__services_index__["a" /* default */].authenticate({
        type: 'local',
        'email': this.loginData.email,
        'password': this.loginData.password
      }).then(function (result) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('authenticateUser', __WEBPACK_IMPORTED_MODULE_0__services_index__["a" /* default */].get('user'));
        this.$router.push('/admin');
        toastr.success('Hi, you have successfully logged in!', 'Logged in!');
      }.bind(this)).catch(function (error) {
        toastr.error(error.message, 'Problem logging in!');
      }.bind(this));
    }
  },
  components: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(toastr) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translations_en__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__translations_de__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sentry_browser__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sentry_integrations__ = __webpack_require__(334);












if (true) {}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);

var messages = {
  "en": __WEBPACK_IMPORTED_MODULE_6__translations_en__["a" /* default */],
  "de": __WEBPACK_IMPORTED_MODULE_7__translations_de__["a" /* default */]
};

var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: 'de',
  messages: messages
});

toastr.options = {
  "positionClass": "toast-bottom-right"
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 209,
	"./af.js": 209,
	"./ar": 216,
	"./ar-dz": 210,
	"./ar-dz.js": 210,
	"./ar-kw": 211,
	"./ar-kw.js": 211,
	"./ar-ly": 212,
	"./ar-ly.js": 212,
	"./ar-ma": 213,
	"./ar-ma.js": 213,
	"./ar-sa": 214,
	"./ar-sa.js": 214,
	"./ar-tn": 215,
	"./ar-tn.js": 215,
	"./ar.js": 216,
	"./az": 217,
	"./az.js": 217,
	"./be": 218,
	"./be.js": 218,
	"./bg": 219,
	"./bg.js": 219,
	"./bn": 220,
	"./bn.js": 220,
	"./bo": 221,
	"./bo.js": 221,
	"./br": 222,
	"./br.js": 222,
	"./bs": 223,
	"./bs.js": 223,
	"./ca": 224,
	"./ca.js": 224,
	"./cs": 225,
	"./cs.js": 225,
	"./cv": 226,
	"./cv.js": 226,
	"./cy": 227,
	"./cy.js": 227,
	"./da": 228,
	"./da.js": 228,
	"./de": 231,
	"./de-at": 229,
	"./de-at.js": 229,
	"./de-ch": 230,
	"./de-ch.js": 230,
	"./de.js": 231,
	"./dv": 232,
	"./dv.js": 232,
	"./el": 233,
	"./el.js": 233,
	"./en-au": 234,
	"./en-au.js": 234,
	"./en-ca": 235,
	"./en-ca.js": 235,
	"./en-gb": 236,
	"./en-gb.js": 236,
	"./en-ie": 237,
	"./en-ie.js": 237,
	"./en-nz": 238,
	"./en-nz.js": 238,
	"./eo": 239,
	"./eo.js": 239,
	"./es": 241,
	"./es-do": 240,
	"./es-do.js": 240,
	"./es.js": 241,
	"./et": 242,
	"./et.js": 242,
	"./eu": 243,
	"./eu.js": 243,
	"./fa": 244,
	"./fa.js": 244,
	"./fi": 245,
	"./fi.js": 245,
	"./fo": 246,
	"./fo.js": 246,
	"./fr": 249,
	"./fr-ca": 247,
	"./fr-ca.js": 247,
	"./fr-ch": 248,
	"./fr-ch.js": 248,
	"./fr.js": 249,
	"./fy": 250,
	"./fy.js": 250,
	"./gd": 251,
	"./gd.js": 251,
	"./gl": 252,
	"./gl.js": 252,
	"./gom-latn": 253,
	"./gom-latn.js": 253,
	"./he": 254,
	"./he.js": 254,
	"./hi": 255,
	"./hi.js": 255,
	"./hr": 256,
	"./hr.js": 256,
	"./hu": 257,
	"./hu.js": 257,
	"./hy-am": 258,
	"./hy-am.js": 258,
	"./id": 259,
	"./id.js": 259,
	"./is": 260,
	"./is.js": 260,
	"./it": 261,
	"./it.js": 261,
	"./ja": 262,
	"./ja.js": 262,
	"./jv": 263,
	"./jv.js": 263,
	"./ka": 264,
	"./ka.js": 264,
	"./kk": 265,
	"./kk.js": 265,
	"./km": 266,
	"./km.js": 266,
	"./kn": 267,
	"./kn.js": 267,
	"./ko": 268,
	"./ko.js": 268,
	"./ky": 269,
	"./ky.js": 269,
	"./lb": 270,
	"./lb.js": 270,
	"./lo": 271,
	"./lo.js": 271,
	"./lt": 272,
	"./lt.js": 272,
	"./lv": 273,
	"./lv.js": 273,
	"./me": 274,
	"./me.js": 274,
	"./mi": 275,
	"./mi.js": 275,
	"./mk": 276,
	"./mk.js": 276,
	"./ml": 277,
	"./ml.js": 277,
	"./mr": 278,
	"./mr.js": 278,
	"./ms": 280,
	"./ms-my": 279,
	"./ms-my.js": 279,
	"./ms.js": 280,
	"./my": 281,
	"./my.js": 281,
	"./nb": 282,
	"./nb.js": 282,
	"./ne": 283,
	"./ne.js": 283,
	"./nl": 285,
	"./nl-be": 284,
	"./nl-be.js": 284,
	"./nl.js": 285,
	"./nn": 286,
	"./nn.js": 286,
	"./pa-in": 287,
	"./pa-in.js": 287,
	"./pl": 288,
	"./pl.js": 288,
	"./pt": 290,
	"./pt-br": 289,
	"./pt-br.js": 289,
	"./pt.js": 290,
	"./ro": 291,
	"./ro.js": 291,
	"./ru": 292,
	"./ru.js": 292,
	"./sd": 293,
	"./sd.js": 293,
	"./se": 294,
	"./se.js": 294,
	"./si": 295,
	"./si.js": 295,
	"./sk": 296,
	"./sk.js": 296,
	"./sl": 297,
	"./sl.js": 297,
	"./sq": 298,
	"./sq.js": 298,
	"./sr": 300,
	"./sr-cyrl": 299,
	"./sr-cyrl.js": 299,
	"./sr.js": 300,
	"./ss": 301,
	"./ss.js": 301,
	"./sv": 302,
	"./sv.js": 302,
	"./sw": 303,
	"./sw.js": 303,
	"./ta": 304,
	"./ta.js": 304,
	"./te": 305,
	"./te.js": 305,
	"./tet": 306,
	"./tet.js": 306,
	"./th": 307,
	"./th.js": 307,
	"./tl-ph": 308,
	"./tl-ph.js": 308,
	"./tlh": 309,
	"./tlh.js": 309,
	"./tr": 310,
	"./tr.js": 310,
	"./tzl": 311,
	"./tzl.js": 311,
	"./tzm": 313,
	"./tzm-latn": 312,
	"./tzm-latn.js": 312,
	"./tzm.js": 313,
	"./uk": 314,
	"./uk.js": 314,
	"./ur": 315,
	"./ur.js": 315,
	"./uz": 317,
	"./uz-latn": 316,
	"./uz-latn.js": 316,
	"./uz.js": 317,
	"./vi": 318,
	"./vi.js": 318,
	"./x-pseudo": 319,
	"./x-pseudo.js": 319,
	"./yo": 320,
	"./yo.js": 320,
	"./zh-cn": 321,
	"./zh-cn.js": 321,
	"./zh-hk": 322,
	"./zh-hk.js": 322,
	"./zh-tw": 323,
	"./zh-tw.js": 323
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 697;

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/SNX3.55138d2.jpg";

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(737),
  /* scopeId */
  "data-v-3b6a361e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(741),
  /* scopeId */
  "data-v-5d7d7f72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(734),
  /* scopeId */
  "data-v-25e1afea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(743),
  /* scopeId */
  "data-v-68e80e9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(736),
  /* scopeId */
  "data-v-3a7bda28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(731),
  /* scopeId */
  "data-v-19df85d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(739),
  /* scopeId */
  "data-v-4a783cf2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(744),
  /* scopeId */
  "data-v-77f42502",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(749),
  /* scopeId */
  "data-v-9c981794",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(745),
  /* scopeId */
  "data-v-89e7950a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(742),
  /* scopeId */
  "data-v-5dd75460",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(750),
  /* scopeId */
  "data-v-e4cb8046",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(738),
  /* scopeId */
  "data-v-43bf16ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(735),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(730),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(748),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "cancelModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Cancel Booking\n  ")]), _vm._v(" "), (!_vm.cancelled) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("To cancel a booking, please provide a reservation identifier - code, email or telephone number.")]), _vm._v(" "), _c('div', {
    staticClass: "ui huge fluid action input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter code, telephone or email"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.searchReservation
    }
  }, [_vm._v("Search Booking")])]), _vm._v(" "), (_vm.searched) ? _c('div', [_c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (!_vm.reservations) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('p', [_vm._v("No booking was found under the provided code\n        ")])]) : _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('h4', [_vm._v("Reservation for " + _vm._s(_vm.reservations[0].contact.firstName) + " " + _vm._s(_vm.reservations[0].contact.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "ui secondary segment"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "ui negative cancel-booking icon button"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v(" Cancel This Booking")]), _vm._v(" "), _c('div', {
    staticClass: "ui special popup"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Are you sure?")]), _vm._v(" "), _c('p', [_vm._v("This action is irreversible!")]), _vm._v(" "), _c('div', {
    staticClass: "ui icon primary button",
    on: {
      "click": _vm.cancelReservation
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Yes, cancel")])])]), _vm._v(" "), _c('table', {
    staticClass: "ui very basic table"
  }, [_c('tbody', _vm._l((_vm.bookings), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(booking.boat.name) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(booking.hour) + " h\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n                €" + _vm._s(_vm.numeral(booking.cost).format('0,0.00')) + "\n              ")])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.toPay))])])])])], 1)])])]) : _vm._e()]) : _c('div', {
    staticClass: "content"
  }, [(!_vm.reservation) ? _c('div', {
    staticClass: "ui info message"
  }, [_c('p', [_vm._v("Your booking was cancelled!\n      ")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n    ")])])
}]}

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "newReservationModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Add Reservation\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("To add reservation, enter contact details")]), _vm._v(" "), _c('div', {
    staticClass: "ui top attached segment"
  }, [_c('form', {
    staticClass: "ui contact-details form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reserve($event)
      }
    }
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Number of People")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.numPeople),
      expression: "details.numPeople"
    }],
    attrs: {
      "type": "number",
      "name": "numPeople",
      "placeholder": "Enter number"
    },
    domProps: {
      "value": (_vm.details.numPeople)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.numPeople = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Select reason")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details._reason),
      expression: "details._reason"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.details._reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.reasons), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason._id
      }
    }, [_vm._v(_vm._s(reason.title))])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.additionalServices), function(additionalService) {
    return _c('div', {
      staticClass: "service list item"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "large green checkmark icon",
      class: {
        'green checkmark': additionalService.selected, 'grey delete': !additionalService.selected
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n            " + _vm._s(additionalService.title) + "\n            "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                          " + _vm._s(additionalService.description) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      class: {
        'strong': additionalService.selected
      }
    }, [_vm._v("€ " + _vm._s(_vm.numeral(additionalService.price).format('0,0.00'))), (additionalService.priceType === 'perPerson') ? _c('span', [_vm._v(" / person")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "select"
    }, [_c('div', {
      staticClass: "ui basic tiny buttons"
    }, [(!additionalService.selected) ? _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Select")]) : _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Remove")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("Additional wishes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.wishes),
      expression: "details.wishes"
    }],
    attrs: {
      "name": "wishes",
      "rows": "2",
      "placeholder": "Specify additional wishes to track"
    },
    domProps: {
      "value": (_vm.details.wishes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.wishes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Additional questions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.questions),
      expression: "details.questions"
    }],
    attrs: {
      "name": "questions",
      "rows": "2",
      "placeholder": "Specify additional questions to track"
    },
    domProps: {
      "value": (_vm.details.questions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.questions = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.voucher),
      expression: "details.voucher"
    }],
    attrs: {
      "type": "text",
      "name": "voucher",
      "placeholder": "Enter voucher"
    },
    domProps: {
      "value": (_vm.details.voucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.voucher = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "barcode icon"
  })])]), _vm._v(" "), _c('div', [(_vm.voucher) ? _c('div', {
    staticClass: "ui positive message"
  }, [_c('p', [_vm._v("A discount of\n            "), _c('strong', [(_vm.voucher.deduct.percentage > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.percentage > 0 && _vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.absolute) + ".00€")]) : _vm._e()]), _vm._v("\n            is applied to this booking.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.title),
      expression: "contact.title"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contact.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Herr"
    }
  }, [_vm._v("Herr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Frau"
    }
  }, [_vm._v("Frau")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v("Dr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Prof"
    }
  }, [_vm._v("Prof")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mag"
    }
  }, [_vm._v("Mag")])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.firstName),
      expression: "contact.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.contact.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.lastName),
      expression: "contact.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.contact.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.company),
      expression: "contact.company"
    }],
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.company = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Telephone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.tel),
      expression: "contact.tel"
    }],
    attrs: {
      "type": "text",
      "name": "tel"
    },
    domProps: {
      "value": (_vm.contact.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.address),
      expression: "contact.address"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "ten wide field"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.city),
      expression: "contact.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.contact.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six wide field"
  }, [_c('label', [_vm._v("Post Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.zip),
      expression: "contact.zip"
    }],
    attrs: {
      "type": "text",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.contact.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.zip = $event.target.value
      }
    }
  })])])], 2)]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic table"
  }, [_c('tbody', [_vm._l((_vm.selected), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(booking.boat.name) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(booking.hour) + " h\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n          €" + _vm._s(booking.cost) + ".00\n        ")])])
  }), _vm._v(" "), _vm._l((_vm.additionalServices), function(service) {
    return (service.selected) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n          " + _vm._s(service.title) + " "), (service.priceType === 'perPerson' && _vm.details.numPeople) ? _c('span', [_vm._v("x" + _vm._s(_vm.details.numPeople))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(service.priceType === 'perPerson' && _vm.details.numPeople) ? _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price * _vm.details.numPeople).format('0,0.00')))]) : _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price).format('0,0.00')))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.voucher) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.voucher.code))])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.voucher.deduct.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.totalCost))])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui positive button",
    on: {
      "click": _vm.reserve
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Add Reservation\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n    ")])
}]}

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "pusher"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "reservationModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Reservation Details\n  ")]), _vm._v(" "), (_vm.reservation) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "ui eleven wide column"
  }, [_c('div', {
    staticClass: "ui top attached segment"
  }, [_c('h4', [_vm._v(_vm._s(_vm.reservation.contact.title) + " " + _vm._s(_vm.reservation.contact.firstName) + " " + _vm._s(_vm.reservation.contact.lastName))]), _vm._v(" "), _c('p', [(_vm.reservation.contact.company) ? _c('span', [_vm._v("Company: " + _vm._s(_vm.reservation.contact.company)), _c('br')]) : _vm._e(), _vm._v("\n            Email: " + _vm._s(_vm.reservation.contact.email)), _c('br'), _vm._v("\n            Telephone: " + _vm._s(_vm.reservation.contact.tel)), _c('br'), _vm._v("\n            Address: " + _vm._s(_vm.reservation.contact.address)), _c('br'), _vm._v("\n            City: " + _vm._s(_vm.reservation.contact.city) + ", " + _vm._s(_vm.reservation.contact.zip)), _c('br')]), _vm._v(" "), (_vm.reservation.contact.comments) ? _c('div', [_c('h5', [_vm._v("Comments")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.reservation.contact.comments))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic table"
  }, [_c('tbody', [_vm._l((_vm.reservation.bookings), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm.reservation.boat.name) + "\n            ")]), _vm._v(" "), _c('td', [(_vm.boat && _vm.boat.startsAtHalfHour) ? _c('span', [_vm._v("\n                " + _vm._s((parseInt(booking.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(booking.hour.split(' - ')[1]) - 1) + ':30') + " h\n              ")]) : _c('span', [_vm._v("\n                " + _vm._s(booking.hour) + " h\n              ")])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n              €" + _vm._s(booking.cost) + ".00\n            ")])])
  }), _vm._v(" "), _vm._l((_vm.reservation.services), function(service) {
    return _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n              " + _vm._s(service.title) + "\n              "), (service.priceType === 'perPerson' && service.people) ? _c('span', [_vm._v("x" + _vm._s(service.people))]) : _vm._e(), _vm._v(" "), (!service.billed) ? _c('span', [_vm._v("(not billed)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(!service.billed) ? _c('span', [_vm._v("€0.00")]) : (service.priceType === 'perPerson' && service.people) ? _c('span', [_vm._v("\n                €" + _vm._s(_vm.numeral(service.price * service.people).format('0,00.00')) + "\n              ")]) : _c('span', [_vm._v("\n                €" + _vm._s(_vm.numeral(service.price).format('0,00.00')) + "\n              ")])])])
  }), _vm._v(" "), (_vm.reservation.discount) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.reservation.discount.voucher))])]) : _vm._e(), _vm._v(" "), (_vm.reservation.discount && _vm.reservation.discount.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.reservation.discount.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.reservation.discount && _vm.reservation.discount.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.reservation.discount.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.paymentTotal))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Additional Services")]), _vm._v(" "), _c('table', {
    staticClass: "ui basic table"
  }, [_c('tbody', _vm._l((_vm.reservation.services), function(service) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(service.title) + "\n              ")]), _vm._v(" "), _c('td', [(service.priceType === 'perPerson') ? _c('div', {
      staticClass: "ui mini labeled input"
    }, [_c('div', {
      staticClass: "ui label"
    }, [_vm._v("\n                    P\n                  ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.people),
        expression: "service.people"
      }],
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (service.people)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.people = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui basic tiny button",
      on: {
        "click": function($event) {
          _vm.toggleBillStatus(service._id)
        }
      }
    }, [(service.billed) ? _c('span', [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Billed")]) : _c('span', [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Off Bill")])])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui dropdown"
    }, [_c('div', {
      staticClass: "text"
    }, [(!service.status || service.status === 'pending') ? _c('span', {
      staticClass: "pending service status"
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (service.status === 'inProgress') ? _c('span', {
      staticClass: "in-progress service status"
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (service.status === 'delivered') ? _c('span', {
      staticClass: "delivered service status"
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]) : _vm._e(), _vm._v(" "), (service.status === 'escalated') ? _c('span', {
      staticClass: "problem service status"
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu",
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'pending')
        }
      }
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'inProgress')
        }
      }
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'delivered')
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]), _vm._v(" "), _c('div', {
      staticClass: "ui divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'escalated')
        }
      }
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Wishes")]), _vm._v(" "), _c('table', {
    staticClass: "ui basic table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm.reservation.wishes || "no additional wishes") + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "collapsing"
  }, [(_vm.reservation.wishes) ? _c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.wishesStatus || _vm.reservation.wishesStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('table', {
    staticClass: "ui basic table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm.reservation.questions || "no additional questions") + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "collapsing"
  }, [(_vm.reservation.questions) ? _c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.questionsStatus || _vm.reservation.questionsStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui five wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("People:")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui input",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.people),
      expression: "people"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number",
      "placeholder": "Enter number"
    },
    domProps: {
      "value": (_vm.people)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.people = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid button",
    on: {
      "click": _vm.savePeople
    }
  }, [_c('i', {
    staticClass: "save icon"
  }), _vm._v(" Save")])]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui selection dropdown",
    staticStyle: {
      "width": "100%",
      "min-width": "0"
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(_vm.reservation.status) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.checkIn($event)
      }
    }
  }, [_vm._v("Checked In")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.checkOut($event)
      }
    }
  }, [_vm._v("Finished")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui header"
  }, [_vm._v("Payment:")]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px"
    }
  }, [_vm._v("To Pay: €" + _vm._s(_vm.paymentTotal))]), _vm._v(" "), _c('div', {
    staticClass: "ui selection dropdown",
    staticStyle: {
      "width": "100%",
      "min-width": "0"
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [(_vm.reservation.payment.status === 'paid') ? _c('span', [_vm._v("Paid")]) : _vm._e(), _vm._v(" "), (_vm.reservation.payment.status === 'unpaid') ? _c('span', [_vm._v("Unpaid")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.paid($event)
      }
    }
  }, [_vm._v("Paid")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.unpaid($event)
      }
    }
  }, [_vm._v("Unpaid")])])])])])])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n    ")])])
}]}

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addBoat($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Boat")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Boats\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.boats), function(boat) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(boat.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(boat.order))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui label"
    }, [_vm._v(_vm._s(boat.type))])]), _vm._v(" "), _c('td', [_vm._v("\n          €" + _vm._s(boat.price) + "/h\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(boat.capacity.max) + " Pax\n        ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui label",
      class: {
        'green': !boat.hidden, 'red': boat.hidden
      }
    }, [_vm._v("\n            " + _vm._s(boat.hidden ? 'No' : 'Yes') + "\n          ")])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(boat.startsAtHalfHour ? '**:30' : '**:00') + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editBoat(boat)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Boat")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editBoat(boat)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Boat")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteBoat(boat)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Boat")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete boat "), (_vm.boatForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.boatForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteBoat(_vm.boatForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "boatModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.boat._id) ? _c('span', [_vm._v("Edit Boat")]) : _c('span', [_vm._v("Add Boat")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.type),
      expression: "boat.type"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boat.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "insel"
    }
  }, [_vm._v("Insel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sofa"
    }
  }, [_vm._v("Sofa Boat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paper"
    }
  }, [_vm._v("Paper Boat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "oktagon"
    }
  }, [_vm._v("Oktagon")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.name),
      expression: "boat.name"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.boat.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Order")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.order),
      expression: "boat.order"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.order = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("People: Min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.capacity.min),
      expression: "boat.capacity.min"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.capacity.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.capacity.min = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("People: Max")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.capacity.max),
      expression: "boat.capacity.max"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.capacity.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.capacity.max = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Price p/h (€)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.price),
      expression: "boat.price"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.boat.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boat.price = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Hidden for public booking")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.hidden),
      expression: "boat.hidden"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.boat.hidden) ? _vm._i(_vm.boat.hidden, null) > -1 : (_vm.boat.hidden)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.boat.hidden,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.boat.hidden = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.boat.hidden = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.boat.hidden = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label')])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Corona - Starts at half hour (**:30)")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boat.startsAtHalfHour),
      expression: "boat.startsAtHalfHour"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.boat.startsAtHalfHour) ? _vm._i(_vm.boat.startsAtHalfHour, null) > -1 : (_vm.boat.startsAtHalfHour)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.boat.startsAtHalfHour,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.boat.startsAtHalfHour = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.boat.startsAtHalfHour = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.boat.startsAtHalfHour = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label')])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('vue-editor', {
    model: {
      value: (_vm.boat.description),
      callback: function($$v) {
        _vm.boat.description = $$v
      },
      expression: "boat.description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveBoat
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Boat\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Order\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Type\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Price\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Capacity\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Visible For Booking\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Starts At\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bookingConfirmation"
    }
  }, [_c('div', {
    staticClass: "ui white raised top attached padded segment",
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "nine wide column",
    staticStyle: {
      "border-right": "1px solid #e8e8e8"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.createdReservation.contact.title) + " " + _vm._s(_vm.createdReservation.contact.firstName) + " " + _vm._s(_vm.createdReservation.contact.lastName))]), _vm._v(" "), _c('p', [(_vm.createdReservation.contact.company) ? _c('span', [_vm._v(_vm._s(_vm.$t('Company')) + ": " + _vm._s(_vm.createdReservation.contact.company)), _c('br')]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.$t('Email')) + ": " + _vm._s(_vm.createdReservation.contact.email)), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('Telephone')) + ": " + _vm._s(_vm.createdReservation.contact.tel)), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('Address')) + ": " + _vm._s(_vm.createdReservation.contact.address)), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('City')) + ": " + _vm._s(_vm.createdReservation.contact.city) + ", " + _vm._s(_vm.createdReservation.contact.zip) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('People')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.createdReservation.people))])])]), _vm._v(" "), _c('div', {
    staticClass: "seven wide column center aligned middle aligned"
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.createdReservation.code))])]), _vm._v(" "), _c('div', [_vm._v("Reservation Code")])])])]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic white table",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('tbody', [_vm._l((_vm.createdReservation.bookings), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(booking.boat.name) + "\n      ")]), _vm._v(" "), _c('td', [(booking.boat.startsAtHalfHour) ? _c('span', [_vm._v("\n          " + _vm._s((parseInt(booking.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(booking.hour.split(' - ')[1]) - 1) + ':30') + " h\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(booking.hour) + " h\n        ")])]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n        €" + _vm._s(booking.cost) + ".00\n      ")])])
  }), _vm._v(" "), (_vm.createdReservation.discount) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.createdReservation.discount.voucher))])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.discount && _vm.createdReservation.discount.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.createdReservation.discount.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.discount && _vm.createdReservation.discount.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.createdReservation.discount.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.numeral(_vm.totalCost).format('0,0.00')))])])]), _vm._v(" "), (_vm.createdReservation.services.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Services')))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.createdReservation.services), function(service) {
    return (service.selected) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n        " + _vm._s(service.title))]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(service.priceType === 'perPerson') ? _c('span', [_vm._v("p.P. €" + _vm._s(_vm.numeral(service.price).format('0,0.00')))]) : _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price).format('0,0.00')))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.createdReservation.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Wishes')))])])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.createdReservation.wishes) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Questions')))])])]) : _vm._e(), _vm._v(" "), (_vm.createdReservation.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.createdReservation.questions) + "\n      ")])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])])
}]}

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui simple large sidebar fixed vertical inverted labeled menu left"
  }, [_c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/booking",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v("\n    Booking Panel\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/reservations",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v("\n    Reservations\n  ")]), _vm._v(" "), (_vm.canSeeBoats) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/boats",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "ship icon"
  }), _vm._v("\n    Boats\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeUsers) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/users",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "users icon"
  }), _vm._v("\n    Users\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeReasons) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/reasons",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "question icon"
  }), _vm._v("\n    Reasons\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeServices) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/services",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "cocktail icon"
  }), _vm._v("\n    Services\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeVouchers) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/vouchers",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "barcode icon"
  }), _vm._v("\n    Vouchers\n  ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeSettings) ? _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/admin/settings",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "edit icon"
  }), _vm._v("\n    Settings\n  ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "blue item",
    attrs: {
      "to": "/logout"
    }
  }, [_c('i', {
    staticClass: "sign out icon"
  }), _vm._v("\n    Logout\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "position": "relative",
      "background": "#ffffff"
    }
  }, [_c('h2', {
    staticClass: "ui main header"
  }, [_vm._v("Boot Mieten")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.$i18n.locale = 'de'
      }
    }
  }, [_c('i', {
    staticClass: "de flag"
  }), _vm._v(" Deutsch")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.$i18n.locale = 'en'
      }
    }
  }, [_c('i', {
    staticClass: "gb flag"
  }), _vm._v(" English")])])])]), _vm._v(" "), (_vm.bookingDisabled) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Buchung derzeit nicht möglich.\n        ")])]) : _c('div', [_c('div', {
    staticClass: "ui four large steps"
  }, [_c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 1
    }, {
      completed: _vm.selected.length > 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Boat & Time')))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Choose your boat and desired date and time'))
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 2
    }, {
      completed: _vm.detailsFormValid
    }, {
      disabled: _vm.selected.length == 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Details & Extras')))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Enter additional wishes'))
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 3
    }, {
      completed: _vm.formValid
    }, {
      disabled: !_vm.detailsFormValid || _vm.selected.length == 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Contact Details')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('Enter contact details')))])])]), _vm._v(" "), _c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 4
    }, {
      completed: _vm.step > 4
    }, {
      disabled: !_vm.formValid || _vm.selected.length == 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 4
      }
    }
  }, [_c('i', {
    staticClass: "info icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Review & Confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('Confirm your booking')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "floating-actions floating-actions--right"
  }, [(_vm.step == 1) ? _c('button', {
    staticClass: "ui big primary button mobile-fluid",
    class: {
      'disabled': !_vm.canContinue
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step + 1
      }
    }
  }, [(_vm.canContinue) ? _c('span', [_vm._v(_vm._s(_vm.$t('Accept & Continue')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Select slots to continue')))]), _vm._v(" "), _c('i', {
    staticClass: "right arrow icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('button', {
    staticClass: "ui big icon primary button mobile-fluid",
    class: {
      'disabled': !_vm.canContinue
    },
    on: {
      "click": _vm.goToContactDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Accept & Continue')))]), _vm._v(" "), _c('i', {
    staticClass: "right arrow icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('button', {
    staticClass: "ui big icon primary button mobile-fluid",
    class: {
      'disabled': !_vm.canContinue
    },
    on: {
      "click": _vm.goToConfirm
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Go To Confirmation')))]), _vm._v(" "), _c('i', {
    staticClass: "right arrow icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('button', {
    staticClass: "ui huge icon green button confirm-cta confirm-cta--floating mobile-fluid",
    on: {
      "click": _vm.confirmBooking
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Confirm Booking')))]), _vm._v(" "), _c('i', {
    staticClass: "checkmark icon"
  })]) : _vm._e()]), _vm._v(" "), (_vm.canBack) ? _c('div', {
    staticClass: "floating-actions floating-actions--left"
  }, [_c('button', {
    staticClass: "ui negative big button",
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_c('i', {
    staticClass: "left arrow icon"
  }), _vm._v("\n            " + _vm._s(_vm.$t('Back')) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "beforeEnter": _vm.beforeAnimationEnter,
      "beforeLeave": _vm.beforeAnimationLeave
    }
  }, [(_vm.step == 1) ? _c('div', {
    key: "step1",
    staticStyle: {
      "position": "absolute",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('div', {
    staticClass: "item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('Selected date')) + ":\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dateMinus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar"
  }, [_c('div', {
    staticClass: "ui huge icon input"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Datum"
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.datePlus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), (_vm.selected.length > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('Price for selected')) + ":\n                "), _c('div', {
    staticClass: "ui large blue basic label"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.selectedPrice))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui blue raised segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "segment"
    }
  }, [_c('h2', {
    staticClass: "ui red header"
  }, [_vm._v("\n                Buchungsbeginn zur vollen Stunde\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "width": "72px"
      },
      attrs: {
        "id": hour === '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n                    " + _vm._s(hour) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartFull), function(boat) {
    return _c('tr', {
      class: {
        'thick-border': _vm.boatsStartFull[_vm.boatsStartFull.indexOf(boat) - 1] && boat.type !== _vm.boatsStartFull[_vm.boatsStartFull.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      attrs: {
        "data-tooltip": "Click for details and pictures",
        "data-inverted": "true",
        "data-variation": "mini"
      },
      on: {
        "click": function($event) {
          _vm.showBoatDescription(boat)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(boat.name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "300",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(boat.capacity.min) + "-" + _vm._s(boat.capacity.max) + " Pax - " + _vm._s(boat.price) + ",-€/Std.")]), _c('br')]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return _c('booking-choice', {
        key: hour.index,
        attrs: {
          "hour": hour,
          "boat": boat,
          "selected": _vm.selected,
          "date": _vm.date,
          "allBookings": _vm.allBookings,
          "bookingAllowedBefore": _vm.settings.bookingAllowedBefore,
          "clientId": _vm.clientId,
          "updatedBooking": _vm.updatedBooking
        },
        on: {
          "selected": _vm.selected
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    staticClass: "ruler",
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }, [_c('span', [_vm._v("\n                " + _vm._s(_vm.$t('NOW')) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui orange raised segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "80px"
    },
    attrs: {
      "id": "segment2"
    }
  }, [_c('h2', {
    staticClass: "ui red header"
  }, [_vm._v("\n                Buchungsbeginn zur halben Stunde\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached table",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "125px !important"
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "width": "72px !important"
      },
      attrs: {
        "id": hour === '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n                    " + _vm._s((parseInt(hour.split(' - ')[0]) - 1) + ':30')), _c('br'), _vm._v("-"), _c('br'), _vm._v(_vm._s((parseInt(hour.split(' - ')[1]) - 1) + ':30') + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartHalf), function(boat) {
    return _c('tr', {
      class: {
        'thick-border': _vm.boatsStartHalf[_vm.boatsStartHalf.indexOf(boat) - 1] && boat.type !== _vm.boatsStartHalf[_vm.boatsStartHalf.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      attrs: {
        "data-tooltip": "Click for details and pictures",
        "data-inverted": "true",
        "data-variation": "mini"
      },
      on: {
        "click": function($event) {
          _vm.showBoatDescription(boat)
        }
      }
    }, [_c('div', {
      staticClass: "title",
      staticStyle: {
        "width": "110px"
      }
    }, [_vm._v(_vm._s(boat.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "300",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(boat.capacity.min) + "-" + _vm._s(boat.capacity.max) + " Pax - " + _vm._s(boat.price) + ",-€/Std.")]), _c('br')]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return _c('booking-choice', {
        key: hour.index,
        attrs: {
          "hour": hour,
          "boat": boat,
          "selected": _vm.selected,
          "date": _vm.date,
          "allBookings": _vm.allBookings,
          "bookingAllowedBefore": _vm.settings.bookingAllowedBefore,
          "clientId": _vm.clientId,
          "updatedBooking": _vm.updatedBooking
        },
        on: {
          "selected": _vm.selected
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    staticClass: "ruler",
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }, [_c('span', [_vm._v("\n                " + _vm._s(_vm.$t('NOW')) + "\n              ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('div', {
    key: "step2"
  }, [_c('div', {
    staticClass: "ui blue raised segments",
    staticStyle: {
      "position": "absolute",
      "margin-bottom": "80px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.$t('ADDITIONAL DETAILS')))])]), _vm._v(" "), _c('div', {
    staticClass: "ui very padded segment"
  }, [_c('form', {
    staticClass: "ui details large form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui relaxed grid"
  }, [_c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('How many guests will be on the boat(s)?')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.numPeople),
      expression: "details.numPeople"
    }],
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "number",
      "name": "numPeople",
      "min": "1",
      "step": "1",
      "placeholder": "Enter number"
    },
    domProps: {
      "value": (_vm.details.numPeople)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.numPeople = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('What\'s the reason for booking our boats?')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details._reason),
      expression: "details._reason"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.details._reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.reasons), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason._id
      }
    }, [_vm._v(_vm._s(reason.title))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui sixteen wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you require additional services?')))])]), _vm._v(" "), _vm._l((_vm.additionalServices), function(additionalService) {
    return _c('div', {
      staticClass: "service list item"
    }, [_c('div', {
      staticClass: "select"
    }, [_c('div', {
      staticClass: "ui basic tiny buttons"
    }, [(!additionalService.selected) ? _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Select\n                              ")]) : _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Remove\n                              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n                            " + _vm._s(additionalService.title) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                            " + _vm._s(additionalService.description) + "\n                          ")]), _vm._v(" "), (additionalService.letter === 'V') ? _c('br') : _vm._e(), _vm._v(" "), (additionalService.letter === 'V') ? _c('img', {
      staticStyle: {
        "height": "80px"
      },
      attrs: {
        "src": __webpack_require__(710)
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      class: {
        'strong': additionalService.selected
      }
    }, [_vm._v("€ " + _vm._s(_vm.numeral(additionalService.price).format('0,0.00'))), (additionalService.priceType === 'perPerson') ? _c('span', [_vm._v(" / person")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "large green checkmark icon",
      class: {
        'green checkmark': additionalService.selected, 'grey delete': !additionalService.selected
      }
    })])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you have any additional questions?')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.questions),
      expression: "details.questions"
    }],
    attrs: {
      "name": "questions",
      "rows": "4",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.details.questions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.questions = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you have a voucher code?')))]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.voucher),
      expression: "details.voucher"
    }],
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "name": "voucher",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.details.voucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.voucher = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "barcode icon"
  })])]), _vm._v(" "), (_vm.voucher) ? _c('div', {
    staticClass: "ui positive message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('Congratulations! You are eligible for discount.')) + "\n                          ")]), _vm._v(" "), _c('p', [_vm._v("A discount of\n                            "), _c('strong', [(_vm.voucher.deduct.percentage > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.percentage > 0 && _vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.absolute) + ".00€")]) : _vm._e()]), _vm._v("\n                            is applied to this booking.")])]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('div', {
    key: "step3"
  }, [_c('div', {
    staticClass: "ui blue raised segments",
    staticStyle: {
      "position": "absolute",
      "margin-bottom": "80px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.$t('YOUR CONTACT DETAILS')))])]), _vm._v(" "), _c('div', {
    staticClass: "ui padded segment"
  }, [_c('form', {
    staticClass: "ui contact-details form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirmBooking($event)
      }
    }
  }, [_c('div', {
    staticClass: "ui relaxed grid"
  }, [_c('div', {
    staticClass: "seven wide column"
  }, [_c('div', {
    staticClass: "ui error message"
  }), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.title),
      expression: "contact.title"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contact.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('Mr or Mrs')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Herr"
    }
  }, [_vm._v(_vm._s(_vm.$t('Mr')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Frau"
    }
  }, [_vm._v(_vm._s(_vm.$t('Mrs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.title),
      expression: "contact.title"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contact.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('Select')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dr')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Prof"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prof')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mag"
    }
  }, [_vm._v(_vm._s(_vm.$t('Mag')))])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('First Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.firstName),
      expression: "contact.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.contact.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Last Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.lastName),
      expression: "contact.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.contact.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Company')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.company),
      expression: "contact.company"
    }],
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.company = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.tel),
      expression: "contact.tel"
    }],
    attrs: {
      "type": "text",
      "name": "tel"
    },
    domProps: {
      "value": (_vm.contact.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.address),
      expression: "contact.address"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "ten wide field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('City')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.city),
      expression: "contact.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.contact.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six wide field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Post Code')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.zip),
      expression: "contact.zip"
    }],
    attrs: {
      "type": "text",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.contact.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.zip = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui inline checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.newsletterAccepted),
      expression: "contact.newsletterAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "newsletter"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact.newsletterAccepted) ? _vm._i(_vm.contact.newsletterAccepted, null) > -1 : (_vm.contact.newsletterAccepted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.contact.newsletterAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.contact.newsletterAccepted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.contact.newsletterAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact.newsletterAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('I agree to receive newsletter emails')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui inline checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.photosAccepted),
      expression: "contact.photosAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "photos"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact.photosAccepted) ? _vm._i(_vm.contact.photosAccepted, null) > -1 : (_vm.contact.photosAccepted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.contact.photosAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.contact.photosAccepted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.contact.photosAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact.photosAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('I agree that my photos can be used for Meine Insel promotion')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui inline checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.termsAccepted),
      expression: "contact.termsAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact.termsAccepted) ? _vm._i(_vm.contact.termsAccepted, null) > -1 : (_vm.contact.termsAccepted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.contact.termsAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.contact.termsAccepted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.contact.termsAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact.termsAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('I accept the')) + " "), _c('a', {
    attrs: {
      "href": "https://www.meine-insel.at/agb",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('Terms of Service')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui nine wide column"
  }, [_c('div', {
    staticClass: "ui styled fluid accordion"
  }, [_c('div', {
    staticClass: "title active"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n                          Was passiert bei Schlechtwetter?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content active"
  }, [_c('p', [_vm._v("Als Schlechtwetter gilt:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Regen")]), _vm._v(" "), _c('li', [_vm._v("Sturm (mehr als Beaufort 5)")]), _vm._v(" "), _c('li', [_vm._v("Temperaturen unter 16 °C")])]), _vm._v(" "), _c('p', [_vm._v("Maßgeblich ist immer das Wetter an der Alten Donau.")]), _vm._v(" "), _c('p', [_vm._v("Da es in Wien große lokale Unterschiede geben kann, rufen Sie uns im Zweifel bitte ca. 3 Stunden vor Fahrtbeginn an.")]), _vm._v(" "), _c('p', [_vm._v("Bei Regen wird die Reservierung automatisch kostenlos storniert. Bei starker Bewölkung ohne Regen kann die Fahrt stattfinden.")]), _vm._v(" "), _c('p', [_vm._v("Beginnt es während der Fahrt zu regnen, zahlen Sie nur die tatsächlich genutzte Zeit.")])]), _vm._v(" "), _c('div', {
    staticClass: "title active"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n                          Mietzeit\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content active"
  }, [_c('p', [_vm._v("Unsere Boote werden stundenweise zur vollen Stunde vermietet. Die Mietzeit beinhaltet jeweils eine kurze Übergabe- und Rücknahmezeit.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1 Stunde: 50 Minuten Fahrzeit")]), _vm._v(" "), _c('li', [_vm._v("2 Stunden: 100 Minuten Fahrzeit")]), _vm._v(" "), _c('li', [_vm._v("3 Stunden: 160 Minuten Fahrzeit")])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('div', {
    key: "step4"
  }, [_c('div', {
    staticClass: "ui blue raised segment",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "margin-bottom": "80px",
      "padding-top": "50px",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "ui centered grid"
  }, [_c('div', {
    staticClass: "ui seven wide column"
  }, [_c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('Please verify your booking and confirm.')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top attached segment"
  }, [_c('h4', [_vm._v(_vm._s(_vm.contact.title) + " " + _vm._s(_vm.contact.firstName) + " " + _vm._s(_vm.contact.lastName))]), _vm._v(" "), _c('p', [(_vm.contact.company) ? _c('span', [_vm._v(_vm._s(_vm.$t('Company')) + ": " + _vm._s(_vm.contact.company)), _c('br')]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.$t('Email')) + ": " + _vm._s(_vm.contact.email)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('Telephone')) + ": " + _vm._s(_vm.contact.tel)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('Address')) + ": " + _vm._s(_vm.contact.address)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('City')) + ": " + _vm._s(_vm.contact.city) + ", " + _vm._s(_vm.contact.zip) + "\n                    ")])]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('People')))]), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("\n                        " + _vm._s(_vm.details.numPeople) + "\n                      ")])]), _vm._v(" "), _vm._l((_vm.selected), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(booking.boat.name) + "\n                      ")]), _vm._v(" "), _c('td', [(booking.boat.startsAtHalfHour) ? _c('span', [_vm._v("\n                          " + _vm._s((parseInt(booking.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(booking.hour.split(' - ')[1]) - 1) + ':30') + " h\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(booking.hour) + " h\n                        ")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n                        €" + _vm._s(booking.cost) + ".00\n                      ")])])
  }), _vm._v(" "), (_vm.voucher) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.voucher.code))])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.voucher.deduct.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.selectedPrice))])])]), _vm._v(" "), (_vm.additionalServices.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Services')))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.additionalServices), function(service) {
    return (service.selected) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n                        " + _vm._s(service.title))]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(service.priceType === 'perPerson') ? _c('span', [_vm._v("p.P. €" + _vm._s(_vm.numeral(service.price).format('0,0.00')))]) : _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price).format('0,0.00')))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.details.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Wishes')))])])]) : _vm._e(), _vm._v(" "), (_vm.details.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.details.wishes) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.details.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Questions')))])])]) : _vm._e(), _vm._v(" "), (_vm.details.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.details.questions) + "\n                      ")])]) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "confirm-cta-note"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('Please click here to finalize your booking.')) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "ui huge fluid green button confirm-cta confirm-cta--inline",
    on: {
      "click": _vm.confirmBooking
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Confirm Booking')))]), _vm._v(" "), _c('i', {
    staticClass: "checkmark icon"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pay-warning"
  }, [_c('i', {
    staticClass: "money bill alternate outline icon"
  }), _vm._v("\n                    " + _vm._s(_vm.$t('Payment is made on-site')) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('in cash')))]), _vm._v(" " + _vm._s(_vm.$t('— no card payments.')) + "\n                  ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic modal",
    attrs: {
      "id": "confirmModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Booking Confirmed\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            You will be notified by email.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui green ok inverted button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n              Okay\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic modal",
    attrs: {
      "id": "timeoutWarningModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Are you there?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Your booking session will expire in "), _c('strong', [_vm._v(_vm._s(_vm.settings.sessionTimeoutClear) + " seconds")]), _vm._v("! Press any\n            click to continue booking.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui inverted icon cancel button"
  }, [_c('i', {
    staticClass: "right arrow icon"
  }), _vm._v("\n              Continue booking\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic modal",
    attrs: {
      "id": "emailConfirmModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Booking Confirmed\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Your booking was confirmed! An email was sent to you with all details and instructions.")]), _vm._v(" "), _c('p', [_vm._v("You can print this confirmation")]), _vm._v(" "), _c('booking-confirmation', {
    attrs: {
      "created-reservation": _vm.createdReservation
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui inverted icon cancel button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n              Close\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted icon button",
    on: {
      "click": _vm.printConfirmation
    }
  }, [_c('i', {
    staticClass: "print icon"
  }), _vm._v("\n              Print\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "boatDescriptionModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.describeBoat.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.describeBoat.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui icon cancel button"
  }, [_vm._v("\n              Close\n            ")])])]), _vm._v(" "), _c('cancel-booking')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('i', {
    staticClass: "de flag"
  }), _vm._v(" Deutsch")])
}]}

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui raised clearing segment"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "padding-bottom": "10px",
      "border-bottom": "1px solid #eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "font-size": "16px"
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerDetails($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.reservation.code))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "130px"
    }
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" " + _vm._s(_vm.reservation.contact.firstName) + " " + _vm._s(_vm.reservation.contact.lastName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    }
  }, [_c('i', {
    staticClass: "ship icon"
  }), _vm._v(" " + _vm._s(_vm.reservation.boat.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "230px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.moment(_vm.reservation.firstBooking.date).format('ll')) + ": "), _c('strong', {
    staticClass: "ui basic large label"
  }, [_vm._v(_vm._s(_vm.starts) + " - " + _vm._s(_vm.ends) + "h")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px"
    }
  }, [(_vm.reservation.confirmed) ? _c('div', {
    staticClass: "ui label"
  }, [_vm._v(_vm._s(_vm.reservation.status))]) : _c('div', {
    staticClass: "ui yellow label"
  }, [_vm._v("unconfirmed")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "120px"
    }
  }, [(_vm.reservation.payment.status == 'paid') ? _c('div', {
    staticClass: "ui small icon label"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Paid")]) : _vm._e(), _vm._v(" "), (_vm.reservation.payment.status == 'unpaid') ? _c('div', {
    staticClass: "ui small label",
    class: {
      'red': _vm.reservation.status == 'returned' && _vm.reservation.payment.status == 'unpaid'
    }
  }, [_vm._v("Unpaid: "), _c('strong', [_vm._v("€" + _vm._s(_vm.reservation.payment.toPay))])]) : _vm._e(), _vm._v(" "), (_vm.reservation.payment.status == 'refund') ? _c('div', {
    staticClass: "ui small label",
    class: {
      'orange': _vm.reservation.payment.status == 'refund'
    }
  }, [_vm._v("Refund: -"), _c('strong', [_vm._v("€" + _vm._s(Math.abs(_vm.reservation.payment.toPay)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui tiny buttons"
  }, [(_vm.reservation.status == 'reserved') ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.checkIn
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Check In")]) : _vm._e(), _vm._v(" "), (_vm.reservation.status == 'inProgress' ||
    _vm.reservation.status == 'checkIn' ||
    (_vm.reservation.status == 'returned' && (_vm.reservation.payment.status == 'unpaid' || _vm.reservation.payment.status == 'refund'))) ? _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.paid
    }
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(" Paid")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui floating dropdown blue icon button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.checkIn
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Check In")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.paid
    }
  }, [_c('i', {
    staticClass: "money icon"
  }), _vm._v(" Paid")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.checkOut
    }
  }, [_c('i', {
    staticClass: "sign out icon"
  }), _vm._v(" Check Out")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.triggerDetails
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v(" View Details")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0",
      "border-bottom": "1px solid #eeeeee",
      "font-size": "13px"
    }
  }, [_c('strong', [_vm._v("Booked At:")]), _vm._v(" " + _vm._s(_vm.moment(_vm.reservation.createdAt).format('MMM DD, HH:mm')) + "\n    • "), _c('strong', [_vm._v("People:")]), _vm._v(" " + _vm._s(_vm.reservation.people) + "\n    • "), _c('strong', [_vm._v("Telephone:")]), _vm._v(" " + _vm._s(_vm.reservation.contact.tel) + "\n    • "), _c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.reservation.contact.email) + "\n    "), (_vm.reservation.contact.company) ? _c('span', [_vm._v(" • "), _c('strong', [_vm._v("Company:")]), _vm._v(" " + _vm._s(_vm.reservation.contact.company))]) : _vm._e(), _vm._v(" "), (_vm.reservation.discount) ? _c('span', [_vm._v(" • "), _c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.reservation.discount.voucher))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n    Reason: " + _vm._s(_vm.reservation.reason) + "\n  ")]), _vm._v(" "), (_vm.reservation.wishes) ? _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0",
      "border-bottom": "1px solid #eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.wishesStatus || _vm.reservation.wishesStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.wishesStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.wishesStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])])]), _vm._v(" "), _c('strong', [_vm._v("WISHES:")]), _c('br'), _vm._v(_vm._s(_vm.reservation.wishes) + "\n    "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.reservation.questions) ? _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0",
      "border-bottom": "1px solid #eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "status-block"
  }, [_c('div', {
    staticClass: "ui dropdown"
  }, [_c('div', {
    staticClass: "text"
  }, [(!_vm.reservation.questionsStatus || _vm.reservation.questionsStatus === 'pending') ? _c('span', {
    staticClass: "pending service status"
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'inProgress') ? _c('span', {
    staticClass: "in-progress service status"
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'takenCare') ? _c('span', {
    staticClass: "delivered service status"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]) : _vm._e(), _vm._v(" "), (_vm.reservation.questionsStatus === 'escalated') ? _c('span', {
    staticClass: "problem service status"
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('pending')
      }
    }
  }, [_c('i', {
    staticClass: "wait icon"
  }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('inProgress')
      }
    }
  }, [_c('i', {
    staticClass: "refresh icon"
  }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('takenCare')
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Taken Care")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.questionsStatus('escalated')
      }
    }
  }, [_c('i', {
    staticClass: "alarm outline icon"
  }), _vm._v(" Escalated")])])])])]), _vm._v(" "), _c('strong', [_vm._v("QUESTIONS:")]), _c('br'), _vm._v("\n\n    " + _vm._s(_vm.reservation.questions) + "\n    "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.reservation.services && _vm.reservation.services.length > 0) ? _c('div', {
    staticClass: "content bordered",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('strong', [_vm._v("SERVICES:")]), _c('br'), _vm._v(" "), _vm._l((_vm.reservation.services), function(service) {
    return _c('div', {
      staticClass: "service row"
    }, [_vm._v("\n      " + _vm._s(service.title) + "\n      "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [(service.priceType === 'perPerson') ? _c('div', {
      staticClass: "ui mini labeled input"
    }, [_c('div', {
      staticClass: "ui label"
    }, [_vm._v("\n            P\n          ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.people),
        expression: "service.people"
      }],
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (service.people)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.people = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui basic tiny button",
      on: {
        "click": function($event) {
          _vm.toggleBillStatus(service._id)
        }
      }
    }, [(service.billed) ? _c('span', [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Billed")]) : _c('span', [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Off Bill")])]), _vm._v(" "), _c('div', {
      staticClass: "status-block"
    }, [_c('div', {
      staticClass: "ui dropdown"
    }, [_c('div', {
      staticClass: "text"
    }, [(!service.status || service.status === 'pending') ? _c('span', {
      staticClass: "pending service status"
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]) : _vm._e(), _vm._v(" "), (service.status === 'inProgress') ? _c('span', {
      staticClass: "in-progress service status"
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]) : _vm._e(), _vm._v(" "), (service.status === 'delivered') ? _c('span', {
      staticClass: "delivered service status"
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]) : _vm._e(), _vm._v(" "), (service.status === 'escalated') ? _c('span', {
      staticClass: "problem service status"
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu",
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'pending')
        }
      }
    }, [_c('i', {
      staticClass: "wait icon"
    }), _vm._v(" Pending")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'inProgress')
        }
      }
    }, [_c('i', {
      staticClass: "refresh icon"
    }), _vm._v(" In Progress")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'delivered')
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Delivered")]), _vm._v(" "), _c('div', {
      staticClass: "ui divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.serviceStatus(service._id, 'escalated')
        }
      }
    }, [_c('i', {
      staticClass: "alarm outline icon"
    }), _vm._v(" Escalated")])])])])])])
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addReason($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Reasons\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.reasons), function(reason) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(reason.title))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editReason(reason)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Reason")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editReason(reason)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Reason")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteReason(reason)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Reason")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete reason "), (_vm.reasonForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.reasonForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteReason(_vm.reasonForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "reasonModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.reason._id) ? _c('span', [_vm._v("Edit Reason")]) : _c('span', [_vm._v("Add Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Reason")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason.title),
      expression: "reason.title"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.reason.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason.title = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveReason
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Reason\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Reason\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "ui",
    class: [{
      'dimmable': _vm.screenWidth > 768,
      'dimmed': _vm.hovered
    }],
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": _vm.select
    }
  }, [_c('div', {
    staticClass: "ui simple responsive dimmer",
    class: {
      'red': _vm.expired || _vm.disabled
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.disabled) ? _c('div', {
    staticClass: "center"
  }, [_vm._v("\n        Not Available\n      ")]) : (_vm.expired) ? _c('div', {
    staticClass: "center"
  }, [_vm._v("\n        Too Late\n      ")]) : _c('div', {
    staticClass: "center"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.boat.name))])]), _vm._v(" "), (!_vm.boat.startsAtHalfHour) ? _c('p', [_vm._v(_vm._s(_vm.hour) + " Uhr")]) : _c('p', [_vm._v("\n          " + _vm._s((parseInt(_vm.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(_vm.hour.split(' - ')[1]) - 1) + ':30') + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "booking-field",
    class: [_vm.booking.status, {
      'expired': _vm.expired
    }, {
      'disabled': _vm.disabled
    }, {
      'my': _vm.booking.clientId === this.clientId
    }]
  })])
},staticRenderFns: []}

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addUser($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add User")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Users\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ui label",
      class: [{
        'red': user.role === 'superAdmin',
        'orange': user.role === 'admin',
        'blue': user.role === 'cashier',
        'green': user.role === 'crew'
      }]
    }, [_vm._v(_vm._s(user.role) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit User")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit User")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteUser(user)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete User")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete user "), (_vm.userForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.userForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteUser(_vm.userForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "userModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.user._id) ? _c('span', [_vm._v("Edit User")]) : _c('span', [_vm._v("Add User")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select User Role...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "crew"
    }
  }, [_vm._v("Crew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cashier"
    }
  }, [_vm._v("Cashier")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sales"
    }
  }, [_vm._v("Sales")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "driver"
    }
  }, [_vm._v("Driver")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "admin"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "superAdmin"
    }
  }, [_vm._v("Super Admin")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveUser
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save User\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Name\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Role\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "ui dimmable",
    class: [{
      'dimmed': _vm.hovered
    }],
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": _vm.select
    }
  }, [_c('div', {
    staticClass: "ui simple dimmer",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.status ? _vm.booking.status.toUpperCase() : 'OPEN'))])]), _vm._v(" "), (_vm.booking.reservation) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.reservation ? _vm.booking.reservation.contact.firstName +
    ' ' +
    _vm.booking.reservation.contact.lastName : ''))])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.reservation.code))])]) : _vm._e(), _vm._v(" "), (!_vm.boat.startsAtHalfHour) ? _c('p', [_vm._v(_vm._s(_vm.hour) + " Uhr")]) : _c('p', [_vm._v("\n          " + _vm._s((parseInt(_vm.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(_vm.hour.split(' - ')[1]) - 1) + ':30') + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "booking-field",
    class: [
      _vm.booking.status,
      {
        'create-selected': _vm.createSelected
      },
      {
        'unconfirmed': _vm.booking.reservation && !_vm.booking.reservation.confirmed
      },
      {
        'ui dropdown': ['reserved', 'selected', 'blocked', 'open', 'readyToGo', 'boatOut', 'returned'].indexOf(_vm.booking.status) > -1
      },
      {
        'moving': _vm.moving
      }
    ]
  }, [(_vm.booking.status === 'blocked') ? _c('p', [_c('strong', [_vm._v("INTERNAL BLOCK")])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('p', [_vm._v(_vm._s(_vm.booking.reservation.contact.firstName) + " " + _vm._s(_vm.booking.reservation.contact.lastName))]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation && _vm.booking.reservation.confirmed) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.booking.reservation.code))])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('table', {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "1px solid #fff",
      "color": "#fff"
    }
  }, [_c('tr', [_vm._l((_vm.booking.reservation.services), function(service) {
    return _c('td', {
      staticClass: "service letter",
      staticStyle: {
        "color": "#fff"
      }
    }, [(service.selected) ? _c('strong', [_vm._v(_vm._s(service.letter))]) : _vm._e()])
  }), _vm._v(" "), _c('td', {
    staticClass: "service letter"
  }, [(_vm.booking.reservation.questions) ? _c('strong', [_vm._v("Q")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "service letter"
  }, [(_vm.booking.reservation.wishes) ? _c('strong', [_vm._v("W")]) : _vm._e()])], 2)]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "5px",
      "padding-right": "5px",
      "color": "#fff",
      "font-size": "12px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.booking.reservation.people) + "\n      "), (_vm.booking.discount && _vm.booking.discount.voucher) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.booking.discount.voucher) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation && !_vm.booking.reservation.confirmed) ? _c('div', {
    staticClass: "ui mini label"
  }, [_c('strong', [_vm._v("UNCONFIRMED")])]) : _vm._e(), _vm._v(" "), (_vm.booking.reservation) ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.viewDetails
    }
  }, [_c('i', {
    staticClass: "info icon"
  }), _vm._v(" View Details")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.booking.status === 'readyToGo') ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.goOut
    }
  }, [_c('i', {
    staticClass: "sign out icon"
  }), _vm._v(" Boat Went Out")]) : _vm._e(), _vm._v(" "), (_vm.booking.status === 'boatOut') ? _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.returned
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Boat Returned")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.cancelBooking
    }
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Cancel This Booking Slot")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.cancelReservation
    }
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Cancel Whole Reservation")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.moveBooking
    }
  }, [_c('i', {
    staticClass: "exchange icon"
  }), _vm._v(" Move Booking")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.extendBooking
    }
  }, [_c('i', {
    staticClass: "hourglass end icon"
  }), _vm._v(" Extend Booking")])]) : (_vm.booking.status === 'open' || _vm.booking.status === 'selected') ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.blockSlot
    }
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Block Booking Slot")])]) : (_vm.booking.status === 'blocked') ? _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.unblockSlot
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Unblock Booking Slot")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dateMinus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow left"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.datePlus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar",
    attrs: {
      "id": "calendar2"
    }
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [(!_vm.filters.dateTo) ? _c('i', {
    staticClass: "calendar icon"
  }) : _c('i', {
    staticClass: "close link icon",
    on: {
      "click": function($event) {
        _vm.clearDateTo()
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Date filter to",
      "autocomplete": "off"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text input item"
  }, [_c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "barcode icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.code),
      expression: "filters.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search Code"
    },
    domProps: {
      "value": (_vm.filters.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filters.code = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Reservations\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _vm._l((_vm.reservations), function(reservation) {
    return _c('reservation-row', {
      key: reservation._id,
      attrs: {
        "reservation": reservation,
        "boats": _vm.boats
      },
      on: {
        "triggerDetails": _vm.openReservationDetails,
        "printReceipt": _vm.printReceipt
      }
    })
  }), _vm._v(" "), (_vm.reservations.length === 0) ? _c('div', {
    staticClass: "ui message"
  }, [_vm._v("\n          There are no reservations for selected date or search criteria.\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "pickup receipt"
  }, [_c('p', [_vm._v("Code: "), _c('strong', [_vm._v(_vm._s(_vm.receipt.code))])]), _vm._v(" "), _c('p', [_vm._v("Boat: "), _c('strong', [_vm._v(_vm._s(_vm.receipt.boat))])])]), _vm._v(" "), _c('details-modal', {
    attrs: {
      "reservationProp": _vm.editReservation,
      "boats": _vm.boats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar",
    attrs: {
      "id": "calendar1"
    }
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Datum"
    }
  })])])])
}]}

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui centered grid"
  }, [_c('div', {
    staticClass: "ui ten wide column"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('table', {
    staticClass: "ui very basic striped table"
  }, [_c('tr', [_c('td', [_vm._v("Admin overrides current user selection")]), _vm._v(" "), _c('td', {
    staticClass: "right aligned four wide"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.adminOverridesSelected),
      expression: "settings.adminOverridesSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": "adminOverridesSelected"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.adminOverridesSelected) ? _vm._i(_vm.settings.adminOverridesSelected, null) > -1 : (_vm.settings.adminOverridesSelected)
    },
    on: {
      "change": _vm.trackChange,
      "__c": function($event) {
        var $$a = _vm.settings.adminOverridesSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.adminOverridesSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.adminOverridesSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.adminOverridesSelected = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Booking session timeout warning shows after")]), _vm._v(" "), _c('td', {
    staticClass: "four wide"
  }, [_c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.sessionTimeout),
      expression: "settings.sessionTimeout"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter time"
    },
    domProps: {
      "value": (_vm.settings.sessionTimeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.sessionTimeout = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n                                        min\n                                    ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Upon warning, booking gets cleared after")]), _vm._v(" "), _c('td', {
    staticClass: "four wide"
  }, [_c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.sessionTimeoutClear),
      expression: "settings.sessionTimeoutClear"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter time"
    },
    domProps: {
      "value": (_vm.settings.sessionTimeoutClear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.sessionTimeoutClear = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n                                        min\n                                    ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("How many minutes before can booking be made?")]), _vm._v(" "), _c('td', {
    staticClass: "four wide"
  }, [_c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.bookingAllowedBefore),
      expression: "settings.bookingAllowedBefore"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter time"
    },
    domProps: {
      "value": (_vm.settings.bookingAllowedBefore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.bookingAllowedBefore = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n                                        min\n                                    ")])])])])]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.saveSettings
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save settings")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('booking')], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge borderless menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n      Selected date:\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dateMinus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow left"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.datePlus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [(_vm.loading) ? _c('i', {
    staticClass: "circle notched loading icon"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "small add-reservation item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.startCreateReservation($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Reservation")])]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "30px"
    },
    attrs: {
      "id": "segment"
    }
  }, [_c('h4', {
    staticClass: "ui red header"
  }, [_vm._v("\n      Buchungsbeginn zur vollen Stunde\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached fifteen column table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "two wide"
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      attrs: {
        "id": hour == '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n          " + _vm._s(hour) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartFull), function(boat) {
    return _c('tr', {
      key: boat._id,
      class: {
        'thick-border': _vm.boats[_vm.boats.indexOf(boat) - 1] && boat.type !== _vm.boats[_vm.boats.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      class: {
        'out': boat.state.currentlyOut
      }
    }, [_c('span', {
      staticClass: "title",
      class: {
        'hidden': boat.hidden
      }
    }, [_vm._v("\n            " + _vm._s(boat.name) + " "), (boat.hidden) ? _c('i', {
      staticClass: "hide icon"
    }) : _vm._e()]), _vm._v(" "), (boat.state.currentlyOut) ? _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "#c54700"
      }
    }, [_c('br'), _vm._v("IN USE "), (boat.state.currentlyOut) ? _c('i', {
      staticClass: "circle notched loading icon"
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.hours), function(hour, index) {
      return _c('booking-choice', {
        key: boat._id + '-' + hour.index,
        attrs: {
          "hour": hour,
          "hourIndex": index,
          "boat": boat,
          "hours": _vm.hours,
          "selected": _vm.selected,
          "date": _vm.date,
          "id": boat._id + '-' + index,
          "move": _vm.move,
          "create": _vm.create,
          "settings": _vm.settings,
          "updatedBooking": _vm.updatedBooking,
          "allBookings": _vm.allBookings
        },
        on: {
          "selected": _vm.selected,
          "triggerDetails": _vm.openReservationDetails,
          "moveBooking": _vm.moveBooking,
          "moveTo": _vm.moveTo,
          "selectForCreate": _vm.selectForCreate
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "120px"
    },
    attrs: {
      "id": "segment2"
    }
  }, [_c('h4', {
    staticClass: "ui red header"
  }, [_vm._v("\n      Buchungsbeginn zur halben Stunde\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached table",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "two wide",
    staticStyle: {
      "width": "119px !important"
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "width": "86px !important"
      },
      attrs: {
        "id": hour == '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n          " + _vm._s((parseInt(hour.split(' - ')[0]) - 1) + ':30')), _c('br'), _vm._v("-"), _c('br'), _vm._v(_vm._s((parseInt(hour.split(' - ')[1]) - 1) + ':30') + "\n        ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartHalf), function(boat) {
    return _c('tr', {
      key: boat._id,
      class: {
        'thick-border': _vm.boats[_vm.boats.indexOf(boat) - 1] && boat.type !== _vm.boats[_vm.boats.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      class: {
        'out': boat.state.currentlyOut
      }
    }, [_c('div', {
      staticClass: "title",
      class: {
        'hidden': boat.hidden
      },
      staticStyle: {
        "width": "105px"
      }
    }, [_vm._v("\n            " + _vm._s(boat.name) + " "), (boat.hidden) ? _c('i', {
      staticClass: "hide icon"
    }) : _vm._e()]), _vm._v(" "), (boat.state.currentlyOut) ? _c('div', {
      staticStyle: {
        "font-size": "12px",
        "color": "#c54700"
      }
    }, [_vm._v("IN USE "), (boat.state.currentlyOut) ? _c('i', {
      staticClass: "circle notched loading icon"
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.hours), function(hour, index) {
      return _c('booking-choice', {
        key: boat._id + '-' + hour.index,
        attrs: {
          "hour": hour,
          "hourIndex": index,
          "boat": boat,
          "hours": _vm.hours,
          "selected": _vm.selected,
          "date": _vm.date,
          "id": boat._id + '-' + index,
          "move": _vm.move,
          "create": _vm.create,
          "settings": _vm.settings,
          "updatedBooking": _vm.updatedBooking,
          "allBookings": _vm.allBookings
        },
        on: {
          "selected": _vm.selected,
          "triggerDetails": _vm.openReservationDetails,
          "moveBooking": _vm.moveBooking,
          "moveTo": _vm.moveTo,
          "selectForCreate": _vm.selectForCreate
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }) : _vm._e()]), _vm._v(" "), (_vm.move.status) ? _c('div', {
    staticClass: "bottom-message"
  }, [_c('div', {
    staticClass: "ui icon floating message"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Select the slot to move the reservation to\n        ")]), _vm._v(" "), _c('p', [_vm._v("You are moving the reservation "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.reservation.code))]), _vm._v("\n          from "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.date))]), _vm._v(", boat "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.boat.name))]), _vm._v("\n          at "), _c('strong', [_vm._v(_vm._s(_vm.move.booking.hour) + "h")])]), _vm._v(" "), _c('div', {
    staticClass: "ui negative tiny button",
    on: {
      "click": function($event) {
        _vm.move.status = false
      }
    }
  }, [_vm._v("Cancel moving")])])])]) : _vm._e(), _vm._v(" "), (_vm.create.status) ? _c('div', {
    staticClass: "bottom-message"
  }, [_c('div', {
    staticClass: "ui icon floating message"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Select slots to create reservation for\n        ")]), _vm._v(" "), _c('p', [_vm._v("Please select the slots to book for the new reservation.")]), _vm._v(" "), (_vm.create.selected.length > 0) ? _c('div', {
    staticClass: "ui positive tiny button",
    on: {
      "click": _vm.showNewReservationModal
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Create Reservation")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui negative basic tiny button",
    on: {
      "click": function($event) {
        _vm.create.status = false;
        _vm.create.selected = []
      }
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('details-modal', {
    attrs: {
      "reservationProp": _vm.editReservation,
      "boats": _vm.boats
    }
  }), _vm._v(" "), _c('new-reservation-modal', {
    attrs: {
      "selected": _vm.create.selected
    },
    on: {
      "reservationCreated": function($event) {
        _vm.create.status = false;
        _vm.create.selected = []
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar"
  }, [_c('div', {
    staticClass: "ui huge icon input"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Datum"
    }
  })])])])
}]}

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_vm._v("\nsadasdasd\n      ")])])])
}]}

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addService($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Service")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Services\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.services), function(service) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(service.title))]), _vm._v(" "), _c('td', [_vm._v("€ " + _vm._s(_vm.numeral(service.price).format('0,0.00')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(service.description))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('strong', [_vm._v(_vm._s(service.letter))])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editService(service)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Service")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editService(service)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Service")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteService(service)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Service")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete service "), (_vm.serviceForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.serviceForDelete.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteService(_vm.serviceForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "serviceModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.service._id) ? _c('span', [_vm._v("Edit Service")]) : _c('span', [_vm._v("Add Service")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.title),
      expression: "service.title"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.service.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "twelve wide field"
  }, [_c('label', [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.price),
      expression: "service.price"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.service.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.price = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "euro icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "four wide field"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.priceType),
      expression: "service.priceType"
    }],
    staticClass: "ui selection",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service.priceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Fixed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "perPerson"
    }
  }, [_vm._v("Per Person")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.description),
      expression: "service.description"
    }],
    staticClass: "ui input",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.service.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Letter in admin booking panel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.letter),
      expression: "service.letter"
    }],
    staticClass: "ui input",
    attrs: {
      "maxlength": "1"
    },
    domProps: {
      "value": (_vm.service.letter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.letter = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveService
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Service\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Title\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Price\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Description\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Letter\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addVoucher($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Voucher")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Vouchers\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.vouchers), function(voucher) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(voucher.code))]), _vm._v(" "), _c('td', [_vm._v("Relative: "), _c('strong', [_vm._v("-" + _vm._s(voucher.deduct.percentage * 100) + "%")]), _vm._v(", Absolute: "), _c('strong', [_vm._v("-" + _vm._s(voucher.deduct.absolute) + "€")])]), _vm._v(" "), _c('td', [_vm._v("Min Total: "), _c('strong', [_vm._v(_vm._s(voucher.min.absolute) + "€")]), _vm._v(", Min Hours: "), _c('strong', [_vm._v(_vm._s(voucher.min.hours))])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Voucher")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Voucher")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Voucher")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete voucher "), (_vm.voucherForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.voucherForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteVoucher(_vm.voucherForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "voucherModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.voucher._id) ? _c('span', [_vm._v("Edit Voucher")]) : _c('span', [_vm._v("Add Voucher")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.code),
      expression: "voucher.code"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.voucher.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Deduct %")]), _vm._v(" "), _c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.deduct.percentage),
      expression: "voucher.deduct.percentage"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.deduct.percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.deduct.percentage = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Deduct Absolute")]), _vm._v(" "), _c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.deduct.absolute),
      expression: "voucher.deduct.absolute"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.deduct.absolute)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.deduct.absolute = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("€")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Minimum Price")]), _vm._v(" "), _c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.min.absolute),
      expression: "voucher.min.absolute"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.min.absolute)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.min.absolute = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("€")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Minimum Hours")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.min.hours),
      expression: "voucher.min.hours"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.min.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.min.hours = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveVoucher
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Voucher\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Code\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Deduct\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Conditions\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui stackable four column middle aligned centered grid"
  }, [_c('div', {
    staticClass: "four wide column",
    staticStyle: {
      "margin-top": "180px"
    }
  }, [_c('div', {
    staticClass: "ui raised padded segment"
  }, [_c('h2', {
    staticClass: "ui center aligned padded secondary header"
  }, [_vm._v("\n            Meine Insel Booking\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "ui huge form",
    class: [{
      'error': _vm.error != ''
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.email),
      expression: "loginData.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "E-mail address"
    },
    domProps: {
      "value": (_vm.loginData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginData.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginData.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui fluid big primary submit button",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "sign in icon"
  }), _vm._v(" Login")])
}]}

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(755);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var DEBUG = "production" === 'development';

var state = {
  user: {
    authenticated: false,
    data: {}
  }
};

var mutations = {
  AUTHENTICATE_USER: function AUTHENTICATE_USER(state, user) {
    state.user.authenticated = true;
    state.user.data = user;
  },
  LOGOUT_USER: function LOGOUT_USER(state) {
    state.user.data = {};
    state.user.authenticated = false;
  }
};

var actions = {
  logoutUser: function logoutUser(_ref) {
    var commit = _ref.commit;

    commit('LOGOUT_USER');
  },
  authenticateUser: function authenticateUser(_ref2, user) {
    var commit = _ref2.commit;

    commit('AUTHENTICATE_USER', user);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  strict: DEBUG
}));

/***/ })

},[407]);


// WEBPACK FOOTER //
// static/js/app.06f1c42342b39de65e43.js